

let courses = [

"AAAA 100 ",
"ACCT 351 Intermediate Financial Accounting 1 (3 credits)",
"ACCT 352 Intermediate Financial Accounting 2 (3 credits)",
"ACCT 354 Financial Statement Analysis (3 credits)",
"ACCT 361 Management Accounting (3 credits)",
"ACCT 362 Cost Accounting (3 credits)",
"ACCT 385 Principles of Taxation (3 credits)",
"ACCT 401 Sustainability and Environmental Accounting (3 credits)",
"ACCT 434 Topics in Accounting 1 (3 credits)",
"ACCT 452 Financial Reporting Valuation (3 credits)",
"ACCT 453 Advanced Financial Accounting (3 credits)",
"ACCT 454 Financial Reporting (3 credits)",
"ACCT 455 Development of Accounting Thought (3 credits)",
"ACCT 463 Management Control (3 credits)",
"ACCT 471 Non-Profit Accounting (3 credits)",
"ACCT 475 Principles of Auditing (3 credits)",
"ACCT 476 Internal Auditing (3 credits)",
"ACCT 477 External Auditing (3 credits)",
"ACCT 486 Business Taxation 2 (3 credits)",
"ACCT 604 Financial Statements 1 (3 credits)",
"ACCT 605 Financial Statements 2 (3 credits)",
"ACCT 618 Financial Reporting: Structure & Analysis (3 credits)",
"ACCT 619 Financial Reporting: Valuation (3 credits)",
"ACCT 622 Intermediate Financial Reporting 1 (3 credits)",
"ACCT 623 Intermediate Financial Reporting 2 (3 credits)",
"ACCT 624 Management Accounting: Planning & Control (3 credits)",
"ACCT 625 Canadian Taxation (3 credits)",
"ACCT 626 Data Analytics in Accounting (1.5 credits)",
"ACCT 645D1 Financial Management in Healthcare (1 credit)",
"ACCT 645D2 Financial Management in Healthcare (1 credit)",
"ACCT 653 Issues in Professional Accounting 1 (3 credits)",
"ACCT 653D1 Issues in Professional Accounting 1 (1.5 credits)",
"ACCT 653D2 Issues in Professional Accounting 1 (1.5 credits)",
"ACCT 654 Issues in Professional Accounting 2 (3 credits)",
"ACCT 654D1 Issues in Professional Accounting 2 (1.5 credits)",
"ACCT 654D2 Issues in Professional Accounting 2 (1.5 credits)",
"ACCT 663 Strategic Aspects of Accounting 1 (3 credits)",
"ACCT 663D1 Strategic Aspects of Accounting 1 (1.5 credits)",
"ACCT 663D2 Strategic Aspects of Accounting 1 (1.5 credits)",
"ACCT 664 Strategic Aspects of Accounting 2 (3 credits)",
"ACCT 664D1 Strategic Aspects of Accounting 2 (1.5 credits)",
"ACCT 664D2 Strategic Aspects of Accounting 2 (1.5 credits)",
"ACCT 683 Practice of Taxation (4 credits)",
"ACCT 685 Accounting and Performance Management (4 credits)",
"ACCT 687 Assurance Services (4 credits)",
"ACCT 689 Financial Business Analysis (4 credits)",
"ACCT 690 Advanced Topics in Accounting 1 (3 credits)",
"ACCT 695 Integrative Analysis (4 credits)",
"ACCT 696 Advanced Topics in Accounting Analytics (1.5 credits)",
"ACCT 699 Exam Preparation Seminar",
"ACCT 705 Seminar in Accounting (3 credits)",
"ACCT 706 Research Design in Accounting (3 credits)",
"ACCT 707 Accountability and Sustainability (3 credits)",
"AEBI 120 General Biology (3 credits)",
"AEBI 122 Cell Biology (3 credits)",
"AEBI 210 Organisms 1 (3 credits)",
"AEBI 211 Organisms 2 (3 credits)",
"AEBI 212 Evolution and Phylogeny (3 credits)",
"AEBI 421 Tropical Horticultural Ecology (3 credits)",
"AEBI 423 Sustainable Land Use (3 credits)",
"AEBI 425 Tropical Energy and Food (3 credits)",
"AEBI 427 Barbados Interdisciplinary Project (6 credits)",
"AECH 110 General Chemistry 1 (4 credits)",
"AECH 111 General Chemistry 2 (4 credits)",
"AECH 118 General Chemistry Laboratory 1 (1 credit)",
"AECH 119 General Chemistry Laboratory 2 (1 credit)",
"AEHM 205 Science Literacy (3 credits)",
"AEHM 300 ESL: High Intermediate 1 (3 credits)",
"AEHM 301 ESL: High Intermediate 2 (3 credits)",
"AEHM 330 Academic and Scientific Writing (3 credits)",
"AEMA 101 Calculus 1 (3 credits)",
"AEMA 102 Calculus 2 (4 credits)",
"AEMA 105 Precalculus Lab (1 credit)",
"AEMA 202 Intermediate Calculus (3 credits)",
"AEMA 305 Differential Equations (3 credits)",
"AEMA 310 Statistical Methods 1 (3 credits)",
"AEMA 403 Environmetrics Stage (3 credits)",
"AEMA 411 Experimental Designs 01 (3 credits)",
"AEMA 414 Temporal and Spatial Statistics 01 (3 credits)",
"AEMA 610 Statistical Methods 2 (3 credits)",
"AEMA 611 Experimental Designs 1 (3 credits)",
"AEMA 614 Temporal and Spatial Statistics 1 (3 credits)",
"AEPH 112 Introductory Physics 1 (4 credits)",
"AEPH 113 Physics 1 (4 credits)",
"AEPH 114 Introductory Physics 2 (4 credits)",
"AEPH 115 Physics 2 (4 credits)",
"AEPH 120 Physics Laboratory 1 (1 credit)",
"AEPH 122 Physics Laboratory 2 (1 credit)",
"AERO 401 Introduction to Aerospace Engineering (3 credits)",
"AERO 410 Aerospace Design and Certification Process (3 credits)",
"AERO 460D1 Aerospace Project (3 credits)",
"AERO 460D2 Aerospace Project (3 credits)",
"AFRI 200 Introduction to African Studies (3 credits)",
"AFRI 401 Swahili Language and Culture (3 credits)",
"AFRI 480 Honours Thesis (3 credits)",
"AFRI 481 Special Topics 1 (3 credits)",
"AFRI 499 Arts Internships: African Studies (3 credits)",
"AFRI 598 Research Seminar in African Studies (3 credits)",
"AGEC 200 Principles of Microeconomics (3 credits)",
"AGEC 201 Principles of Macroeconomics (3 credits)",
"AGEC 231 Economic Systems of Agriculture (3 credits)",
"AGEC 242 Management Theories and Practices (3 credits)",
"AGEC 320 Intermediate Microeconomic Theory (3 credits)",
"AGEC 330 Agriculture and Food Markets (3 credits)",
"AGEC 332 Farm Management and Finance (3 credits)",
"AGEC 333 Resource Economics (3 credits)",
"AGEC 425 Applied Econometrics (3 credits)",
"AGEC 430 Agriculture Food and Resource Policy (3 credits)",
"AGEC 442 Economics of International Agricultural Development (3 credits)",
"AGEC 450 Agribusiness Management (3 credits)",
"AGEC 491 Research & Methodology (3 credits)",
"AGEC 492 Special Topics in Agricultural Economics 01 (3 credits)",
"AGEC 630 Food and Agricultural Policy (3 credits)",
"AGEC 633 Environmental and Natural Resource Economics (3 credits)",
"AGEC 642 Economics of Agricultural Development (3 credits)",
"AGEC 685 Selected Topics in Agricultural Economics (3 credits)",
"AGEC 690 Seminar in Agricultural Economics (3 credits)",
"AGEC 691 M.Sc. Thesis 1 (3 credits)",
"AGEC 692 M.Sc. Thesis 2 (3 credits)",
"AGEC 693 M.Sc. Thesis 3 (6 credits)",
"AGEC 694 M.Sc. Thesis 4 (6 credits)",
"AGEC 695 M.Sc. Thesis 5 (6 credits)",
"AGRI 120 Exobiospheres (3 credits)",
"AGRI 195 Freshman Seminar 1 (0.5 credits)",
"AGRI 196 Freshman Seminar 2 (0.5 credits)",
"AGRI 210 Agro-Ecological History (3 credits)",
"AGRI 215 Agro-Ecosystems Field Course (3 credits)",
"AGRI 310 Internship in Agriculture/Environment (3 credits)",
"AGRI 325 Sustainable Agriculture and Food Security (3 credits)",
"AGRI 330 Agricultural Legislation (1 credit)",
"AGRI 340 Principles of Ecological Agriculture (3 credits)",
"AGRI 410D1 Agrology Internship (3 credits)",
"AGRI 410D2 Agrology Internship (3 credits)",
"AGRI 411 Global Issues on Development Food and Agriculture (3 credits)",
"AGRI 430 Professional Practice in Agrology (2 credits)",
"AGRI 435 Soil and Water Quality Management (3 credits)",
"AGRI 452 Water Resources in Barbados (3 credits)",
"AGRI 490 Agri-Food Industry Project (3 credits)",
"AGRI 493 International Project Management (3 credits)",
"AGRI 498 Agricultural Development Research (3 credits)",
"AGRI 499 Agricultural Development Internship (3 credits)",
"AGRI 510 Professional Practice (3 credits)",
"AGRI 519 Sustainable Development Plans (6 credits)",
"AGRI 550 Sustained Tropical Agriculture (3 credits)",
"ANAE 301 TCP Anesthesia (2 credits)",
"ANAT 212 Molecular Mechanisms of Cell Function (3 credits)",
"ANAT 214 Systemic Human Anatomy (3 credits)",
"ANAT 261 Introduction to Dynamic Histology (4 credits)",
"ANAT 262 Introductory Molecular and Cell Biology (3 credits)",
"ANAT 314 Human Musculoskeletal Anatomy (3 credits)",
"ANAT 315 Clinical Human Musculoskeletal Anatomy (3 credits)",
"ANAT 316 Clinical Human Visceral Anatomy (3 credits)",
"ANAT 321 Circuitry of the Human Brain (3 credits)",
"ANAT 322 Neuroendocrinology (3 credits)",
"ANAT 323 Clinical Neuroanatomy (3 credits)",
"ANAT 365 Cellular Trafficking (3 credits)",
"ANAT 381 Experimental Embryology (3 credits)",
"ANAT 396 Undergraduate Research Project (3 credits)",
"ANAT 416 Development Disease and Regeneration (3 credits)",
"ANAT 432 Honours Research Project (9 credits)",
"ANAT 432D1 Honours Research Project (4.5 credits)",
"ANAT 432D2 Honours Research Project (4.5 credits)",
"ANAT 458 Membranes and Cellular Signaling (3 credits)",
"ANAT 499 Supervised Library Research (1 credit)",
"ANAT 514 Advanced Human Anatomy Laboratory (3 credits)",
"ANAT 541 Cell and Molecular Biology of Aging (3 credits)",
"ANAT 542 Transmission Electron Microscopy of Biological Samples (3 credits)",
"ANAT 565 Diseases-Membrane Trafficking (3 credits)",
"ANAT 601 MSc Seminar Examination (3 credits)",
"ANAT 663D1 Histology (3 credits)",
"ANAT 663D2 Histology (3 credits)",
"ANAT 690D1 Cell and Developmental Biology (3 credits)",
"ANAT 690D2 Cell and Developmental Biology (3 credits)",
"ANAT 695 Seminars in Cell Biology 1 (3 credits)",
"ANAT 696 Seminars in Cell Biology 2 (3 credits)",
"ANAT 697 Seminars in Cell Biology 3 (3 credits)",
"ANAT 698 M.Sc. Thesis Research 1 (24 credits)",
"ANAT 698D1 M.Sc. Thesis Research 1 (12 credits)",
"ANAT 698D2 M.Sc. Thesis Research 1 (12 credits)",
"ANAT 701 Ph.D. Comprehensive Examination",
"ANAT 701D1 Ph.D. Comprehensive Examination",
"ANAT 701D2 Ph.D. Comprehensive Examination",
"ANSC 234 Biochemistry 2 (3 credits)",
"ANSC 250 Principles of Animal Science (3 credits)",
"ANSC 251 Comparative Anatomy (3 credits)",
"ANSC 301 Principles of Animal Breeding (3 credits)",
"ANSC 303 Farm Livestock Internship (2 credits)",
"ANSC 312 Animal Health and Disease (3 credits)",
"ANSC 323 Mammalian Physiology (3 credits)",
"ANSC 324 Developmental Biology and Reproduction (3 credits)",
"ANSC 326 Fundamentals of Population Genetics (3 credits)",
"ANSC 350 Food-Borne Pathogens (3 credits)",
"ANSC 400 Eukaryotic Cells and Viruses (3 credits)",
"ANSC 420 Animal Biotechnology (3 credits)",
"ANSC 424 Metabolic Endocrinology (3 credits)",
"ANSC 433 Animal Nutrition and Metabolism (3 credits)",
"ANSC 451 Dairy and Beef Production Management (3 credits)",
"ANSC 455 Special Topics: Animal Science (3 credits)",
"ANSC 458 Swine and Poultry Production (3 credits)",
"ANSC 490 Project (3 credits)",
"ANSC 504 Population Genetics (3 credits)",
"ANSC 530 Experimental Techniques in Nutrition (3 credits)",
"ANSC 551 Carbohydrate and Lipid Metabolism (3 credits)",
"ANSC 552 Protein Metabolism and Nutrition (3 credits)",
"ANSC 555 The Use and Welfare of Animals (3 credits)",
"ANSC 560 Biology of Lactation (3 credits)",
"ANSC 565 Applied Information Systems (3 credits)",
"ANSC 600 Advanced Eukaryotic Cells and Viruses (3 credits)",
"ANSC 604 Advanced Animal Biotechnology (3 credits)",
"ANSC 605 Estimation: Genetic Parameters (3 credits)",
"ANSC 606 Selection Index and Animal Improvement (3 credits)",
"ANSC 611D1 Advanced Reproductive Biology (1.5 credits)",
"ANSC 611D2 Advanced Reproductive Biology (1.5 credits)",
"ANSC 622 Experimental Techniques in Animal Science (3 credits)",
"ANSC 635 Vitamins and Minerals in Nutrition (3 credits)",
"ANSC 636 Analysis - Animal Breeding Research Data (3 credits)",
"ANSC 637 Livestock Breeding Systems (3 credits)",
"ANSC 643 Project 1 (3 credits)",
"ANSC 644 Project 2 (3 credits)",
"ANSC 645 Project 3 (3 credits)",
"ANSC 646 Project 4 (3 credits)",
"ANSC 647 Project 5 (3 credits)",
"ANSC 680 M.Sc. Thesis 1 (9 credits)",
"ANSC 681 M.Sc. Thesis 2 (9 credits)",
"ANSC 682 M.Sc. Thesis 3 (9 credits)",
"ANSC 683 M.Sc. Thesis 4 (9 credits)",
"ANSC 691 Special Topic: Animal Sciences (3 credits)",
"ANSC 692 Topic in Animal Sciences 1 (3 credits)",
"ANSC 695 MSc General Topic Seminar (1 credit)",
"ANSC 696 MSc Research Proposal Seminar (1 credit)",
"ANSC 697 MSc Research Results Seminar (1 credit)",
"ANSC 701 Doctoral Comprehensive Examination",
"ANSC 797 Animal Science Seminar 3 (1 credit)",
"ANSC 798 Animal Science Seminar 4 (1 credit)",
"ANTH 201 Prehistoric Archaeology (3 credits)",
"ANTH 202 Socio-Cultural Anthropology (3 credits)",
"ANTH 203 Human Evolution (3 credits)",
"ANTH 204 Anthropology of Meaning (3 credits)",
"ANTH 206 Environment and Culture (3 credits)",
"ANTH 207 Ethnography Through Film (3 credits)",
"ANTH 208 Evolutionary Anthropology (3 credits)",
"ANTH 209 Anthropology of Religion (3 credits)",
"ANTH 210 Archaeology of Early Cities (3 credits)",
"ANTH 212 Anthropology of Development (3 credits)",
"ANTH 214 Violence Warfare Culture (3 credits)",
"ANTH 222 Legal Anthropology (3 credits)",
"ANTH 227 Medical Anthropology (3 credits)",
"ANTH 301 Nomadic Pastoralists (3 credits)",
"ANTH 302 New Horizons in Medical Anthropology (3 credits)",
"ANTH 303 Ethnographies of Post-socialism (3 credits)",
"ANTH 304 Chinese Culture in Ethnography and Film (3 credits)",
"ANTH 307 Andean Prehistory (3 credits)",
"ANTH 308 Political Anthropology 01 (3 credits)",
"ANTH 311 Primate Behaviour and Ecology (3 credits)",
"ANTH 312 Zooarchaeology (3 credits)",
"ANTH 314 Psychological Anthropology 01 (3 credits)",
"ANTH 315 Society/Culture: East Africa (3 credits)",
"ANTH 317 Prehistory of North America (3 credits)",
"ANTH 318 Globalization and Religion (3 credits)",
"ANTH 319 Inka Archaeology and Ethnohistory (3 credits)",
"ANTH 320 Social Evolution (3 credits)",
"ANTH 322 Social Change in Modern Africa (3 credits)",
"ANTH 323 Anthropology of Things (3 credits)",
"ANTH 325 Anthropology of the Self (3 credits)",
"ANTH 326 Anthropology of Latin America (3 credits)",
"ANTH 327 Anthropology of South Asia (3 credits)",
"ANTH 328 Archaeology East Asian Empires (3 credits)",
"ANTH 329 Modern Chinese Society and Change (3 credits)",
"ANTH 330 Traditional Whaling Societies (3 credits)",
"ANTH 331 Prehistory of East Asia (3 credits)",
"ANTH 332 Mesoamerican Archaeology (3 credits)",
"ANTH 337 Mediterranean Society and Culture (3 credits)",
"ANTH 338 Native Peoples of North America (3 credits)",
"ANTH 339 Ecological Anthropology (3 credits)",
"ANTH 340 Middle Eastern Society and Culture (3 credits)",
"ANTH 341 Women in Cross-cultural Perspective (3 credits)",
"ANTH 342 Gender Inequality and the State (3 credits)",
"ANTH 343 Anthropology and the Animal (3 credits)",
"ANTH 344 Quantitative Approaches to Anthropology (3 credits)",
"ANTH 347 Paleolithic Cultures (3 credits)",
"ANTH 352 History of Anthropological Theory (3 credits)",
"ANTH 355 Theories of Culture and Society (3 credits)",
"ANTH 357 Archaeological Methods (3 credits)",
"ANTH 358 The Process of Anthropological Research (3 credits)",
"ANTH 359 History of Archaeological Theory (3 credits)",
"ANTH 360 Archaeology of Ancient China (3 credits)",
"ANTH 361 Archaeology of South Asia (3 credits)",
"ANTH 365 Anthropology of Forced Migration and Displacement (3 credits)",
"ANTH 370 Anthropology and the Image (3 credits)",
"ANTH 380 Special Topic 1 (3 credits)",
"ANTH 381 Special Topic 2 (3 credits)",
"ANTH 399 Archaeology of Japan and Korea (3 credits)",
"ANTH 401 Comparative Anthropology (3 credits)",
"ANTH 402 Topics in Ethnography (3 credits)",
"ANTH 403 Current Issues in Archaeology (3 credits)",
"ANTH 406 Great Debates in Ethnography (3 credits)",
"ANTH 407 Anthropology of the Body (3 credits)",
"ANTH 408 Sensory Ethnography (3 credits)",
"ANTH 410 Great Debates in Anthropological Theory (3 credits)",
"ANTH 411 Primate Studies & Conservation (3 credits)",
"ANTH 412 Topics: Anthropological Theory (3 credits)",
"ANTH 413 Gender in Archaeology (3 credits)",
"ANTH 416 Environment/Development: Africa (3 credits)",
"ANTH 418 Environment and Development (3 credits)",
"ANTH 419 Archaeology of Hunter-Gatherers (3 credits)",
"ANTH 422 Contemporary Latin American Culture and Society (3 credits)",
"ANTH 423 Mind Brain and Psychopathology (3 credits)",
"ANTH 426 Immigration and Culture (3 credits)",
"ANTH 428 Saints and Mediation in Latin America (3 credits)",
"ANTH 436 North American Native Peoples (3 credits)",
"ANTH 437 Historical Archaeology (3 credits)",
"ANTH 438 Topics in Medical Anthropology (3 credits)",
"ANTH 440 Cognitive Anthropology (3 credits)",
"ANTH 443 Medical Anthropological Theory (3 credits)",
"ANTH 450 Archaeology of Landscape (3 credits)",
"ANTH 451 Research in Society and Development in Africa (3 credits)",
"ANTH 458 Archaeology of the Silk Roads (3 credits)",
"ANTH 460 Archaeological Field Studies (3 credits)",
"ANTH 461 Research Techniques (3 credits)",
"ANTH 480 Special Topic 5 (3 credits)",
"ANTH 481 Special Topic 6 (3 credits)",
"ANTH 490 Honours Thesis (6 credits)",
"ANTH 490D1 Honours Thesis (3 credits)",
"ANTH 490D2 Honours Thesis (3 credits)",
"ANTH 490N1 Honours Thesis (3 credits)",
"ANTH 490N2 Honours Thesis (3 credits)",
"ANTH 491 Joint Honours Thesis (3 credits)",
"ANTH 499 Internship: Anthropology (3 credits)",
"ANTH 500 Chinese Diversity and Diaspora (3 credits)",
"ANTH 501 Anthropology Beyond the Human (3 credits)",
"ANTH 502 Social Life of Death (3 credits)",
"ANTH 503 Production of the Past (3 credits)",
"ANTH 504 Environmental Archaeology (3 credits)",
"ANTH 505 Current Advances in Archaeological Theory (3 credits)",
"ANTH 510 Advanced Problems in Anthropology of Religion (3 credits)",
"ANTH 511 Computational Approaches to Prehistory (3 credits)",
"ANTH 512 Political Ecology (3 credits)",
"ANTH 513 The Poetry of Anthropology (3 credits)",
"ANTH 515 The Archaeology of Politics (3 credits)",
"ANTH 522 Issues in Biological Anthropology (3 credits)",
"ANTH 540 Topics in Anthropological Theory (3 credits)",
"ANTH 551 Advanced Topics: Archaeological Research (3 credits)",
"ANTH 555 Advanced Topics in Ethnology (3 credits)",
"ANTH 575 Concepts of Race (3 credits)",
"ANTH 602 Theory 1 (3 credits)",
"ANTH 602D1 Theory 1 (1.5 credits)",
"ANTH 602D2 Theory 1 (1.5 credits)",
"ANTH 603 Theory 2 (3 credits)",
"ANTH 603D1 Theory 2 (1.5 credits)",
"ANTH 603D2 Theory 2 (1.5 credits)",
"ANTH 605 Culture Area (3 credits)",
"ANTH 607D1 Proseminar in Archaeology (3 credits)",
"ANTH 607D2 Proseminar in Archaeology (3 credits)",
"ANTH 609 Proseminar in Anthropology (6 credits)",
"ANTH 609D1 Proseminar in Anthropology (3 credits)",
"ANTH 609D2 Proseminar in Anthropology (3 credits)",
"ANTH 610 Social Organization (3 credits)",
"ANTH 611 Research Design (3 credits)",
"ANTH 614 Economic Anthropology 1 (3 credits)",
"ANTH 614D1 Economic Anthropology 1 (1.5 credits)",
"ANTH 614D2 Economic Anthropology 1 (1.5 credits)",
"ANTH 615 Seminar in Medical Anthropology (3 credits)",
"ANTH 615D1 Seminar in Medical Anthropology (1.5 credits)",
"ANTH 615D2 Seminar in Medical Anthropology (1.5 credits)",
"ANTH 616 Political Anthropology 1 (3 credits)",
"ANTH 616D1 Political Anthropology 1 (1.5 credits)",
"ANTH 616D2 Political Anthropology 1 (1.5 credits)",
"ANTH 631 Symbolic Anthropology 1 (3 credits)",
"ANTH 631D1 Symbolic Anthropology 1 (1.5 credits)",
"ANTH 631D2 Symbolic Anthropology 1 (1.5 credits)",
"ANTH 634 Anthropology of Development 1 (3 credits)",
"ANTH 634D1 Anthropology of Development 1 (1.5 credits)",
"ANTH 634D2 Anthropology of Development 1 (1.5 credits)",
"ANTH 635 Anthropology of Development 2 (3 credits)",
"ANTH 635D1 Anthropology of Development 2 (1.5 credits)",
"ANTH 635D2 Anthropology of Development 2 (1.5 credits)",
"ANTH 640 Psychological Anthropology 1 (3 credits)",
"ANTH 645 Anthropology Mind & Brain (3 credits)",
"ANTH 648 Structural Anthropology (3 credits)",
"ANTH 648D1 Structural Anthropology (1.5 credits)",
"ANTH 648D2 Structural Anthropology (1.5 credits)",
"ANTH 650 Archaeology of Northern China: Post-Han (3 credits)",
"ANTH 660 Research Methods (3 credits)",
"ANTH 665 Quantitative Methods (3 credits)",
"ANTH 670 Archaeological Theory 1 (3 credits)",
"ANTH 670D1 Archaeological Theory 1 (1.5 credits)",
"ANTH 670D2 Archaeological Theory 1 (1.5 credits)",
"ANTH 671 Archaeological Theory 2 (3 credits)",
"ANTH 671D1 Archaeological Theory 2 (1.5 credits)",
"ANTH 671D2 Archaeological Theory 2 (1.5 credits)",
"ANTH 673 Archaeological Field Methods (3 credits)",
"ANTH 678 Ethnohistory (3 credits)",
"ANTH 680 Tutorial Reading 1 (3 credits)",
"ANTH 680D1 Tutorial Reading 1 (1.5 credits)",
"ANTH 680D2 Tutorial Reading 1 (1.5 credits)",
"ANTH 681 Tutorial Reading 2 (3 credits)",
"ANTH 682 Tutorial Reading 3 (3 credits)",
"ANTH 684 Tutorial Reading 5 (3 credits)",
"ANTH 684D1 Tutorial Reading 5 (1.5 credits)",
"ANTH 684D2 Tutorial Reading 5 (1.5 credits)",
"ANTH 685 Research Tutorial 1 (3 credits)",
"ANTH 686 Research Tutorial 2 (3 credits)",
"ANTH 694 M.A. Thesis Tutorial 1 (6 credits)",
"ANTH 695 M.A. Thesis Tutorial 2 (6 credits)",
"ANTH 699 M.A. Thesis (21 credits)",
"ANTH 699D1 M.A. Thesis (10.5 credits)",
"ANTH 699D2 M.A. Thesis (10.5 credits)",
"ANTH 700 Ph.D. Preliminary Examination",
"ANTH 700D1 Ph.D. Preliminary Examination",
"ANTH 700D2 Ph.D. Preliminary Examination",
"ANTH 701 PhD Comprehensive Examination",
"ANTH 702 PhD Proposal Defence",
"ANTH 760 Advanced Anthropological Methods (3 credits)",
"ANTH 770 Advanced Archaeological Theory (3 credits)",
"ANTH 780 Reading and Research 1 (3 credits)",
"ANTH 780D1 Reading and Research 1 (1.5 credits)",
"ANTH 780D2 Reading and Research 1 (1.5 credits)",
"ANTH 781 Reading and Research 2 (3 credits)",
"ANTH 790 Ph.D. Tutorial 1 (3 credits)",
"ANTH 790D1 Ph.D. Tutorial 1 (1.5 credits)",
"ANTH 790D2 Ph.D. Tutorial 1 (1.5 credits)",
"ANTH 790N1 Ph.D. Tutorial 1 (1.5 credits)",
"ANTH 790N2 Ph.D. Tutorial 1 (1.5 credits)",
"ANTH 791 Ph.D. Tutorial 2 (3 credits)",
"ANTH 791D1 Ph.D. Tutorial 2 (1.5 credits)",
"ANTH 791D2 Ph.D. Tutorial 2 (1.5 credits)",
"ANTH 791N1 Ph.D. Tutorial 2 (1.5 credits)",
"ANTH 791N2 Ph.D. Tutorial 2 (1.5 credits)",
"ANTH 792 Ph.D. Tutorial 3 (3 credits)",
"ANTH 792D1 Ph.D. Tutorial 3 (1.5 credits)",
"ANTH 792D2 Ph.D. Tutorial 3 (1.5 credits)",
"ANTH 792N1 Ph.D. Tutorial 3 (1.5 credits)",
"ANTH 792N2 Ph.D. Tutorial 3 (1.5 credits)",
"ARCH 201 Communication Behaviour and Architecture (6 credits)",
"ARCH 202 Architectural Graphics and Elements of Design (6 credits)",
"ARCH 217 Freehand Drawing (1 credit)",
"ARCH 218 Freehand Drawing 2 (1 credit)",
"ARCH 221 Architectural Drawing (2 credits)",
"ARCH 240 Organization of Materials in Buildings (3 credits)",
"ARCH 241 Architectural Structures 1 (3 credits)",
"ARCH 250 Architectural History 1 (3 credits)",
"ARCH 251 Architectural History 2 (3 credits)",
"ARCH 303 Design and Construction 1 (6 credits)",
"ARCH 304 Design and Construction 2 (6 credits)",
"ARCH 321 Freehand Drawing 3 (1 credit)",
"ARCH 322 Freehand Drawing 4 (1 credit)",
"ARCH 324 Sketching School (1 credit)",
"ARCH 325 Architectural Sketching (2 credits)",
"ARCH 342 Digital Representation (3 credits)",
"ARCH 354 Architectural History 3 (3 credits)",
"ARCH 355 Architectural History 4 (3 credits)",
"ARCH 375 Landscape (3 credits)",
"ARCH 377 Energy Environment and Buildings 1 (3 credits)",
"ARCH 378 Introduction to Building Environments (3 credits)",
"ARCH 379 Summer Course Abroad (3 credits)",
"ARCH 383 Geometry and Architecture (3 credits)",
"ARCH 388 Introduction to Historic Preservation (2 credits)",
"ARCH 405 Design and Construction 3 (6 credits)",
"ARCH 406 Design and Construction 4 (6 credits)",
"ARCH 410 Design and Construction 5 (6 credits)",
"ARCH 445 Architectural Structures 2 (3 credits)",
"ARCH 447 Energy Environment and Buildings 2 (3 credits)",
"ARCH 451 Building Regulations and Safety (3 credits)",
"ARCH 461 Freehand Drawing and Sketching (1 credit)",
"ARCH 490 Selected Topics in Design (2 credits)",
"ARCH 491 Selected Topics in Landscape Studies (2 credits)",
"ARCH 492 Selected Topics in Professional Practice (2 credits)",
"ARCH 500 Internship in Architecture",
"ARCH 512 Architectural Modelling (3 credits)",
"ARCH 514 Community Design Workshop (4 credits)",
"ARCH 515 Sustainable Design (3 credits)",
"ARCH 517 Sustainable Residential Development (3 credits)",
"ARCH 519 Field Course Abroad (3 credits)",
"ARCH 520 Montreal: Urban Morphology (3 credits)",
"ARCH 521 Structure of Cities (3 credits)",
"ARCH 523 Significant Texts and Buildings (3 credits)",
"ARCH 525 Seminar on Analysis and Theory (3 credits)",
"ARCH 526 Philosophy of Structure (3 credits)",
"ARCH 527 Civic Design (3 credits)",
"ARCH 528 History of Housing (3 credits)",
"ARCH 529 Housing Theory (3 credits)",
"ARCH 531 Architectural Intentions Vitruvius - Renaissance (3 credits)",
"ARCH 532 Origins of Modern Architecture (3 credits)",
"ARCH 533 New Approaches to Architectural History (3 credits)",
"ARCH 535 History of Architecture in Canada (3 credits)",
"ARCH 536 Heritage Conservation (3 credits)",
"ARCH 540 Selected Topics in Architecture 1 (3 credits)",
"ARCH 541 Selected Topics in Architecture 2 (3 credits)",
"ARCH 542 Selected Topics in Architecture 3 (3 credits)",
"ARCH 543 Selected Topics in Architecture 4 (3 credits)",
"ARCH 551 Urban Design and Planning (3 credits)",
"ARCH 562 Innovative Homes and Communities (3 credits)",
"ARCH 564 Design for Development (3 credits)",
"ARCH 566 Cultural Landscapes Seminar (3 credits)",
"ARCH 600 Advanced Internship in Architecture",
"ARCH 602 Housing Seminar (3 credits)",
"ARCH 603 Urban Design and Housing Studio (6 credits)",
"ARCH 604 Urban Design Seminar (3 credits)",
"ARCH 622 Research Methods for Architecture (4 credits)",
"ARCH 623 Project Preparation (3 credits)",
"ARCH 624 History and Theory Project (15 credits)",
"ARCH 626 Critical Design Strategies (4 credits)",
"ARCH 627 Research Methods (3 credits)",
"ARCH 628 Housing Project Report (15 credits)",
"ARCH 629 Cultural Mediations and Technology Research Report (15 credits)",
"ARCH 632 Urban Design and Housing Research Report (15 credits)",
"ARCH 635 Selected Topics in Housing 1 (3 credits)",
"ARCH 636 Selected Topics in Housing 2 (3 credits)",
"ARCH 641 Energy and Environments 1 (3 credits)",
"ARCH 642 Energy and Environments 2 (3 credits)",
"ARCH 645 Housing Project 1 (6 credits)",
"ARCH 646 Housing Project 2 (6 credits)",
"ARCH 647 Cultural Mediations and Technology Studio (6 credits)",
"ARCH 651 Architectural History and Theory Seminar 1 (6 credits)",
"ARCH 652 Architectural History and Theory Seminar 2 (4 credits)",
"ARCH 652D1 Architectural History and Theory Seminar 2 (2 credits)",
"ARCH 652D2 Architectural History and Theory Seminar 2 (2 credits)",
"ARCH 653 Architectural History and Theory Seminar 3 (4 credits)",
"ARCH 654 Architectural History and Theory Seminar 4 (6 credits)",
"ARCH 670 Advanced Landscape Theory (3 credits)",
"ARCH 671 Design Research and Methodology (6 credits)",
"ARCH 672 Architectural Design Studio 1 (9 credits)",
"ARCH 673 Architectural Design Studio 2 (9 credits)",
"ARCH 674 Professional Practice 1 (3 credits)",
"ARCH 675 Architecture in Global Perspective (3 credits)",
"ARCH 676 Advanced Architectural Design (9 credits)",
"ARCH 677 Architectural Design 3 (9 credits)",
"ARCH 678 Advanced Construction (3 credits)",
"ARCH 679 Writing in Architecture (3 credits)",
"ARCH 680 Field Sketching (2 credits)",
"ARCH 681 Directed Research Project Preparation (1 credit)",
"ARCH 683 Directed Research Project (9 credits)",
"ARCH 684 Contemporary Theory 1 (4 credits)",
"ARCH 685 Contemporary Theory 2 (4 credits)",
"ARCH 688 Directed Research 1 (3 credits)",
"ARCH 689 Directed Research 2 (3 credits)",
"ARCH 700 Thesis Proposal",
"ARCH 701 Comprehensive Examination",
"ARCH 702 Dissertation Report 1",
"ARCH 703 Dissertation Report 2",
"ARCH 711 Doctoral Proseminar 1 (3 credits)",
"ARCH 712 Doctoral Proseminar 2 (3 credits)",
"ARCH 721 Literature Review 1 (3 credits)",
"ARCH 722 Literature Review 2 (3 credits)",
"ARCH 723 Literature Review 3 (3 credits)",
"ARTH 199 FYS: Themes in Art History (3 credits)",
"ARTH 200 Introduction to Art History 1 (3 credits)",
"ARTH 202 Introduction to Contemporary Art (3 credits)",
"ARTH 204 Introduction to Medieval Art and Architecture (3 credits)",
"ARTH 205 Introduction to Modern Art (3 credits)",
"ARTH 207 Introduction Early Modern Art 1400-1700 (3 credits)",
"ARTH 209 Introduction to Ancient Art and Architecture (3 credits)",
"ARTH 215 Introduction to East Asian Art (3 credits)",
"ARTH 223 Introduction Italian Renaissance Art 1300-1500 (3 credits)",
"ARTH 225 Introduction to Seventeenth - Century Art (3 credits)",
"ARTH 226 Introduction to Eighteenth-Century Art and Architecture (3 credits)",
"ARTH 300 Canadian Art to 1914 (3 credits)",
"ARTH 302 Aspects of Canadian Art (3 credits)",
"ARTH 305 Methods in Art History (3 credits)",
"ARTH 310 Postcolonialism (3 credits)",
"ARTH 314 The Medieval City (3 credits)",
"ARTH 315 Indigenous Art and Culture (3 credits)",
"ARTH 321 Visual Culture of the Dutch Republic (3 credits)",
"ARTH 323 Realism and Impressionism (3 credits)",
"ARTH 324 Sixteenth-Century Art in Italy (3 credits)",
"ARTH 325 Visual Culture Renaissance Venice (3 credits)",
"ARTH 326 Studies in Manuscript and Print Culture (3 credits)",
"ARTH 334 Eighteenth Century European Art (3 credits)",
"ARTH 335 Art in the Age of Revolution (3 credits)",
"ARTH 336 Art Now (3 credits)",
"ARTH 337 Modern Art and Theory to WWI (3 credits)",
"ARTH 338 Modern Art and Theory: WWI - WWII (3 credits)",
"ARTH 339 Critical Issues - Contemporary Art (3 credits)",
"ARTH 340 The Gothic Cathedral (3 credits)",
"ARTH 351 Vision and Visuality in Art History (3 credits)",
"ARTH 352 Feminism in Art and Art History (3 credits)",
"ARTH 353 Selected Topics in Art History 1 (3 credits)",
"ARTH 354 Selected Topics Art History 2 (3 credits)",
"ARTH 356 Modern & Contemporary Chinese Art (3 credits)",
"ARTH 357 Early Chinese Art (3 credits)",
"ARTH 358 Later Chinese Art (960-1911) (3 credits)",
"ARTH 360 Studies in the Photographic (3 credits)",
"ARTH 366 Italian Renaissance Art 1 (3 credits)",
"ARTH 367 Italian Renaissance Art 2 (3 credits)",
"ARTH 368 Studies in Northern Renaissance Art 01 (3 credits)",
"ARTH 400 Selected Methods in Art History (3 credits)",
"ARTH 401 Honours Research Paper (3 credits)",
"ARTH 411 Canadian Art and Race (3 credits)",
"ARTH 420 Selected Topics in Art and Architecture 1 (3 credits)",
"ARTH 421 Selected Topics in Art and Architecture 2 (3 credits)",
"ARTH 422 Selected Topics in Art and Architecture 3 (3 credits)",
"ARTH 425 Arts of Medieval Spain (3 credits)",
"ARTH 430 Concepts - Discipline Art History (3 credits)",
"ARTH 435 Early Modern Visual Culture (3 credits)",
"ARTH 440 The Body and Visual Culture (3 credits)",
"ARTH 447 Independent Research Course (3 credits)",
"ARTH 457 Brushwork in Chinese Painting (3 credits)",
"ARTH 466 Studies in Italian Renaissance Art 01 (3 credits)",
"ARTH 473 Studies in 17th and Early 18th Century Art 04 (3 credits)",
"ARTH 474 Studies in Later 18th and 19th Century Art 03 (3 credits)",
"ARTH 479 Studies: Modern Art and Theoretical Problems 04 (3 credits)",
"ARTH 490 Museum Internship (3 credits)",
"ARTH 501 Advanced Topics in Art History and Visual Culture (3 credits)",
"ARTH 502 Advanced Topics in Art and Architectural History (3 credits)",
"ARTH 600 Advanced Professional Seminar (3 credits)",
"ARTH 606 Research Paper Preparation (3 credits)",
"ARTH 607 Research Paper Proposal (3 credits)",
"ARTH 608 Research Paper 1 (6 credits)",
"ARTH 609 Research Paper 2 (6 credits)",
"ARTH 617 Modern Art (3 credits)",
"ARTH 618 Art History - 1400-1900 1 (3 credits)",
"ARTH 630 Directed Reading 1 (3 credits)",
"ARTH 645 Medieval Art and Archaeology (3 credits)",
"ARTH 646 Topics: Chinese Visual Culture (3 credits)",
"ARTH 647 Topics: Renaissance Art & Architecture 1 (3 credits)",
"ARTH 648 Topics: Renaissance Art & Architecture 2 (3 credits)",
"ARTH 653 Topics: Early Modern Visual Culture 1 (3 credits)",
"ARTH 654 Topics: Early Modern Visual Culture 2 (3 credits)",
"ARTH 658 19th Century Painting and Sculpture (3 credits)",
"ARTH 660 Contemporary Art & Criticism 1 (3 credits)",
"ARTH 661 Contemporary Art & Criticism 2 (3 credits)",
"ARTH 673 Topics: 18th - Century Art & Architecture 1 (3 credits)",
"ARTH 675 Topics: 19th - Century Art & Architecture 1 (3 credits)",
"ARTH 678 Topics: 19th - Century Art & Architecture 2 (3 credits)",
"ARTH 687 Topics: Canadian Art & Visual Culture 2 (3 credits)",
"ARTH 698 Thesis Research 1 (12 credits)",
"ARTH 699 Thesis Research 2 (12 credits)",
"ARTH 701 Ph.D. Comprehensive Examination",
"ARTH 701D1 Ph.D. Comprehensive Examination",
"ARTH 701D2 Ph.D. Comprehensive Examination",
"ARTH 701N1 Ph.D. Comprehensive Examination",
"ARTH 701N2 Ph.D. Comprehensive Examination",
"ARTH 714 Directed Reading 2 (3 credits)",
"ARTH 715 Research: Modern Architecture - 1750 to Present 1 (3 credits)",
"ARTH 719 Seminar in Urban Planning and Topography 3 (3 credits)",
"ARTH 723 Art Criticism 1 (3 credits)",
"ARTH 724 Art Criticism 2 (3 credits)",
"ARTH 725 Methods in Art History 1 (3 credits)",
"ARTH 730 Current Problems in Art History 1 (3 credits)",
"ARTH 731 Current Problems in Art History 2 (3 credits)",
"ASPL 613 Government Regulation of Air Transport (3 credits)",
"ASPL 614 Airline Business and Law (3 credits)",
"ASPL 632 Comparative Air Law (3 credits)",
"ASPL 632D1 Comparative Air Law (1.5 credits)",
"ASPL 632D2 Comparative Air Law (1.5 credits)",
"ASPL 633 Public International Air Law (3 credits)",
"ASPL 636 Private International Air Law (3 credits)",
"ASPL 637 Space Law: General Principles (3 credits)",
"ASPL 638 Law of Space Applications (3 credits)",
"ASPL 639 Government Regulation of Space Activities (3 credits)",
"ASPL 655 Research Project 1 (15 credits)",
"ASPL 656 Research Project 2 (2 credits)",
"ASPL 657 Research Project 3 (1 credit)",
"ASPL 690 Master's Thesis 1 (3 credits)",
"ASPL 691 Master's Thesis 2 (3 credits)",
"ASPL 692 Master's Thesis 3 (6 credits)",
"ASPL 693 Master's Thesis 4 (12 credits)",
"ASPL 694 Master's Thesis 5 (3 credits)",
"ASPL 701 Comprehensive - Air/Space Law",
"ATOC 100 Extreme-Weather and Climate-Change Physics (3 credits)",
"ATOC 181 Introduction to Atmospheric Science (3 credits)",
"ATOC 182 Introduction to Oceanic Sciences (3 credits)",
"ATOC 183 Climate and Climate Change (3 credits)",
"ATOC 184 Science of Storms (3 credits)",
"ATOC 185 Natural Disasters (3 credits)",
"ATOC 214 Introduction: Physics of the Atmosphere (3 credits)",
"ATOC 215 Oceans Weather and Climate (3 credits)",
"ATOC 219 Introduction to Atmospheric Chemistry (3 credits)",
"ATOC 309 Weather Radars and Satellites (3 credits)",
"ATOC 312 Rotating Fluid Dynamics (3 credits)",
"ATOC 315 Thermodynamics and Convection (3 credits)",
"ATOC 357 Atmospheric and Oceanic Science Laboratory (3 credits)",
"ATOC 373 Arctic Climate and Climate Change (3 credits)",
"ATOC 396 Undergraduate Research Project (3 credits)",
"ATOC 400 Independent Study of an Environmental Problem (3 credits)",
"ATOC 404 Climate Physics (3 credits)",
"ATOC 473 Artic Field Research (6 credits)",
"ATOC 480 Honours Research Project (3 credits)",
"ATOC 512 Atmospheric and Oceanic Dynamics (3 credits)",
"ATOC 513 Waves and Stability (3 credits)",
"ATOC 515 Turbulence in Atmosphere and Oceans (3 credits)",
"ATOC 519 Advances in Chemistry of Atmosphere (3 credits)",
"ATOC 521 Cloud Physics (3 credits)",
"ATOC 525 Atmospheric Radiation (3 credits)",
"ATOC 530 Paleoclimate Dynamics (3 credits)",
"ATOC 531 Dynamics of Current Climates (3 credits)",
"ATOC 540 Synoptic Meteorology 1 (3 credits)",
"ATOC 541 Synoptic Meteorology 2 (3 credits)",
"ATOC 546 Current Weather Discussion (1 credit)",
"ATOC 548 Mesoscale Meteorology (3 credits)",
"ATOC 550 Special Topics Meteorology and Oceanography (1 credit)",
"ATOC 551 Selected Topics 1 (3 credits)",
"ATOC 552 Selected Topics 2 (3 credits)",
"ATOC 555 Field Course 1 (3 credits)",
"ATOC 556 Field Course 2 (3 credits)",
"ATOC 557 Research Methods: Atmospheric and Oceanic Science (3 credits)",
"ATOC 558 Numerical Methods and Laboratory (3 credits)",
"ATOC 568 Ocean Physics (3 credits)",
"ATOC 616 Topics - Geophysical Fluid Dynamics (3 credits)",
"ATOC 626 Atmospheric/Oceanic Remote Sensing (3 credits)",
"ATOC 666 Topics In Ocean Circulation (3 credits)",
"ATOC 669D1 CSE Seminar (0.5 credits)",
"ATOC 669D2 CSE Seminar (0.5 credits)",
"ATOC 670 Reading Course: Meteorology 1 (3 credits)",
"ATOC 671 Reading Course: Meteorology 2 (3 credits)",
"ATOC 672 Reading Course: Oceanography 1 (3 credits)",
"ATOC 691 Master's Thesis Literature Review (3 credits)",
"ATOC 692 Master's Thesis Research 1 (6 credits)",
"ATOC 692N1 Master's Thesis Research 1 (3 credits)",
"ATOC 692N2 Master's Thesis Research 1 (3 credits)",
"ATOC 693 Master's Thesis Research 2 (6 credits)",
"ATOC 693N1 Master's Thesis Research 2 (3 credits)",
"ATOC 693N2 Master's Thesis Research 2 (3 credits)",
"ATOC 694 Master's Thesis Progress Report and Seminar (3 credits)",
"ATOC 695 Master's Thesis Research 3 (6 credits)",
"ATOC 696 Master's Thesis Research 4 (6 credits)",
"ATOC 699 Master's Thesis (12 credits)",
"ATOC 699N1 Master's Thesis (6 credits)",
"ATOC 699N2 Master's Thesis (6 credits)",
"ATOC 700 Ph.D. Proposal Seminar (1 credit)",
"ATOC 701 Ph.D. Comprehensive (General)",
"ATOC 701D1 Ph.D. Comprehensive (General)",
"ATOC 701D2 Ph.D. Comprehensive (General)",
"ATOC 751 Seminar: Physical Meteorology (1 credit)",
"ATOC 751D1 Seminar: Physical Meteorology (0.5 credits)",
"ATOC 751D2 Seminar: Physical Meteorology (0.5 credits)",
"ATOC 752D1 Atmospheric Oceanic and Climate Dynamics (0.5 credits)",
"ATOC 752D2 Atmospheric Oceanic and Climate Dynamics (0.5 credits)",
"BASC 201 Arts & Science Integrative Topics (3 credits)",
"BASC 396 Undergraduate Research Project (3 credits)",
"BASC 449 Integrative Research Project (6 credits)",
"BASC 449D1 Integrative Research Project (3 credits)",
"BASC 449D2 Integrative Research Project (3 credits)",
"BASC 449N1 Integrative Research Project (3 credits)",
"BASC 449N2 Integrative Research Project (3 credits)",
"BBME 600D1 Seminars in Biological and Biomedical Engineering (1.5 credits)",
"BBME 600D2 Seminars in Biological and Biomedical Engineering (1.5 credits)",
"BBME 600N1 Seminars in Biological and Biomedical Engineering (1.5 credits)",
"BBME 600N2 Seminars in Biological and Biomedical Engineering (1.5 credits)",
"BBME 693 Thesis Research 1 (6 credits)",
"BBME 694 Thesis Research 2 (6 credits)",
"BBME 695 Thesis Submission (12 credits)",
"BBME 696 Thesis Research 3 (3 credits)",
"BBME 697 Thesis Research 4 (3 credits)",
"BBME 701 Ph.D. Comprehensive Examination",
"BIEN 200 Introduction to Bioengineering (2 credits)",
"BIEN 210 Electrical and Optical Properties of Biological Systems (3 credits)",
"BIEN 219 Introduction to Physical Molecular and Cell Biology (4 credits)",
"BIEN 290 Bioengineering Measurement Laboratory (3 credits)",
"BIEN 300 Thermodynamics in Bioengineering (3 credits)",
"BIEN 310 Introduction to Biomolecular Engineering (3 credits)",
"BIEN 314 Transport Phenomena in Biological Systems 1 (3 credits)",
"BIEN 320 Molecular Cellular and Tissue Biomechanics (3 credits)",
"BIEN 330 Tissue Engineering and Regenerative Medicine (3 credits)",
"BIEN 340 Transport Phenomena in Biological Systems 2 (3 credits)",
"BIEN 350 Biosignals Systems and Control (4 credits)",
"BIEN 360 Physical Chemistry in Bioengineering (3 credits)",
"BIEN 390 Bioengineering Laboratory (3 credits)",
"BIEN 410 Computational Methods in Biomolecular Engineering (3 credits)",
"BIEN 420 Biodevices Design for Diagnostics and Screening (3 credits)",
"BIEN 462 Engineering Principles in Physiological Systems (3 credits)",
"BIEN 470 Bioengineering Design Project (6 credits)",
"BIEN 470D1 Bioengineering Design Project (3 credits)",
"BIEN 470D2 Bioengineering Design Project (3 credits)",
"BIEN 470N1 Bioengineering Design Project (3 credits)",
"BIEN 470N2 Bioengineering Design Project (3 credits)",
"BIEN 471 Bioengineering Research Project (2 credits)",
"BIEN 500 Special Topics in Bioengineering 1 (3 credits)",
"BIEN 510 Engineered Nanomaterials for Biomedical Applications (3 credits)",
"BIEN 515 Special Topics in Bioengineering 2 (3 credits)",
"BIEN 520 High Throughput Bioanalytical Devices (3 credits)",
"BIEN 525 Special Topics in Bioengineering 3 (3 credits)",
"BIEN 530 Imaging and Bioanalytical Instrumentation (3 credits)",
"BIEN 540 Information Storage and Processing in Biological Systems (3 credits)",
"BIEN 550 Biomolecular Devices (3 credits)",
"BIEN 560 Design of Biosensors (3 credits)",
"BIEN 570 Active Mechanics in Biology (3 credits)",
"BIEN 580 Synthetic Biology (3 credits)",
"BIEN 590 Cell Culture Engineering (3 credits)",
"BIEN 680 Bioprocessing of Vaccines (4 credits)",
"BINF 301 Introduction to Bioinformatics (3 credits)",
"BINF 511 Bioinformatics for Genomics (3 credits)",
"BINF 531 Statistical Bioinformatics (3 credits)",
"BINF 621 Bioinformatics: Molecular Biology (3 credits)",
"BINF 660 Advances in Bioinformatics (3 credits)",
"BIOC 212 Molecular Mechanisms of Cell Function (3 credits)",
"BIOC 220 Laboratory Methods in Biochemistry and Molecular Biology 1 (3 credits)",
"BIOC 300D1 Laboratory in Biochemistry (3 credits)",
"BIOC 300D2 Laboratory in Biochemistry (3 credits)",
"BIOC 311 Metabolic Biochemistry (3 credits)",
"BIOC 312 Biochemistry of Macromolecules (3 credits)",
"BIOC 320 Laboratory Methods in Biochemistry and Molecular Biology 2 (3 credits)",
"BIOC 396 Undergraduate Research Project (3 credits)",
"BIOC 404 Biophysical Methods in Biochemistry (3 credits)",
"BIOC 450 Protein Structure and Function (3 credits)",
"BIOC 454 Nucleic Acids (3 credits)",
"BIOC 458 Membranes and Cellular Signaling (3 credits)",
"BIOC 462 Research Laboratory in Biochemistry (6 credits)",
"BIOC 470 Lipids and Lipoproteins in Disease (3 credits)",
"BIOC 491 Independent Research (6 credits)",
"BIOC 503 Immunochemistry (3 credits)",
"BIOC 600 Advanced Strategies in Genetics and Genomics (3 credits)",
"BIOC 603 Genomics and Gene Expression (3 credits)",
"BIOC 604 Macromolecular Structure (3 credits)",
"BIOC 605 Protein Biology and Proteomics (3 credits)",
"BIOC 610 Seminars in Chemical Biology 1 (1 credit)",
"BIOC 611 Seminars in Chemical Biology 3 (1 credit)",
"BIOC 670 Biochemistry of Lipoproteins (3 credits)",
"BIOC 689 Seminars in Chemical Biology 2 (1 credit)",
"BIOC 690 Seminars in Chemical Biology 4 (1 credit)",
"BIOC 694 Thesis Research 4 (3 credits)",
"BIOC 695 Thesis Research 1 (Chemical - Biology) (6 credits)",
"BIOC 696 Seminars in Biochemistry (3 credits)",
"BIOC 696D1 Seminars in Biochemistry (1.5 credits)",
"BIOC 696D2 Seminars in Biochemistry (1.5 credits)",
"BIOC 696N1 Seminars in Biochemistry (1.5 credits)",
"BIOC 696N2 Seminars in Biochemistry (1.5 credits)",
"BIOC 697 Thesis Research 1 (9 credits)",
"BIOC 698 Thesis Research 2 (12 credits)",
"BIOC 699 Thesis Research 3 (15 credits)",
"BIOC 701 Research Seminar 1",
"BIOC 702 Ph.D. Thesis Proposal",
"BIOC 703 Ph.D. Seminar",
"BIOE 680 Bioethical Theory (3 credits)",
"BIOE 681 Bioethics Practicum (3 credits)",
"BIOE 682 Medical Basis of Bioethics (3 credits)",
"BIOE 686 Directed Readings 1 (3 credits)",
"BIOE 687 Directed Readings 2 (3 credits)",
"BIOE 690 M.Sc. Thesis Literature Survey (3 credits)",
"BIOE 691 M.Sc. Thesis Research Proposal (3 credits)",
"BIOE 692 M.Sc. Thesis Research Progress Report (6 credits)",
"BIOE 692D1 M.Sc. Thesis Research Progress Report (3 credits)",
"BIOE 692D2 M.Sc. Thesis Research Progress Report (3 credits)",
"BIOE 693 M.Sc. Thesis (12 credits)",
"BIOE 693D1 M.Sc. Thesis (6 credits)",
"BIOE 693D2 M.Sc. Thesis (6 credits)",
"BIOE 694 Independent Studies 3 (3 credits)",
"BIOL 101 Organismal Biology Laboratory (1 credit)",
"BIOL 102 Cell and Molecular Biology Methods (1 credit)",
"BIOL 111 Principles: Organismal Biology (3 credits)",
"BIOL 112 Cell and Molecular Biology (3 credits)",
"BIOL 115 Essential Biology (3 credits)",
"BIOL 200 Molecular Biology (3 credits)",
"BIOL 201 Cell Biology and Metabolism (3 credits)",
"BIOL 202 Basic Genetics (3 credits)",
"BIOL 205 Functional Biology of Plants and Animals (3 credits)",
"BIOL 206 Methods in Biology (3 credits)",
"BIOL 210 Perspectives of Science (3 credits)",
"BIOL 215 Introduction to Ecology and Evolution (3 credits)",
"BIOL 219 Introduction to Physical Molecular and Cell Biology (4 credits)",
"BIOL 240 Monteregian Flora (3 credits)",
"BIOL 300 Molecular Biology of the Gene (3 credits)",
"BIOL 301 Cell and Molecular Laboratory (4 credits)",
"BIOL 303 Developmental Biology (3 credits)",
"BIOL 304 Evolution (3 credits)",
"BIOL 305 Animal Diversity (3 credits)",
"BIOL 306 Neural Basis of Behaviour (3 credits)",
"BIOL 307 Behavioural Ecology (3 credits)",
"BIOL 308 Ecological Dynamics (3 credits)",
"BIOL 309 Mathematical Models in Biology (3 credits)",
"BIOL 310 Biodiversity and Ecosystems (3 credits)",
"BIOL 313 Eukaryotic Cell Biology (3 credits)",
"BIOL 314 Molecular Biology of Cancer (3 credits)",
"BIOL 316 Biomembranes and Organelles (3 credits)",
"BIOL 319 Introduction to Biophysics (3 credits)",
"BIOL 320 Evolution of Brain and Behaviour (3 credits)",
"BIOL 324 Ecological Genetics (3 credits)",
"BIOL 331 Ecology/Behaviour Field Course (3 credits)",
"BIOL 334 Applied Tropical Ecology (3 credits)",
"BIOL 334D1 Applied Tropical Ecology (1.5 credits)",
"BIOL 334D2 Applied Tropical Ecology (1.5 credits)",
"BIOL 335 Marine Mammals (3 credits)",
"BIOL 342 Contemporary Topics in Aquatic Ecology (3 credits)",
"BIOL 350 Insect Biology and Control (3 credits)",
"BIOL 352 Dinosaur Biology (3 credits)",
"BIOL 355 Trees: Ecology & Evolution (3 credits)",
"BIOL 363 Mammalian Evolution (3 credits)",
"BIOL 370 Human Genetics Applied (3 credits)",
"BIOL 373 Biometry (3 credits)",
"BIOL 377 Independent Reading Project (3 credits)",
"BIOL 385 Plant Growth and Development (3 credits)",
"BIOL 389 Laboratory in Neurobiology (3 credits)",
"BIOL 395 Quantitative Biology Seminar (1 credit)",
"BIOL 396 Undergraduate Research Project (3 credits)",
"BIOL 413 Directed Reading (1 credit)",
"BIOL 414 Invertebrate Brain Circuits and Behaviours (3 credits)",
"BIOL 416 Genetics of Mammalian Development (3 credits)",
"BIOL 418 Freshwater Invertebrate Ecology (3 credits)",
"BIOL 427 Herpetology (3 credits)",
"BIOL 428 Biological Diversity in Africa (3 credits)",
"BIOL 429 East African Ecology (3 credits)",
"BIOL 432 Limnology (3 credits)",
"BIOL 434 Theoretical Ecology (3 credits)",
"BIOL 435 Natural Selection (3 credits)",
"BIOL 436 Evolution and Society (3 credits)",
"BIOL 441 Biological Oceanography (3 credits)",
"BIOL 451 Research in Ecology and Development in Africa (3 credits)",
"BIOL 465 Conservation Biology (3 credits)",
"BIOL 466 Independent Research Project 1 (3 credits)",
"BIOL 467 Independent Research Project 2 (3 credits)",
"BIOL 468 Independent Research Project 3 (6 credits)",
"BIOL 468D1 Independent Research Project 3 (3 credits)",
"BIOL 468D2 Independent Research Project 3 (3 credits)",
"BIOL 468N1 Independent Research Project 3 (3 credits)",
"BIOL 468N2 Independent Research Project 3 (3 credits)",
"BIOL 469 Independent Research Project 4 (9 credits)",
"BIOL 469D1 Independent Research Project 4 (4.5 credits)",
"BIOL 469D2 Independent Research Project 4 (4.5 credits)",
"BIOL 479D1 Honours Research Project 1 (4.5 credits)",
"BIOL 479D2 Honours Research Project 1 (4.5 credits)",
"BIOL 480D1 Honours Research Project 2 (6 credits)",
"BIOL 480D2 Honours Research Project 2 (6 credits)",
"BIOL 499D1 Honours Seminar in Biology (2 credits)",
"BIOL 499D2 Honours Seminar in Biology (2 credits)",
"BIOL 506 Neurobiology of Learning (3 credits)",
"BIOL 507 Animal Communication (3 credits)",
"BIOL 509 Methods in Molecular Ecology (3 credits)",
"BIOL 510 Advances in Community Ecology (3 credits)",
"BIOL 515 Advances in Aquatic Ecology (3 credits)",
"BIOL 517 Cognitive Ecology (3 credits)",
"BIOL 518 Advanced Topics in Cell Biology (3 credits)",
"BIOL 520 Gene Activity in Development (3 credits)",
"BIOL 524 Topics in Molecular Biology (3 credits)",
"BIOL 530 Advances in Neuroethology (3 credits)",
"BIOL 532 Developmental Neurobiology Seminar (3 credits)",
"BIOL 540 Ecology of Species Invasions (3 credits)",
"BIOL 544 Genetic Basis of Life Span (3 credits)",
"BIOL 546 Genetics of Model Systems (3 credits)",
"BIOL 551 Principles of Cellular Control (3 credits)",
"BIOL 553 Neotropical Environments (3 credits)",
"BIOL 555D1 Functional Ecology of Trees (1.5 credits)",
"BIOL 555D2 Functional Ecology of Trees (1.5 credits)",
"BIOL 565 Cell and Tissue Mechanobiology (3 credits)",
"BIOL 568 Topics on the Human Genome (3 credits)",
"BIOL 569 Developmental Evolution (3 credits)",
"BIOL 570 Advanced Seminar in Evolution (3 credits)",
"BIOL 573 Vertebrate Palaeontology Field Course (3 credits)",
"BIOL 575 Human Biochemical Genetics (3 credits)",
"BIOL 580 Genetic Approaches to Neural Systems (3 credits)",
"BIOL 583 Advanced Biometry (3 credits)",
"BIOL 585 Game Theory and Evolutionary Dynamics (3 credits)",
"BIOL 588 Advances in Molecular/Cellular Neurobiology (3 credits)",
"BIOL 590 Linking Community and Ecosystem Ecology (3 credits)",
"BIOL 592 Integrated Bioinformatics (3 credits)",
"BIOL 594 Advanced Evolutionary Ecology (3 credits)",
"BIOL 596 Advanced Experimental Design (1 credit)",
"BIOL 597 Advanced Biostatistics (2 credits)",
"BIOL 598 Advanced Design and Statistics (3 credits)",
"BIOL 610 Scientific Manuscript Writing (3 credits)",
"BIOL 632 Advanced Limnology (3 credits)",
"BIOL 640 Tropical Biology and Conservation (3 credits)",
"BIOL 645 Biodiversity Science (3 credits)",
"BIOL 650 Recent Advances in Biology 1 (3 credits)",
"BIOL 651 Recent Advances in Biology 2 (3 credits)",
"BIOL 652 Recent Advances in Biology 3 (3 credits)",
"BIOL 652D1 Recent Advances in Biology 3 (1.5 credits)",
"BIOL 652D2 Recent Advances in Biology 3 (1.5 credits)",
"BIOL 655 Laboratory Projects and Techniques 1 (3 credits)",
"BIOL 656 Laboratory Projects and Techniques 2 (3 credits)",
"BIOL 690 Master's Thesis Research 4 (10 credits)",
"BIOL 697 Master's Thesis Research 1 (13 credits)",
"BIOL 698 Master's Thesis Research 2 (13 credits)",
"BIOL 699 Master's Thesis Research 3 (13 credits)",
"BIOL 700 Doctoral Qualifying Examination",
"BIOL 702 Ph.D. Seminar (6 credits)",
"BIOS 601 Epidemiology: Introduction and Statistical Models (4 credits)",
"BIOS 602 Epidemiology: Regression Models (4 credits)",
"BIOS 610 Causal Inference in Biostatistics (4 credits)",
"BIOS 612 Advanced Generalized Linear Models (4 credits)",
"BIOS 613 Introduction to Statistical Genetics (4 credits)",
"BIOS 624 Data Analysis & Report Writing (4 credits)",
"BIOS 624D1 Data Analysis & Report Writing (2 credits)",
"BIOS 624D2 Data Analysis & Report Writing (2 credits)",
"BIOS 630 Research Project/Practicum in Biostatistics (6 credits)",
"BIOS 630D1 Research Project/Practicum in Biostatistics (3 credits)",
"BIOS 630D2 Research Project/Practicum in Biostatistics (3 credits)",
"BIOS 631 Biostatistics Internship (6 credits)",
"BIOS 637 Advanced Modeling: Survival and Other Multivariable Data (4 credits)",
"BIOS 690 M.Sc. Thesis (21 credits)",
"BIOS 691 Special Topics in Biostatistics 1 (4 credits)",
"BIOS 692 Special Topics in Biostatistics 2 (4 credits)",
"BIOS 693 Special Topics in Biostatistics 3 (4 credits)",
"BIOS 694 Special Topics in Biostatistics 4 (4 credits)",
"BIOS 695 Special Topics in Biostatistics 5 (1 credit)",
"BIOS 696 Special Topics in Biostatistics 6 (1 credit)",
"BIOS 697 Special Topics in Biostatistics 7 (2 credits)",
"BIOS 698 Special Topics in Biostatistics 8 (2 credits)",
"BIOS 700 Ph.D. Comprehensive Examination Part A",
"BIOS 701 Ph.D. Comprehensive Examination Part B",
"BIOS 702 Ph.D. Proposal",
"BIOS 702D1 Ph.D. Proposal",
"BIOS 702D2 Ph.D. Proposal",
"BIOT 505 Selected Topics in Biotechnology (3 credits)",
"BMDE 501 Selected Topics in Biomedical Engineering (3 credits)",
"BMDE 502 BME Modelling and Identification (3 credits)",
"BMDE 503 Biomedical Instrumentation (3 credits)",
"BMDE 504 Biomaterials and Bioperformance (3 credits)",
"BMDE 505 Cell and Tissue Engineering (3 credits)",
"BMDE 506 Molecular Biology Techniques (3 credits)",
"BMDE 508 Introduction to Micro and Nano-Bioengineering (3 credits)",
"BMDE 509 Quantitative Analysis and Modelling of Cellular Processes (3 credits)",
"BMDE 510 Topics in Astrobiology (3 credits)",
"BMDE 512 Finite-Element Modelling in Biomedical Engineering (3 credits)",
"BMDE 519 Biomedical  Signals and Systems (3 credits)",
"BMDE 520 Machine Learning for Biomedical Data (3 credits)",
"BMDE 525D1 Design of Assistive Technologies: Principles and Praxis (3 credits)",
"BMDE 525D2 Design of Assistive Technologies: Principles and Praxis (3 credits)",
"BMDE 600D1 Seminars in Biomedical Engineering (1.5 credits)",
"BMDE 600D2 Seminars in Biomedical Engineering (1.5 credits)",
"BMDE 610 Functional Neuroimaging Fusion (3 credits)",
"BMDE 650 Advanced Medical Imaging (3 credits)",
"BMDE 651 Orthopaedic Engineering (3 credits)",
"BMDE 652 Bioinformatics: Proteomics (3 credits)",
"BMDE 653 Patents in Biomedical Engineering (3 credits)",
"BMDE 654 Biomedical Regulatory Affairs - Medical Devices (3 credits)",
"BMDE 655 Biomedical Clinical Trials - Medical Devices (3 credits)",
"BMDE 656 Medical Device Reimbursement (3 credits)",
"BMDE 660 Advanced MR Imaging and Spectroscopy of the Brain (3 credits)",
"BMDE 691 Thesis Research 2 (3 credits)",
"BMDE 692 Thesis Research 3 (3 credits)",
"BMDE 693 Thesis Research 4 (6 credits)",
"BMDE 694 Thesis Research 5 (6 credits)",
"BMDE 695 Thesis Submission (12 credits)",
"BMDE 700 Ph.D. Comprehensive",
"BREE 103 Linear Algebra (3 credits)",
"BREE 187 Freshman Seminar 1 (0.5 credits)",
"BREE 188 Freshman Seminar 2 (0.5 credits)",
"BREE 205 Engineering Design 1 (3 credits)",
"BREE 210 Mechanical Analysis & Design (3 credits)",
"BREE 214 Geomatics (3 credits)",
"BREE 216 Bioresource Engineering Materials (3 credits)",
"BREE 217 Hydrology and Water Resources (3 credits)",
"BREE 252 Computing for Engineers (3 credits)",
"BREE 301 Biothermodynamics (3 credits)",
"BREE 305 Fluid Mechanics (3 credits)",
"BREE 312 Electric Circuits and Machines (3 credits)",
"BREE 314 Agri-Food Buildings (3 credits)",
"BREE 319 Engineering Mathematics (3 credits)",
"BREE 322 Organic Waste Management (3 credits)",
"BREE 324 Elements of Food Engineering (3 credits)",
"BREE 325 Food Process Engineering (3 credits)",
"BREE 327 Bio-Environmental Engineering (3 credits)",
"BREE 329 Precision Agriculture (3 credits)",
"BREE 341 Mechanics of Materials (3 credits)",
"BREE 412 Machinery Systems Engineering (3 credits)",
"BREE 415 Design of Machines and Structural Elements (3 credits)",
"BREE 416 Engineering for Land Development (3 credits)",
"BREE 418 Soil Mechanics and Foundations (3 credits)",
"BREE 419 Structural Design (3 credits)",
"BREE 420 Engineering for Sustainability (3 credits)",
"BREE 423 Biological Material Properties (3 credits)",
"BREE 451 Undergraduate Seminar 1 - Oral Presentation (1 credit)",
"BREE 452 Undergraduate Seminar 2 Poster Presentation (1 credit)",
"BREE 453 Undergraduate Seminar 3 - Scientific Writing (1 credit)",
"BREE 481 Undergraduate Seminar 1 (0.5 credits)",
"BREE 482 Undergraduate Seminar 2 (0.5 credits)",
"BREE 483 Undergraduate Seminar 3 (0.5 credits)",
"BREE 484 Undergraduate Seminar 4 (0.5 credits)",
"BREE 485 Senior Undergraduate Seminar 1 (1 credit)",
"BREE 486 Senior Undergraduate Seminar 2 (1 credit)",
"BREE 490 Engineering Design 2 (3 credits)",
"BREE 495 Engineering Design 3 (3 credits)",
"BREE 497 Bioresource Engineering Project (3 credits)",
"BREE 501 Simulation and Modelling (3 credits)",
"BREE 502 Drainage/Irrigation Engineering (3 credits)",
"BREE 503 Water: Society Law and Policy (3 credits)",
"BREE 504 Instrumentation and Control (3 credits)",
"BREE 506 Advances in Drainage Management (3 credits)",
"BREE 509 Hydrologic Systems and Modelling (3 credits)",
"BREE 510 Watershed Systems Management (3 credits)",
"BREE 512 Soil Cutting and Tillage (3 credits)",
"BREE 515 Soil Hydrologic Modelling (3 credits)",
"BREE 518 Ecological Engineering (3 credits)",
"BREE 519 Advanced Food Engineering (3 credits)",
"BREE 520 Food Fibre and Fuel Elements (3 credits)",
"BREE 522 Bio-Based Polymers (3 credits)",
"BREE 525 Climate Control for Buildings (3 credits)",
"BREE 529 GIS for Natural Resource Management (3 credits)",
"BREE 530 Fermentation Engineering (3 credits)",
"BREE 531 Post-Harvest Drying (3 credits)",
"BREE 532 Post-Harvest Storage (3 credits)",
"BREE 533 Water Quality Management (3 credits)",
"BREE 535 Food Safety Engineering (3 credits)",
"BREE 600 Project/Internship Proposal (1 credit)",
"BREE 601 Integrated Food and Bioprocessing Internship 1 (6 credits)",
"BREE 602 Integrated Food and Bioprocessing Internship 2 (6 credits)",
"BREE 603 Advanced Properties: Food and Plant Materials (3 credits)",
"BREE 608 Special Problems in Bioresource Engineering 1 (3 credits)",
"BREE 623 Proposal Preparation (3 credits)",
"BREE 630 Integrated Water Resources Management Internship (13 credits)",
"BREE 631 Integrated Water Resources Management Project (6 credits)",
"BREE 651 Departmental Seminar M.Sc. 1 (1 credit)",
"BREE 652 Departmental Seminar M.Sc. 2 (1 credit)",
"BREE 655 Integrated Water Resources Management Research Visits (3 credits)",
"BREE 671 Project 1 (6 credits)",
"BREE 672 Project 2 (6 credits)",
"BREE 672D1 Project 2 (3 credits)",
"BREE 672D2 Project 2 (3 credits)",
"BREE 673 Project 3 (3 credits)",
"BREE 691 M.Sc. Thesis 1 (4 credits)",
"BREE 692 M.Sc. Thesis 2 (4 credits)",
"BREE 693 M.Sc. Thesis 3 (4 credits)",
"BREE 694 M.Sc. Thesis 4 (4 credits)",
"BREE 695 M.Sc. Thesis 5 (4 credits)",
"BREE 696 M.Sc. Thesis 6 (4 credits)",
"BREE 697 M.Sc. Thesis 7 (4 credits)",
"BREE 698 M.Sc. Thesis 8 (3 credits)",
"BREE 699 Scientific Publication (3 credits)",
"BREE 701 Ph.D. Comprehensive Examination",
"BREE 702 Special Problems in Bioresource Engineering 2 (3 credits)",
"BREE 751 Departmental Seminar Ph.D. 1",
"BREE 752 Departmental Seminar Ph.D. 2",
"BREE 753 Departmental Seminar Ph.D. 3",
"BREE 754 Departmental Seminar Ph.D. 4",
"BTEC 306 Experiments in Biotechnology (3 credits)",
"BTEC 501 Bioinformatics (3 credits)",
"BTEC 502 Biotechnology Ethics and Society (3 credits)",
"BTEC 535 Functional Genomics in Model Organisms (3 credits)",
"BTEC 555 Structural Bioinformatics (3 credits)",
"BTEC 619 Biotechnology Laboratory 2 (4 credits)",
"BTEC 620 Biotechnology Laboratory 1 (4 credits)",
"BTEC 621 Biotechnology Management (3 credits)",
"BTEC 622 Biotechnology Research Project 1 (2 credits)",
"BTEC 623 Biotechnology Research Project 2 (6 credits)",
"BTEC 624 Biotechnology Research Project 3 (6 credits)",
"BTEC 624D1 Biotech Research Project 3 (3 credits)",
"BTEC 624D2 Biotechnology Research Project 3 (3 credits)",
"BTEC 625 Biotechnology Research Project 4 (2 credits)",
"BTEC 650 Therapeutic Antibody Design (3 credits)",
"BTEC 691 Biotechnology Practicum (3 credits)",
"BUS1 414 Estate Planning (3 credits)",
"BUS1 431 Payment Mechanisms (3 credits)",
"BUS1 532 Bankruptcy and Insolvency (3 credits)",
"BUS2 365 Business Associations (4 credits)",
"BUS2 365D1 Business Associations (2 credits)",
"BUS2 365D2 Business Associations (2 credits)",
"BUS2 500 Copyright and Trademark Theory (3 credits)",
"BUS2 501 Patent Theory and Policy (3 credits)",
"BUS2 502 Intellectual & Industrial Property (3 credits)",
"BUS2 503 Business Organizations (3 credits)",
"BUS2 504 Securities Regulation (3 credits)",
"BUS2 505 Corporate Finance (3 credits)",
"BUS2 531 Banking Law (3 credits)",
"BUS2 561 Insurance (3 credits)",
"BUSA 100 Introduction to Management (3 credits)",
"BUSA 250 Expressive Analysis for Management (3 credits)",
"BUSA 356 Management in Global Context (3 credits)",
"BUSA 364 Business Law 1 (3 credits)",
"BUSA 368 Business Law 2 (3 credits)",
"BUSA 391 International Business Law (3 credits)",
"BUSA 394 Managing in Asia (3 credits)",
"BUSA 395 Managing in Europe (3 credits)",
"BUSA 399 Internship Project (1 credit)",
"BUSA 400 Independent Studies in Management (3 credits)",
"BUSA 401 Independent Studies in International Business (3 credits)",
"BUSA 402 Independent Studies in Social Business and Enterprise (3 credits)",
"BUSA 430 Business Climate in Developing Countries (3 credits)",
"BUSA 433 Topics in International Business 1 (3 credits)",
"BUSA 434 Topics in General Management (3 credits)",
"BUSA 435 Topics in International Business 2 (3 credits)",
"BUSA 462 Management of New Enterprises (3 credits)",
"BUSA 464 Management of Small Enterprises (3 credits)",
"BUSA 465 Technological Entrepreneurship (3 credits)",
"BUSA 466 Technological Entrepreneurship Project (3 credits)",
"BUSA 481 Managing in North America (3 credits)",
"BUSA 493 Global Economic Competitiveness (3 credits)",
"BUSA 497 Internship in International Business (3 credits)",
"BUSA 498 International Internship (6 credits)",
"BUSA 499 Case Analysis and Presentation (3 credits)",
"BUSA 600 Analytics Internship (3 credits)",
"BUSA 611 Independent Studies in Analytics 1 (1.5 credits)",
"BUSA 613 Independent Studies in Analytics 2 (3 credits)",
"BUSA 614 Governance of Corporation: Contemporary Issues (3 credits)",
"BUSA 615 Global Competitiveness (3 credits)",
"BUSA 625 Asia/Pacific Management (3 credits)",
"BUSA 626 International Business Law (3 credits)",
"BUSA 627 North America: Global Markets (3 credits)",
"BUSA 630 Stage Paper (1 credit)",
"BUSA 640 Launching New Ventures (3 credits)",
"BUSA 642 Reflective Dimension Manager Role (4 credits)",
"BUSA 643 Collaborative Dimension Manager (4 credits)",
"BUSA 644 Analytic Dimension of Manager Role (4 credits)",
"BUSA 645 Worldly Dimension of Manager Role (4 credits)",
"BUSA 646 Health Management Capstone (3 credits)",
"BUSA 647D1 Healthcare Management Practicum (2 credits)",
"BUSA 647D2 Healthcare Management Practicum (2 credits)",
"BUSA 649 Community Analytics Project (3 credits)",
"BUSA 650 Internship (6 credits)",
"BUSA 650D1 Internship (3 credits)",
"BUSA 650D2 Internship (3 credits)",
"BUSA 651 Practicum (6 credits)",
"BUSA 651D1 Practicum (3 credits)",
"BUSA 651D2 Practicum (3 credits)",
"BUSA 660 CEO Insights (3 credits)",
"BUSA 663 Reflective Mindset (6 credits)",
"BUSA 664 Creating the Small Business (3 credits)",
"BUSA 665 Managing the Small Enterprise (3 credits)",
"BUSA 666 The Practice of Management (5 credits)",
"BUSA 667 Analytic Mindset (6 credits)",
"BUSA 668 The Venture (5 credits)",
"BUSA 668J1 The Venture (1.7 credits)",
"BUSA 668J2 The Venture (1.7 credits)",
"BUSA 668J3 The Venture (1.6 credits)",
"BUSA 670 Managing Organizations (5 credits)",
"BUSA 670D1 Managing Organizations (2.5 credits)",
"BUSA 670D2 Managing Organizations (2.5 credits)",
"BUSA 671 Managerial Experience (3 credits)",
"BUSA 672 Managerial Exchange (3 credits)",
"BUSA 672D1 Managerial Exchange (1.5 credits)",
"BUSA 672D2 Managerial Exchange (1.5 credits)",
"BUSA 672J1 Managerial Exchange (1 credit)",
"BUSA 672J2 Managerial Exchange (1 credit)",
"BUSA 672J3 Managerial Exchange (1 credit)",
"BUSA 675 Managing Context (5 credits)",
"BUSA 676 Worldly Mindset (6 credits)",
"BUSA 677 Collaborative Mindset (6 credits)",
"BUSA 678 Catalytic Mindset (6 credits)",
"BUSA 680 Managing People (5 credits)",
"BUSA 684 Analytics Study Trip (3 credits)",
"BUSA 685 Managing Change (5 credits)",
"BUSA 689 Integrative Project (12 credits)",
"BUSA 689D1 Integrative Project (6 credits)",
"BUSA 689D2 Integrative Project (6 credits)",
"BUSA 689J1 Integrative Project (4 credits)",
"BUSA 689J2 Integrative Project (4 credits)",
"BUSA 689J3 Integrative Project (4 credits)",
"BUSA 690 Advanced Topics in Management 1 (3 credits)",
"BUSA 690D1 Advanced Topics in Management 1 (1.5 credits)",
"BUSA 690D2 Advanced Topics in Management 1 (1.5 credits)",
"BUSA 691 Advanced Topics in Management 2 (3 credits)",
"BUSA 692 Advanced Topics in Management 3 (3 credits)",
"BUSA 693D1 Analytics and Solution Consulting Practicum (3 credits)",
"BUSA 693D2 Analytics and Solution Consulting Practicum (3 credits)",
"BUSA 693N1 Analytics and Solution Consulting Practicum (3 credits)",
"BUSA 693N2 Analytics and Solution Consulting Practicum (3 credits)",
"BUSA 694 Final Master's Paper (12 credits)",
"BUSA 695 Real-Time Decisions (1.5 credits)",
"BUSA 697 European Economy and Management (3 credits)",
"BUSA 698 Health Care Systems (3 credits)",
"BUSA 699 Health Care Management (3 credits)",
"CACC 220 Accounting Concepts for Managers (3 credits)",
"CACC 520 Accounting for Management (3 credits)",
"CACC 521 Concepts of Financial Accounting (3 credits)",
"CACC 523 Financial Aspects of Health Care (3 credits)",
"CACC 523N1 Financial Aspects of Health Care (1.5 credits)",
"CACC 523N2 Financial Aspects of Health Care (1.5 credits)",
"CACF 210 Introductory Financial Accounting (3 credits)",
"CACF 215 Introductory Managerial Accounting (3 credits)",
"CACF 305 Information System Tools in Accounting (3 credits)",
"CACF 310 Intermediate Financial Reporting 1 (3 credits)",
"CACF 325 Intermediate Financial Reporting 2 (3 credits)",
"CACF 340 Corporate Finance: Value Creation and Decision-Making (3 credits)",
"CACF 341 Taxation: Concepts and Regulations (3 credits)",
"CACF 345 Intermediate Managerial Accounting (3 credits)",
"CACF 350 Artificial Intelligence: Application in Accounting Practices (3 credits)",
"CACF 420 Ethical Considerations and Practices (3 credits)",
"CACF 440 Advanced Financial Reporting (3 credits)",
"CACF 445 Audit and Assurance: Principles Theories and Current Practices (3 credits)",
"CACF 450 Financial and Working Capital Management (3 credits)",
"CACF 460 Applied Personal and Corporate Taxation (3 credits)",
"CACF 470 Public Sector Financial Management Practices (3 credits)",
"CACF 490 Capstone",
"CAFT 600 Couple and Family Therapy Pre-Practicum (3 credits)",
"CAFT 601 Diversity  and Couple and Family Therapy (3 credits)",
"CAFT 602 Advanced Assessment in Couple and Family Therapy (3 credits)",
"CAFT 603 Research Methods for Couple and Family Therapists (3 credits)",
"CAFT 604 Contemporary Issues in Couple and Family Therapy (3 credits)",
"CAFT 605 Advanced Family Treatment Across the Lifespan (3 credits)",
"CAFT 606 Internship 1 in Couple and Family Therapy (3 credits)",
"CAFT 607 Legal Ethical and Professional Issues in C & FT (3 credits)",
"CAFT 608 Human Development Across Lifespan: Couple & Family Therapy (3 credits)",
"CAFT 609 Advanced Couple Therapy (3 credits)",
"CAFT 610 Biological Foundations of Behaviour for C&FTs (3 credits)",
"CAFT 611 Internship 2 in Couple and Family Therapy (6 credits)",
"CAFT 612 Internship 3 in Couple and Family Therapy (6 credits)",
"CAFT 613 Couple and Family Therapy Internal Practicum (3 credits)",
"CANS 200 Understanding Canada (3 credits)",
"CANS 300 Topics in Canadian Studies 1 (3 credits)",
"CANS 301 Topics in Canadian Studies 2 (3 credits)",
"CANS 303 Topics in Canadian Studies 3 (3 credits)",
"CANS 304 Nationalisms in Canada (3 credits)",
"CANS 305 Canadian Modernity (3 credits)",
"CANS 306 Issues in Native Studies (3 credits)",
"CANS 307 Canada in the World (3 credits)",
"CANS 308 Sex and Gender in Canada (3 credits)",
"CANS 310 Canadian Cultures: Context and Issues (3 credits)",
"CANS 315 Indigenous Art and Culture (3 credits)",
"CANS 401 Canadian Studies Seminar 1 (3 credits)",
"CANS 402 Canadian Studies Seminar 2 (3 credits)",
"CANS 403 Canadian Material Culture (3 credits)",
"CANS 404 Canadian Studies Seminar 4 (3 credits)",
"CANS 405 Canadian Studies Seminar 5 (3 credits)",
"CANS 406 Canadian Studies Seminar 6 (3 credits)",
"CANS 407 Regions of Canada (3 credits)",
"CANS 408 Individual Reading Course (3 credits)",
"CANS 412 Canada and Americas Seminar (3 credits)",
"CANS 413 Canada and Quebec Seminar (3 credits)",
"CANS 420 Shaping Public Affairs in Canada (3 credits)",
"CANS 480 Honours Thesis 1 (3 credits)",
"CANS 481 Honours Thesis 2 (3 credits)",
"CANS 492 Joint Honours Thesis (3 credits)",
"CANS 492D1 Joint Honours Thesis (1.5 credits)",
"CANS 492D2 Joint Honours Thesis (1.5 credits)",
"CANS 499 Internship - Canadian Studies (3 credits)",
"CATH 200 Introduction to Catholicism (3 credits)",
"CATH 310 Catholic Intellectual Traditions (3 credits)",
"CATH 315 Catholicism and Ethics (3 credits)",
"CATH 320 Catholicism and Modernity (3 credits)",
"CATH 325 Mystery and the Imagination (3 credits)",
"CATH 330 Catholicism in a Global Context (3 credits)",
"CATH 340 Catholicism and Public Policy (3 credits)",
"CATH 370 Topics in Catholic Studies (3 credits)",
"CATH 460 Catholic Studies Seminar (3 credits)",
"CBUS 005D1 Special Topics in Health Care (7 CE units)",
"CBUS 005D2 Special Topics in Health Care (7 CE units)",
"CBUS 008D1 Fundamentals of Organizational Behaviour (7 CE units)",
"CBUS 008D2 Fundamentals of Organizational Behaviour (7 CE units)",
"CBUS 208D1 Facilitation for Results (8 CE units)",
"CBUS 208D2 Facilitation for Results (8 CE units)",
"CBUS 217 Dynamic Pricing and Revenue Management (3.5 CE units)",
"CBUS 218 Airport Commercial Management (5 CE units)",
"CBUS 219 Fuel Efficiency and Conservation (3.5 CE units)",
"CBUS 226 Aviation Project Management (5 CE units)",
"CBUS 237 Aerospace Business & Strategy (4 CE units)",
"CCAU 511 Auditing 1 (3 credits)",
"CCAU 520 External Auditing (3 credits)",
"CCAU 525 Operational Auditing (3 credits)",
"CCCS 280 Introduction to Computer Information Systems (3 credits)",
"CCCS 300 Programming Techniques 1 (3 credits)",
"CCCS 301 Programming Techniques 2 (3 credits)",
"CCCS 310 Web Development (3 credits)",
"CCCS 315 Data Structures and Algorithms (3 credits)",
"CCCS 321 Operating Systems Administration (3 credits)",
"CCCS 325 Mobile Application Development (3 credits)",
"CCCS 330 Database Design and Business Applications Development (3 credits)",
"CCCS 425 Web Services (3 credits)",
"CCCS 431 Networking Fundamentals (3 credits)",
"CCFA 500 Professional Ethical Practices (1.5 credits)",
"CCFA 505 Financial Modeling (1.5 credits)",
"CCFA 510 Current Operations in Global Financial Markets (3 credits)",
"CCFA 515 Essentials of Financial Reporting and Analysis (3 credits)",
"CCFA 520 Theory of Capital Structure and Corporate Finance 1 (3 credits)",
"CCFA 523 Corporate Treasury Management (3 credits)",
"CCFA 527 Introduction to Portfolio and Risk Management (3 credits)",
"CCFA 528 Investment Decisions and Effect of Behavioural Finance (3 credits)",
"CCFA 529 Introduction to Fixed-Income and Equity Investments (3 credits)",
"CCFA 530 Introduction to Applications and Uses of Derivatives (3 credits)",
"CCFA 535 Theory of Capital Structure and Corporate Finance 2 (3 credits)",
"CCFA 536 Behavioural Finance and Wealth Planning (3 credits)",
"CCFA 538 Mergers and Acquisitions Including Firm Valuation Methods (3 credits)",
"CCFA 540 Portfolio Strategies and Management (3 credits)",
"CCFA 542 Hedge Fund (3 credits)",
"CCFA 545 Advanced Fixed-Income and Equity Investments (3 credits)",
"CCFA 547 Advanced Portfolio Management (3 credits)",
"CCFA 548 Alternative Investments (3 credits)",
"CCFA 595 Special Topics in Finance (3 credits)",
"CCFC 511 Financial Accounting 1 (3 credits)",
"CCFC 512 Financial Accounting 2 (3 credits)",
"CCFC 513 Financial Accounting 3 (3 credits)",
"CCFC 514 Accounting Theory and Practice (3 credits)",
"CCFC 515 Issues in Professional Practice 1 (3 credits)",
"CCFC 516 Forensic Accounting (3 credits)",
"CCFC 520 Issues in Professional Practice 2 (3 credits)",
"CCFC 521 Corporate Governance (3 credits)",
"CCFC 522 Strategic Financial Management (3 credits)",
"CCFC 523 Public Accountancy (3 credits)",
"CCFC 590 Topics in Accounting and Auditing (3 credits)",
"CCLW 205 Introduction to Business Law (3 credits)",
"CCLW 300 Public Administration and Law for Indigenous Peoples (3 credits)",
"CCLW 511 Law 1 (3 credits)",
"CCLW 640 Tax Aspects of Litigation (3 credits)",
"CCLW 641 Taxation Research Methodology (3 credits)",
"CCLW 643 U.S. Taxation (3 credits)",
"CCLW 644 Corporate Reorganizations (3 credits)",
"CCLW 645 Taxation: Partnerships and Trusts (3 credits)",
"CCMA 511 Managerial Accounting 1 (3 credits)",
"CCMA 522 Managerial Accounting 2 (3 credits)",
"CCMA 523 Managerial Accounting 3 (3 credits)",
"CCOM 200 Introduction to Creative Writing (3 credits)",
"CCOM 205 Communication in Management 1 (3 credits)",
"CCOM 206 Communication in Engineering (3 credits)",
"CCOM 207 Communication in Public Relations (3 credits)",
"CCOM 208 Professional Writing in Business (4.5 CE units)",
"CCOM 300 Writing and Community Action (3 credits)",
"CCOM 314 Communicating Science (3 credits)",
"CCOM 315 Writing the Internet (3 credits)",
"CCOM 414 Advanced Communicating Science (3 credits)",
"CCOM 550 Business and Professional Communication (3 credits)",
"CCOM 614 Communicating Science to the Public (1 credit)",
"CCOM 615 Communicating Science to the Digital Public (1 credit)",
"CCPA 601 CPA Foundations 1 (6 credits)",
"CCPA 602 CPA Foundations 2 (6 credits)",
"CCPA 621 Taxation (3 credits)",
"CCPA 622 Performance Management (3 credits)",
"CCPA 623 Assurance (3 credits)",
"CCPA 624 Finance for CPAs (3 credits)",
"CCPA 631 Case-Writing and Communications for CPAs (3 credits)",
"CCPA 641 Capstone 1 Seminar (3 credits)",
"CCPA 642 Capstone 2 Examination Preparation",
"CCS2 505 Programming for Data Science (3 credits)",
"CCS2 508 Web Application Development (3 credits)",
"CCS2 510 Computer Network and Internet Security (3 credits)",
"CCS2 520 Life of Projects (3 credits)",
"CCS2 535 Internet Business Project (3 credits)",
"CCS2 550 Multimedia Communication Design and Marketing (3 credits)",
"CCS2 590 Topics in Information Technology (3 credits)",
"CCTR 217 Fundamentals of Comparative Stylistics and Writing (English) (3 credits)",
"CCTR 218 Fundamentals of Comparative Stylistics and Writing (Spanish) (3 credits)",
"CCTR 219 Fundamentals of Comparative Stylistics and Writing (French) (3 credits)",
"CCTR 222 English Usage for Translators (10 CE units)",
"CCTR 223 Le bon usage pour traducteurs (10 CE units)",
"CCTR 225 Introduction to Translation (English to French) (3 credits)",
"CCTR 226 Introduction to Translation (French to English) (3 credits)",
"CCTR 227 Spanish Translation 1 (3 credits)",
"CCTR 228 Introduction to Translation (English to Spanish) (3 credits)",
"CCTR 230 Précis-Writing / Contraction: texte (3 credits)",
"CCTR 232 Documentation and Terminology/Documentation et terminologie (3 credits)",
"CCTR 233 Techniques: Rédaction pour traducteurs (3 credits)",
"CCTR 234 Writing Techniques for Translators (3 credits)",
"CCTR 237 Writing Techniques (Spanish) (3 credits)",
"CCTR 310 Comparative Stylistics 2 (3 credits)",
"CCTR 317 Comparative Stylistics: Spanish/English/French (3 credits)",
"CCTR 325 Semi-Specialized Translation (English to French) (3 credits)",
"CCTR 326 Semi-Specialized Translation (French to English) (3 credits)",
"CCTR 330 Text Revision/Révision: Texte 01 (3 credits)",
"CCTR 331 Current Trends in Translation Studies (3 credits)",
"CCTR 333 Spanish Translation to French (3 credits)",
"CCTR 334 Spanish Translation to English (3 credits)",
"CCTR 335 Semi-Specialized Translation (English to Spanish) (3 credits)",
"CCTR 340 Introduction to Spanish Text Revision (3 credits)",
"CCTR 360 Spanish Translation 2 (3 credits)",
"CCTR 401 Independent Studies: Translation (3 credits)",
"CCTR 433 French Translation 3 (3 credits)",
"CCTR 434 English Translation 3 (3 credits)",
"CCTR 435 French Translation 4 (3 credits)",
"CCTR 436 English Translation 4 (3 credits)",
"CCTR 437 Spanish Translation 3 (3 credits)",
"CCTR 438 Spanish Translation 4 (3 credits)",
"CCTR 441 Traduction Littéraire-Français (3 credits)",
"CCTR 442 Literary Translation-English (3 credits)",
"CCTR 443 International Business Translation (English to Spanish) (1.5 credits)",
"CCTR 445 Healthcare Translation (English to Spanish) (1.5 credits)",
"CCTR 447 International Development Translation (English to Spanish) (1.5 credits)",
"CCTR 449 Transcreation (English to Spanish) (1.5 credits)",
"CCTR 453 Technical Translation: Information Technology (English to French) (1.5 credits)",
"CCTR 455 Technical Translation: Transportation (English to French) (1.5 credits)",
"CCTR 457 Financial Translation: Investments (English to French) (1.5 credits)",
"CCTR 459 Transcreation (English to French) (1.5 credits)",
"CCTR 463 Administrative Translation: Corporate Reports (Fr to Eng) (1.5 credits)",
"CCTR 465 Technical Translation: Energy and Natural Resources(FrtoEn) (1.5 credits)",
"CCTR 467 Administrative Translation: HR & Training (Fr to Eng) (1.5 credits)",
"CCTR 469 Transcreation (French to English) (1.5 credits)",
"CCTR 485 Introduction to Public Service Interpreting (3 credits)",
"CCTR 500 Translation Practicum 1 (3 credits)",
"CCTR 501 Traductologie (3 credits)",
"CCTR 502 Translation Studies (3 credits)",
"CCTR 503 Translation Studies (English/French/Spanish) (3 credits)",
"CCTR 504 Professional Contexts (3 credits)",
"CCTR 506 Editing and Revising (Spanish) (3 credits)",
"CCTR 507 Editing and Revising (French) (3 credits)",
"CCTR 508 Editing and Revising (English) (3 credits)",
"CCTR 510 Computer Assisted Translation / Informatique en traduction (3 credits)",
"CCTR 511 Traduction Spécialisée 1 (3 credits)",
"CCTR 512 Specialized Translation 1 (3 credits)",
"CCTR 513 Traduction Spécialisée 2 (3 credits)",
"CCTR 514 Specialized Translation 2 (3 credits)",
"CCTR 515 Les Classiques Anglais (3 credits)",
"CCTR 516 French Canon in Translation (3 credits)",
"CCTR 517 Histoire Différentielle: Français (3 credits)",
"CCTR 518 Differential History of English (3 credits)",
"CCTR 519 Guided Cultural Reading / Lectures culturelles dirigées (3 credits)",
"CCTR 520 Applied Research: Lexicography/Recherche en lexicographie (3 credits)",
"CCTR 521 Advanced Comparative Stylistics (3 credits)",
"CCTR 522 Advanced Précis - Writing (Spanish) (3 credits)",
"CCTR 523 Text Revision in Spanish/Révision de textes en Espagnol (3 credits)",
"CCTR 524 Differential History of Spanish (3 credits)",
"CCTR 525 Spanish Canon in Translation (3 credits)",
"CCTR 526 Linguistics for Translation / La linguistique et la traduction (3 credits)",
"CCTR 527 History of Translation/Histoire de la traduction (3 credits)",
"CCTR 528 Current Cultural Topics (3 credits)",
"CCTR 529 Text Revision/Révision: Texte 02 (3 credits)",
"CCTR 530 Principles of Jurilinguistics (3 credits)",
"CCTR 533 Specialized Translation (English/French) (3 credits)",
"CCTR 535 Computer-Aided Translation and Terminology (3 credits)",
"CCTR 541 Legal Translation: General (3 credits)",
"CCTR 542 Legal Translation: Securities Law (French to English) (1.5 credits)",
"CCTR 543 Glottopolitics and Public Institutions (1.5 credits)",
"CCTR 544 (Co)Writing Techniques for Legal Drafters (1.5 credits)",
"CCTR 545 Legal Translation: Securities Law (English to French) (1.5 credits)",
"CCTR 551 Comprehensive Evaluation/Évaluation globale",
"CCTR 553 Legal Translation: Judgments (English to French) (2 credits)",
"CCTR 554 Legal Translation: Judgments (French to English) (2 credits)",
"CCTR 555 Legal Translation: Contracts (English to French) (2 credits)",
"CCTR 556 Legal Translation: Contracts (French to English) (2 credits)",
"CCTR 557 Legal Translation: Statutes&Regulations (English to French) (2 credits)",
"CCTR 558 Legal Translation: Statutes&Regulations (French to English) (2 credits)",
"CCTR 599 Special Topics in Translation Studies (3 credits)",
"CCTR 600 Translation Practicum 2 (3 credits)",
"CCTR 601 Independent Studies (3 credits)",
"CCTR 602 Special Topics in Legal Translation (3 credits)",
"CCTR 605 Applied Research Project 1 (3 credits)",
"CCTR 606 Applied Research Project 2 (3 credits)",
"CCTX 511 Taxation 1 (3 credits)",
"CCTX 532 Taxation 2 (3 credits)",
"CCTX 540 U.S. Taxation (3 credits)",
"CCTX 640 Taxation of Real Estate (3 credits)",
"CCTX 641 Federal and Provincial Taxes (3 credits)",
"CCTX 642 Interpretation of Tax Policy (3 credits)",
"CCTX 643 Taxation of International Operations (3 credits)",
"CCTX 644 Tax Aspects: Creative Financing (3 credits)",
"CEAP 150 Critical Analysis and Composition (3 credits)",
"CEAP 250 Research Essay & Rhetoric (3 credits)",
"CEAP 642 Cornerstones of Academic Writing (1 credit)",
"CEAP 643 Literature Reviews and Scholarly Niches (1 credit)",
"CEAP 652 Fundamentals of Academic Presentations (1 credit)",
"CEAP 661 Literature Review 1: Summary and Critique (1 credit)",
"CEAP 665 Literature Review 2: Establishing Scholarly Niches (1 credit)",
"CEAP 671 Selected Topics in Communication 1 (1 credit)",
"CEAP 672 Selected Topics in Communication 2 (1 credit)",
"CEAP 676 Thesis Writing Lab (1 credit)",
"CEC1 206 Transportation Economics (3 credits)",
"CEC2 532 Business Economics (3 credits)",
"CEEN 102 Basic English",
"CEEN 104 Elementary English 1",
"CEEN 106 Elementary English 2",
"CEEN 201 Vocabulary and Reading Strategies (3 credits)",
"CEEN 202 Introduction: English Pronunciation System (3 credits)",
"CEEN 211 Functional English Grammar/Writing 1 (3 credits)",
"CEEN 212 English Communication Practice 1 (3 credits)",
"CEEN 221 Functional English Grammar/Writing 2 (3 credits)",
"CEEN 222 English Communication Practice 2 (3 credits)",
"CEEN 266 Introduction to Creative Writing (3 credits)",
"CEEN 267 English Study Topics: The Story of Canada (3 credits)",
"CEEN 301 English Grammar in Context (3 credits)",
"CEEN 302 English Pronunciation: Stress and Intonation (3 credits)",
"CEEN 331 Functional English Grammar/Writing 3 (3 credits)",
"CEEN 332 English Communication Practice 3 (3 credits)",
"CEEN 401 English Vocabulary in Context (3 credits)",
"CEEN 402 English Communication and Cultural Patterns (3 credits)",
"CEEN 403 Strategic Communication in English (3 credits)",
"CEEN 404 English Creative Non-fiction Writing (3 credits)",
"CEEN 411 English Grammar and Writing Techniques (3 credits)",
"CEEN 412 English Oral Communication Techniques (3 credits)",
"CEEN 421 English Written Communication Contexts (3 credits)",
"CEEN 422 English Oral Communication Contexts (3 credits)",
"CEFN 102 Basic French (3 credits)",
"CEFN 104 Elementary French  (3 credits)",
"CEFN 106 Fundamentals of  French Grammar and Writing (3 credits)",
"CEFN 107 Fundamentals of French Oral Communication (3 credits)",
"CEFN 211 Functional French Grammar/Writing 1 (3 credits)",
"CEFN 212 French Communication Practice 1 (3 credits)",
"CEFN 221 Functional French Grammar/Writing 2 (3 credits)",
"CEFN 222 French Communication Practice 2 (3 credits)",
"CEFN 331 Functional French Grammar/Writing 3 (3 credits)",
"CEFN 332 French Communication Practice 3 (3 credits)",
"CEFN 401 French Vocabulary in Context (3 credits)",
"CEFN 402 Persuasive French in Communication (3 credits)",
"CEFN 411 French Grammar/Writing Techniques (3 credits)",
"CEFN 412 French Oral Communication Techniques (3 credits)",
"CEFN 421 French Written Communication Contexts (3 credits)",
"CEFN 422 French Oral Communication Contexts (3 credits)",
"CEGL 110 English Communication Level 1A (5 CE units)",
"CEGL 120 English Communication Level 1B (5 CE units)",
"CEGL 130 English Communication Level 1C (5 CE units)",
"CEGL 140 English Communication Level 1D (5 CE units)",
"CEGL 170 Elementary 1 Essential English for Health Services (6 CE units)",
"CEGL 171 Elementary 1 English Conversation for Health Services (4 CE units)",
"CEGL 172 Elementary 2 Essential English for Health Services (6 CE units)",
"CEGL 173 Elementary 2 English Conversation for Health Services (4 CE units)",
"CEGL 174 Elementary 3 Essential English for Health Services (6 CE units)",
"CEGL 175 Elementary 3 English Conversation for Health Services (4 CE units)",
"CEGL 210 English Communication Level 2A (5 CE units)",
"CEGL 213 Intensive English - Elementary 1 (20 CE units)",
"CEGL 215 English Grammar at Work (8 CE units)",
"CEGL 216 English Grammar and Writing in Context 1 (8 CE units)",
"CEGL 220 English Communication Level 2B (5 CE units)",
"CEGL 223 Intensive English - Elementary 2 (20 CE units)",
"CEGL 228 Pronunciation Clinic 1 (6 CE units)",
"CEGL 230 English Communication Level 2C (5 CE units)",
"CEGL 238 Pronunciation Clinic 2 (6 CE units)",
"CEGL 240 English Communication Level 2D (5 CE units)",
"CEGL 250 English Communication Level 2E (5 CE units)",
"CEGL 254 Advanced English 1 (12 CE units)",
"CEGL 260 English Communication Level 2F (5 CE units)",
"CEGL 270 Intermediate 1 Essential English for Health Services (6 CE units)",
"CEGL 271 Intermediate 1 English Conversation for Health Services (4 CE units)",
"CEGL 272 Intermediate 2 Essential English for Health Services (6 CE units)",
"CEGL 273 Intermediate 2 English Conversation for Health Services (4 CE units)",
"CEGL 274 Intermediate 3 Essential English for Health Services (6 CE units)",
"CEGL 275 Intermediate 3 English Conversation for Health Services (4 CE units)",
"CEGL 300 Specialized ESL for Academic/Professional Purposes (16 CE units)",
"CEGL 301 Language for Specific Purposes: Tourism Business (16 CE units)",
"CEGL 310 English Communication Level 3A (5 CE units)",
"CEGL 313 Intensive English - Intermediate 1 (20 CE units)",
"CEGL 315 English Grammar and Writing in Context  2 (8 CE units)",
"CEGL 316 English Vocabulary for Workplace (8 CE units)",
"CEGL 320 English Communication Level 3B (5 CE units)",
"CEGL 323 Intensive English - Intermediate 2 (20 CE units)",
"CEGL 330 English Communication Level 3C (5 CE units)",
"CEGL 333 Intensive English - Intermediate 3 (20 CE units)",
"CEGL 340 English Communication Level 3D (5 CE units)",
"CEGL 343 Sp Intensive English Level 4 (30 CE units)",
"CEGL 344 Intensive English/Short Course (20 CE units)",
"CEGL 355 Intensive English - Bridge to Proficiency (20 CE units)",
"CEGL 370 Advanced 1 Essential English for Healthcare (6 CE units)",
"CEGL 371 Advanced 1 English Conversation for Healthcare (4 CE units)",
"CEGL 372 Advanced 2 Essential English for Healthcare (6 CE units)",
"CEGL 373 Advanced 2 English Conversation for Healthcare (4 CE units)",
"CEGL 380 Advanced 1 Essential English for Social Services (6 CE units)",
"CEGL 381 Advanced 1 English Conversation for Social Services (4 CE units)",
"CEGL 382 Advanced 2 Essential English for Social Services (6 CE units)",
"CEGL 383 Advanced 2 English Conversation for Social Services (4 CE units)",
"CEGL 390 Adv. 1-Essential English - Frontline Healthcare Admin (6 CE units)",
"CEGL 391 Adv 1 English Conversation-Frontline Healthcare Admin (4 CE units)",
"CEGL 392 Advanced 2 Essential English-Frontline Healthcare Admin (6 CE units)",
"CEGL 393 Adv 2 English Conversation-Frontline Healthcare Admin (4 CE units)",
"CEGL 400 Physical Environment Sustainability & Contemporary Culture (10 CE units)",
"CEGL 401 Linguistic and Cultural Diversity in Quebec (10 CE units)",
"CEGL 402 Effective Communication for Teachers (3 CE units)",
"CEGL 403 Teaching and Learning Methodologies (3 CE units)",
"CEGL 404 Practicum and Specialized Workshops for Teachers (3 CE units)",
"CEGL 405 Intercultural Communication Challenges in TESL (3 CE units)",
"CEGL 406 Internship for Professional Communication Purposes (24 CE units)",
"CEGL 407 English for International Multilateral Negotiations (10 CE units)",
"CEGL 408 English for Strategic Interpersonal Communication (10 CE units)",
"CEGL 409 Medical English as a Foreign Language for Nurses (12 CE units)",
"CEGL 410 Intensive Professional Development for ESL Teachers (6 CE units)",
"CEGL 413 Intensive English - Advanced A (20 CE units)",
"CEGL 415 English Writing Techniques for Workplace (8 CE units)",
"CEGL 416 English Written Communication Strategies for Workplace (8 CE units)",
"CEGL 420 Intercultural Communication & Globalization (10 CE units)",
"CEGL 423 Intensive English - Advanced B (20 CE units)",
"CEN2 500 New Venture Formation (3 credits)",
"CEN2 505 Sales and Negotiation Strategies (3 credits)",
"CEN2 506 Financing Startups and Ventures (3 credits)",
"CEN2 507 Venture Growth Strategies (3 credits)",
"CEN2 510 Practical Entrepreneurship Management (3 credits)",
"CENG 111 Fundamentals of Aerospace Metallic Materials (4.5 CE units)",
"CENG 112 Introduction to Engineering Design Optimization (2.4 CE units)",
"CENG 113 Dynamics of Turbomachines (2.4 CE units)",
"CENG 220 Industrial Process Control and Automation (10 CE units)",
"CENG 221 Project Management (16 CE units)",
"CENG 221D1 Project Management (8 CE units)",
"CENG 221D2 Project Management (8 CE units)",
"CENG 222 Risk Assessment: Ore Reserves/Mine Planning (16 CE units)",
"CENG 223 Strategic Project Leadership (4 CE units)",
"CENG 224 Agile Project Management (4 CE units)",
"CENG 225 Ore Reserve Risk and Mine Planning (3.5 CE units)",
"CENT 305 Sales and Negotiations (3 credits)",
"CENT 306 Launching a New Business (3 credits)",
"CENT 307 Creating a Business Plan (3 credits)",
"CENT 308 Financing a New Business (3 credits)",
"CENT 309 Business Growth Strategies and Issues (3 credits)",
"CENT 434 Entrepreneurship Issues Management (3 credits)",
"CESL 150 English as a Second Language (6 credits)",
"CESL 200 ESL: Academic English 1 (3 credits)",
"CESL 299 ESL: Academic English Seminar (3 credits)",
"CESL 300 ESL: Academic English 2 (3 credits)",
"CESL 400 ESL: Essay & Critical Thinking (3 credits)",
"CESL 500 ESL: Research Essay and Rhetoric (3 credits)",
"CESL 525 ESL: Business and Professional Communication (3 credits)",
"CESL 631 Strategies for Academic Communication in English (1 credit)",
"CESL 640 Fundamentals of Academic Writing for Graduate Students (3 credits)",
"CESL 641 Fundamentals of Academic Writing in English (1 credit)",
"CESL 650 Pronunciation and Communication (3 credits)",
"CESL 651 Pronunciation for Effective Communication (1 credit)",
"CESL 660 Pronunciation: Independent Study",
"CESL 690 Writing for Graduate Students (3 credits)",
"CFIN 200 Retirement Planning (3 credits)",
"CFIN 300 Fundamentals of Financial Markets and Institutions (3 credits)",
"CFIN 305 Investor Behaviour (3 credits)",
"CFIN 310 Short-Term Financial Management (3 credits)",
"CFIN 350 Alternative Investments (3 credits)",
"CFIN 400 Real Estate Finance (3 credits)",
"CFIN 401 Sustainable Finance and the Firm (3 credits)",
"CFIN 402 Business Valuation and Project Finance (3 credits)",
"CFIN 403 Mergers and Acquisitions (3 credits)",
"CFIN 410 Investment and Portfolio Management (3 credits)",
"CFIN 420 Mutual Funds (3 credits)",
"CFIN 421 Asset Liability Management (3 credits)",
"CFIN 500 Financial Markets and Institutions (3 credits)",
"CFIN 501 Retirement Estate and Tax Planning (3 credits)",
"CFIN 507 Analysis of Financial Statements (3 credits)",
"CFIN 512 Corporate Finance (3 credits)",
"CFIN 515 Behavioural Finance (3 credits)",
"CFIN 522 Applied Topics: Corporate Finance (3 credits)",
"CFIN 525 Treasury Management (3 credits)",
"CFIN 528 Strategic Asset and Liability Management (3 credits)",
"CFIN 530 Investment Analysis (3 credits)",
"CFIN 540 Introduction to International Finance (3 credits)",
"CFIN 550 Analysis of Fixed-Income Securities (3 credits)",
"CFIN 552 Firm Valuation (3 credits)",
"CFIN 553 Corporate Mergers and Acquisitions (3 credits)",
"CFIN 560 Mutual Funds Finance (3 credits)",
"CFIN 561 Sustainable Investments (3 credits)",
"CFIN 562 Finance and Sustainable Enterprise (3 credits)",
"CFIN 590 Topics in Finance (3 credits)",
"CFIN 595 Derivatives and Risk Management Tools (3 credits)",
"CFRN 102 Beginners’ French (11 CE units)",
"CFRN 104 Elementary Communication in French (11 CE units)",
"CFRN 106 Elementary French 2 (11 CE units)",
"CFRN 120 French Oral Communication - Short Beginners A (6 CE units)",
"CFRN 130 French Oral Communication - Beginners A (12 CE units)",
"CFRN 140 French Oral Communication - Short Beginners B (6 CE units)",
"CFRN 160 French Oral Communication - Beginners B (12 CE units)",
"CFRN 203 Intensive French - Beginner (20 CE units)",
"CFRN 215 French Grammar at Work (8 CE units)",
"CFRN 216 French Grammar and Writing in Context 1 (8 CE units)",
"CFRN 220 French Oral Communication - Short Intermediate A (6 CE units)",
"CFRN 223 Intensive French - Elementary Low (20 CE units)",
"CFRN 230 French Oral Communication - Intermediate A (12 CE units)",
"CFRN 240 French Oral Communication - Short Intermediate B (6 CE units)",
"CFRN 260 French Oral Communciation - Intermediate B (12 CE units)",
"CFRN 310 Specialized French for Academic/Professional Purposes (16 CE units)",
"CFRN 313 Sp Intensive French Level 1 (30 CE units)",
"CFRN 315 French Grammar and Writing in Context 2 (8 CE units)",
"CFRN 316 French Vocabulary for Workplace (8 CE units)",
"CFRN 320 French Oral Communication - Short Advanced A (6 CE units)",
"CFRN 323 Intensive French - Elementary (20 CE units)",
"CFRN 325 French Oral Communication - Advanced A (12 CE units)",
"CFRN 333 Intensive French - Intermediate 1 (20 CE units)",
"CFRN 335 French Oral Communication - Short Advanced B (6 CE units)",
"CFRN 343 Intensive French - Intermediate 2 (20 CE units)",
"CFRN 344 Intensive French/Short Course (12 CE units)",
"CFRN 345 French Oral Communication - Advanced B (12 CE units)",
"CFRN 355 Intensive French - Intermediate High (20 CE units)",
"CFRN 415 French Writing Techniques for Workplace (8 CE units)",
"CFRN 416 French Written Communication Strategies for Workplace (8 CE units)",
"CFRN 423 Intensive French - Advanced (20 CE units)",
"CGM2 510 Project Management: Tools and Techniques (3 credits)",
"CGM2 520 Sales Management and Negotiation Strategies (3 credits)",
"CGM2 590 Topics in Management (3 credits)",
"CGM2 590D1 Topics in Management (1.5 credits)",
"CGM2 590D2 Topics in Management (1.5 credits)",
"CGM2 590N1 Topics in Management (1.5 credits)",
"CGM2 590N2 Topics in Management (1.5 credits)",
"CGMG 210 Fundamentals of Project Management (3 credits)",
"CGMG 282 Introduction to Business (3 credits)",
"CGMG 305 Managing in Public and Non-Profit Organizations (3 credits)",
"CGMG 318 Selling Models and Business Negotiation (3 credits)",
"CGMG 319 International Business Practices (3 credits)",
"CGMG 445 Ethical Issues in Business Practices (3 credits)",
"CHEE 200 Chemical Engineering Principles 1 (3 credits)",
"CHEE 204 Chemical Engineering Principles 2 (3 credits)",
"CHEE 220 Chemical Engineering Thermodynamics (3 credits)",
"CHEE 230 Environmental Aspects of Technology (3 credits)",
"CHEE 231 Data Analysis and Design of Experiments (3 credits)",
"CHEE 291 Instrumentation and Measurement 1 (4 credits)",
"CHEE 301 Resource Recovery from Waste (3 credits)",
"CHEE 310 Physical Chemistry for Engineers (3 credits)",
"CHEE 314 Fluid Mechanics (3 credits)",
"CHEE 315 Heat and Mass Transfer (3 credits)",
"CHEE 351 Separation Processes (3 credits)",
"CHEE 360 Technical Paper (1 credit)",
"CHEE 363 Projects Chemical Engineering 1 (2 credits)",
"CHEE 370 Elements of Biotechnology (3 credits)",
"CHEE 380 Materials Science (3 credits)",
"CHEE 390 Computational Methods in Chemical Engineering (3 credits)",
"CHEE 400 Principles of Energy Conversion (3 credits)",
"CHEE 401 Energy Systems Engineering (3 credits)",
"CHEE 423 Chemical Reaction Engineering (3 credits)",
"CHEE 438 Engineering Principles in Pulp and Paper Processes (3 credits)",
"CHEE 440 Process Modelling (3 credits)",
"CHEE 452 Particulate Systems (3 credits)",
"CHEE 453 Process Design (4 credits)",
"CHEE 455 Process Control (3 credits)",
"CHEE 456 Design Project 1 (4 credits)",
"CHEE 457 Design Project 2 (5 credits)",
"CHEE 462 Technical Paper 2 (1 credit)",
"CHEE 474 Biochemical Engineering (3 credits)",
"CHEE 484 Materials Engineering (3 credits)",
"CHEE 491 Instrumentation and Measurement 2 (4 credits)",
"CHEE 494 Research Project and Seminar 1 (3 credits)",
"CHEE 494D1 Research Project and Seminar 1 (1.5 credits)",
"CHEE 494D2 Research Project and Seminar 1 (1.5 credits)",
"CHEE 495 Research Project and Seminar 2 (4 credits)",
"CHEE 495D1 Research Project and Seminar 2 (2 credits)",
"CHEE 495D2 Research Project and Seminar 2 (2 credits)",
"CHEE 496 Environmental Research Project (3 credits)",
"CHEE 496D1 Environmental Research Project (1.5 credits)",
"CHEE 496D2 Environmental Research Project (1.5 credits)",
"CHEE 510 Advanced Separation Processes (3 credits)",
"CHEE 511 Catalysis for Sustainable Fuels and Chemicals (3 credits)",
"CHEE 512 Stem Cell Bioprocess Engineering (3 credits)",
"CHEE 515 Material Surfaces: A Biomimetic Approach (3 credits)",
"CHEE 521 Nanomaterials and the Aquatic Environment (3 credits)",
"CHEE 541 Electrochemical Engineering (3 credits)",
"CHEE 543 Plasma Engineering (3 credits)",
"CHEE 561 Introduction to Soft Tissue Biophysics (3 credits)",
"CHEE 563 Biofluids and Cardiovascular Mechanics (3 credits)",
"CHEE 571 Small Computer Applications: Chemical Engineering (3 credits)",
"CHEE 582 Polymer Science & Engineering (3 credits)",
"CHEE 584 Polymer Processing (3 credits)",
"CHEE 585 Foundations of Soft Matter (3 credits)",
"CHEE 587 Chemical Processing: Electronics Industry (3 credits)",
"CHEE 591 Environmental Bioremediation (3 credits)",
"CHEE 592 Industrial Air Pollution Control (3 credits)",
"CHEE 593 Industrial Water Pollution Control (3 credits)",
"CHEE 594 Biocolloids in Environmental Systems (3 credits)",
"CHEE 611 Heat and Mass Transfer (4 credits)",
"CHEE 621 Thermodynamics (4 credits)",
"CHEE 631 Foundations of Fluid Mechanics (4 credits)",
"CHEE 641 Chemical Reaction Engineering (4 credits)",
"CHEE 651 Advanced Biochemical Engineering (4 credits)",
"CHEE 662 Computational Methods (4 credits)",
"CHEE 672 Process Dynamics and Control (4 credits)",
"CHEE 681 Laboratory Safety 1 (1 credit)",
"CHEE 682 Laboratory Safety 2 (1 credit)",
"CHEE 687 Research Skills and Ethics (2 credits)",
"CHEE 690 Research Techniques (3 credits)",
"CHEE 693 Selected Topics in Chemical Engineering (3 credits)",
"CHEE 694 Oral Presentation Skills (1 credit)",
"CHEE 695 Project in Chemical Engineering (6 credits)",
"CHEE 696 Extended Project (6 credits)",
"CHEE 697 Thesis Proposal (6 credits)",
"CHEE 698 Thesis Research 1 (12 credits)",
"CHEE 698N1 Thesis Research 1 (6 credits)",
"CHEE 698N2 Thesis Research 1 (6 credits)",
"CHEE 699 Thesis Research 2 (13 credits)",
"CHEE 795 Ph.D. Thesis Proposal",
"CHEE 796 Ph.D. Proposal Defence",
"CHEE 797 Ph.D. Seminar",
"CHEM 110 General Chemistry 1 (4 credits)",
"CHEM 112 General Chemistry Laboratory 1 (1 credit)",
"CHEM 120 General Chemistry 2 (4 credits)",
"CHEM 122 General Chemistry Laboratory 2 (1 credit)",
"CHEM 180 World of Chemistry: Environment (3 credits)",
"CHEM 181 World of Chemistry: Food (3 credits)",
"CHEM 182 World of Chemistry: Technology (3 credits)",
"CHEM 183 World of Chemistry: Drugs (3 credits)",
"CHEM 199 FYS: Why Chemistry? (3 credits)",
"CHEM 203 Survey of Physical Chemistry (3 credits)",
"CHEM 204 Physical Chemistry/Biological Sciences 1 (3 credits)",
"CHEM 211 Organic Chemistry 1 Lectures (3 credits)",
"CHEM 212 Introductory Organic Chemistry 1 (4 credits)",
"CHEM 213 Introductory Physical Chemistry 1: Thermodynamics (3 credits)",
"CHEM 214 Physical Chemistry/Biological Sciences 2 (3 credits)",
"CHEM 217 General Analytical Chemistry Lab 1 (1 credit)",
"CHEM 219 Introduction to Atmospheric Chemistry (3 credits)",
"CHEM 222 Introductory Organic Chemistry 2 (4 credits)",
"CHEM 223 Introductory Physical Chemistry 1 (2 credits)",
"CHEM 224 Organic Chemistry Laboratory 1 (1 credit)",
"CHEM 232 Organic Chemistry Principles (4 credits)",
"CHEM 233 Topics in Physical Chemistry (3 credits)",
"CHEM 234 Topics in Organic Chemistry (3 credits)",
"CHEM 243 Introductory Physical Chemistry 2 (2 credits)",
"CHEM 244 Organic Chemistry Laboratory 2 (1 credit)",
"CHEM 253 Introductory Physical Chemistry 1 Laboratory (1 credit)",
"CHEM 267 Introductory Chemical Analysis (3 credits)",
"CHEM 273 Introductory Physical Chemistry 2: Kinetics and Methods (3 credits)",
"CHEM 281 Inorganic Chemistry 1 (3 credits)",
"CHEM 283 Physical Chemistry Laboratory (2 credits)",
"CHEM 287 Introductory Analytical Chemistry (2 credits)",
"CHEM 297 Introductory Analytical Chemistry Laboratory (1 credit)",
"CHEM 302 Introductory Organic Chemistry 3 (3 credits)",
"CHEM 332 Biological Chemistry (3 credits)",
"CHEM 334 Advanced Materials (3 credits)",
"CHEM 345 Introduction to Quantum Chemistry (3 credits)",
"CHEM 355 Applications of Quantum Chemistry (3 credits)",
"CHEM 362 Advanced Organic Chemistry Laboratory (2 credits)",
"CHEM 365 Statistical Thermodynamics (2 credits)",
"CHEM 367 Instrumental Analysis 1 (3 credits)",
"CHEM 371 Inorganic Chemistry Laboratory (2 credits)",
"CHEM 371D1 Inorganic Chemistry Laboratory (1 credit)",
"CHEM 371D2 Inorganic Chemistry Laboratory (1 credit)",
"CHEM 377 Instrumental Analysis 2 (3 credits)",
"CHEM 381 Inorganic Chemistry 2 (3 credits)",
"CHEM 392 Experimental Chemistry 1 (3 credits)",
"CHEM 392D1 Experimental Chemistry 1 (1.5 credits)",
"CHEM 392D2 Experimental Chemistry 1 (1.5 credits)",
"CHEM 396 Undergraduate Research Project (3 credits)",
"CHEM 400 Independent Study in Chemistry (1 credit)",
"CHEM 429 Chemistry of Energy Storage and Utilization. (3 credits)",
"CHEM 434 Advanced Materials (3 credits)",
"CHEM 462 Green Chemistry (3 credits)",
"CHEM 470 Research Project 1 (6 credits)",
"CHEM 470D1 Research Project 1 (3 credits)",
"CHEM 470D2 Research Project 1 (3 credits)",
"CHEM 480 Undergraduate Research Project 2 (3 credits)",
"CHEM 480D1 Undergraduate Research Project 2 (1.5 credits)",
"CHEM 480D2 Undergraduate Research Project 2 (1.5 credits)",
"CHEM 482 Organic Chemistry: Natural Products (3 credits)",
"CHEM 493 Advanced Physical Chemistry Laboratory (2 credits)",
"CHEM 493D1 Advanced Physical Chemistry Laboratory (1 credit)",
"CHEM 493D2 Advanced Physical Chemistry Laboratory (1 credit)",
"CHEM 502 Advanced Bio-Organic Chemistry (3 credits)",
"CHEM 503 Drug Discovery (3 credits)",
"CHEM 504 Drug Design (3 credits)",
"CHEM 505 Computer Modeling of Molecules and Materials (3 credits)",
"CHEM 512 Catalysis Concepts and Applications (3 credits)",
"CHEM 514 Biophysical Chemistry (3 credits)",
"CHEM 516 Nuclear and Radiochemistry (3 credits)",
"CHEM 519 Advances in Chemistry of Atmosphere (3 credits)",
"CHEM 520 Methods in Chemical Biology (3 credits)",
"CHEM 522 Stereochemistry (3 credits)",
"CHEM 531 Chemistry of Inorganic Materials (3 credits)",
"CHEM 532 Structural Organic Chemistry (3 credits)",
"CHEM 533 Small Molecule Crystallography (3 credits)",
"CHEM 534 Nanoscience and Nanotechnology (3 credits)",
"CHEM 540 Advances in Industrial Biotechnology (3 credits)",
"CHEM 547 Laboratory Automation (3 credits)",
"CHEM 552 Physical Organic Chemistry (3 credits)",
"CHEM 555 NMR Spectroscopy (3 credits)",
"CHEM 556 Advanced Quantum Mechanics (3 credits)",
"CHEM 567 Chemometrics: Data Analysis (3 credits)",
"CHEM 571 Polymer Synthesis (3 credits)",
"CHEM 572 Synthetic Organic Chemistry (3 credits)",
"CHEM 574 Introductory Polymer Chemistry (3 credits)",
"CHEM 575 Chemical Kinetics (3 credits)",
"CHEM 577 Electrochemistry (3 credits)",
"CHEM 581 Inorganic Topics 1 (3 credits)",
"CHEM 582 Supramolecular Chemistry (3 credits)",
"CHEM 585 Colloid Chemistry (3 credits)",
"CHEM 587 Topics in Modern Analytical Chemistry (3 credits)",
"CHEM 591 Bioinorganic Chemistry (3 credits)",
"CHEM 593 Statistical Mechanics (3 credits)",
"CHEM 597 Analytical Spectroscopy (3 credits)",
"CHEM 603 Fundamentals of Spectroscopy (5 credits)",
"CHEM 611 Inorganic Topics 2 (4 credits)",
"CHEM 612 Organometallic Chemistry (5 credits)",
"CHEM 621 Reaction Mechanisms in Organic Chemistry (5 credits)",
"CHEM 629 Organic Synthesis (5 credits)",
"CHEM 631D1 Selected Topics in Analytical Chemistry (2 credits)",
"CHEM 631D2 Selected Topics in Analytical Chemistry (2 credits)",
"CHEM 634 Seminar in Advanced Materials (3 credits)",
"CHEM 636 Laboratory Automation 2 (5 credits)",
"CHEM 646 Advanced Statistical Mechanics (4 credits)",
"CHEM 650 Seminars in Chemistry 1 (1 credit)",
"CHEM 651 Seminars in Chemistry 2 (1 credit)",
"CHEM 655 Advanced NMR Spectroscopy (4 credits)",
"CHEM 666 Special Topics 2 (6 credits)",
"CHEM 667 Special Topics 3 (4 credits)",
"CHEM 673 Polymers in Solutions (4 credits)",
"CHEM 688 Progress Assessment 1 (3 credits)",
"CHEM 691 M.Sc. Thesis Research 1 (3 credits)",
"CHEM 692 M.Sc. Thesis Research 2 (6 credits)",
"CHEM 693 M.Sc. Thesis Research 3 (9 credits)",
"CHEM 694 M.Sc. Thesis Research 4 (12 credits)",
"CHEM 695 M.Sc. Thesis Research 5 (15 credits)",
"CHEM 697 M.Sc. Thesis Research 7 (9 credits)",
"CHEM 698 M.Sc. Thesis Research 8 (12 credits)",
"CHEM 699 Project (15 credits)",
"CHEM 701 Comprehensive Examination",
"CHEM 702 Progress Assessment 2",
"CHLC 351 Foundations of Health and Social Services Systems (3 credits)",
"CHLC 401 Evaluation of Health and Social Services (3 credits)",
"CHLC 401D1 Evaluation of Health and Social Services (1.5 credits)",
"CHLC 401D2 Evaluation of Health and Social Services (1.5 credits)",
"CHLC 401J1 Evaluation of Health and Social Services (1 credit)",
"CHLC 401J2 Evaluation of Health and Social Services (1 credit)",
"CHLC 401J3 Evaluation of Health and Social Services (1 credit)",
"CHLC 410  Fundamentals of Health and Social Services Info Systems (3 credits)",
"CHLC 415 Foundations of Legal & Ethical Aspects (3 credits)",
"CHLC 500 Health and Social Service Systems (3 credits)",
"CHLC 502 Health and Social Services Information Systems (3 credits)",
"CHLC 552 Legal & Ethical Aspects: Health and Social Services (3 credits)",
"CHLC 580 Health Services Management Field Project (3 credits)",
"CHLC 590 Topics in Health Care (3 credits)",
"CHLC 590J1 Topics in Health Care (1 credit)",
"CHLC 590J2 Topics in Health Care (1 credit)",
"CHLC 590J3 Topics in Health Care (1 credit)",
"CHLC 590N1 Topics in Health Care (1.5 credits)",
"CHLC 590N2 Topics in Health Care (1.5 credits)",
"CIAM 510 Overview of the Aviation Field (3 credits)",
"CIAM 520 Air Transportation Finance and Economics (3 credits)",
"CIAM 521 Aviation Safety and Security Management (3 credits)",
"CIAM 522 Aviation Law and Policy (3 credits)",
"CIAM 523 Air Navigation Services Management (3 credits)",
"CIAM 524 Airline Management (3 credits)",
"CIAM 525 Airport Management (3 credits)",
"CIAM 526 Air Cargo Management (3 credits)",
"CIAM 540 Integrated Aviation Management Project (3 credits)",
"CIAM 550 Commun & Networking Skills for Aviation Professionals (3 credits)",
"CIAM 552 Analytics & Bus. Intelligence for Aviation Professionals (3 credits)",
"CINC 200 Intercultural Civic Engagement/Service-Learning (3 credits)",
"CIVE 202 Construction Materials (4 credits)",
"CIVE 203 Solid Mechanics Laboratory (1 credit)",
"CIVE 205 Statics (3 credits)",
"CIVE 206 Dynamics (3 credits)",
"CIVE 207 Solid Mechanics (4 credits)",
"CIVE 208 Civil Engineering System Analysis (3 credits)",
"CIVE 210 Surveying (2 credits)",
"CIVE 225 Environmental Engineering (4 credits)",
"CIVE 281 Analytical Mechanics (3 credits)",
"CIVE 284 Structural Engineering Basics (4 credits)",
"CIVE 290 Thermodynamics and Heat Transfer (3 credits)",
"CIVE 302 Probabilistic Systems (3 credits)",
"CIVE 311 Geotechnical Mechanics (4 credits)",
"CIVE 317 Structural Engineering 1 (3 credits)",
"CIVE 318 Structural Engineering 2 (3 credits)",
"CIVE 319 Transportation Engineering (3 credits)",
"CIVE 320 Numerical Methods (4 credits)",
"CIVE 323 Hydrology and Water Resources (3 credits)",
"CIVE 324 Sustainable Project Management (3 credits)",
"CIVE 326 Fluids & Hydraulics Laboratory (1 credit)",
"CIVE 327 Fluid Mechanics and Hydraulics (4 credits)",
"CIVE 385 Structural Steel and Timber Design (3 credits)",
"CIVE 388 Foundation and Concrete Design (3 credits)",
"CIVE 416 Geotechnical Engineering (3 credits)",
"CIVE 418 Design Project (4 credits)",
"CIVE 421 Municipal Systems (3 credits)",
"CIVE 428 Water Resources and Hydraulic Engineering (3 credits)",
"CIVE 430 Water Treatment and Pollution Control (3 credits)",
"CIVE 432 Technical Paper (1 credit)",
"CIVE 433 Urban Planning (3 credits)",
"CIVE 440 Traffic Engineering and Simulation (3 credits)",
"CIVE 446 Construction Engineering (3 credits)",
"CIVE 451 Geoenvironmental Engineering (3 credits)",
"CIVE 452 Water Resources in Barbados (3 credits)",
"CIVE 460 Matrix Structural Analysis (3 credits)",
"CIVE 462 Design of Steel Structures (3 credits)",
"CIVE 463 Design of Concrete Structures (3 credits)",
"CIVE 469 Infrastructure and Society (3 credits)",
"CIVE 470 Undergraduate Research Project (3 credits)",
"CIVE 512 Advanced Civil Engineering Materials (3 credits)",
"CIVE 514 Structural Mechanics (3 credits)",
"CIVE 519 Sustainable Development Plans (6 credits)",
"CIVE 520 Groundwater Hydrology (3 credits)",
"CIVE 521 Nanomaterials and the Aquatic Environment (3 credits)",
"CIVE 527 Renovation and Preservation: Infrastructure (3 credits)",
"CIVE 540 Urban Transportation Planning (3 credits)",
"CIVE 542 Transportation Network Analysis (3 credits)",
"CIVE 546 Selected Topics in Civil Engineering 1 (3 credits)",
"CIVE 550 Water Resources Management (3 credits)",
"CIVE 551 Environmental Transport Processes (3 credits)",
"CIVE 555 Environmental Data Analysis (3 credits)",
"CIVE 557 Microbiology for Environmental Engineering (3 credits)",
"CIVE 558 Biomolecular Techniques for Environmental Engineering (3 credits)",
"CIVE 560 Transportation Safety and Design (3 credits)",
"CIVE 561 Urban Activity Air Pollution and Health (3 credits)",
"CIVE 572 Computational Hydraulics (3 credits)",
"CIVE 573 Hydraulic Structures (3 credits)",
"CIVE 574 Fluid Mechanics of Water Pollution (3 credits)",
"CIVE 577 River Engineering (3 credits)",
"CIVE 584 Mechanics of Groundwater Flow (3 credits)",
"CIVE 602 Finite Element Analysis (4 credits)",
"CIVE 603 Structural Dynamics (4 credits)",
"CIVE 604 Theory of Plates and Shells (4 credits)",
"CIVE 605 Stability of Structures (4 credits)",
"CIVE 607 Advanced Design in Steel (4 credits)",
"CIVE 609 Risk Engineering (4 credits)",
"CIVE 610 Special Topics in Structural Mechanics (4 credits)",
"CIVE 612 Earthquake-Resistant Design (4 credits)",
"CIVE 614 Composites for Construction (4 credits)",
"CIVE 615 Environmental Engineering Seminar (3 credits)",
"CIVE 616 Nonlinear Structural Analysis for Buildings (4 credits)",
"CIVE 617 Design and Rating of Highway and Railway Bridges (4 credits)",
"CIVE 618 Design in Concrete 1 (4 credits)",
"CIVE 621 Sustainable Design of Municipal Systems (4 credits)",
"CIVE 622 Prestressed Concrete (4 credits)",
"CIVE 623 Durability of Construction Materials (4 credits)",
"CIVE 624 Durability of Structures (4 credits)",
"CIVE 625 Condition Assessment of Existing Structures (4 credits)",
"CIVE 628 Design of Wood Structures (4 credits)",
"CIVE 629 Sustainable Design: Water and Wastewater Facilities (4 credits)",
"CIVE 630 Thesis Research 1 (3 credits)",
"CIVE 631 Thesis Research 2 (3 credits)",
"CIVE 632 Thesis Research 3 (3 credits)",
"CIVE 633 Thesis Research 4 (6 credits)",
"CIVE 634 Thesis Research 5 (6 credits)",
"CIVE 635 Thesis Research 6 (6 credits)",
"CIVE 637 Discrete Choice Modeling in Transportation (4 credits)",
"CIVE 648 Special Topics in Civil Engineering (4 credits)",
"CIVE 651 Theory: Water / Wastewater Treatment (4 credits)",
"CIVE 652 Bioprocesses for Wastewater Resource Recovery (4 credits)",
"CIVE 660 Chemical and Physical Treatment of Waters (4 credits)",
"CIVE 661 Modelling of Transportation Emissions (4 credits)",
"CIVE 662 Master's (Thesis) Research Seminar (1 credit)",
"CIVE 663 Environmental Fate of Organic Chemicals (4 credits)",
"CIVE 664 MEng (Non-thesis) Research Seminar (3 credits)",
"CIVE 677 Water-Energy Sustainability (4 credits)",
"CIVE 683 Advanced Foundation Design (4 credits)",
"CIVE 686 Site Remediation (4 credits)",
"CIVE 691 Research Project 1 (1 credit)",
"CIVE 692 Research Project 2 (2 credits)",
"CIVE 693 Research Project 3 (3 credits)",
"CIVE 694 Research Project 4 (4 credits)",
"CIVE 695 Research Project 5 (5 credits)",
"CIVE 696 Research Project 6 (6 credits)",
"CIVE 697 Research Project 7 (7 credits)",
"CIVE 701 Ph.D. Comprehensive Examination",
"CIVE 702 Ph.D. Research Proposal",
"CLAS 201 Greece and Rome (3 credits)",
"CLAS 203 Greek Mythology (3 credits)",
"CLAS 210 Introductory Latin 1 (3 credits)",
"CLAS 212 Introductory Latin 2 (3 credits)",
"CLAS 215 Intensive Introductory Latin (6 credits)",
"CLAS 220 Introductory Ancient Greek 1 (3 credits)",
"CLAS 222 Introductory Ancient Greek 2 (3 credits)",
"CLAS 225 Intensive Introductory Ancient Greek (6 credits)",
"CLAS 230D1 Introductory Modern Greek (3 credits)",
"CLAS 230D2 Introductory Modern Greek (3 credits)",
"CLAS 240 Introduction to Classical Archaeology (3 credits)",
"CLAS 301 Ancient Greek Literature and Society (3 credits)",
"CLAS 302 Roman Literature and Society (3 credits)",
"CLAS 303 Ancient Greek Religion (3 credits)",
"CLAS 304 Ancient Greek Democracy (3 credits)",
"CLAS 305 Roman Religion (3 credits)",
"CLAS 306 Classics in Modern Media (3 credits)",
"CLAS 308 Gender in the Ancient World (3 credits)",
"CLAS 310 Intermediate Latin 1 (3 credits)",
"CLAS 312 Intermediate Latin 2 (3 credits)",
"CLAS 315 Intermediate Latin 2: Selections (3 credits)",
"CLAS 320 Intermediate Ancient Greek 1 (3 credits)",
"CLAS 322 Intermediate Ancient Greek 2 (3 credits)",
"CLAS 326 Intermediate Ancient Greek 2: Selections (3 credits)",
"CLAS 331 Intermediate Modern Greek 1 (3 credits)",
"CLAS 332 Intermediate Modern Greek 2 (3 credits)",
"CLAS 335 Modern Greek Culture and Society (3 credits)",
"CLAS 336 Modern Greek Literature (3 credits)",
"CLAS 345 Study Tour: Greece (3 credits)",
"CLAS 348 Topics: Classical Archaeology (3 credits)",
"CLAS 349 Archaeology Fieldwork: Italy (3 credits)",
"CLAS 350 Special Topics in Classics (3 credits)",
"CLAS 400 Ancient Drama and Theatre (3 credits)",
"CLAS 401 Ancient Comedy (3 credits)",
"CLAS 402 Hellenistic Literature and Society (3 credits)",
"CLAS 403 The Greek and Roman Novel (3 credits)",
"CLAS 404 Classical Tradition (3 credits)",
"CLAS 405 The Epic Tradition (3 credits)",
"CLAS 406 Greek and Roman Historiography (3 credits)",
"CLAS 407 Ancient Lyric and Elegy (3 credits)",
"CLAS 408 Greek and Roman Oratory (3 credits)",
"CLAS 409 Ancient Didactic Poetry (3 credits)",
"CLAS 410 Advanced Latin: Authors (3 credits)",
"CLAS 412 Advanced Latin: Themes (3 credits)",
"CLAS 419 Advanced Latin: Post-Classical (3 credits)",
"CLAS 420 Advanced Ancient Greek: Authors (3 credits)",
"CLAS 422 Advanced Ancient Greek: Themes (3 credits)",
"CLAS 429 Medieval Greek (3 credits)",
"CLAS 450 Advanced Topics (3 credits)",
"CLAS 461 Greco-Roman Religious Literature (3 credits)",
"CLAS 498 Independent Research (3 credits)",
"CLAS 499 Internship: Classics (3 credits)",
"CLAS 500 Classics Seminar (3 credits)",
"CLAS 609 Intensive Latin Review (3 credits)",
"CLAS 610 Readings in Latin Literature (3 credits)",
"CLAS 612 Topics in Latin Literature (3 credits)",
"CLAS 619 Intensive Ancient Greek Review (3 credits)",
"CLAS 620 Readings in Ancient Greek Literature (3 credits)",
"CLAS 622 Topics in Ancient Greek Literature (3 credits)",
"CLAS 645 Field Tour in Greece (3 credits)",
"CLAS 649 Archeological Fieldwork in Italy (3 credits)",
"CLAS 650 Seminar (3 credits)",
"CLAS 678 Modern Greek 1 (3 credits)",
"CLAS 679 Modern Greek 2 (3 credits)",
"CLAS 681 M.A.Research Project 1 (6 credits)",
"CLAS 682 M.A.Research Project 2 (6 credits)",
"CLAS 683 M.A.Research Project 3 (6 credits)",
"CLAS 685 Methods Seminar (3 credits)",
"CLAS 692 Research Paper (3 credits)",
"CLAS 695 M.A. Thesis Proposal (6 credits)",
"CLAS 696 M.A. Thesis Research 1 (6 credits)",
"CLAS 697 M.A. Thesis Research 2 (6 credits)",
"CLAS 698 M.A. Thesis Submission (6 credits)",
"CLAS 699 Tutorial (3 credits)",
"CLAS 701D1 Ph.D. Comprehensive Examination (6 credits)",
"CLAS 701D2 Ph.D. Comprehensive Examination (6 credits)",
"CLAS 701N1 Ph.D. Comprehensive Examination (6 credits)",
"CLAS 701N2 Ph.D. Comprehensive Examination (6 credits)",
"CMIS 422 Information System Security (3 credits)",
"CMIS 520 Accounting Information Support Systems (3 credits)",
"CMIS 530 Digital Analytics and Targeting (3 credits)",
"CMIS 541 Information Systems for Managers (3 credits)",
"CMIS 542 Strategic Internet Marketing (3 credits)",
"CMIS 543 Digital Customer Experience (3 credits)",
"CMIS 544 Digital Marketing Automation Planning and Technology (3 credits)",
"CMIS 545 Cloud Computing Architecture (3 credits)",
"CMIS 549 Digital Media and Search Engine Optimization (3 credits)",
"CMIS 550 Fundamentals of Big Data (3 credits)",
"CMPL 500 Aboriginal Peoples and the Law (3 credits)",
"CMPL 500D1 Aboriginal Peoples and the Law (1.5 credits)",
"CMPL 500D2 Aboriginal Peoples and the Law (1.5 credits)",
"CMPL 501 Jurisprudence (3 credits)",
"CMPL 504 Feminist Legal Theory (3 credits)",
"CMPL 505 Advanced Jurisprudence (2 credits)",
"CMPL 506 Legal Theory (3 credits)",
"CMPL 507 Linguistic and Literary Approaches to Law (2 credits)",
"CMPL 508 Research Seminar 1 (2 credits)",
"CMPL 509 Research Seminar 2 (2 credits)",
"CMPL 510 Roman Law (3 credits)",
"CMPL 511 Social Diversity and Law (3 credits)",
"CMPL 512 Theories of Justice (3 credits)",
"CMPL 513 Talmudic Law (3 credits)",
"CMPL 515 International Carriage of Goods by Sea (3 credits)",
"CMPL 516 International Development Law (3 credits)",
"CMPL 517 Comparative Legal Institutions (3 credits)",
"CMPL 518 Policies Politics and Legislative Process (3 credits)",
"CMPL 519 Comparative Modern Legal History (3 credits)",
"CMPL 521 Trade Regulation (3 credits)",
"CMPL 522 Medical Liability (3 credits)",
"CMPL 524 Entertainment Law (3 credits)",
"CMPL 533 Resolution of International Disputes (3 credits)",
"CMPL 536 European Union Law 1 (3 credits)",
"CMPL 537 European Union Law 2 (2 credits)",
"CMPL 539 International Taxation (3 credits)",
"CMPL 543 Law and Practice of International Trade (3 credits)",
"CMPL 546 International Environmental Law and Politics (3 credits)",
"CMPL 547 Canadian Legal History (3 credits)",
"CMPL 551 Comparative Medical Law (2 credits)",
"CMPL 553 International Maritime Conventions (3 credits)",
"CMPL 565 International Humanitarian Law (3 credits)",
"CMPL 568 Extrajudicial Dispute Resolution (3 credits)",
"CMPL 571 International Law of Human Rights (3 credits)",
"CMPL 573 Civil Liberties (3 credits)",
"CMPL 574 Government Control Of Business (3 credits)",
"CMPL 575 Discrimination and the Law (3 credits)",
"CMPL 576 Science Technology and Law (3 credits)",
"CMPL 577 Communications Law (3 credits)",
"CMPL 578 Computers and the Law (3 credits)",
"CMPL 580 Environment and the Law (3 credits)",
"CMPL 600 Legal Traditions (3 credits)",
"CMPL 601 Civil Law Perspectives (3 credits)",
"CMPL 602 Common Law Perspectives (3 credits)",
"CMPL 603 Human Rights & Cultural Diversity (3 credits)",
"CMPL 604 International Business Law (3 credits)",
"CMPL 605 Regulation Technology/Society (3 credits)",
"CMPL 610 Legal Research Methodology (3 credits)",
"CMPL 610D1 Legal Research Methodology (1.5 credits)",
"CMPL 610D2 Legal Research Methodology (1.5 credits)",
"CMPL 612 Master's Thesis 1 (3 credits)",
"CMPL 613 Master's Thesis 2 (3 credits)",
"CMPL 614 Master's Thesis 3 (3 credits)",
"CMPL 615 Master's Thesis 4 (6 credits)",
"CMPL 615D1 Master's Thesis 4 (3 credits)",
"CMPL 615D2 Master's Thesis 4 (3 credits)",
"CMPL 616 Master's Thesis 5 (12 credits)",
"CMPL 616D1 Master's Thesis 5 (6 credits)",
"CMPL 616D2 Master's Thesis 5 (6 credits)",
"CMPL 617 Master's Thesis 6 (3 credits)",
"CMPL 618 Master's Thesis 7 (2 credits)",
"CMPL 619 Master's Thesis 8 (1 credit)",
"CMPL 635 Independent Study 1 (3 credits)",
"CMPL 636 Independent Study 2 (3 credits)",
"CMPL 637 Independent Study 3 (3 credits)",
"CMPL 641 Theoretical Approaches to Law (3 credits)",
"CMPL 642 Law and Health Care (3 credits)",
"CMPL 655 Research Project 1 (15 credits)",
"CMPL 656 Research Project 2 (2 credits)",
"CMPL 657 Research Project 3 (1 credit)",
"CMPL 701 Comprehensive Examination-Comparative Law",
"CMR2 542 Marketing Principles and Applications (3 credits)",
"CMR2 543 Marketing of Services (3 credits)",
"CMR2 548 Processes of Marketing Research (3 credits)",
"CMR2 549 Strategic Selling (3 credits)",
"CMR2 556 Buyer Behaviour (3 credits)",
"CMR2 564 Marketing Communications: A Strategic Approach (3 credits)",
"CMR2 566 Global Marketing Management (3 credits)",
"CMR2 570 Strategic Marketing Planning (3 credits)",
"CMR2 573 Digital Marketing Communications (3 credits)",
"CMR2 590 Topics in Marketing (3 credits)",
"CMRK 200 Fundamentals of Marketing (3 credits)",
"CMRK 225 Marketing Statistics and Research (3 credits)",
"CMRK 230 Personal Selling and Customer Service (3 credits)",
"CMRK 235 Digital Media Marketing (3 credits)",
"CMRK 320 Principles of Consumer Behaviour (3 credits)",
"CMRK 321 Integrated Marketing Communications (3 credits)",
"CMRK 322 Basics of Service Marketing (3 credits)",
"CMRK 325 Global Marketing (3 credits)",
"CMRK 430 Marketing Applications (3 credits)",
"CMS2 500 Mathematics for Management (3 credits)",
"CMS2 505 Quantitative Analysis Tools in Decision Making (3 credits)",
"CMS2 515 Operations Management (3 credits)",
"CMS2 521 Applied Management Statistics (3 credits)",
"CMS2 524 Management of Service Operations (3 credits)",
"CMS2 525 Supply Chain Management (3 credits)",
"CMS2 527 Business Intelligence and Analytics (3 credits)",
"CMS2 529 Introduction to Data Analytics (3 credits)",
"CMS2 530 Simulation Analysis and Modeling (3 credits)",
"CMS2 531 Re-Engineering and Integration of Business Systems (3 credits)",
"CMS2 532 Lean Operations Systems (3 credits)",
"CMS2 533 Lean Operations and Performance Management in Health Services (3 credits)",
"CMS2 533D1 Lean Operations and Performance Management in Health Services (1.5 credits)",
"CMS2 533D2 Lean Operations and Performance Management in Health Services (1.5 credits)",
"CMS2 533J1 Lean Operations and Performance Management in Health Services (1 credit)",
"CMS2 533J2 Lean Operations and Performance Management in Health Services (1 credit)",
"CMS2 533J3 Lean Operations and Performance Management in Health Services (1 credit)",
"CMS2 540 Six-Sigma Quality Management (3 credits)",
"CMS2 550 Supply Chain Field Project (3 credits)",
"CMS2 590 Special Topics in Mathematics (3 credits)",
"CMSC 000 Foundations of Mathematics",
"CMSC 001 Principles of Calculus (12 CE units)",
"CMSC 002 Advanced Calculus (14 CE units)",
"CMSC 101 Mathematical Tools for Management Professionals (3 credits)",
"CMSC 105 Topics in Foundations of Mathematics (3 credits)",
"CMSC 110 Topics in Applied Mathematics (3 credits)",
"CMSC 203 Survey of Basic Mathematics 1 (3 credits)",
"CMSC 204 Survey of Basic Mathematics 2 (3 credits)",
"CMSC 221 Applied Quantitative Methods (3 credits)",
"CMSC 300 Concepts in Mathematics (3 credits)",
"CMSC 310 Managerial Economics and Analysis (3 credits)",
"CMSC 320 Business Statistics (3 credits)",
"CMSC 395 Special Topics in Mathematics (3 credits)",
"COGS 396 Undergraduate Research Project (3 credits)",
"COGS 401 Research Cognitive Science 1 (6 credits)",
"COGS 401D1 Research Cognitive Science 1 (3 credits)",
"COGS 401D2 Research Cognitive Science 1 (3 credits)",
"COGS 444 Honours Research (6 credits)",
"COGS 444D1 Honours Research (3 credits)",
"COGS 444D2 Honours Research (3 credits)",
"COGS 444N1 Honours Research (3 credits)",
"COGS 444N2 Honours Research (3 credits)",
"COMP 102 Computers and Computing (3 credits)",
"COMP 189 Computers and Society (3 credits)",
"COMP 199 FYS: Excursions in Computer Science (3 credits)",
"COMP 202 Foundations of Programming (3 credits)",
"COMP 204 Computer Programming for Life Sciences (3 credits)",
"COMP 206 Introduction to Software Systems (3 credits)",
"COMP 208 Computer Programming for Physical Sciences and Engineering (3 credits)",
"COMP 230 Logic and Computability (3 credits)",
"COMP 250 Introduction to Computer Science (3 credits)",
"COMP 251 Algorithms and Data Structures (3 credits)",
"COMP 252 Honours Algorithms and Data Structures (3 credits)",
"COMP 273 Introduction to Computer Systems (3 credits)",
"COMP 280 History and Philosophy of Computing (3 credits)",
"COMP 302 Programming Languages and Paradigms (3 credits)",
"COMP 303 Software Design (3 credits)",
"COMP 307 Principles of Web Development (2 credits)",
"COMP 308 Computer Systems Lab (1 credit)",
"COMP 310 Operating Systems (3 credits)",
"COMP 321 Programming Challenges (1 credit)",
"COMP 322 Introduction to C++ (1 credit)",
"COMP 330 Theory of Computation (3 credits)",
"COMP 350 Numerical Computing (3 credits)",
"COMP 360 Algorithm Design (3 credits)",
"COMP 361D1 Software Engineering Project (3 credits)",
"COMP 361D2 Software Engineering Project (3 credits)",
"COMP 362 Honours Algorithm Design (3 credits)",
"COMP 364 Computer Tools for Life Sciences (3 credits)",
"COMP 396 Undergraduate Research Project (3 credits)",
"COMP 400 Project in Computer Science (4 credits)",
"COMP 401 Project in Biology and Computer Science (3 credits)",
"COMP 402 Honours Project in Computer Science and Biology (6 credits)",
"COMP 402D1 Honours Project in Computer Science and Biology (3 credits)",
"COMP 402D2 Honours Project in Computer Science and Biology (3 credits)",
"COMP 409 Concurrent Programming (3 credits)",
"COMP 417 Introduction Robotics and Intelligent Systems (3 credits)",
"COMP 421 Database Systems (3 credits)",
"COMP 424 Artificial Intelligence (3 credits)",
"COMP 445 Computational Linguistics (3 credits)",
"COMP 451 Fundamentals of Machine Learning (3 credits)",
"COMP 462 Computational Biology Methods (3 credits)",
"COMP 480 Independent Studies in Computer Science (3 credits)",
"COMP 512 Distributed Systems (4 credits)",
"COMP 520 Compiler Design (4 credits)",
"COMP 521 Modern Computer Games (4 credits)",
"COMP 522 Modelling and Simulation (4 credits)",
"COMP 523 Language-based Security (3 credits)",
"COMP 524 Theoretical Foundations of Programming Languages (3 credits)",
"COMP 525 Formal Verification (3 credits)",
"COMP 526 Probabilistic Reasoning and AI (3 credits)",
"COMP 527 Logic and Computation (3 credits)",
"COMP 529 Software Architecture (4 credits)",
"COMP 531 Advanced Theory of Computation (3 credits)",
"COMP 533 Model-Driven Software Development (3 credits)",
"COMP 535 Computer Networks 1 (4 credits)",
"COMP 540 Matrix Computations (4 credits)",
"COMP 546 Computational Perception (4 credits)",
"COMP 547 Cryptography and Data Security (4 credits)",
"COMP 550 Natural Language Processing (3 credits)",
"COMP 551 Applied Machine Learning (4 credits)",
"COMP 552 Combinatorial Optimization (4 credits)",
"COMP 553 Algorithmic Game Theory (4 credits)",
"COMP 554 Approximation Algorithms (4 credits)",
"COMP 557 Fundamentals of Computer Graphics (4 credits)",
"COMP 558 Fundamentals of Computer Vision (4 credits)",
"COMP 559 Fundamentals of Computer Animation (4 credits)",
"COMP 560 Graph Algorithms and Applications (3 credits)",
"COMP 561 Computational Biology Methods and Research (4 credits)",
"COMP 564 Advanced Computational Biology Methods and Research (3 credits)",
"COMP 566 Discrete Optimization 1 (3 credits)",
"COMP 567 Discrete Optimization 2 (3 credits)",
"COMP 575 Fundamentals of Distributed Algorithms (3 credits)",
"COMP 579 Reinforcement Learning (4 credits)",
"COMP 596 Topics in Computer Science 3 (3 credits)",
"COMP 597 Topics in Computer Science 4 (4 credits)",
"COMP 598 Topics in Computer Science 1 (3 credits)",
"COMP 599 Topics in Computer Science 2 (4 credits)",
"COMP 601 Thesis Literature Review (2 credits)",
"COMP 601D1 Thesis Literature Review (1 credit)",
"COMP 601D2 Thesis Literature Review (1 credit)",
"COMP 601N1 Thesis Literature Review (1 credit)",
"COMP 601N2 Thesis Literature Review (1 credit)",
"COMP 602 Computer Science Seminar 1 (1 credit)",
"COMP 603 Computer Science Seminar 2 (1 credit)",
"COMP 610 Information Structures 1 (4 credits)",
"COMP 612 Database Programming Principles (4 credits)",
"COMP 614 Distributed Data Management (4 credits)",
"COMP 616D1 Bioinformatics Seminar (1.5 credits)",
"COMP 616D2 Bioinformatics Seminar (1.5 credits)",
"COMP 616N1 Bioinformatics Seminar (1.5 credits)",
"COMP 616N2 Bioinformatics Seminar (1.5 credits)",
"COMP 618 Bioinformatics: Functional Genomics (3 credits)",
"COMP 621 Program Analysis and Transformations (4 credits)",
"COMP 627 Theoretical Programming Languages (4 credits)",
"COMP 642 Numerical Estimation Methods (4 credits)",
"COMP 647 Advanced Cryptography (4 credits)",
"COMP 649 Quantum Cryptography (4 credits)",
"COMP 652 Machine Learning (4 credits)",
"COMP 655 Distributed Simulation (4 credits)",
"COMP 667 Software Fault Tolerance (4 credits)",
"COMP 680 Mining Biological Sequences (4 credits)",
"COMP 690 Probabilistic Analysis of Algorithms (4 credits)",
"COMP 691 Thesis Research 1 (3 credits)",
"COMP 693 Research Project 1 (3 credits)",
"COMP 694 Research Project 2 (6 credits)",
"COMP 695 Research Project 3 (6 credits)",
"COMP 696 Thesis Research 2 (3 credits)",
"COMP 697 Thesis Research 3 (4 credits)",
"COMP 698 Thesis Research 4 (10 credits)",
"COMP 699 Thesis Research 5 (12 credits)",
"COMP 700 Ph.D. Comprehensive Examination",
"COMP 700D1 Ph.D. Comprehensive Examination",
"COMP 700D2 Ph.D. Comprehensive Examination",
"COMP 701 Thesis Proposal and Area Examination (3 credits)",
"COMP 760 Advanced Topics Theory 1 (4 credits)",
"COMP 761 Advanced Topics Theory 2 (4 credits)",
"COMP 762 Advanced Topics Programming 1 (4 credits)",
"COMP 763 Advanced Topics Programming 2 (4 credits)",
"COMP 764 Advanced Topics Systems 1 (4 credits)",
"COMP 765 Advanced Topics Systems 2 (4 credits)",
"COMP 766 Advanced Topics Applications 1 (4 credits)",
"COMP 767 Advanced Topics: Applications 2 (4 credits)",
"COMS 200 History of Communication (3 credits)",
"COMS 210 Introduction to Communication Studies (3 credits)",
"COMS 230 Communication and Democracy (3 credits)",
"COMS 300 Media and Modernity in the 20th Century (3 credits)",
"COMS 301 Core Concepts in Critical Theory (3 credits)",
"COMS 301J1 Core Concepts in Critical Theory (1 credit)",
"COMS 301J2 Core Concepts in Critical Theory (1 credit)",
"COMS 301J3 Core Concepts in Critical Theory (1 credit)",
"COMS 310 Media and Feminist Studies (3 credits)",
"COMS 320 Media and Empire (3 credits)",
"COMS 330 Media in Cultural Life (3 credits)",
"COMS 340 New Media (3 credits)",
"COMS 350 Sound Culture (3 credits)",
"COMS 354 Media Studies of Crime (3 credits)",
"COMS 355 Media Governance (3 credits)",
"COMS 361 Selected Topics Communication Studies 1 (3 credits)",
"COMS 362 Selected Topics Communication Studies 2 (3 credits)",
"COMS 400 Critical Theory Seminar (3 credits)",
"COMS 410 Cultures in Visualization (3 credits)",
"COMS 411 Disability Technology and Communication (3 credits)",
"COMS 425 Urban Culture & Everyday Life (3 credits)",
"COMS 435 Advanced Issues in Media Governance (3 credits)",
"COMS 490 Special Topics in History and Theory of Media (3 credits)",
"COMS 491 Special Topics in Communications Studies (3 credits)",
"COMS 492 Power Difference and Justice (3 credits)",
"COMS 495 Directed Reading (3 credits)",
"COMS 497 Independent Study (3 credits)",
"COMS 500 Special Topics in Communications Studies 1 (3 credits)",
"COMS 501 Special Topics in Communications Studies 2 (3 credits)",
"COMS 510 Canadian Broadcasting Policy (3 credits)",
"COMS 521 Communications in History (3 credits)",
"COMS 541 Cultural Industries (3 credits)",
"COMS 560 Communications and Development (3 credits)",
"COMS 601 The Problem of Communication (3 credits)",
"COMS 608 Sound Studies (3 credits)",
"COMS 611 History/Theory/Technology (3 credits)",
"COMS 612 Philosophy of Technology (3 credits)",
"COMS 613 Gender and Technology (3 credits)",
"COMS 614 Discourse Theory and Analysis (3 credits)",
"COMS 616 Staff-Student Colloquium 1 (3 credits)",
"COMS 617 Staff-Student Colloquium 2 (3 credits)",
"COMS 619 Material Culture & Communications (3 credits)",
"COMS 623 Information Design (3 credits)",
"COMS 625 Media Policy (3 credits)",
"COMS 627 Global Media Governance (3 credits)",
"COMS 629 Canadian Cultural Communications Policy (3 credits)",
"COMS 630 Readings in Communications Research 1 (3 credits)",
"COMS 631 Textual Analysis of Media (3 credits)",
"COMS 633 Feminist Media Studies (3 credits)",
"COMS 635 Communication and Postcolonial Thought (3 credits)",
"COMS 637 Historiography of Communications (3 credits)",
"COMS 639 Interpretive Methods in Media (3 credits)",
"COMS 643 Cultural Studies of News (3 credits)",
"COMS 644 Diasporic Popular Culture (3 credits)",
"COMS 646 Popular Media (3 credits)",
"COMS 647 Emerging Media (3 credits)",
"COMS 648 Bodies and Machines (3 credits)",
"COMS 649 Audience Analysis (3 credits)",
"COMS 651 Crime Media Culture (3 credits)",
"COMS 655 Media and the Senses (3 credits)",
"COMS 670D1 Film Studies Seminar (1.5 credits)",
"COMS 670D2 Film Studies Seminar (1.5 credits)",
"COMS 675 Media and Urban Life (3 credits)",
"COMS 681 Special Topics: Media and Culture (3 credits)",
"COMS 682 Special Topics in Media Theory (3 credits)",
"COMS 683 Special Topics in Media and Politics (3 credits)",
"COMS 692 M.A. Thesis Preparation 1 (6 credits)",
"COMS 693 M.A. Thesis Preparation 2 (6 credits)",
"COMS 694 M.A. Thesis Preparation 3 (6 credits)",
"COMS 695 M.A. Thesis Preparation 4 (6 credits)",
"COMS 696 Research Project 1 (6 credits)",
"COMS 697 Research Project 2 (6 credits)",
"COMS 702 Comprehensive Examination",
"COMS 703 Dissertation Proposal",
"COMS 730 Readings in Communications Research 2 (3 credits)",
"CORG 225 Foundation of Organizational Behaviour and Administration (3 credits)",
"CORG 225J1 Foundation of Organizational Behaviour and Administration (1 credit)",
"CORG 225J2 Foundation of Organizational Behaviour and Administration (1 credit)",
"CORG 225J3 Foundation of Organizational Behaviour and Administration (1 credit)",
"CORG 225N1 Foundation of Organizational Behaviour and Administration (1.5 credits)",
"CORG 225N2 Foundation of Organizational Behaviour and Administration (1.5 credits)",
"CORG 295 Employee Labour Relations and Law (3 credits)",
"CORG 395 Labour and Employment Law (3 credits)",
"CORG 415 Leading Teams in Organizations (3 credits)",
"CORG 416 Leading Change in Organizations (3 credits)",
"CORG 420 Human Resource Management: Theory and Practice (3 credits)",
"CORG 440 Organizational Learning and Development (3 credits)",
"CORG 445 Workforce Planning and Talent Acquisition (3 credits)",
"CORG 450 Workplace Health and Safety (3 credits)",
"CORG 470 Theories and Practices of Compensation (3 credits)",
"CORG 551 Behaviour in Organizations (3 credits)",
"CORG 551J1 Behaviour in Organizations (1 credit)",
"CORG 551J2 Behaviour in Organizations (1 credit)",
"CORG 551J3 Behaviour in Organizations (1 credit)",
"CORG 551N1 Behaviour in Organizations (1.5 credits)",
"CORG 551N2 Behaviour in Organizations (1.5 credits)",
"CORG 553 Employee and Labour Relations (3 credits)",
"CORG 554 Managing Occupational Health and Safety (3 credits)",
"CORG 555 Strategic Human Resources Management (3 credits)",
"CORG 556 Managing and Engaging Teamwork (3 credits)",
"CORG 556D1 Managing and Engaging Teamwork (1.5 credits)",
"CORG 556D2 Managing and Engaging Teamwork (1.5 credits)",
"CORG 556N1 Managing and Engaging Teamwork (1.5 credits)",
"CORG 556N2 Managing and Engaging Teamwork (1.5 credits)",
"CORG 557 Talent and Performance Management (3 credits)",
"CORG 560 Staffing Organizations (3 credits)",
"CORG 561 Developing Human Resources (3 credits)",
"CORG 562 Total Compensation and Rewards (3 credits)",
"CORG 565 Human Resources Information Systems: HRIS (3 credits)",
"CORG 590 Topics in Human Resources Management (3 credits)",
"CORG 590N1 Topics in Human Resources Management (1.5 credits)",
"CORG 590N2 Topics in Human Resources Management (1.5 credits)",
"CPAC 101 Topics in Citizenship and Social Engagement (1 credit)",
"CPAC 102 Topics in Volunteerism and Community Development (1 credit)",
"CPAG 220 Fundamentals of Public Finance Budgeting and Reporting (3 credits)",
"CPAG 225 Foundations of Public Regulations and Ethics in Public Sector (3 credits)",
"CPAG 300 Lean Operational Practices in Public Services (3 credits)",
"CPAG 305 Current Issues in Public Sector Administration (3 credits)",
"CPAG 400 Diversity and Cross Cultural Management (3 credits)",
"CPAG 410 Strategic Planning and Implementation (3 credits)",
"CPAG 500 Lean Operations in Public Services (3 credits)",
"CPAG 510 Current Issues in Public Sector Management (3 credits)",
"CPAG 515 Public Regulations and Ethics in the Public Sector (3 credits)",
"CPAG 520 Leadership and Governance in Public Organizations (3 credits)",
"CPAG 525 Public Finance Budgeting and Reporting (3 credits)",
"CPD2 505 Risk Management and Insurance (3 credits)",
"CPDV 301 Risk Management (3 credits)",
"CPDV 302 Risk Control (3 credits)",
"CPDV 303 Risk Financing (3 credits)",
"CPDV 305 General Insurance 1 (3 credits)",
"CPDV 306 General Insurance 2 (3 credits)",
"CPDV 400 Risks and Capital for Banks 1 (3 credits)",
"CPDV 402 Risks and Capital for Banks 2 (3 credits)",
"CPL2 510 Communication and Networking Skills (3 credits)",
"CPL2 511 Business Analytics for Decision-Making (1.5 credits)",
"CPL2 512 People Analytics for Decision-Making (1.5 credits)",
"CPL2 524 Introduction: International Business (3 credits)",
"CPL2 530 Canadian Import Export and Customs Regulations (3 credits)",
"CPL2 531 Leadership Theory and Practice (3 credits)",
"CPL2 532 Leading Change (3 credits)",
"CPL2 532D1 Leading Change (1.5 credits)",
"CPL2 532D2 Leading Change (1.5 credits)",
"CPL2 532J1 Leading Change (1 credit)",
"CPL2 532J2 Leading Change (1 credit)",
"CPL2 532J3 Leading Change (1 credit)",
"CPL2 532N1 Leading Change (1.5 credits)",
"CPL2 532N2 Leading Change (1.5 credits)",
"CPL2 533 Developing Leadership Skills (3 credits)",
"CPL2 534 Leading in Diverse and Global Workplaces (3 credits)",
"CPL2 535 Business in Emerging and Asian Markets (3 credits)",
"CPL2 552 Strategic Management (3 credits)",
"CPL2 552J1 Strategic Management (1 credit)",
"CPL2 552J2 Strategic Management (1 credit)",
"CPL2 552J3 Strategic Management (1 credit)",
"CPL2 552N1 Strategic Management (1.5 credits)",
"CPL2 552N2 Strategic Management (1.5 credits)",
"CPL2 553 Small Business Management (3 credits)",
"CPL2 554 International Business Policy (3 credits)",
"CPL2 561 North America and Global Economy (3 credits)",
"CPL2 590 Topics in International Business (3 credits)",
"CPL2 591 Essentials Coaching Skills (1 credit)",
"CPL2 592 Performance and Developmental Coaching Skills (1 credit)",
"CPL2 593 Transformative Coaching Skills (1 credit)",
"CPL2 595 Topics in Leadership (3 credits)",
"CPL2 595D1 Topics in Leadership (1.5 credits)",
"CPL2 595D2 Topics in Leadership (1.5 credits)",
"CPL2 595J1 Topics in Leadership (1 credit)",
"CPL2 595J2 Topics in Leadership (1 credit)",
"CPL2 595J3 Topics in Leadership (1 credit)",
"CPL2 595N1 Topics in Leadership (1.5 credits)",
"CPL2 595N2 Topics in Leadership (1.5 credits)",
"CPRL 214 Applied Public Relations Methods 1 (3 credits)",
"CPRL 220 Fundamentals of Fund-Raising (3 credits)",
"CPRL 221 Professional Communication and Networking (3 credits)",
"CPRL 223 Basics of Public Relations (3 credits)",
"CPRL 224 Applied Public Relations Methods 2 (3 credits)",
"CPRL 225 Social and Traditional Media Relations (3 credits)",
"CPRL 226 Corporate Communications (3 credits)",
"CPRL 227 Internal Communication (3 credits)",
"CPRL 228 Event Management (3 credits)",
"CPRL 321 PR Issues Management (3 credits)",
"CPRL 322 Cases in Public Relations (3 credits)",
"CPRL 510 Fundamentals of Public Relations (3 credits)",
"CPRL 515 Fund-raising and Philanthropy (3 credits)",
"CPRL 520 Applied Public Relations Communication (3 credits)",
"CPRL 530 Internal Stakeholder Communication (3 credits)",
"CPRL 531 Media Context and Applications (3 credits)",
"CPRL 532 Public Relations Event Management (3 credits)",
"CPRL 533 Communications in the Corporate Sector (3 credits)",
"CPRL 534 Communications in the Not-For-Profit Sector (3 credits)",
"CPRL 535 Public Opinion and Public Policy (3 credits)",
"CPRL 540 Communication Planning (3 credits)",
"CPRL 541 Ethics in Public Relations (3 credits)",
"CPRL 590 Topics in Public Relations (3 credits)",
"CSCI 101 General Chemistry (4 credits)",
"CSCI 102 Physics - Science Mechanics (4 credits)",
"CSCI 103 General Biology (4 credits)",
"CSCI 104 Introduction to Psychology (3 credits)",
"CSPN 540 Organizational Culture in the Hispanic World (3 credits)",
"CSPN 541 Language and Culture for Professional Communication (3 credits)",
"CSPN 542 Written Communication Contexts (3 credits)",
"CSPN 543 Oral Communication Contexts (3 credits)",
"CSPN 544 Professional Discourse (3 credits)",
"CTPT 200 Introduction to Supply Chain Management (3 credits)",
"CTPT 201 Sourcing (3 credits)",
"CTPT 202 Production and Inventory Planning and Control 1 (3 credits)",
"CTPT 205 Principles of Logistics 1 (3 credits)",
"CTPT 206 Transportation Management and Economics (3 credits)",
"CTPT 208 Fundamentals of Logistics (3 credits)",
"CTPT 220 Strategic Logistics (3 credits)",
"CTPT 225 Principles of Logistics 2 (3 credits)",
"CTPT 310 Production and Inventory Planning and Control 2 (3 credits)",
"CTPT 311 Supply Chain Risk Management (3 credits)",
"CTPT 347 Transportation Management (3 credits)",
"CTPT 410 International Trade and Logistics (3 credits)",
"CTPT 430 Fundamentals of Integrated Business Systems (3 credits)",
"CTPT 440 Supply Chain Management (3 credits)",
"DENT 101J1 Dentistry Apprenticeship 1 (1.34 credits)",
"DENT 101J2 Dentistry Apprenticeship 1 (1.33 credits)",
"DENT 101J3 Dentistry Apprenticeship 1 (1.33 credits)",
"DENT 113D1 Community Oral Health Services 1 (0.5 credits)",
"DENT 113D2 Community Oral Health Services 1 (0.5 credits)",
"DENT 125D1 Oral Health Research 1 (0.5 credits)",
"DENT 125D2 Oral Health Research 1 (0.5 credits)",
"DENT 202 Oral Health (8 credits)",
"DENT 203 Oral Disease (4 credits)",
"DENT 204D1 Management of Oral Disease (12.5 credits)",
"DENT 204D2 Management of Oral Disease (12.5 credits)",
"DENT 205D1 Dental Public Health 1 (1.5 credits)",
"DENT 205D2 Dental Public Health 1 (1.5 credits)",
"DENT 206 Social Justice Seminar 1 (0.5 credits)",
"DENT 206D1 Social Justice Seminar 1 (0.25 credits)",
"DENT 206D2 Social Justice Seminar 1 (0.25 credits)",
"DENT 208D1 Introduction to Infection Prevention and Control (0.5 credits)",
"DENT 208D2 Introduction to Infection Prevention and Control (0.5 credits)",
"DENT 210 Introduction to Oral Medicine and Oral Diagnosis (1 credit)",
"DENT 213 Community Oral Health Services 2 (1 credit)",
"DENT 213D1 Community Oral Health Services 2 (0.5 credits)",
"DENT 213D2 Community Oral Health Services 2 (0.5 credits)",
"DENT 215D1 Tooth Movement (1.75 credits)",
"DENT 215D2 Tooth Movement (1.75 credits)",
"DENT 217 Foundations of Dentistry (7 credits)",
"DENT 218D1 Support Tissue (1.5 credits)",
"DENT 218D2 Support Tissue (1.5 credits)",
"DENT 220D1 Introduction to Restorative Dentistry (5 credits)",
"DENT 220D2 Introduction to Restorative Dentistry (5 credits)",
"DENT 221D1 Tooth Loss (2.5 credits)",
"DENT 221D2 Tooth Loss (2.5 credits)",
"DENT 222D1 Radiology (1.5 credits)",
"DENT 222D2 Radiology (1.5 credits)",
"DENT 224D1 Transition to Clinic (1.5 credits)",
"DENT 224D2 Transition to Clinic (1.5 credits)",
"DENT 225 Oral Health Research 2 (2 credits)",
"DENT 225D1 Oral Health Research 2 (1 credit)",
"DENT 225D2 Oral Health Research 2 (1 credit)",
"DENT 305D1 Dental Public Health (1 credit)",
"DENT 305D2 Dental Public Health (1 credit)",
"DENT 306D1 Social Justice Seminar 2 (0.25 credits)",
"DENT 306D2 Social Justice Seminar 2 (0.25 credits)",
"DENT 307D1 Business Aspects of Dentistry (1 credit)",
"DENT 307D2 Business Aspects of Dentistry (1 credit)",
"DENT 309 Implantology (5 credits)",
"DENT 309J1 Implantology (1.67 credits)",
"DENT 309J2 Implantology (1.67 credits)",
"DENT 309J3 Implantology (1.66 credits)",
"DENT 310J1 Clinical Practice/Junior Clerkship (1.33 credits)",
"DENT 310J2 Clinical Practice/Junior Clerkship (1.33 credits)",
"DENT 310J3 Clinical Practice/Junior Clerkship (1.34 credits)",
"DENT 311J1 Endodontics 1 (1.83 credits)",
"DENT 311J2 Endodontics 1 (1.83 credits)",
"DENT 311J3 Endodontics 1 (1.84 credits)",
"DENT 312 Summer Clinic Externship (4 credits)",
"DENT 313D1 Community Oral Health Services 3 (1.5 credits)",
"DENT 313D2 Community Oral Health Services 3 (1.5 credits)",
"DENT 314 Summer Clinic/Externships (3 credits)",
"DENT 315J1 Orthodontics 1 (2 credits)",
"DENT 315J2 Orthodontics 1 (2 credits)",
"DENT 315J3 Orthodontics 1 (2 credits)",
"DENT 316D1 Pediatric Dentistry 1 (3.5 credits)",
"DENT 316D2 Pediatric Dentistry 1 (3.5 credits)",
"DENT 317D1 Oral Pathology and Medicine (1.5 credits)",
"DENT 317D2 Oral Pathology and Medicine (1.5 credits)",
"DENT 317J1 Oral Pathology and Medicine (1 credit)",
"DENT 317J2 Oral Pathology and Medicine (1 credit)",
"DENT 317J3 Oral Pathology and Medicine (1 credit)",
"DENT 318J1 Periodontology (1.33 credits)",
"DENT 318J2 Periodontology (1.33 credits)",
"DENT 318J3 Periodontology (1.34 credits)",
"DENT 319D1 Dental Pharmacology (1.5 credits)",
"DENT 319D2 Dental Pharmacology (1.5 credits)",
"DENT 319J1 Dental Pharmacology (1 credit)",
"DENT 319J2 Dental Pharmacology (1 credit)",
"DENT 319J3 Dental Pharmacology (1 credit)",
"DENT 320 Restorative Dentistry (6 credits)",
"DENT 320J1 Restorative Dentistry (2 credits)",
"DENT 320J2 Restorative Dentistry (2 credits)",
"DENT 320J3 Restorative Dentistry (2 credits)",
"DENT 322 Image Interpretation (2 credits)",
"DENT 322J1 Image Interpretation (0.67 credits)",
"DENT 322J2 Image Interpretation (0.67 credits)",
"DENT 322J3 Image Interpretation (0.66 credits)",
"DENT 323 Oral and Maxillofacial Surgery (2 credits)",
"DENT 323J1 Oral and Maxillofacial Surgery (0.7 credits)",
"DENT 323J2 Oral and Maxillofacial Surgery (0.7 credits)",
"DENT 323J3 Oral and Maxillofacial Surgery (0.6 credits)",
"DENT 325D1 Oral Health Research 3 (1 credit)",
"DENT 325D2 Oral Health Research 3 (1 credit)",
"DENT 326 Pediatric Dentistry Externship",
"DENT 337 Clinical Decision Making (2 credits)",
"DENT 406D1 Ethics and Jurisprudence (0.25 credits)",
"DENT 406D2 Ethics and Jurisprudence (0.25 credits)",
"DENT 407D1 Practice Management (1 credit)",
"DENT 407D2 Practice Management (1 credit)",
"DENT 409 Advanced Restorative Dentistry (2 credits)",
"DENT 409J1 Advanced Restorative Dentistry (0.67 credits)",
"DENT 409J2 Advanced Restorative Dentistry (0.67 credits)",
"DENT 409J3 Advanced Restorative Dentistry (0.66 credits)",
"DENT 410D1 Clinical Practice/Senior Clerkship (5 credits)",
"DENT 410D2 Clinical Practice/Senior Clerkship (5 credits)",
"DENT 411D1 Endodontics 2 (1 credit)",
"DENT 411D2 Endodontics 2 (1 credit)",
"DENT 412D1 Introduction to Orofacial Pain (1.5 credits)",
"DENT 412D2 Introduction to Orofacial Pain (1.5 credits)",
"DENT 412J1 Introduction to Orofacial Pain (1 credit)",
"DENT 412J2 Introduction to Orofacial Pain (1 credit)",
"DENT 412J3 Introduction to Orofacial Pain (1 credit)",
"DENT 413 Community Oral Health Services 4 (1 credit)",
"DENT 415D1 Orthodontics 2 (3.5 credits)",
"DENT 415D2 Orthodontics 2 (3.5 credits)",
"DENT 415J1 Orthodontics 2 (2.33 credits)",
"DENT 415J2 Orthodontics 2 (2.33 credits)",
"DENT 415J3 Orthodontics 2 (2.34 credits)",
"DENT 416D1 Pediatric Dentistry 2 (1.5 credits)",
"DENT 416D2 Pediatric Dentistry 2 (1.5 credits)",
"DENT 418D1 Periodontology Seminar (1 credit)",
"DENT 418D2 Periodontology Seminar (1 credit)",
"DENT 418J1 Periodontology Seminar (0.67 credits)",
"DENT 418J2 Periodontology Seminar (0.67 credits)",
"DENT 418J3 Periodontology Seminar (0.66 credits)",
"DENT 423D1 Oral Maxillofacial Surgery and Pathology (2 credits)",
"DENT 423D2 Oral Maxillofacial Surgery and Pathology (2 credits)",
"DENT 423J1 Oral Maxillofacial Surgery and Pathology (1.33 credits)",
"DENT 423J2 Oral Maxillofacial Surgery and Pathology (1.33 credits)",
"DENT 423J3 Oral Maxillofacial Surgery and Pathology (1.34 credits)",
"DENT 425D1 Oral Health Research 4 (1.5 credits)",
"DENT 425D2 Oral Health Research 4 (1.5 credits)",
"DENT 428D1 Periodontics Clerkship",
"DENT 428D2 Periodontics Clerkship",
"DENT 429 International Outreach Externship",
"DENT 437 Clinical Decision Making (3 credits)",
"DENT 504 Biomaterials and Bioperformance (3 credits)",
"DENT 505 Epidemiology and Data Analysis in Primary Care 1 (3 credits)",
"DENT 509 Epidemiology and Data Analysis in Primary Care 2 (3 credits)",
"DENT 520 Orthodontic Seminar 1 (8 credits)",
"DENT 521D1 Orthodontic Seminar 2 (6 credits)",
"DENT 521D2 Orthodontic Seminar 2 (6 credits)",
"DENT 522D1 Orthodontic Seminar 3 (5 credits)",
"DENT 522D2 Orthodontic Seminar 3 (5 credits)",
"DENT 523D1 Orthodontic Seminar 4 (4 credits)",
"DENT 523D2 Orthodontic Seminar 4 (4 credits)",
"DENT 524D1 Clinical Orthodontics 1 (3 credits)",
"DENT 524D2 Clinical Orthodontics 1 (3 credits)",
"DENT 525 Clinical Orthodontics 2 (6 credits)",
"DENT 526D1 Clinical Orthodontics 3 (3 credits)",
"DENT 526D2 Clinical Orthodontics 3 (3 credits)",
"DENT 527 Clinical Orthodontics 4 (6 credits)",
"DENT 528D1 Clinical Orthodontics 5 (3 credits)",
"DENT 528D2 Clinical Orthodontics 5 (3 credits)",
"DENT 529 Clinical Orthodontics 6 (2 credits)",
"DENT 571J1 Topics in Oral and Maxillofacial Surgery for Interns (17.33 credits)",
"DENT 571J2 Topics in Oral and Maxillofacial Surgery for Interns (17.33 credits)",
"DENT 571J3 Topics in Oral and Maxillofacial Surgery for Interns (17.33 credits)",
"DENT 575 Dental Residency Training 1 (18 credits)",
"DENT 576 Dental Residency Training 2 (17 credits)",
"DENT 577 Dental Residency Training 3 (17 credits)",
"DENT 578 Community Practice Rotations",
"DENT 580 OMFS Training - Integrated Program (26 credits)",
"DENT 580D1 OMFS Training - Integrated Program (13 credits)",
"DENT 580D2 OMFS Training - Integrated Program (13 credits)",
"DENT 581J1 Oral and Maxillofacial Surgery Training 1 (12 credits)",
"DENT 581J2 Oral and Maxillofacial Surgery Training 1 (12 credits)",
"DENT 581J3 Oral and Maxillofacial Surgery Training 1 (12 credits)",
"DENT 582J1 Oral and Maxillofacial Surgery Training 2 (12 credits)",
"DENT 582J2 Oral and Maxillofacial Surgery Training 2 (12 credits)",
"DENT 582J3 Oral and Maxillofacial Surgery Training 2 (12 credits)",
"DENT 583 Oral and Maxillofacial Surgery Training 3 (36 credits)",
"DENT 583J1 Oral and Maxillofacial Surgery Training 3 (12 credits)",
"DENT 583J2 Oral and Maxillofacial Surgery Training 3 (12 credits)",
"DENT 583J3 Oral and Maxillofacial Surgery Training 3 (12 credits)",
"DENT 584J1 Oral and Maxillofacial Surgery Training 4 (8 credits)",
"DENT 584J2 Oral and Maxillofacial Surgery Training 4 (8 credits)",
"DENT 584J3 Oral and Maxillofacial Surgery Training 4 (8 credits)",
"DENT 585J1 Oral and Maxillofacial Surgery Clinical and Seminars (4 credits)",
"DENT 585J2 Oral and Maxillofacial Surgery Clinical and Seminars (4 credits)",
"DENT 585J3 Oral and Maxillofacial Surgery Clinical and Seminars (4 credits)",
"DENT 610 Introduction to Craniofacial Research (3 credits)",
"DENT 614 Foundations of Mixed Methods Research (2 credits)",
"DENT 625 Applied Qualitative Health Research (3 credits)",
"DENT 631 OMFS 2 Seminar (3 credits)",
"DENT 632 Clinical OMFS 2 (3 credits)",
"DENT 641 OMFS 3 Seminar (3 credits)",
"DENT 642 Clinical OMFS 3 (3 credits)",
"DENT 650 Thesis Research 1 (3 credits)",
"DENT 651 Thesis Research 2 (6 credits)",
"DENT 652 Thesis Research 3 (9 credits)",
"DENT 652D1 Thesis Research 3 (4.5 credits)",
"DENT 652D2 Thesis Research 3 (4.5 credits)",
"DENT 653 Thesis Research 4 (15 credits)",
"DENT 653D1 Thesis Research 4 (7.5 credits)",
"DENT 653D2 Thesis Research 4 (7.5 credits)",
"DENT 654 Mechanisms and Management of Pain (3 credits)",
"DENT 663 Principles of Health Research (1 credit)",
"DENT 664 Health Research Communications (1 credit)",
"DENT 665 Leadership and Management Skills in Research (1 credit)",
"DENT 669 Extracellular Matrix Biology (3 credits)",
"DENT 670 Dentistry Community Health Practicum (6 credits)",
"DENT 671 Advanced Research Seminar (2 credits)",
"DENT 671D1 Advanced Research Seminar (1 credit)",
"DENT 671D2 Advanced Research Seminar (1 credit)",
"DENT 671N1 Advanced Research Seminar (1 credit)",
"DENT 671N2 Advanced Research Seminar (1 credit)",
"DENT 672 Applied Mixed Methods in Health Research (3 credits)",
"DENT 673 Biotechnology and Entrepreneurship (3 credits)",
"DENT 679 Epidemiology and Data Analysis in Primary Care 3 (3 credits)",
"DENT 681 Readings in Dentistry and Health Research 1 (1 credit)",
"DENT 682 Readings in Dentistry and Health Research 2 (2 credits)",
"DENT 683 Readings in Dentistry and Health Research 3 (3 credits)",
"DENT 685 Theory of Dental Public Health (3 credits)",
"DENT 686 Illness Experience and Social Determinants of Health (2 credits)",
"DENT 690 Literature Reviews (3 credits)",
"DENT 706 Advanced Seminar in Qualitative Health Research (3 credits)",
"DENT 786D1 Team Science in Health Research (3 credits)",
"DENT 786D2 Team Science in Health Research (3 credits)",
"DUMY 100 ",
"EAST 199 FYS: East Asian Culture (3 credits)",
"EAST 211 Introduction: East Asian Culture: China (3 credits)",
"EAST 212 Introduction: East Asian Culture: Japan (3 credits)",
"EAST 213 Introduction: East Asian Culture: Korea (3 credits)",
"EAST 215 Introduction to East Asian Art (3 credits)",
"EAST 220 First Level Korean (9 credits)",
"EAST 220D1 First Level Korean (4.5 credits)",
"EAST 220D2 First Level Korean (4.5 credits)",
"EAST 230 First Level Chinese (9 credits)",
"EAST 230D1 First Level Chinese (4.5 credits)",
"EAST 230D2 First Level Chinese (4.5 credits)",
"EAST 240 First Level Japanese (9 credits)",
"EAST 240D1 First Level Japanese (4.5 credits)",
"EAST 240D2 First Level Japanese (4.5 credits)",
"EAST 241 Japanese Writing Beginners 1 (3 credits)",
"EAST 242 Japanese Writing Beginners 2 (3 credits)",
"EAST 250 Introduction to Asian Media Studies (3 credits)",
"EAST 279 Introduction to Film History (3 credits)",
"EAST 303 Current Topics: Chinese Studies 1 (3 credits)",
"EAST 304 Current Topics: Chinese Studies 2 (3 credits)",
"EAST 305 Current Topics: Japanese Studies 1 (3 credits)",
"EAST 306 Current Topics: Japanese Studies 2 (3 credits)",
"EAST 307 Topics: East Asian Language and Literature 1 (3 credits)",
"EAST 308 Topics: East Asian Language and Literature 2 (3 credits)",
"EAST 313 Current Topics: Korean Studies 1 (3 credits)",
"EAST 314 Current Topics: Korean Studies 2 (3 credits)",
"EAST 319 Introduction to Manga (3 credits)",
"EAST 320 Second Level Korean (9 credits)",
"EAST 320D1 Second Level Korean (4.5 credits)",
"EAST 320D2 Second Level Korean (4.5 credits)",
"EAST 328 Archaeology East Asian Empires (3 credits)",
"EAST 330 Second Level Chinese (9 credits)",
"EAST 330D1 Second Level Chinese (4.5 credits)",
"EAST 330D2 Second Level Chinese (4.5 credits)",
"EAST 340 Second Level Japanese (9 credits)",
"EAST 340D1 Second Level Japanese (4.5 credits)",
"EAST 340D2 Second Level Japanese (4.5 credits)",
"EAST 341 Japanese Writing Intermediate 1 (3 credits)",
"EAST 342 Japanese Writing Intermediate 2 (3 credits)",
"EAST 350 Gender and Sexuality in Chinese Literature (3 credits)",
"EAST 351 Women Writers of China (3 credits)",
"EAST 352 Critical Approaches to Chinese Literature (3 credits)",
"EAST 353 Approaches to Chinese Cinema (3 credits)",
"EAST 356 Modern & Contemporary Chinese Art (3 credits)",
"EAST 357 Early Chinese Art (3 credits)",
"EAST 358 Later Chinese Art (960-1911) (3 credits)",
"EAST 360 Archaeology of Ancient China (3 credits)",
"EAST 361 Animation and New Media (3 credits)",
"EAST 362 Japanese Cinema (3 credits)",
"EAST 363 Early and Medieval Japan (3 credits)",
"EAST 364 Mass Culture and Postwar Japan (3 credits)",
"EAST 368 Asian Genre Cinemas (3 credits)",
"EAST 369 Gender and Sexuality in Asian Media (3 credits)",
"EAST 370 History of Sexuality in Japan (3 credits)",
"EAST 372 Topics in Television: Asia (3 credits)",
"EAST 375 Korean Media & Popular Culture (3 credits)",
"EAST 377 Topics: Transnational Asian Culture (3 credits)",
"EAST 385 Global Korea (3 credits)",
"EAST 388 Asian Migrations and Diasporas (3 credits)",
"EAST 389 Global Cinema and Media Asia (3 credits)",
"EAST 390 The Chinese Family in History (3 credits)",
"EAST 399 Archaeology of Japan and Korea (3 credits)",
"EAST 420 Third Level Korean 1 (3 credits)",
"EAST 421 Third Level Korean 2 (3 credits)",
"EAST 430D1 Third Level Chinese (3 credits)",
"EAST 430D2 Third Level Chinese (3 credits)",
"EAST 437 Historical Archaeology (3 credits)",
"EAST 440 Third Level Japanese (6 credits)",
"EAST 440D1 Third Level Japanese (3 credits)",
"EAST 440D2 Third Level Japanese (3 credits)",
"EAST 453 Topics: Chinese Literature (3 credits)",
"EAST 454 Topics: Chinese Cinema (3 credits)",
"EAST 458 Archaeology of the Silk Roads (3 credits)",
"EAST 461 Inventing Modern Japanese Novel (3 credits)",
"EAST 462 Japan in Asia (3 credits)",
"EAST 464 Image Text Performance (3 credits)",
"EAST 467 Topics: Japanese Cinema (3 credits)",
"EAST 468 Science and Technology: Asia (3 credits)",
"EAST 477 Media and Environment in Asia (3 credits)",
"EAST 478 Topics: Korean Film & Media (3 credits)",
"EAST 491 Tutorial: East Asian Languages and Literatures 1 (3 credits)",
"EAST 492 Tutorial: East Asian Languages and Literatures 2 (3 credits)",
"EAST 493 Special Topics: East Asian Studies 1 (3 credits)",
"EAST 494 Special Topics: East Asian Studies 2 (3 credits)",
"EAST 495 Joint Honours Thesis:  East Asian Studies (3 credits)",
"EAST 495D1 Joint Honours Thesis:  East Asian Studies (1.5 credits)",
"EAST 495D2 Joint Honours Thesis: East Asian Studies (1.5 credits)",
"EAST 495N1 Joint Honours Thesis: East Asian Studies (1.5 credits)",
"EAST 495N2 Joint Honours Thesis: East Asian Studies (1.5 credits)",
"EAST 498D1 Honours Thesis: East Asian Studies (3 credits)",
"EAST 498D2 Honours Thesis: East Asian Studies (3 credits)",
"EAST 498N1 Honours Thesis: East Asian Studies (3 credits)",
"EAST 498N2 Honours Thesis: East Asian Studies (3 credits)",
"EAST 499 Internship: East Asian Studies (3 credits)",
"EAST 501 Advanced Topics in Japanese Studies 1 (3 credits)",
"EAST 502 Advanced Topics in Japanese Studies 2 (3 credits)",
"EAST 503 Advanced Topics in Chinese Studies 1 (3 credits)",
"EAST 504 Advanced Topics in Chinese Studies 2 (3 credits)",
"EAST 505 Advanced Topics in Korean Studies (3 credits)",
"EAST 515 Seminar: Beyond Orientalism (3 credits)",
"EAST 525 Critical Area Studies in Asia (3 credits)",
"EAST 527 Culture and Capital in Asia (3 credits)",
"EAST 530D1 Fourth Level Chinese (3 credits)",
"EAST 530D2 Fourth Level Chinese (3 credits)",
"EAST 533 Classical Chinese 1 (3 credits)",
"EAST 534 Classical Chinese 2 (3 credits)",
"EAST 535 Chinese for Business 1 (3 credits)",
"EAST 536 Chinese for Business 2 (3 credits)",
"EAST 540D1 Fourth Level Japanese (3 credits)",
"EAST 540D2 Fourth Level Japanese (3 credits)",
"EAST 543 Classical Japanese 1 (3 credits)",
"EAST 544 Classical Japanese 2 (3 credits)",
"EAST 546 Advanced Reading: Japanese (3 credits)",
"EAST 547 Advanced Translation in Japanese (3 credits)",
"EAST 550 Classical Chinese Poetry Themes and Genres (3 credits)",
"EAST 551 Technologies of Self in Early China (3 credits)",
"EAST 556 Advanced Reading in Chinese (3 credits)",
"EAST 557 Advanced Translation: Chinese (3 credits)",
"EAST 559 Advanced Topics: Chinese Literature (3 credits)",
"EAST 560 Screen Cultures and Media Arts (3 credits)",
"EAST 562 Japanese Literary Theory and Practice (3 credits)",
"EAST 563 Images Ideograms Aesthetics (3 credits)",
"EAST 564 Structures of Modernity: Asia (3 credits)",
"EAST 569 Advanced Topics: Japanese Literature (3 credits)",
"EAST 570 Modern Japanese Thought (3 credits)",
"EAST 576 Advanced Reading in Korean (3 credits)",
"EAST 577 Advanced Translation: Korean (3 credits)",
"EAST 582 Japanese Culture and Society (3 credits)",
"EAST 600 East Asian Studies 1 (3 credits)",
"EAST 601 East Asian Studies 2 (3 credits)",
"EAST 619 Topics in Literary Theory (3 credits)",
"EAST 621 Bibliography and Research Methods: China (3 credits)",
"EAST 650 Archaeology of Northern China: Post-Han (3 credits)",
"EAST 651 Seminar in Taoist Studies 1 (3 credits)",
"EAST 652 Seminar in Taoist Studies 2 (3 credits)",
"EAST 653 Chinese Popular Culture 1 (3 credits)",
"EAST 654 Chinese Popular Culture 2 (3 credits)",
"EAST 655 East Asian Poetry and Poetics (3 credits)",
"EAST 657 Women's Writings in Traditional China (3 credits)",
"EAST 660 Seminar: Japanese Fiction (3 credits)",
"EAST 680 Seminar: Social Change in Asia (3 credits)",
"EAST 685 Animal Studies (3 credits)",
"EAST 690 MA Thesis Research 1 (3 credits)",
"EAST 691 MA Thesis Research 2 (3 credits)",
"EAST 692 MA Thesis Research 3 (3 credits)",
"EAST 693 MA Thesis Research 4 (3 credits)",
"EAST 694 MA Thesis Research 5 (3 credits)",
"EAST 695 MA Thesis Research 6 (3 credits)",
"EAST 696 MA Thesis Research 7 (6 credits)",
"EAST 696D1 MA Thesis Research 7 (3 credits)",
"EAST 696D2 MA Thesis Research 7 (3 credits)",
"EAST 700D1 PhD Comprehensive Exam 1",
"EAST 700D2 PhD Comprehensive Exam 1",
"EAST 701 PhD Comprehensive Exam 2",
"EAST 701D1 PhD Comprehensive Exam 2",
"EAST 701D2 PhD Comprehensive Exam 2",
"ECON 199 FYS: Aspects of Globalization (3 credits)",
"ECON 205 An Introduction to Political Economy (3 credits)",
"ECON 208 Microeconomic Analysis and Applications (3 credits)",
"ECON 209 Macroeconomic Analysis and Applications (3 credits)",
"ECON 219 Current Economic Problems: Topics (3 credits)",
"ECON 221 Economic History (3 credits)",
"ECON 223 Political Economy of Trade Policy (3 credits)",
"ECON 225 Economics of the Environment (3 credits)",
"ECON 227 Economic Statistics (6 credits)",
"ECON 227D1 Economic Statistics (3 credits)",
"ECON 227D2 Economic Statistics (3 credits)",
"ECON 230 Microeconomic Theory (6 credits)",
"ECON 230D1 Microeconomic Theory (3 credits)",
"ECON 230D2 Microeconomic Theory (3 credits)",
"ECON 250D1 Introduction to Economic Theory: Honours (3 credits)",
"ECON 250D2 Introduction to Economic Theory: Honours (3 credits)",
"ECON 257D1 Economic Statistics - Honours (3 credits)",
"ECON 257D2 Economic Statistics - Honours (3 credits)",
"ECON 295 Macroeconomic Policy (3 credits)",
"ECON 302 Money Banking & Government Policy (3 credits)",
"ECON 303 Canadian Economic Policy (3 credits)",
"ECON 304 Financial Instruments & Institutions (3 credits)",
"ECON 305 Industrial Organization (3 credits)",
"ECON 306 Labour Markets and Wages (3 credits)",
"ECON 308 Governmental Policy Towards Business (3 credits)",
"ECON 310 Introduction to Behavioural Economics (3 credits)",
"ECON 311 United States Economic Development (3 credits)",
"ECON 313 Economic Development 1 (3 credits)",
"ECON 314 Economic Development 2 (3 credits)",
"ECON 316 The Underground Economy (3 credits)",
"ECON 318 The Criminal Economy (3 credits)",
"ECON 319 Economic Crises (3 credits)",
"ECON 326 Ecological Economics (3 credits)",
"ECON 330D1 Macroeconomic Theory (3 credits)",
"ECON 330D2 Macroeconomic Theory (3 credits)",
"ECON 331 Economic Development: Russia and USSR (3 credits)",
"ECON 334 History of Economic Doctrines (3 credits)",
"ECON 335 The Japanese Economy (3 credits)",
"ECON 336 The Chinese Economy (3 credits)",
"ECON 337 Introductory Econometrics 1 (3 credits)",
"ECON 338 Introductory Econometrics 2 (3 credits)",
"ECON 341 Economic History of a World Area (3 credits)",
"ECON 344 Industrial Revolution and Economic Development (3 credits)",
"ECON 345 The International Economy since 1914 (3 credits)",
"ECON 347 Economics of Climate Change (3 credits)",
"ECON 348 Urban Economics (3 credits)",
"ECON 352D1 Macroeconomics - Honours (3 credits)",
"ECON 352D2 Macroeconomics - Honours (3 credits)",
"ECON 399 Internship: Economics (3 credits)",
"ECON 405 Natural Resource Economics (3 credits)",
"ECON 406 Topics in Economic Policy (3 credits)",
"ECON 408 Public Sector Economics 1 (3 credits)",
"ECON 409 Public Sector Economics 2 (3 credits)",
"ECON 411 Economic Development: A World Area (3 credits)",
"ECON 416 Topics in Economic Development 2 (3 credits)",
"ECON 420 Topics in Economic Theory (3 credits)",
"ECON 423 International Trade (3 credits)",
"ECON 424 International Payments (3 credits)",
"ECON 426 Labour Economics (3 credits)",
"ECON 430 The Economics of Well-Being (3 credits)",
"ECON 434 Current Economic Problems (3 credits)",
"ECON 440 Health Economics (3 credits)",
"ECON 447 Economics of Information and Uncertainty (3 credits)",
"ECON 450 Advanced Economic Theory 1 - Honours (3 credits)",
"ECON 452 Advanced Economic Theory 2 - Honours (3 credits)",
"ECON 453 International Trade - Honours (3 credits)",
"ECON 454 Open Economy Macroeconomics - Honours (3 credits)",
"ECON 459 Topics in Monetary Economics - Honours (3 credits)",
"ECON 460 History of Thought 1 - Honours (3 credits)",
"ECON 461 History of Thought 2 - Honours (3 credits)",
"ECON 462 Seminar in Economic History (3 credits)",
"ECON 468 Econometrics 1 - Honours (3 credits)",
"ECON 469 Econometrics 2 - Honours (3 credits)",
"ECON 473 Income Distribution (3 credits)",
"ECON 480 Research Project 1 (3 credits)",
"ECON 510 Experimental Economics (3 credits)",
"ECON 511 Energy Economy and Environment (3 credits)",
"ECON 525 Project Analysis (3 credits)",
"ECON 531 Historical Experience of Economic Development (3 credits)",
"ECON 546 Game Theory (3 credits)",
"ECON 577 Mathematical Economics 1 (3 credits)",
"ECON 581 Selected Topics in Economics (3 credits)",
"ECON 610 Microeconomic Theory 1 (3 credits)",
"ECON 611 Microeconomic Theory 2 (3 credits)",
"ECON 620 Macroeconomic Theory 1 (3 credits)",
"ECON 621 Macroeconomic Theory 2 (3 credits)",
"ECON 622 Public Finance (3 credits)",
"ECON 622D1 Public Finance (1.5 credits)",
"ECON 622D2 Public Finance (1.5 credits)",
"ECON 623 Money and Banking (3 credits)",
"ECON 624 International Economics (3 credits)",
"ECON 624D1 International Economics (1.5 credits)",
"ECON 624D2 International Economics (1.5 credits)",
"ECON 625 Economics of Natural Resources (3 credits)",
"ECON 634 Economic Development 3 (3 credits)",
"ECON 637 Industrial Organization and Regulation (3 credits)",
"ECON 641 Labour Economics (3 credits)",
"ECON 647 Applied Computational Economics (3 credits)",
"ECON 650 Research 1 (3 credits)",
"ECON 651 Research 2 (3 credits)",
"ECON 652 Research 3 (3 credits)",
"ECON 653 Research 4 (3 credits)",
"ECON 654 Research Methods in Economics (3 credits)",
"ECON 661 Applied Time-Series and Forecasting (3 credits)",
"ECON 662 Econometrics (6 credits)",
"ECON 662D1 Econometrics (3 credits)",
"ECON 662D2 Econometrics (3 credits)",
"ECON 664 Applied Cross-Sectional Methods (3 credits)",
"ECON 665 Quantitative Methods (3 credits)",
"ECON 670 Thesis 1 (6 credits)",
"ECON 671 Thesis 2 (6 credits)",
"ECON 672 Thesis 3 (6 credits)",
"ECON 680 M.A. Report 1 (3 credits)",
"ECON 681 M.A. Report 2 (3 credits)",
"ECON 681D1 M.A. Report 2 (1.5 credits)",
"ECON 681D2 M.A. Report 2 (1.5 credits)",
"ECON 682 M.A. Report 3 (3 credits)",
"ECON 682D1 M.A. Report 3 (1.5 credits)",
"ECON 682D2 M.A. Report 3 (1.5 credits)",
"ECON 683 M.A. Report 4 (3 credits)",
"ECON 688 Seminar on Social Statistics (3 credits)",
"ECON 701 Ph.D. Comprehensive Examination",
"ECON 705 Reading Course: Selected Topics Economics (3 credits)",
"ECON 706 Selected Topics (3 credits)",
"ECON 709 Microeconomic Theory 3 (3 credits)",
"ECON 710 Selected Topics in Economics (3 credits)",
"ECON 711 Microeconomic Theory 2 (3 credits)",
"ECON 712 Macroeconomic Theory 1 (3 credits)",
"ECON 713 Macroeconomic Theory 2 (3 credits)",
"ECON 720 Advanced Game Theory (3 credits)",
"ECON 721 Advanced Monetary Theory (3 credits)",
"ECON 722 Advanced Topics in Macroeconomics (3 credits)",
"ECON 724 International Economics (3 credits)",
"ECON 726 Topics in Environmental Economics (3 credits)",
"ECON 734 Economic Development 4 (3 credits)",
"ECON 737 Industrial Organization and Regulation Seminar (3 credits)",
"ECON 741 Advanced Labour Economics (3 credits)",
"ECON 742 Empirical Microeconomics (3 credits)",
"ECON 744 Health Economics (3 credits)",
"ECON 752 Topics in Financial Economics (3 credits)",
"ECON 761 Econometrics: Time Series Analysis (3 credits)",
"ECON 762 Econometrics - Asymptotic and Finite - Sample (3 credits)",
"ECON 762D1 Econometrics - Asymptotic and Finite - Sample (1.5 credits)",
"ECON 762D2 Econometrics - Asymptotic and Finite-Sample (1.5 credits)",
"ECON 763 Financial Econometrics (3 credits)",
"ECON 765 Models for Financial Economics (3 credits)",
"ECON 770 PhD Research Seminar 1 (1 credit)",
"ECON 771 PhD Research Seminar 2 (1 credit)",
"ECSE 200 Electric Circuits 1 (3 credits)",
"ECSE 202 Introduction to Software Development (3 credits)",
"ECSE 205 Probability and Statistics for Engineers (3 credits)",
"ECSE 206 Introduction to Signals and Systems (3 credits)",
"ECSE 210 Electric Circuits 2 (3 credits)",
"ECSE 211 Design Principles and Methods (3 credits)",
"ECSE 221 Introduction to Computer Engineering (3 credits)",
"ECSE 222 Digital Logic (3 credits)",
"ECSE 223 Model-Based Programming (3 credits)",
"ECSE 251 Electric and Magnetic Fields (3 credits)",
"ECSE 291 Electrical Measurements Laboratory (2 credits)",
"ECSE 303 Signals and Systems 1 (3 credits)",
"ECSE 304 Signals and Systems 2 (3 credits)",
"ECSE 305 Probability and Random Signals 1 (3 credits)",
"ECSE 306 Fundamentals of Signals and Systems (3 credits)",
"ECSE 307 Linear Systems and Control (4 credits)",
"ECSE 308 Introduction to Communication Systems and Networks (4 credits)",
"ECSE 309 Fundamentals of Communication Systems and Networks (3 credits)",
"ECSE 310 Thermodynamics of Computing (3 credits)",
"ECSE 316 Signals and Networks (3 credits)",
"ECSE 321 Introduction to Software Engineering (3 credits)",
"ECSE 322 Computer Engineering (3 credits)",
"ECSE 323 Digital System Design (5 credits)",
"ECSE 324 Computer Organization (4 credits)",
"ECSE 325 Digital Systems (3 credits)",
"ECSE 326 Software Requirements Engineering (3 credits)",
"ECSE 330 Introduction to Electronics (3 credits)",
"ECSE 331 Electronics (4 credits)",
"ECSE 334 Introduction to Microelectronics (3 credits)",
"ECSE 335 Microelectronics (4 credits)",
"ECSE 343 Numerical Methods in Engineering (3 credits)",
"ECSE 351 Electromagnetic Fields (3 credits)",
"ECSE 352 Electromagnetic Waves (3 credits)",
"ECSE 353 Electromagnetic Fields and Waves (3 credits)",
"ECSE 354 Electromagnetic Wave Propagation (4 credits)",
"ECSE 361 Power Engineering (3 credits)",
"ECSE 362 Fundamentals of Power Engineering (4 credits)",
"ECSE 396 Honours Research Laboratory Rotation 1 (1 credit)",
"ECSE 397 Honours Research Laboratory Rotation 2 (1 credit)",
"ECSE 403 Control (4 credits)",
"ECSE 404 Control Systems (3 credits)",
"ECSE 405 Antennas (3 credits)",
"ECSE 408 Communication Systems (4 credits)",
"ECSE 411 Communications Systems 1 (3 credits)",
"ECSE 412 Discrete Time Signal Processing (3 credits)",
"ECSE 413 Communications Systems 2 (3 credits)",
"ECSE 414 Introduction to Telecommunication Networks (3 credits)",
"ECSE 415 Introduction to Computer Vision (3 credits)",
"ECSE 416 Telecommunication Networks (4 credits)",
"ECSE 420 Parallel Computing (3 credits)",
"ECSE 421 Embedded Systems (3 credits)",
"ECSE 422 Fault Tolerant Computing (3 credits)",
"ECSE 423 Fundamentals of Photonics (3 credits)",
"ECSE 424 Human-Computer Interaction (3 credits)",
"ECSE 425 Computer Architecture (3 credits)",
"ECSE 426 Microprocessor Systems (3 credits)",
"ECSE 427 Operating Systems (3 credits)",
"ECSE 428 Software Engineering Practice (3 credits)",
"ECSE 429 Software Validation (3 credits)",
"ECSE 430 Photonic Devices and Systems (3 credits)",
"ECSE 431 Introduction to VLSI CAD (3 credits)",
"ECSE 432 Physical Basis: Transistor Devices (3 credits)",
"ECSE 433 Physical Basis of Transistor Devices (4 credits)",
"ECSE 434 Microelectronics Laboratory (2 credits)",
"ECSE 435 Mixed-Signal Test Techniques (3 credits)",
"ECSE 436 Signal Processing Hardware (3 credits)",
"ECSE 437 Software Delivery (3 credits)",
"ECSE 439 Software Language Engineering (3 credits)",
"ECSE 444 Microprocessors (4 credits)",
"ECSE 446 Realistic Image Synthesis (3 credits)",
"ECSE 450 Electromagnetic Compatibility (3 credits)",
"ECSE 451 EM Transmission and Radiation (3 credits)",
"ECSE 456 ECSE Design Project 1 (3 credits)",
"ECSE 457 ECSE Design Project 2 (3 credits)",
"ECSE 458D1 Capstone Design Project (3 credits)",
"ECSE 458D2 Capstone Design Project (3 credits)",
"ECSE 458N1 Capstone Design Project (3 credits)",
"ECSE 458N2 Capstone Design Project (3 credits)",
"ECSE 460 Appareillage électrique (Electrical Power Equipment) (3 credits)",
"ECSE 461 Electric Machinery (3 credits)",
"ECSE 462 Electromechanical Energy Conversion (3 credits)",
"ECSE 463 Electric Power Generation (3 credits)",
"ECSE 464 Power Systems Analysis (3 credits)",
"ECSE 465 Power Electronic Systems (3 credits)",
"ECSE 466 Réseaux de distribution (3 credits)",
"ECSE 467 Comportement des réseaux électriques (3 credits)",
"ECSE 468 Electricité industrielle (Industrial Power Systems) (3 credits)",
"ECSE 469 Protection des réseaux électriques (3 credits)",
"ECSE 470 Electromechanical Systems (4 credits)",
"ECSE 472 Fundamentals of Circuit Simulation and Modelling (3 credits)",
"ECSE 474 Design Project 1 (1 credit)",
"ECSE 475 Design Project 2 (2 credits)",
"ECSE 476 Software Engineering Design Project 1 (1 credit)",
"ECSE 477 Software Engineering Design Project 2 (2 credits)",
"ECSE 478D1 Electrical Engineering Honours Thesis (3 credits)",
"ECSE 478D2 Electrical Engineering Honours Thesis (3 credits)",
"ECSE 478N1 Electrical Engineering Honours Thesis (3 credits)",
"ECSE 478N2 Electrical Engineering Honours Thesis (3 credits)",
"ECSE 485 IC Fabrication Laboratory (2 credits)",
"ECSE 486 Power Laboratory (2 credits)",
"ECSE 487 Computer Architecture Laboratory (2 credits)",
"ECSE 488 High Frequency Laboratory (2 credits)",
"ECSE 489 Telecommunication Network Laboratory (2 credits)",
"ECSE 490 Digital Signal Processing Laboratory (2 credits)",
"ECSE 491 Communication Systems Laboratory (2 credits)",
"ECSE 492 Optical Communications Laboratory (2 credits)",
"ECSE 493 Control and Robotics Laboratory (2 credits)",
"ECSE 494 Electrical Engineering Design Project (3 credits)",
"ECSE 496 Honours Research Laboratory Rotation 3 (1 credit)",
"ECSE 497 Honours Research Laboratory Rotation 4 (1 credit)",
"ECSE 498 Honours Thesis 1 (3 credits)",
"ECSE 499 Honours Thesis 2 (3 credits)",
"ECSE 500 Mathematical Foundations of Systems (3 credits)",
"ECSE 501 Linear Systems (3 credits)",
"ECSE 504 Sampled Data Control (3 credits)",
"ECSE 506 Stochastic Control & Decision Theory (3 credits)",
"ECSE 507 Optimization and Optimal Control (3 credits)",
"ECSE 508 Multi-Agent Systems (3 credits)",
"ECSE 509 Probability and Random Signals 2 (3 credits)",
"ECSE 510 Filtering and Prediction for Stochastic Systems (3 credits)",
"ECSE 511 Introduction to Digital Communication (3 credits)",
"ECSE 512 Digital Signal Processing 1 (3 credits)",
"ECSE 513 Robust Control Systems (3 credits)",
"ECSE 515 Optical Fibre Communications (3 credits)",
"ECSE 516 Nonlinear and Hybrid Control Systems (3 credits)",
"ECSE 517 Neural Prosthetic Systems (3 credits)",
"ECSE 518 Telecommunication Network Analysis (3 credits)",
"ECSE 519 Semiconductor Nanostructures and Nanophotonic Devices (3 credits)",
"ECSE 521 Digital Communications 1 (3 credits)",
"ECSE 522 Nonlinear Phenomena in Power Systems Dynamics (4 credits)",
"ECSE 523 Speech Communications (3 credits)",
"ECSE 524 Interconnects and Signal Integrity (3 credits)",
"ECSE 526 Artificial Intelligence (3 credits)",
"ECSE 527 Optical Engineering (4 credits)",
"ECSE 528 Telecommunication Network Architecture (3 credits)",
"ECSE 529 Computer and Biological Vision (3 credits)",
"ECSE 530 Logic Synthesis (3 credits)",
"ECSE 532 Computer Graphics (4 credits)",
"ECSE 533 Physical Basis of Semiconductor Devices (3 credits)",
"ECSE 534 Analog Microelectronics (3 credits)",
"ECSE 535 Nanoelectronic Devices (3 credits)",
"ECSE 536 RF Microelectronics (3 credits)",
"ECSE 537 Advanced Digital Integrated Circuits (3 credits)",
"ECSE 538 Safety-Critical Embedded Software (3 credits)",
"ECSE 539 Advanced Software Language Engineering (4 credits)",
"ECSE 540 Photonic Devices and Applications (3 credits)",
"ECSE 541 Design of Multiprocessor Systems-­on-­Chip (3 credits)",
"ECSE 542 Human Computer Interaction (4 credits)",
"ECSE 543 Numerical Methods in Electrical Engineering (3 credits)",
"ECSE 544 Computational Photography (4 credits)",
"ECSE 545 Microelectronics Technology (3 credits)",
"ECSE 546 Advanced Image Synthesis (4 credits)",
"ECSE 547 Finite Elements in Electrical Engineering (3 credits)",
"ECSE 548 Introduction to VLSI Systems (3 credits)",
"ECSE 549 Expert Systems in Electrical Design (3 credits)",
"ECSE 551 Machine Learning for Engineers (4 credits)",
"ECSE 552 Deep Learning (4 credits)",
"ECSE 553 Critical Systems (4 credits)",
"ECSE 559 Flexible AC Transmission Systems (3 credits)",
"ECSE 562 Low-Carbon Power Generation Engineering (4 credits)",
"ECSE 563 Power Systems Operation and Planning (3 credits)",
"ECSE 564 Power Systems Dynamics and Control (4 credits)",
"ECSE 565 Introduction to Power Electronics (3 credits)",
"ECSE 570 Automatic Speech Recognition (3 credits)",
"ECSE 571 Optoelectronic Devices (3 credits)",
"ECSE 572 Nonlinear Optics (3 credits)",
"ECSE 573 Microwave Electronics (3 credits)",
"ECSE 574 CMOS Sensor Microsystems (3 credits)",
"ECSE 593 Antennas and Propagation (3 credits)",
"ECSE 596 Optical Waveguides (3 credits)",
"ECSE 597 Circuit Simulation and Modelling (4 credits)",
"ECSE 608 Machine Learning (4 credits)",
"ECSE 609 Custom High-Performance Computing Architectures (4 credits)",
"ECSE 610 Wireless Communications (4 credits)",
"ECSE 611 Software Analytics (4 credits)",
"ECSE 612 Multi-User Communications (4 credits)",
"ECSE 615 Digital Signal Processing 2 (4 credits)",
"ECSE 618 Haptics (4 credits)",
"ECSE 620 Information Theory and Coding (4 credits)",
"ECSE 621 Statistic Detection and Estimation (4 credits)",
"ECSE 623 Digital Communications 2 (4 credits)",
"ECSE 626 Statistical Computer Vision (4 credits)",
"ECSE 634 Analog Integrated Circuits Signal Processing (4 credits)",
"ECSE 635 Printed Electronics (4 credits)",
"ECSE 648 VLSI Design (4 credits)",
"ECSE 649 VLSI Testing (4 credits)",
"ECSE 651 M.Eng. Project 1 (1 credit)",
"ECSE 652 M.Eng. Project 2 (2 credits)",
"ECSE 653 M.Eng. Project 3 (3 credits)",
"ECSE 654 M.Eng. Project 4 (4 credits)",
"ECSE 655 M.Eng. Project 5 (4 credits)",
"ECSE 656 M.Eng. Project 6 (4 credits)",
"ECSE 670D1 Computational Science Engineering Seminar (0.5 credits)",
"ECSE 670D2 Computational Science Engineering Seminar (0.5 credits)",
"ECSE 670N1 Computational Science Engineering Seminar (0.5 credits)",
"ECSE 670N2 Computational Science Engineering Seminar (0.5 credits)",
"ECSE 675 Solar Cells and Junctions (4 credits)",
"ECSE 677 Experimental Techniques: Solid State (4 credits)",
"ECSE 678 Special Topics in Solids 1 (4 credits)",
"ECSE 680 Topics in Photonics (4 credits)",
"ECSE 681 Colloquium in Electrical Engineering (4 credits)",
"ECSE 682 Topics in Computers and Circuits (4 credits)",
"ECSE 683 Topics in Vision and Robotics (4 credits)",
"ECSE 686 Topics: Communication Systems (4 credits)",
"ECSE 686D1 Topics: Communication Systems (2 credits)",
"ECSE 686D2 Topics: Communication Systems (2 credits)",
"ECSE 686N1 Topics: Communication Systems (2 credits)",
"ECSE 686N2 Topics: Communication Systems (2 credits)",
"ECSE 688 Recent Advances in Electrical Engineering 1 (4 credits)",
"ECSE 689 Recent Advances: Electrical Engineering 2 (4 credits)",
"ECSE 691 Thesis Research 1 (3 credits)",
"ECSE 692 Thesis Research 2 (4 credits)",
"ECSE 693 Thesis Research 3 (4 credits)",
"ECSE 694 Thesis Research 4 (4 credits)",
"ECSE 695 Thesis Research 5 (4 credits)",
"ECSE 696 Thesis Research 6 (4 credits)",
"ECSE 697 Thesis Research 7 (4 credits)",
"ECSE 701 Ph.D. Qualifying Examination",
"ECSE 702 Ph.D. Research Plan Proposal",
"ECSE 703 Doctoral Research Seminar",
"EDEA 204 Drawing (3 credits)",
"EDEA 205 Painting 2 (3 credits)",
"EDEA 206 1st Year Professional Seminar (1 credit)",
"EDEA 208 Second Professional Seminar (Music) (1 credit)",
"EDEA 241 Basic Art Media for Classroom (3 credits)",
"EDEA 242 Cultural Skills 1 (3 credits)",
"EDEA 243 Cultural Skills 2 (3 credits)",
"EDEA 244 Cultural Skills - Fall (3 credits)",
"EDEA 245 Cultural Skills - Winter (3 credits)",
"EDEA 246 Cultural Skills - Spring (3 credits)",
"EDEA 247 Cultural Skills - Summer (3 credits)",
"EDEA 296 Basic Design (3 credits)",
"EDEA 302 Special Topics (3 credits)",
"EDEA 304 Painting 3 (3 credits)",
"EDEA 305 Painting 4 (3 credits)",
"EDEA 307 Drawing 2 (3 credits)",
"EDEA 332 Art Curriculum and Instruction - Elementary (3 credits)",
"EDEA 341 Listening for Learning (3 credits)",
"EDEA 342 Curriculum and Instruction in Drama Education (3 credits)",
"EDEA 345 Music Curriculum and Instruction for Generalists (3 credits)",
"EDEA 352 Music Listening in Education (3 credits)",
"EDEA 362 Movement Music and Communication (3 credits)",
"EDEA 394 Creative Dramatics for Classroom (3 credits)",
"EDEA 407 Final Year Professional Seminar Music (3 credits)",
"EDEA 410 Aesthetics and Art for the Classroom (3 credits)",
"EDEA 442 Methods in Music Education 1 (3 credits)",
"EDEA 472 Methods in Music Education 2 (3 credits)",
"EDEA 496 Sculpture 1 (3 credits)",
"EDEA 497 Sculpture 2 (3 credits)",
"EDEA 652 Approaches to Music Curriculum (3 credits)",
"EDEC 200 Introduction to Inuit Studies (3 credits)",
"EDEC 201 First Year Professional Seminar (1 credit)",
"EDEC 202 Effective Communication (3 credits)",
"EDEC 203 Communication in Education (3 credits)",
"EDEC 203D1 Communication in Education (1.5 credits)",
"EDEC 203D2 Communication in Education (1.5 credits)",
"EDEC 204 Communication in Social Work (3 credits)",
"EDEC 208 Expressive Writing (3 credits)",
"EDEC 215 English Exam for Teacher Certification",
"EDEC 216 Indigenous Language Requirement",
"EDEC 220 Curriculum Development (3 credits)",
"EDEC 221 Leadership and Group Skills (3 credits)",
"EDEC 222 Personnel Management and Group Skills (3 credits)",
"EDEC 227 Naskapi Language 1 (3 credits)",
"EDEC 228 Naskapi Language 2 (3 credits)",
"EDEC 230 Conflict Resolution (3 credits)",
"EDEC 233 Indigenous Education (3 credits)",
"EDEC 237 Mi'gmaw Heritage Language 1 (3 credits)",
"EDEC 238 Mi'gmaw Heritage Language 2 (3 credits)",
"EDEC 239 Mi'gmaw Language 1 (3 credits)",
"EDEC 240 Mi'gmaw Language 2 (3 credits)",
"EDEC 241 Cree Language 1 (3 credits)",
"EDEC 242 Cree Language 2 (3 credits)",
"EDEC 243 Teaching: Multigrade Classrooms (3 credits)",
"EDEC 244 Issues in Aboriginal Education (3 credits)",
"EDEC 245 Middle School Teaching (3 credits)",
"EDEC 246 Middle School Curriculum (3 credits)",
"EDEC 247 Policy Issues in Quebec Education (3 credits)",
"EDEC 248 Equity and Education (3 credits)",
"EDEC 249 Global Education and Social Justice (3 credits)",
"EDEC 253 Second Professional Seminar (Kindergarten/Elementary) (1 credit)",
"EDEC 253D1 Second Professional Seminar (Kindergarten/Elementary) (0.5 credits)",
"EDEC 253D2 Second Professional Seminar (Kindergarten/Elementary) (0.5 credits)",
"EDEC 254 Second Professional Seminar (Secondary) (1 credit)",
"EDEC 254D1 Second Professional Seminar (Secondary) (0.5 credits)",
"EDEC 254D2 Second Professional Seminar (Secondary) (0.5 credits)",
"EDEC 260 Philosophical Foundations (3 credits)",
"EDEC 262 Media Technology and Education (3 credits)",
"EDEC 263 Information Communication Technology in Indigenous Literacy (3 credits)",
"EDEC 270 Algonquin Heritage Language 1 (3 credits)",
"EDEC 271 Algonquin Heritage Language 2 (3 credits)",
"EDEC 272 Algonquin Language 1 (3 credits)",
"EDEC 273 Algonquin Language 2 (3 credits)",
"EDEC 275 Mohawk Heritage Language 1 (3 credits)",
"EDEC 276 Mohawk Heritage Language 2 (3 credits)",
"EDEC 277 Mohawk Language 1 (3 credits)",
"EDEC 278 Mohawk Language 2 (3 credits)",
"EDEC 288 Inuktitut for Beginners (3 credits)",
"EDEC 289 Inuktitut Orthography and Grammar (3 credits)",
"EDEC 300 Special Topics 1 (3 credits)",
"EDEC 300D1 Special Topics 1 (1.5 credits)",
"EDEC 300D2 Special Topics 1 (1.5 credits)",
"EDEC 301 Special Topics 2 (3 credits)",
"EDEC 302 Language and Learning - Curriculum (3 credits)",
"EDEC 305 Communication in Management 2 (3 credits)",
"EDEC 306 Third Year Professional Seminar (Sec) (3 credits)",
"EDEC 308 Learning to Write Fiction (3 credits)",
"EDEC 309 Learning to Write Poetry (3 credits)",
"EDEC 311 Resource Management (6 credits)",
"EDEC 312 Practicum in Educational Leadership (3 credits)",
"EDEC 313 Indigenous Land-Based Pedagogy (3 credits)",
"EDEC 341 Intermediate Indigenous Heritage Language (3 credits)",
"EDEC 342 Intermediate Indigenous Language (3 credits)",
"EDEC 344 Advanced Indigenous Language (3 credits)",
"EDEC 351 Third Professional Seminar (Secondary) (2 credits)",
"EDEC 374 Education and the Environment (3 credits)",
"EDEC 403 The Dialects of Inuktitut (3 credits)",
"EDEC 404 Fourth Year Professional Seminar (Sec) (3 credits)",
"EDEC 405 Fourth Year Professional Seminar (K/Elem) (3 credits)",
"EDEC 575 Special Topics in Education (3 credits)",
"EDEC 590 Culturally Appropriate Teaching (3 credits)",
"EDEC 591 Cultural Values and Socialization (3 credits)",
"EDEC 602 Foundations in Curriculum (3 credits)",
"EDEC 603 Extended Individual Reading Course (6 credits)",
"EDEC 604 Literacy and Learning Across Curriculum (3 credits)",
"EDEC 606 Autobiographical Approaches in Education (3 credits)",
"EDEC 610 Literature: Children/Young Adults (3 credits)",
"EDEC 612 Digital Media and Learning (3 credits)",
"EDEC 614 Numeracy Across the Curriculum (3 credits)",
"EDEC 616 Individual Reading Course (3 credits)",
"EDEC 617 Special Topics in Educational Studies (3 credits)",
"EDEC 620 Meanings of Literacy (3 credits)",
"EDEC 624 Researching Teaching Learning and Teacher Education (3 credits)",
"EDEC 625 MA Seminar in Practice-Based Teacher Education 1 (3 credits)",
"EDEC 626 MA Seminar in Math and Science Education 2 (3 credits)",
"EDEC 627 Critical Discourse Studies in Education (3 credits)",
"EDEC 628 Literacy - Multilingual/Multicultural Settings (3 credits)",
"EDEC 629 Writing: Theory Research and Practice (3 credits)",
"EDEC 635 Research Writing (3 credits)",
"EDEC 646 Sociocultural and Epistemic Understandings of Science (3 credits)",
"EDEC 647 Sociocultural and Epistemic Understandings of Mathematics (3 credits)",
"EDEC 648 Historical Knowledge and Social Change (3 credits)",
"EDEC 700 Proseminar in Education 1 (2 credits)",
"EDEC 701 Ph.D. Comprehensive Examination",
"EDEC 702 Proseminar in Education 2 (2 credits)",
"EDEC 703 Ph.D. Colloquium (4 credits)",
"EDEC 705 Advanced Research Designs (3 credits)",
"EDEC 706 Textual Approaches to Research (3 credits)",
"EDEC 707 Interpretive Inquiry (3 credits)",
"EDEC 708 PhD Seminar in Practice-Based Teacher Education 1 (3 credits)",
"EDEC 709 PhD Seminar in Math and Science Education 2 (3 credits)",
"EDEE 130 Diagnostic Math Test for B.Ed. K/Elementary",
"EDEE 223 Language Arts (3 credits)",
"EDEE 230 Elementary School Mathematics 1 (3 credits)",
"EDEE 234 Elementary School Geometry (3 credits)",
"EDEE 240 Use and Adaptation of Curricula (3 credits)",
"EDEE 241 Teaching Language Arts (3 credits)",
"EDEE 242 Teaching Mathematics (3 credits)",
"EDEE 243 Reading Methods in Inuktitut/Cree (3 credits)",
"EDEE 245 Orientation to Education (3 credits)",
"EDEE 246 Cultivating Language and Thought (3 credits)",
"EDEE 248 Reading and Writing Inuktitut/Cree (3 credits)",
"EDEE 250 The Kindergarten Classroom (2 credits)",
"EDEE 253 Kindergarten Classroom Pedagogy (3 credits)",
"EDEE 260 Reading Methods - Kindergarten/Elementary (3 credits)",
"EDEE 261 Reading Clinic - Early Childhood (3 credits)",
"EDEE 270 Elementary School Science (3 credits)",
"EDEE 273 Elementary School Science 2 (3 credits)",
"EDEE 275 Science Teaching (2 credits)",
"EDEE 280 Geography History and Citizenship Education (3 credits)",
"EDEE 282 Teaching Social Sciences (2 credits)",
"EDEE 283 Social Studies Pedagogy (3 credits)",
"EDEE 292 Using Instructional Resources (3 credits)",
"EDEE 325 Children's Literature (3 credits)",
"EDEE 332 Teaching Elementary Mathematics 2 (3 credits)",
"EDEE 340 Special Topics: Cultural Issues (3 credits)",
"EDEE 345 Literature and Creative Writing 1 (3 credits)",
"EDEE 346 Literature and Creative Writing 2 (3 credits)",
"EDEE 347 Grammar and Composition 1 (3 credits)",
"EDEE 348 Grammar and Composition 2 (3 credits)",
"EDEE 350 Integrating the Curriculum (2 credits)",
"EDEE 352 Classroom Practices (2 credits)",
"EDEE 353 Third Year Professional Seminar (Kindergarten/Elementary) (3 credits)",
"EDEE 355 Classroom-based Evaluation (3 credits)",
"EDEE 370 Traditional Indigenous Life Skills (3 credits)",
"EDEE 371 Integrating Indigenous Storytelling and Creative Writing (3 credits)",
"EDEE 373 Traditional Healing (3 credits)",
"EDEE 383 Oral and Family History (3 credits)",
"EDEE 435 Mathematics Topics (3 credits)",
"EDEE 444 First Nations and Inuit Curriculum (3 credits)",
"EDEE 473 Ecological Studies (3 credits)",
"EDEE 655 Special Topics - Curriculum Studies (3 credits)",
"EDEM 220 Contemporary Issues in Education (3 credits)",
"EDEM 502 Indigenous Family Dynamics and Supporting Institutions (3 credits)",
"EDEM 503 Research Seminar In Indigenous Studies (3 credits)",
"EDEM 603 Individual Reading Course (6 credits)",
"EDEM 606 Educational Leadership Issues (3 credits)",
"EDEM 609 Critical Perspectives in Educational Theory and Research (3 credits)",
"EDEM 610 Leadership in Action (3 credits)",
"EDEM 615 Selected Issues: Contemporary Education (6 credits)",
"EDEM 616 Individual Reading Course (3 credits)",
"EDEM 621 Thesis 1 (6 credits)",
"EDEM 623 Thesis 2 (6 credits)",
"EDEM 625 Project 1 (6 credits)",
"EDEM 625N1 Project 1 (3 credits)",
"EDEM 625N2 Project 1 (3 credits)",
"EDEM 627 Project 2 (6 credits)",
"EDEM 628 Education Resource Management (3 credits)",
"EDEM 630 Workplace Learning (3 credits)",
"EDEM 635 Fiscal Accountability in Education (3 credits)",
"EDEM 637 Managing Educational Change (3 credits)",
"EDEM 644 Curriculum Development and Implementation (3 credits)",
"EDEM 646 Planning and Evaluation (3 credits)",
"EDEM 660 Community Relations in Education (3 credits)",
"EDEM 664 Education and the Law (3 credits)",
"EDEM 671 Role of the Leader (3 credits)",
"EDEM 673 Leadership Theory in Education (3 credits)",
"EDEM 674 Organizational Theory and Education (3 credits)",
"EDEM 675 Special Topics 1 in Educational Leadership (3 credits)",
"EDEM 676 Organizing Non-Formal Learning (3 credits)",
"EDEM 677 Special Topics 2 in Educational Leadership (3 credits)",
"EDEM 681 Practicum - Administrative Studies (3 credits)",
"EDEM 690 Research Methods: Theory and Practice (3 credits)",
"EDEM 692 Qualitative Research Methods (3 credits)",
"EDEM 693 School Improvement Approaches (3 credits)",
"EDEM 695 Policy Studies in Education (3 credits)",
"EDEM 699 Thesis 3 (12 credits)",
"EDEM 699D1 Thesis 3 (6 credits)",
"EDEM 699D2 Thesis 3 (6 credits)",
"EDEM 699N1 Thesis 3 (6 credits)",
"EDEM 699N2 Thesis 3 (6 credits)",
"EDER 209 Search for Authenticity (3 credits)",
"EDER 252 Understanding and Teaching Jewish Life (3 credits)",
"EDER 309 The Religious Quest (3 credits)",
"EDER 318 Teaching the Jewish Liturgy (3 credits)",
"EDER 319 Teaching the Holocaust (3 credits)",
"EDER 320 Visions and Realities of Jewish Education (3 credits)",
"EDER 360 Ethics and Religious Culture (K/Elementary) (2 credits)",
"EDER 372 Ethics and Religious Culture (Secondary) (3 credits)",
"EDER 394 Philosophy of God (3 credits)",
"EDER 395 Moral Values and Human Action (3 credits)",
"EDER 401 Teaching Biblical Literature - Jewish School 1 (3 credits)",
"EDER 451 Tutorial in Jewish Education (3 credits)",
"EDER 461 Society and Change (3 credits)",
"EDER 473 Living with Insight (3 credits)",
"EDER 494 Human Rights and Ethics in Practice (3 credits)",
"EDER 520 Issues in Jewish Education (3 credits)",
"EDER 521 Teaching Judaism: Yiddish (3 credits)",
"EDER 522 Teaching Judaism: Hebrew (3 credits)",
"EDER 523 Teaching Judaism: Bible (3 credits)",
"EDER 524 Teaching Judaism: History (3 credits)",
"EDER 525 Teaching Judaism: Holidays (3 credits)",
"EDER 526 Teaching Judaism: Liturgy (3 credits)",
"EDER 527 Teaching Judaism: Special Topics (3 credits)",
"EDER 528 Teaching Judaism: The Holocaust (3 credits)",
"EDER 529 Hebrew Language Requirement",
"EDER 600 Globalization Education & Change (3 credits)",
"EDER 603 Individual Reading Course (6 credits)",
"EDER 606 Philosophy of Moral Education (3 credits)",
"EDER 607 Ethics and Values in Education (3 credits)",
"EDER 608 Educational Implications of Social Theory (3 credits)",
"EDER 609 Education and Philosophical Thought (3 credits)",
"EDER 610D1 Internship (7.5 credits)",
"EDER 610D2 Internship (7.5 credits)",
"EDER 614 Sociology of Education (3 credits)",
"EDER 615 Introduction to Philosophy of Education (3 credits)",
"EDER 616 Individual Reading Course (3 credits)",
"EDER 617 Aesthetics and Education (3 credits)",
"EDER 622 Studies in Comparative Education (3 credits)",
"EDER 625 Special Topics in Educational Studies (3 credits)",
"EDER 626 Theory and Praxis of Ethics and Religious Education (3 credits)",
"EDER 633 Project 1 (6 credits)",
"EDER 634 Project 2 (6 credits)",
"EDER 636 Critical and Ethical Dimensions of Sexualities Education (3 credits)",
"EDER 639 Education and Development (3 credits)",
"EDER 643 Women Education and Development (3 credits)",
"EDER 649 Education: Multicultural Societies (3 credits)",
"EDER 690 Thesis Preparation 1 (6 credits)",
"EDER 691 Thesis Preparation 2 (6 credits)",
"EDER 692 Thesis Preparation 3 (12 credits)",
"EDES 334 Teaching Secondary Social Studies 1 (3 credits)",
"EDES 335 Teaching Secondary Science 1 (3 credits)",
"EDES 350 Classroom Practices (3 credits)",
"EDES 353 Teaching Secondary Mathematics 1 (3 credits)",
"EDES 361 Teaching Secondary English 1 (3 credits)",
"EDES 365 Experiences in Communications (3 credits)",
"EDES 366 Literature for Young Adults (3 credits)",
"EDES 434 Teaching Secondary Social Studies 2 (3 credits)",
"EDES 435 Teaching Secondary Science 2 (3 credits)",
"EDES 453 Teaching Secondary Mathematics 2 (3 credits)",
"EDES 461 Teaching Secondary English 2 (3 credits)",
"EDET 398 Special Project (3 credits)",
"EDFC 497 Individual Research Project (3 credits)",
"EDFE 200 First Field Experience (K/Elem & Secondary) (2 credits)",
"EDFE 205 First Field Experience (Music) (2 credits)",
"EDFE 208 Second Field Experience (Music) (3 credits)",
"EDFE 208D1 Second Field Experience (Music) (1.5 credits)",
"EDFE 208D2 Second Field Experience (Music) (1.5 credits)",
"EDFE 209 First Field Experience (TESL) (2 credits)",
"EDFE 210 Middle School Practicum (3 credits)",
"EDFE 214 Aboriginal Education Practicum 1 (3 credits)",
"EDFE 246 First Field Experience (Physical Education) (3 credits)",
"EDFE 254 Second Field Experience (Secondary) (3 credits)",
"EDFE 254D1 Second Field Experience (Secondary) (1.5 credits)",
"EDFE 254D2 Second Field Experience (Secondary) (1.5 credits)",
"EDFE 255 Second Field Experience (TESL) (3 credits)",
"EDFE 255D1 Second Field Experience (TESL) (1.5 credits)",
"EDFE 255D2 Second Field Experience (TESL) (1.5 credits)",
"EDFE 256 Second Field Experience (Kindergarten/Elementary) (3 credits)",
"EDFE 256D1 Second Field Experience (Kindergarten/Elementary) (1.5 credits)",
"EDFE 256D2 Second Field Experience (Kindergarten/Elementary) (1.5 credits)",
"EDFE 261 Stage d'assistanat - 2e année (3 credits)",
"EDFE 300 Indigenous Education Field Experience (5 credits)",
"EDFE 303 Third Field Course (K/Elem) (7 credits)",
"EDFE 305 3rd Field Experience Music (7 credits)",
"EDFE 306 Third Field Experience (Kindergarten/Elementary) (8 credits)",
"EDFE 308 Third Field Experience (Music) (8 credits)",
"EDFE 325 Aboriginal Education Practicum 2 (3 credits)",
"EDFE 326 Aboriginal Education Practicum 3 (3 credits)",
"EDFE 351 Third Field Experience (Secondary) (8 credits)",
"EDFE 359 Third Field Experience (TESL) (8 credits)",
"EDFE 362 Stage d'enseignement en Français langue seconde (7 credits)",
"EDFE 373 Second Field Experience (Physical Education) (3 credits)",
"EDFE 380 Third Field Experience (Physical Education) (7 credits)",
"EDFE 406 Fourth Field Experience (K/Elem) (7 credits)",
"EDFE 407 Fourth Field Experience (Music) (7 credits)",
"EDFE 425 Aboriginal Education Practicum 4 (3 credits)",
"EDFE 451 Fourth Field Experience (Secondary) (7 credits)",
"EDFE 459 Fourth Field Experience (TESL) (7 credits)",
"EDFE 461 Stage d'enseignement - immersion (9 credits)",
"EDFE 480 Fourth Field Experience (Physical Education) (7 credits)",
"EDFM 260 Stage de familiarisation (1 credit)",
"EDFM 361 Stage d'enseignement 1 (7 credits)",
"EDFM 460 Stage d'enseignement 2 (9 credits)",
"EDIN 601 Internship 1 (9 credits)",
"EDIN 601D1 Internship 1 (4.5 credits)",
"EDIN 601D2 Internship 1 (4.5 credits)",
"EDIN 602 Internship 2 (10 credits)",
"EDIN 602D1 Internship 2 (5 credits)",
"EDIN 602D2 Internship 2 (5 credits)",
"EDIN 610 Internship 1 (7 credits)",
"EDIN 620 Internship 2 (8 credits)",
"EDKP 100 Introduction to Physical and Health Education in Quebec (3 credits)",
"EDKP 200 Weight Training (1 credit)",
"EDKP 201 Physical Activity Leadership (3 credits)",
"EDKP 204 Health Education (3 credits)",
"EDKP 205 Structural Anatomy (3 credits)",
"EDKP 206 Biomechanics of Human Movement (3 credits)",
"EDKP 208 Biomechanics and Motor Learning (3 credits)",
"EDKP 213 Aquatics (1 credit)",
"EDKP 214 Basketball (2 credits)",
"EDKP 215 Standard First Aid/Cardio-Pulmonary Resuscitation Level C",
"EDKP 217 Track and Field (3 credits)",
"EDKP 218 Volleyball (2 credits)",
"EDKP 219 Healthy Lifestyle Activity (1 credit)",
"EDKP 223 Games 1: Elementary Physical Education (3 credits)",
"EDKP 224 Foundations of Movement Education (3 credits)",
"EDKP 225 Games 2: Secondary Physical Education (3 credits)",
"EDKP 226 Quebec Education Program Orientation (1 credit)",
"EDKP 227 Rugby (1 credit)",
"EDKP 228 Football 1 (1 credit)",
"EDKP 229 Ice Hockey 1 (1 credit)",
"EDKP 231 Martial Arts (1 credit)",
"EDKP 232 Health-Related Fitness (3 credits)",
"EDKP 233 Soccer (2 credits)",
"EDKP 234 Team Handball (1 credit)",
"EDKP 235 Non-Traditional Physical Activities (3 credits)",
"EDKP 236 Softball (1 credit)",
"EDKP 237 Outdoor Education (3 credits)",
"EDKP 238 Field Hockey 1 (1 credit)",
"EDKP 239 Medical Imaging of Anatomy (1 credit)",
"EDKP 240 Winter Activities (1 credit)",
"EDKP 241 Indigenous Physical Activities (3 credits)",
"EDKP 244 Dance and Fitness (1 credit)",
"EDKP 245 Special Topics 01 (1 credit)",
"EDKP 250 Introductory Principles in Applied Kinesiology (3 credits)",
"EDKP 252 Racquet Sports (2 credits)",
"EDKP 253 Movement Education (3 credits)",
"EDKP 261 Motor Development (3 credits)",
"EDKP 292 Nutrition and Wellness (3 credits)",
"EDKP 293 Anatomy and Physiology (3 credits)",
"EDKP 300 Special Topics 02 (3 credits)",
"EDKP 301 Kinesiology Internship 1 (3 credits)",
"EDKP 307 Evaluation in Physical Education (3 credits)",
"EDKP 311 Athletic Injuries (3 credits)",
"EDKP 314 Basketball 2 (1 credit)",
"EDKP 318 Volleyball 2 (1 credit)",
"EDKP 330 Physical Activity and Health (3 credits)",
"EDKP 332 Physical Education Curriculum and Instruction (3 credits)",
"EDKP 336 Lacrosse (1 credit)",
"EDKP 342 Physical Education Methods (3 credits)",
"EDKP 350 Physical Fitness Evaluation Methods (3 credits)",
"EDKP 391 Physiology in Sport and Exercise (3 credits)",
"EDKP 393 Skill Learning and Expertise (3 credits)",
"EDKP 394 Historical Perspectives (3 credits)",
"EDKP 395 Exercise Physiology (3 credits)",
"EDKP 396 Adapted Physical Activity (3 credits)",
"EDKP 400 Special Topics 03 (3 credits)",
"EDKP 401 Kinesiology Internship 2 (3 credits)",
"EDKP 405 Sport in Society (3 credits)",
"EDKP 442 Physical Education Pedagogy (3 credits)",
"EDKP 443 Research Methods (3 credits)",
"EDKP 444 Ergonomics (3 credits)",
"EDKP 445 Exercise Metabolism (3 credits)",
"EDKP 446 Physical Activity and Ageing (3 credits)",
"EDKP 447 Motor Control (3 credits)",
"EDKP 448 Exercise and Health Psychology (3 credits)",
"EDKP 449 Exercise Pathophysiology 2 (3 credits)",
"EDKP 450 Advanced Principles in Applied Kinesiology (3 credits)",
"EDKP 451 Personal Trainer Practicum (3 credits)",
"EDKP 452 Fitness & Lifestyle Consulting (3 credits)",
"EDKP 453 Research Practicum in Kinesiology (3 credits)",
"EDKP 453D1 Research Practicum in Kinesiology (1.5 credits)",
"EDKP 453D2 Research Practicum in Kinesiology (1.5 credits)",
"EDKP 454 Honours Research Practicum (3 credits)",
"EDKP 485 Exercise Pathophysiology 1 (3 credits)",
"EDKP 494 Physical Education Curriculum Development (3 credits)",
"EDKP 495 Scientific Principles of Training (3 credits)",
"EDKP 498 Sport Psychology (3 credits)",
"EDKP 499 Undergraduate Honours Research Project (6 credits)",
"EDKP 499D1 Undergraduate Honours Research Project (3 credits)",
"EDKP 499D2 Undergraduate Honours Research Project (3 credits)",
"EDKP 499N1 Undergraduate Honours Research Project (3 credits)",
"EDKP 499N2 Undergraduate Honours Research Project (3 credits)",
"EDKP 504 Health & Lifestyle Education (3 credits)",
"EDKP 542 Environmental Exercise Physiology (3 credits)",
"EDKP 548 Applied Exercise Psychology (3 credits)",
"EDKP 566 Advanced Biomechanics Theory (3 credits)",
"EDKP 603 Individual Reading Course 1 (6 credits)",
"EDKP 603D1 Individual Reading Course 1 (3 credits)",
"EDKP 603D2 Individual Reading Course 1 (3 credits)",
"EDKP 605 Research Methods 1 (3 credits)",
"EDKP 608 Special Project (15 credits)",
"EDKP 616 Individual Reading Course 2 (3 credits)",
"EDKP 617 Seminar in Kinesiology and Physical Education 1",
"EDKP 618 Seminar in Kinesiology and Physical Education 2",
"EDKP 619 Seminar in Kinesiology and Physical Education 3",
"EDKP 620 Seminar in Kinesiology and Physical Education 4",
"EDKP 630 Human Walking Mechanics (3 credits)",
"EDKP 631 Qualitative Methods (3 credits)",
"EDKP 635 Modeling Human Movement (3 credits)",
"EDKP 640 Advanced Ergonomics (3 credits)",
"EDKP 650 Research in Physical Education Pedagogy (3 credits)",
"EDKP 652 Cardio-Respiratory Exercise Physiology (3 credits)",
"EDKP 654 Sport Psychology (3 credits)",
"EDKP 655 Inclusive Physical Activity (3 credits)",
"EDKP 661D1 Current Topics in Kinesiology Research (3 credits)",
"EDKP 661D2 Current Topics in Kinesiology Research (3 credits)",
"EDKP 662 Nerve/Muscle Exercise Response (3 credits)",
"EDKP 664 Motor Learning (3 credits)",
"EDKP 665 Motor Behaviour and Disability (3 credits)",
"EDKP 671 Experimental Problems (3 credits)",
"EDKP 672 Advanced Experimental Problems (6 credits)",
"EDKP 672D1 Advanced Experimental Problems (3 credits)",
"EDKP 672D2 Advanced Experimental Problems (3 credits)",
"EDKP 691 Thesis Research 1 (6 credits)",
"EDKP 691D1 Thesis Research 1 (3 credits)",
"EDKP 691D2 Thesis Research 1 (3 credits)",
"EDKP 692 Thesis Research 2 (6 credits)",
"EDKP 692D1 Thesis Research 2 (3 credits)",
"EDKP 692D2 Thesis Research 2 (3 credits)",
"EDKP 693 Thesis Research 3 (6 credits)",
"EDKP 693D1 Thesis Research 3 (3 credits)",
"EDKP 693D2 Thesis Research 3 (3 credits)",
"EDKP 694 Thesis Research 4 (6 credits)",
"EDKP 694D1 Thesis Research 4 (3 credits)",
"EDKP 694D2 Thesis Research 4 (3 credits)",
"EDKP 695 Thesis Research 5 (3 credits)",
"EDKP 696 Thesis Research 6 (3 credits)",
"EDKP 701 Ph.D. Comprehensive Examination",
"EDLE 601 Resource Administration & Fiscal Accountability (3 credits)",
"EDLE 602 Marketing & Strategy in International Education Leadership (3 credits)",
"EDLE 603 Educational Planning and Evaluation (3 credits)",
"EDLE 604 Education and Internationalization (3 credits)",
"EDLE 605 Leading for Success in Educational Institutions (3 credits)",
"EDPC 201 Introduction to Student Advising (3 credits)",
"EDPC 202 Helping Skills Practicum 1 (3 credits)",
"EDPC 203 Helping Skills Practicum 2 (3 credits)",
"EDPC 205 Career/Occupational Development (3 credits)",
"EDPC 208 Native Families' Dynamics (3 credits)",
"EDPC 209 Basic Crisis Intervention Skills (3 credits)",
"EDPC 210 Field Experience (3 credits)",
"EDPC 501 Facilitating Relationships (3 credits)",
"EDPC 502 Group Processes and Diversity (3 credits)",
"EDPC 503 Intersectional Relationships and Sexualities (3 credits)",
"EDPC 504 Communication and Critical Conflict Resolution (3 credits)",
"EDPC 505 Crisis Intervention Processes (3 credits)",
"EDPC 507 Advocacy Outreach and Leadership (3 credits)",
"EDPC 508 Seminar in Special Topics (3 credits)",
"EDPC 509 Individual Reading Course (3 credits)",
"EDPC 511 End of Life Care (3 credits)",
"EDPC 540 Social Responsibility and Relationships in Digital Age (3 credits)",
"EDPC 542 Leadership and Support Roles of the Teacher (3 credits)",
"EDPC 562 Career as a Lifelong Process (3 credits)",
"EDPC 606 Theories of Intervention 1 (3 credits)",
"EDPC 607 Theories of Counselling 2 (3 credits)",
"EDPC 608 Group Counselling: Theory (3 credits)",
"EDPC 609 Psychological Testing 1 (3 credits)",
"EDPC 610 Psychological Testing 2 (3 credits)",
"EDPC 615 Assessment and Diagnosis 1 (3 credits)",
"EDPC 616 Individual Reading Course (3 credits)",
"EDPC 618 Professional Ethics and the Law (3 credits)",
"EDPC 619 Research Project 1 (3 credits)",
"EDPC 620 Research Project 2 (3 credits)",
"EDPC 621 Research Project 3 (3 credits)",
"EDPC 624 Group Counselling: Practice (3 credits)",
"EDPC 625 Clinic Practicum 1 (6 credits)",
"EDPC 626 Clinic Practicum 2 (6 credits)",
"EDPC 628 Research Project 4 (3 credits)",
"EDPC 629 Research Project 5 (3 credits)",
"EDPC 630 Research Project 6 (3 credits)",
"EDPC 662 Career Psychology (3 credits)",
"EDPC 665D1 Practicum (3 credits)",
"EDPC 665D2 Practicum (3 credits)",
"EDPC 670 Current Trends in Counselling (3 credits)",
"EDPC 677 Internship Research Seminar: Quantitative Studies (3 credits)",
"EDPC 678 Internship Research Seminar: Qualitative Studies (3 credits)",
"EDPC 679 Internship: General 1 (6 credits)",
"EDPC 679D1 Internship: General 1 (3 credits)",
"EDPC 679D2 Internship: General 1 (3 credits)",
"EDPC 680D1 Internship Research Seminar (3 credits)",
"EDPC 680D2 Internship Research Seminar (3 credits)",
"EDPC 682 Practicum: Psychological Testing (6 credits)",
"EDPC 682D1 Practicum: Psychological Testing (3 credits)",
"EDPC 682D2 Practicum: Psychological Testing (3 credits)",
"EDPC 682N1 Practicum: Psychological Testing (3 credits)",
"EDPC 682N2 Practicum: Psychological Testing (3 credits)",
"EDPC 683 Practicum in Psychological Testing: Personality Assessment (3 credits)",
"EDPC 684 Practicum in Psychological Testing: Cognitive Assessment (3 credits)",
"EDPC 685 Internship: Vocational and Rehabilitation Counselling (6 credits)",
"EDPC 685D1 Internship: Vocational and Rehabilitation Counselling (3 credits)",
"EDPC 685D2 Internship: Vocational and Rehabilitation Counselling (3 credits)",
"EDPC 697 Thesis Preparation 1 (6 credits)",
"EDPC 698 Thesis Preparation 2 (6 credits)",
"EDPC 699 Thesis Preparation 3 (12 credits)",
"EDPC 699D1 Thesis Preparation 3 (6 credits)",
"EDPC 699D2 Thesis Preparation 3 (6 credits)",
"EDPC 701 Comprehensive Examination",
"EDPC 702 Assessment & Diagnosis 2 (3 credits)",
"EDPC 709 Advanced Theories and Models (3 credits)",
"EDPC 714 Theory / Models: Family Therapy (3 credits)",
"EDPC 719 Advanced Small Group Counselling (3 credits)",
"EDPC 720 Consultation and Program Evaluation (3 credits)",
"EDPC 720D1 Consultation and Program Evaluation (1.5 credits)",
"EDPC 720D2 Consultation and Program Evaluation (1.5 credits)",
"EDPC 770 Individual Reading Course (6 credits)",
"EDPC 780 Supervision (6 credits)",
"EDPC 780D1 Supervision (3 credits)",
"EDPC 780D2 Supervision (3 credits)",
"EDPC 782 Doctoral Field Experience (6 credits)",
"EDPC 782D1 Doctoral Field Experience (3 credits)",
"EDPC 782D2 Doctoral Field Experience (3 credits)",
"EDPC 783 Doctoral Fieldwork 2 (3 credits)",
"EDPC 784 Assessment Practicum (3 credits)",
"EDPC 786 Proposal Preparation and Defense (6 credits)",
"EDPC 786D1 Proposal Preparation and Defense (3 credits)",
"EDPC 786D2 Proposal Preparation and Defense (3 credits)",
"EDPC 795 Pre-doctoral Internship (24 credits)",
"EDPC 795D1 Pre-doctoral Internship (12 credits)",
"EDPC 795D2 Pre-doctoral Internship (12 credits)",
"EDPD 250 Students with Diverse Abilities (2 CE units)",
"EDPD 251 Communicative Competence: English as a Second Language (2 CE units)",
"EDPD 252 Competency-Based Training and Industry Benefits (2 CE units)",
"EDPD 253 Teacher Burnout: Retention to Sustainability (2 CE units)",
"EDPD 254 Course Design and Teaching Development (4.5 CE units)",
"EDPD 255 Inclusive Education (2 CE units)",
"EDPD 256 Motivating the Unmotivated (2 CE units)",
"EDPD 257 Self-Awareness in Pedagogy (2 CE units)",
"EDPD 258 Making Technology Educational (2 CE units)",
"EDPD 259 Real World Connections for the Math Classroom (2 CE units)",
"EDPD 260 Enhancing Educators’ Well-Being: Best Practices in Action (2 CE units)",
"EDPD 261 Effective School Response to Self-Injury (2 CE units)",
"EDPD 262 Developing Communication in the Mathematics Classroom (2 CE units)",
"EDPD 263 Special Topics in Global Trends in Education (2 CE units)",
"EDPE 208 Personality and Social Development (3 credits)",
"EDPE 300 Educational Psychology (3 credits)",
"EDPE 304 Measurement and Evaluation (3 credits)",
"EDPE 335 Instructional Psychology (3 credits)",
"EDPE 355 Cognition and Education (3 credits)",
"EDPE 375 Introductory Statistics (3 credits)",
"EDPE 377 Adolescence and Education (3 credits)",
"EDPE 495 Individual Reading Course (3 credits)",
"EDPE 496 Individual Reading Course (3 credits)",
"EDPE 502 Theories of Human Development (3 credits)",
"EDPE 515 Gender Identity Development (3 credits)",
"EDPE 535 Instructional Design (3 credits)",
"EDPE 550 Consciousness and Virtual Reality (3 credits)",
"EDPE 555 Socio-Cultural Foundations of Learning Sciences (3 credits)",
"EDPE 561 Artificial Intelligence in Education (3 credits)",
"EDPE 575 Statistics for Practitioners (3 credits)",
"EDPE 595 Seminar in Special Topics 1 (3 credits)",
"EDPE 596 Seminar in Special Topics 2 (3 credits)",
"EDPE 600 Current Topics: Educational Psychology (3 credits)",
"EDPE 600D1 Current Topics: Educational Psychology (1.5 credits)",
"EDPE 600D2 Current Topics: Educational Psychology (1.5 credits)",
"EDPE 602 Uses of Research Findings in Education (3 credits)",
"EDPE 604 Thesis 1 (3 credits)",
"EDPE 605 Research Methods (3 credits)",
"EDPE 607 Thesis 2 (3 credits)",
"EDPE 609 Selected Topics in Educational Psychology (3 credits)",
"EDPE 611 School Psychology Seminar (3 credits)",
"EDPE 616 Cognitive Development (3 credits)",
"EDPE 619 Child and Adolescent Therapy (3 credits)",
"EDPE 620 Developmental Psychopathology (3 credits)",
"EDPE 622 Multiculturalism and Gender (3 credits)",
"EDPE 623 Social-Emotional Development (3 credits)",
"EDPE 625 Practicum 1: School Psychology (3 credits)",
"EDPE 626 Practicum 2: School Psychology (3 credits)",
"EDPE 627 Ethical and Professional Practice of Psychology (3 credits)",
"EDPE 632D1 Research Seminar",
"EDPE 632D2 Research Seminar",
"EDPE 633 Research Internship 1 (3 credits)",
"EDPE 634 Research Internship 2 (3 credits)",
"EDPE 635 Theories of Learning and Instruction (3 credits)",
"EDPE 636 Motivation and Instruction (3 credits)",
"EDPE 637  Issues in Health Professions Education (3 credits)",
"EDPE 640 Emerging Technologies for Educational Change (3 credits)",
"EDPE 656 Applied Theory/Methods in the Learning Sciences (3 credits)",
"EDPE 663 Learning Environments (3 credits)",
"EDPE 664 Expertise Reasoning and Problem Solving (3 credits)",
"EDPE 666 Foundations of Learning Science (3 credits)",
"EDPE 668 Advanced Seminar in Learning Sciences (3 credits)",
"EDPE 670 Educational Assessment and Evaluation (3 credits)",
"EDPE 672 Human Development Seminar 1 (3 credits)",
"EDPE 673 Human Development Seminar 2 (3 credits)",
"EDPE 676 Intermediate Statistics (3 credits)",
"EDPE 682 Univariate/Multivariate Analysis (3 credits)",
"EDPE 683 Human Development Seminar 3 (3 credits)",
"EDPE 684 Applied Multivariate Statistics (3 credits)",
"EDPE 686 Human Development Seminar 4 (3 credits)",
"EDPE 687 Qualitative Methods in Educational Psychology (3 credits)",
"EDPE 691 Reading Course (3 credits)",
"EDPE 692 Reading Course (6 credits)",
"EDPE 692D1 Reading Course (3 credits)",
"EDPE 692D2 Reading Course (3 credits)",
"EDPE 693 Thesis 3 (3 credits)",
"EDPE 694 Thesis 4 (3 credits)",
"EDPE 695 Thesis 5 (6 credits)",
"EDPE 695D1 Thesis 5 (3 credits)",
"EDPE 695D2 Thesis 5 (3 credits)",
"EDPE 696 Thesis 6 (6 credits)",
"EDPE 696D1 Thesis 6 (3 credits)",
"EDPE 696D2 Thesis 6 (3 credits)",
"EDPE 697 Special Activity 1 (6 credits)",
"EDPE 697D1 Special Activity 1 (3 credits)",
"EDPE 697D2 Special Activity 1 (3 credits)",
"EDPE 698 Special Activity 2 (6 credits)",
"EDPE 698D1 Special Activity 2 (3 credits)",
"EDPE 698D2 Special Activity 2 (3 credits)",
"EDPE 699D1 Special Activity (6 credits)",
"EDPE 699D2 Special Activity (6 credits)",
"EDPE 704 Professional Development Seminar 1 (3 credits)",
"EDPE 705 Professional Development Seminar 2 (3 credits)",
"EDPE 706 Professional Development Seminar 3 (3 credits)",
"EDPE 707 Professional Development Seminar 4 (3 credits)",
"EDPE 708 Comprehensive Examination",
"EDPE 708D1 Comprehensive Examination",
"EDPE 708D2 Comprehensive Examination",
"EDPE 710 Consultation in School Psychology (3 credits)",
"EDPE 712 Neurological Bases of Behaviour Across Lifespan (3 credits)",
"EDPE 721 School Psychology: Elementary (6 credits)",
"EDPE 721D1 School Psychology: Elementary (3 credits)",
"EDPE 721D2 School Psychology: Elementary (3 credits)",
"EDPE 722 School Psychology: Secondary (6 credits)",
"EDPE 722D1 School Psychology: Secondary (3 credits)",
"EDPE 722D2 School Psychology: Secondary (3 credits)",
"EDPE 723 School Psychology: Community (6 credits)",
"EDPE 723D1 School Psychology: Community (3 credits)",
"EDPE 723D2 School Psychology: Community (3 credits)",
"EDPE 725 Internship 1 - School Psychology (12 credits)",
"EDPE 725D1 Internship 1 - School Psychology (6 credits)",
"EDPE 725D2 Internship 1 - School Psychology (6 credits)",
"EDPE 726 Internship 2 - School Psychology (12 credits)",
"EDPE 726D1 Internship 2 - School Psychology (6 credits)",
"EDPE 726D2 Internship 2 - School Psychology (6 credits)",
"EDPH 689 Teaching and Learning in Higher Education (3 credits)",
"EDPI 211 Social and Emotional Development (3 credits)",
"EDPI 212 Perceptual Motor Development (3 credits)",
"EDPI 309 Diverse Learners (3 credits)",
"EDPI 341 Instruction in Inclusive Schools (3 credits)",
"EDPI 344 Assessment for Instruction (3 credits)",
"EDPI 440 Managing the Inclusive Classroom (3 credits)",
"EDPI 441 Students with Behavior Difficulties (3 credits)",
"EDPI 442 Students with Learning Difficulties (3 credits)",
"EDPI 446 Special Topics (3 credits)",
"EDPI 450 Computers and Special Needs (3 credits)",
"EDPI 526 Supporting Students' Strengths and Talents (3 credits)",
"EDPI 527 Creativity and its Cultivation (3 credits)",
"EDPI 539 Field Work 1 (3 credits)",
"EDPI 540 Field Work 2 (3 credits)",
"EDPI 543 Family School and Community (3 credits)",
"EDPI 616 Individual Reading Course (3 credits)",
"EDPI 642 Inclusion: Past Present and Future (3 credits)",
"EDPI 643 Education of Learners/Special Needs 2 (3 credits)",
"EDPI 645 Assessment For Effective Intervention (3 credits)",
"EDPI 654 Instruction/Curriculum Adaptation (3 credits)",
"EDPI 656 Community-Based Field Work (6 credits)",
"EDPI 656D1 Community-Based Field Work (3 credits)",
"EDPI 656D2 Community-Based Field Work (3 credits)",
"EDPI 665 Teaching of Reading (3 credits)",
"EDPI 667 Promoting Social and Emotional Well-Being (3 credits)",
"EDPI 691 Research Project 1 (3 credits)",
"EDPI 692 Research Project 2 (3 credits)",
"EDPI 693 Research Project 3 (3 credits)",
"EDPI 694 Research Project 4 (3 credits)",
"EDPI 743D1 Seminar on Special Needs (1.5 credits)",
"EDPI 743D2 Seminar on Special Needs (1.5 credits)",
"EDPS 600 Introductory Professional Seminar (3 credits)",
"EDPS 605 Culminating Professional Seminar (1 credit)",
"EDPS 610 Professional Seminar 1 (2 credits)",
"EDPS 620 Professional Seminar 2 (1 credit)",
"EDPT 200 Integrating Educational Technology in Classrooms (3 credits)",
"EDPT 204 Creating and Using Media for Learning (3 credits)",
"EDSL 210 First Professional Seminar (1 credit)",
"EDSL 215 Communication in Education for TESL in Quebec (3 credits)",
"EDSL 247 Second Language Education in Indigenous Communities (3 credits)",
"EDSL 254 Second Professional Seminar (TESL) (1 credit)",
"EDSL 255 Second Professional Seminar (2 credits)",
"EDSL 255D1 Second Professional Seminar (1 credit)",
"EDSL 255D2 Second Professional Seminar (1 credit)",
"EDSL 260 Séminaire professionnel-2e (1 credit)",
"EDSL 300 Foundations of L2 Education (3 credits)",
"EDSL 301 Étude de la langue (3 credits)",
"EDSL 304 Sociolinguistics and L2 Education (3 credits)",
"EDSL 305 L2 Learning: Classroom Settings (3 credits)",
"EDSL 311 Pedagogical Grammar (3 credits)",
"EDSL 315 Third Year Professional Seminar (2 credits)",
"EDSL 320 Séminaire 3 professionnel (1 credit)",
"EDSL 330 Literacy 1:Teaching Reading in ESL (3 credits)",
"EDSL 332 Literacy 2: Teaching Writing in ESL (3 credits)",
"EDSL 334 Teaching Oral Skills in ESL (3 credits)",
"EDSL 341 Littératie et littérature jeunesse en FLS (3 credits)",
"EDSL 345 Enseignement du FLS-immersion (3 credits)",
"EDSL 350 Essentials of English Grammar (3 credits)",
"EDSL 390 Teaching English as a Second Language in the Community (3 credits)",
"EDSL 412 Assessment in TESL (3 credits)",
"EDSL 415 Fourth Professional Seminar (3 credits)",
"EDSL 420 Séminaire 4 professionnel (2 credits)",
"EDSL 444 Laboratoire d'enseignement en français langue seconde (3 credits)",
"EDSL 447 Methods in TESL 1 (3 credits)",
"EDSL 449 Special Topics in Second Language Teaching (3 credits)",
"EDSL 458 Methods in TESL 2 (3 credits)",
"EDSL 472 Enseignement du français langue seconde-secondaire (3 credits)",
"EDSL 500 Foundations and Issues in Second Language Education (3 credits)",
"EDSL 505 Second Language Acquisition Applied to Classroom Contexts (3 credits)",
"EDSL 512 Grammar in Teaching English as a Second Language (3 credits)",
"EDSL 515 Étude de la langue française pour enseignants (3 credits)",
"EDSL 541 Littératie et littérature de jeunesse en contexte immersif (3 credits)",
"EDSL 544 Didactique du français en contexte immersif (3 credits)",
"EDSL 545 Fondements pédagogiques de l’immersion (3 credits)",
"EDSL 601 Methods and Curriculum in Second Language Teaching 1 (3 credits)",
"EDSL 602 Methods and Curriculum in Second Language Teaching 2 (3 credits)",
"EDSL 603 Individual Reading Course 1 (6 credits)",
"EDSL 616 Individual Reading Course 2 (3 credits)",
"EDSL 617 Special Topics in Second Language Education (3 credits)",
"EDSL 620 Social Justice Issues in Second Language Education (3 credits)",
"EDSL 623 Second Language Learning (3 credits)",
"EDSL 624 Educational Sociolinguistics (3 credits)",
"EDSL 627 Instructed Second Language Acquisition Research (3 credits)",
"EDSL 629 Second Language Assessment (3 credits)",
"EDSL 630 Qualitative/Ethnographic Methods (3 credits)",
"EDSL 632 Second Language Literacy Development (3 credits)",
"EDSL 640 Language Awareness: Theory and Practice (3 credits)",
"EDSL 651 Content-Based L2 Learning (3 credits)",
"EDSL 666 Thesis Research 1 (6 credits)",
"EDSL 667 Thesis Research 2 (6 credits)",
"EDSL 668 Thesis Research 3 (6 credits)",
"EDSL 669 Thesis Research 4 (6 credits)",
"EDSL 711 Language Acquisition Issues 3 (2 credits)",
"EDSP 501 Individual Reading Course 1 (3 credits)",
"EDSP 600D1 School Psychology Seminar (1.5 credits)",
"EDSP 600D2 School Psychology Seminar (1.5 credits)",
"EDSP 601 Individual Reading Course 2 (3 credits)",
"EDSP 602 Selected Topics in School/Applied Child Psychology 1 (3 credits)",
"EDSP 609 Introduction to Cognitive Assessment (3 credits)",
"EDSP 610 Introduction to Psycho-educational Assessment (3 credits)",
"EDSP 611 History Theory and Best Practices in School Psychology (3 credits)",
"EDSP 619 Child and Adolescent Therapy (3 credits)",
"EDSP 650D1 Professional Practice in School Setting (1.5 credits)",
"EDSP 650D2 Professional Practice in School Setting (1.5 credits)",
"EDSP 682D1 Psycho-Educational Assessment & Intervention Practicum (3 credits)",
"EDSP 682D2 Psycho-Educational Assessment & Intervention Practicum (3 credits)",
"EDSP 685 Selected Topics in School Psychology (3 credits)",
"EDSP 691 Research Project 1 (3 credits)",
"EDSP 692 Research Project 2 (3 credits)",
"EDSP 693 Research Project 3 (3 credits)",
"EDSP 694 Research Project 4 (3 credits)",
"EDSP 695 Research Project 5 (3 credits)",
"EDSP 696 Research Project 6 (3 credits)",
"EDSP 701 Comprehensive Examination",
"EDSP 702 Selected Topics in School/Applied Child Psychology 2 (3 credits)",
"EDSP 705D1 Practicum: School Psychology (3 credits)",
"EDSP 705D2 Practicum: School Psychology (3 credits)",
"EDSP 710 Consultation in School Psychology (3 credits)",
"EDSP 715D1 Theory and Practice of Supervision (3 credits)",
"EDSP 715D2 Theory and Practice of Supervision (3 credits)",
"EDSP 721D1 Field Placement 1: School Psychology (3 credits)",
"EDSP 721D2 Field Placement 1: School Psychology (3 credits)",
"EDSP 722D1 Field Placement 2: School Psychology (3 credits)",
"EDSP 722D2 Field Placement 2: School Psychology (3 credits)",
"EDSP 723D1 Field Placement 3:School Psychology (3 credits)",
"EDSP 723D2 Field Placement 3:School Psychology (3 credits)",
"EDSP 725D1 Internship: School Psychology (12 credits)",
"EDSP 725D2 Internship: School Psychology (12 credits)",
"EDTL 500 Applications of Educational Psychology Across Classrooms (3 credits)",
"EDTL 506 Philosophy of Education (3 credits)",
"EDTL 508 Critical Influences on Educational Praxis (3 credits)",
"EDTL 515 English Exam for Teacher Certification",
"EDTL 520 Perspectives on Knowledge in Mathematics and Science (3 credits)",
"EDTL 525 Teaching Science and Technology (3 credits)",
"EDTL 601 Cross-curricular Teaching Methods (3 credits)",
"EDTL 604 Techniques for Assessment (3 credits)",
"EDTL 606 Methods in Teaching Science in Secondary School (3 credits)",
"EDTL 607 Language and Policy in Quebec Education (3 credits)",
"EDTL 608 Methods in Teaching Mathematics in Secondary School (3 credits)",
"EDTL 609 Diverse Learners (3 credits)",
"EDTL 610 Methods in Teaching Secondary English Language Arts (3 credits)",
"EDTL 611 Classroom Competencies (3 credits)",
"EDTL 612 Adv Applied Meth in Teach'g Ethics&ReligCulture in Sec Sch (3 credits)",
"EDTL 614 Methods in Teaching Social Science in Secondary School (3 credits)",
"EDTL 616 Methods in Second Language Education in Secondary School (3 credits)",
"EDTL 625 Applied Methods in Teaching Science in Secondary School (3 credits)",
"EDTL 626 Advanced Applied Methods in Teaching Science in Sec. School (3 credits)",
"EDTL 627 Applied Methods in Teaching Mathematics in Secondary School (3 credits)",
"EDTL 628 Advanced Methods in Teaching Mathematics in Sec. School (3 credits)",
"EDTL 629 Applied Methods in Teaching Secondary Eng. Language Arts (3 credits)",
"EDTL 630 Advanced Applied Methods in Teaching Sec English Lang Arts (3 credits)",
"EDTL 633 Applied Methods in Teaching Social Science in Sec. School (3 credits)",
"EDTL 634 Adv Applied Meth in Teaching Social Sciences in Sec. School (3 credits)",
"EDTL 635 Applied Methods in Second Language Education (3 credits)",
"EDTL 636 Adv. Applied Methods in Second Language Education (3 credits)",
"EDTL 640 Teacher Inquiry and Action Research (3 credits)",
"EDUM 215 Test de certification en français écrit",
"EDUM 245 Français écrit pour futurs enseignants (3 credits)",
"EDUM 262 Système éducatif - profession enseignante (3 credits)",
"EDUM 263 Apprentissage et développement (3 credits)",
"EDUM 264 Phonétique et phonologie (3 credits)",
"EDUM 265 Acquisition-apprentissage-langues secondes (3 credits)",
"EDUM 266 Mathématiques au primaire (3 credits)",
"EDUM 267 Didactique des arts plastiques 1 (3 credits)",
"EDUM 268 Intégration des TIC (3 credits)",
"EDUM 269 École et environnement social (3 credits)",
"EDUM 270 Morphologie et syntaxe (3 credits)",
"EDUM 271 Lexique et sémantique (3 credits)",
"EDUM 341 Littératie et Littérature Jeunesse en FLS (3 credits)",
"EDUM 391 Didactique du français en accueil 1 (3 credits)",
"EDUM 392 Gestion de classe en langues secondes (3 credits)",
"EDUM 393 Adolescent et expérience scolaire (3 credits)",
"EDUM 394 Séminaire de stage-3e (1 credit)",
"EDUM 402 Évaluation en français langue seconde (3 credits)",
"EDUM 491 Didactique des mathématiques en langues secondes (3 credits)",
"EDUM 492 Didactique des sciences-technologies (3 credits)",
"EDUM 493 Sciences humaines au primaire (3 credits)",
"EDUM 494 Didactique de l'univers social et TIC (3 credits)",
"EDUM 495 Recherche-résolution de problèmes (3 credits)",
"EDUM 496 Laboratoire de formation professionnelle (3 credits)",
"EDUM 497 Problématique en éducation préscolaire (3 credits)",
"EDUM 498 Didactique du français en accueil 2 (3 credits)",
"EDUM 499 Séminaire de stage-4e (2 credits)",
"ELEC 200 Global and Public Health Pre-Clerkship Elective",
"ELEC 300 Elective (4 credits)",
"ELEC 400 Elective 1 Clerkship (4 credits)",
"ELEC 400D1 Elective 1 Clerkship (2 credits)",
"ELEC 400D2 Elective 1 Clerkship (2 credits)",
"ELEC 401 Elective 2 Clerkship (3 credits)",
"ELEC 402 Elective 3 Clerkship (3 credits)",
"ELEC 403 Elective 4 Clerkship (3 credits)",
"ELEC 404 Elective 5 Clerkship (3 credits)",
"ELEC 405 Elective 5 - Senior Clerkships (3 credits)",
"ENGL 199 FYS: Literature and Democracy (3 credits)",
"ENGL 200 Survey of English Literature 1 (3 credits)",
"ENGL 201 Survey of English Literature 2 (3 credits)",
"ENGL 202 Departmental Survey of English Literature 1 (3 credits)",
"ENGL 203 Departmental Survey of English Literature 2 (3 credits)",
"ENGL 204 English Literature and the Bible (3 credits)",
"ENGL 215 Introduction to Shakespeare (3 credits)",
"ENGL 225 American Literature 1 (3 credits)",
"ENGL 226 American Literature 2 (3 credits)",
"ENGL 227 American Literature 3 (3 credits)",
"ENGL 228 Canadian Literature 1 (3 credits)",
"ENGL 229 Canadian Literature 2 (3 credits)",
"ENGL 230 Introduction to Theatre Studies (3 credits)",
"ENGL 237 Introduction to Study of a Literary Form (3 credits)",
"ENGL 269 Introduction to Performance (3 credits)",
"ENGL 275 Introduction to Cultural Studies (3 credits)",
"ENGL 276 Methods of Cultural Analysis (3 credits)",
"ENGL 277 Introduction to Film Studies (3 credits)",
"ENGL 279 Introduction to Film as Art (3 credits)",
"ENGL 280 Introduction to Film as Mass Medium (3 credits)",
"ENGL 290 Postcolonial and World Literatures in English (3 credits)",
"ENGL 297 Special Topics of Literary Study (3 credits)",
"ENGL 300 The Seventeenth Century (3 credits)",
"ENGL 301 Earlier 18th Century Novel (3 credits)",
"ENGL 302 Restoration and 18th C. English Literature 1 (3 credits)",
"ENGL 303 Restoration and 18th C. English Literature 2 (3 credits)",
"ENGL 304 Later Eighteenth Century Novel (3 credits)",
"ENGL 305 Renaissance English Literature 1 (3 credits)",
"ENGL 306 Theatre History: Medieval and Early Modern (3 credits)",
"ENGL 307 Renaissance English Literature 2 (3 credits)",
"ENGL 308 English Renaissance Drama 1 (3 credits)",
"ENGL 309 English Renaissance Drama 2 (3 credits)",
"ENGL 310 Restoration and 18th Century Drama (3 credits)",
"ENGL 311 Poetics (3 credits)",
"ENGL 312 Victorian and Edwardian Drama 1 (3 credits)",
"ENGL 313 Canadian Drama and Theatre (3 credits)",
"ENGL 314 20th Century Drama (3 credits)",
"ENGL 315 Shakespeare (3 credits)",
"ENGL 316 Milton (3 credits)",
"ENGL 316D1 Milton (1.5 credits)",
"ENGL 316D2 Milton (1.5 credits)",
"ENGL 317 Theory of English Studies 1 (3 credits)",
"ENGL 318 Theory of English Studies 2 (3 credits)",
"ENGL 319 Theory of English Studies 3 (3 credits)",
"ENGL 320 Postcolonial Literature (3 credits)",
"ENGL 322 Theories of the Text (3 credits)",
"ENGL 323 20th Century American Poetry (3 credits)",
"ENGL 324 20th Century American Prose (3 credits)",
"ENGL 326 19th Century American Prose (3 credits)",
"ENGL 327 Canadian Prose Fiction 1 (3 credits)",
"ENGL 328 Development of Canadian Poetry 1 (3 credits)",
"ENGL 329 English Novel: 19th  Century 1 (3 credits)",
"ENGL 330 English Novel: 19th  Century 2 (3 credits)",
"ENGL 331 Literature Romantic Period 1 (3 credits)",
"ENGL 332 Literature Romantic Period 2 (3 credits)",
"ENGL 333 Development of Canadian Poetry 2 (3 credits)",
"ENGL 334 Victorian Poetry (3 credits)",
"ENGL 335 The 20th Century Novel 1 (3 credits)",
"ENGL 336 The 20th Century Novel 2 (3 credits)",
"ENGL 337 Theme or Genre in Medieval Literature (3 credits)",
"ENGL 338 Short Story (3 credits)",
"ENGL 339 Canadian Prose Fiction 2 (3 credits)",
"ENGL 342 Introduction to Old English (3 credits)",
"ENGL 343 Literature and Science 1 (3 credits)",
"ENGL 345 Literature and Society (3 credits)",
"ENGL 346 Materiality and Sociology of Text (3 credits)",
"ENGL 347 Great Writings of Europe 1 (3 credits)",
"ENGL 348 Great Writings of Europe 2 (3 credits)",
"ENGL 349 English Literature and Folklore 1 (3 credits)",
"ENGL 350 Studies in the History of Film 1 (3 credits)",
"ENGL 351 Studies in the History of Film 2 (3 credits)",
"ENGL 352 Theories of Difference (3 credits)",
"ENGL 354 Sexuality and Representation (3 credits)",
"ENGL 355 The Poetics of Performance (3 credits)",
"ENGL 356 Middle English (3 credits)",
"ENGL 357 Chaucer - Canterbury Tales (3 credits)",
"ENGL 358 Chaucer - Troilus and Criseyde (3 credits)",
"ENGL 359 The Poetics of the Image (3 credits)",
"ENGL 360 Literary Criticism (3 credits)",
"ENGL 361 Poetry of the 20th Century 1 (3 credits)",
"ENGL 362 Poetry of the 20th Century 2 (3 credits)",
"ENGL 363 Studies in the History of Film 3 (3 credits)",
"ENGL 364 Creative Writing: Fiction 2 (3 credits)",
"ENGL 365 Costuming for the Theatre 1 (3 credits)",
"ENGL 366 Film Genre (3 credits)",
"ENGL 367 Acting 2 (3 credits)",
"ENGL 368 Stage Scenery and Lighting 1 (3 credits)",
"ENGL 369 Creative Writing: Playwriting (3 credits)",
"ENGL 370 Theatre History: The Long Eighteenth Century (3 credits)",
"ENGL 371 Theatre History: 19th to 21st Centuries (3 credits)",
"ENGL 372 Stage Scenery and Lighting 2 (3 credits)",
"ENGL 373 Voice and Speech 2 (3 credits)",
"ENGL 374 Film Movement or Period (3 credits)",
"ENGL 375 Interpretation Dramatic Text (3 credits)",
"ENGL 375D1 Interpretation Dramatic Text (1.5 credits)",
"ENGL 375D2 Interpretation Dramatic Text (1.5 credits)",
"ENGL 376 Scene Study (3 credits)",
"ENGL 377 Costuming for the Theatre 2 (3 credits)",
"ENGL 378 Media and Culture (3 credits)",
"ENGL 379 Film Theory (3 credits)",
"ENGL 380 Non-Fiction Media: Cinema Television Radio (3 credits)",
"ENGL 381 A Film-Maker 1 (3 credits)",
"ENGL 382 International Cinema 1 (3 credits)",
"ENGL 383 Studies in Communications 1 (3 credits)",
"ENGL 385 Topics in Literature and Film (3 credits)",
"ENGL 386 Fans Celebrities Audiences (3 credits)",
"ENGL 388 Studies in Popular Culture (3 credits)",
"ENGL 389 Studies in Popular Culture (3 credits)",
"ENGL 390 Political and Cultural Theory (3 credits)",
"ENGL 391 Special Topics: Cultural Studies 1 (3 credits)",
"ENGL 393 Canadian Cinema (3 credits)",
"ENGL 394 Popular Literary Forms (3 credits)",
"ENGL 395 Cultural and Theatre Studies (3 credits)",
"ENGL 396 Women in Film and Media (3 credits)",
"ENGL 397 Feminist Approaches to Cultural Studies (3 credits)",
"ENGL 398 Psychoanalytic Approaches to Cultural Studies (3 credits)",
"ENGL 400 Earlier English Renaissance (3 credits)",
"ENGL 401 Studies in the 17th Century (3 credits)",
"ENGL 403 Studies in the 18th Century (3 credits)",
"ENGL 404 Studies in 19th Century Literature 1 (3 credits)",
"ENGL 405 Studies in 19th Century Literature 2 (3 credits)",
"ENGL 407 The 20th Century (3 credits)",
"ENGL 408 The 20th Century (3 credits)",
"ENGL 409 Studies in a Canadian Author (3 credits)",
"ENGL 410 Theme or Movement Canadian Literature (3 credits)",
"ENGL 411 Studies in Canadian Fiction (3 credits)",
"ENGL 413 Special Topics in Canadian Drama and Theatre (3 credits)",
"ENGL 414 Studies in 20th Century Literature 1 (3 credits)",
"ENGL 415 Studies in 20th Century Literature 2 (3 credits)",
"ENGL 416 Studies in Shakespeare (3 credits)",
"ENGL 417 A Major English Poet (3 credits)",
"ENGL 418 A Major Modernist Writer (3 credits)",
"ENGL 419 Studies in 20th Century Literature (3 credits)",
"ENGL 421 African Literature (3 credits)",
"ENGL 422 Studies in 19th Century American Literature (3 credits)",
"ENGL 423 Studies in 19th Century Literature (3 credits)",
"ENGL 424 Irish Literature (3 credits)",
"ENGL 430 Studies in Drama (3 credits)",
"ENGL 431 Studies in Drama (3 credits)",
"ENGL 434 Independent Theatre Project (3 credits)",
"ENGL 437 Studies in Literary Form (3 credits)",
"ENGL 438 Studies in Literary Form (3 credits)",
"ENGL 440 First Nations and Inuit Literature and Media (3 credits)",
"ENGL 441 Special Topics in Canadian Cultural Studies (3 credits)",
"ENGL 443 Contemporary Women's Fiction (3 credits)",
"ENGL 444 Studies: Women's Writing and Feminist Theory (3 credits)",
"ENGL 447 Crosscurrents/English Literature and European Literature 1 (3 credits)",
"ENGL 450 Film Aesthetics (3 credits)",
"ENGL 451 A Period in Cinema (3 credits)",
"ENGL 452 Studies in Old English (3 credits)",
"ENGL 454 Topics in Cultural Studies and Gender (3 credits)",
"ENGL 456 Middle English (3 credits)",
"ENGL 458 Theories of Text and Performance 1 (3 credits)",
"ENGL 459 Theories of Text and Performance 2 (3 credits)",
"ENGL 460 Studies in Literary Theory (3 credits)",
"ENGL 461 Studies in Literary Theory 2 (3 credits)",
"ENGL 464 Creative Writing: Poetry (3 credits)",
"ENGL 465D1 Theatre Laboratory (4.5 credits)",
"ENGL 465D2 Theatre Laboratory (4.5 credits)",
"ENGL 466 Directing for the Theatre (6 credits)",
"ENGL 466D1 Directing for the Theatre (3 credits)",
"ENGL 466D2 Directing for the Theatre (3 credits)",
"ENGL 467 Advanced Studies in Theatre History (3 credits)",
"ENGL 469 Acting 3 (3 credits)",
"ENGL 472 Special Topics: Cultural Studies 2 (3 credits)",
"ENGL 476 Alternative Approaches to Media 1 (3 credits)",
"ENGL 477 Alternative  Approaches to Media 2 (3 credits)",
"ENGL 479 Philosophy of Film (3 credits)",
"ENGL 480 Studies in History of Film 1 (3 credits)",
"ENGL 481 A Film-Maker 2 (3 credits)",
"ENGL 482 International Cinema 2 (3 credits)",
"ENGL 483 Seminar in the Film (3 credits)",
"ENGL 484 Seminar in the Film (3 credits)",
"ENGL 485 Special Topics in Theatre History 1700-1900 (3 credits)",
"ENGL 486 Special Topics in Theatre History After 1900 (3 credits)",
"ENGL 488 Special Topics / Communications and Mass Media 2 (3 credits)",
"ENGL 489 Culture and Critical Theory 1 (3 credits)",
"ENGL 490 Culture and Critical Theory 2 (3 credits)",
"ENGL 491 Honours Essay (6 credits)",
"ENGL 491D1 Honours Essay (3 credits)",
"ENGL 491D2 Honours Essay (3 credits)",
"ENGL 491J1 Honours Essay (2 credits)",
"ENGL 491J2 Honours Essay (2 credits)",
"ENGL 491J3 Honours Essay (2 credits)",
"ENGL 491N1 Honours Essay (3 credits)",
"ENGL 491N2 Honours Essay (3 credits)",
"ENGL 492 Image and Text (3 credits)",
"ENGL 495 Individual Reading Course (3 credits)",
"ENGL 496 Individual Reading Course (3 credits)",
"ENGL 497 Seminar in Cultural Studies (3 credits)",
"ENGL 498 Internship English (3 credits)",
"ENGL 500 Middle English (3 credits)",
"ENGL 501 16th Century (3 credits)",
"ENGL 503 18th Century (3 credits)",
"ENGL 504 19th Century (3 credits)",
"ENGL 505 20th Century (3 credits)",
"ENGL 506 Studies in 20th Century Literature (3 credits)",
"ENGL 512 Contemporary Studies in Literature and Culture (3 credits)",
"ENGL 516 Shakespeare (3 credits)",
"ENGL 525 American Literature (3 credits)",
"ENGL 527 Canadian Literature (3 credits)",
"ENGL 528 Canadian Literature (3 credits)",
"ENGL 529 Topics in American Studies (3 credits)",
"ENGL 529D1 Topics in American Studies (1.5 credits)",
"ENGL 529D2 Topics in American Studies (1.5 credits)",
"ENGL 530 Literary Forms (3 credits)",
"ENGL 531 Literary Forms (3 credits)",
"ENGL 533 Literary Movements (3 credits)",
"ENGL 535 Literary Themes (3 credits)",
"ENGL 540 Literary Theory 1 (3 credits)",
"ENGL 545 Topics in Literature & Society (3 credits)",
"ENGL 553 Old English Literature (3 credits)",
"ENGL 565 Drama Workshop (3 credits)",
"ENGL 566 Special Studies in Drama 1 (3 credits)",
"ENGL 568 Topics in the Dramatic Form (3 credits)",
"ENGL 585 Cultural Studies: Film (3 credits)",
"ENGL 586 Cultural Studies: Other Media (3 credits)",
"ENGL 587 Theoretical Approaches to Cultural Studies (3 credits)",
"ENGL 604 Old English Language and Literature (3 credits)",
"ENGL 607 Middle English Literature (3 credits)",
"ENGL 608 Chaucer 1 (3 credits)",
"ENGL 609 Chaucer 2 (3 credits)",
"ENGL 615 Shakespeare (3 credits)",
"ENGL 616 Elizabethan and Jacobean Drama (3 credits)",
"ENGL 620 Studies in Drama and Theatre (3 credits)",
"ENGL 640 The American Novel (3 credits)",
"ENGL 661 Seminar of Special Studies (3 credits)",
"ENGL 662 Seminar of Special Studies (3 credits)",
"ENGL 670 Topics in Cultural Studies (3 credits)",
"ENGL 675 Literary Criticism (3 credits)",
"ENGL 680 Canadian Literature (3 credits)",
"ENGL 681 M.A. Research Paper Preparation 1 (3 credits)",
"ENGL 682 M.A. Research Paper Preparation 2 (3 credits)",
"ENGL 683 M.A. Research Paper Preparation 3 (3 credits)",
"ENGL 684 M.A. Research Paper (9 credits)",
"ENGL 684D1 M.A. Research Paper (4.5 credits)",
"ENGL 684D2 M.A. Research Paper (4.5 credits)",
"ENGL 687 Research Seminar (3 credits)",
"ENGL 690 Seminar of Special Studies (3 credits)",
"ENGL 693 Research Methods (3 credits)",
"ENGL 694 Graduate Research Seminar (6 credits)",
"ENGL 695 M.A. Thesis Preparation (3 credits)",
"ENGL 699 M.A. Thesis (24 credits)",
"ENGL 699D1 M.A. Thesis (12 credits)",
"ENGL 699D2 M.A. Thesis (12 credits)",
"ENGL 699J1 M.A. Thesis (8 credits)",
"ENGL 699J2 M.A. Thesis (8 credits)",
"ENGL 699J3 M.A. Thesis (8 credits)",
"ENGL 699N1 M.A. Thesis (12 credits)",
"ENGL 699N2 M.A. Thesis (12 credits)",
"ENGL 701D1 Doctoral Comprehensive Examination",
"ENGL 701D2 Doctoral Comprehensive Examination",
"ENGL 708 Studies in a Literary Form (3 credits)",
"ENGL 710 Renaissance Studies (3 credits)",
"ENGL 714 Renaissance Poetry (3 credits)",
"ENGL 716 Special Studies in Shakespeare (3 credits)",
"ENGL 722 Milton (3 credits)",
"ENGL 726 Narrative Prose of 18th Century (3 credits)",
"ENGL 730 Romantic Theory and Poetry (3 credits)",
"ENGL 731 19th Century Studies (3 credits)",
"ENGL 733 Victorian Novel (3 credits)",
"ENGL 734 Studies in Fiction (3 credits)",
"ENGL 746 The 19th Century (3 credits)",
"ENGL 757 Modern Drama (3 credits)",
"ENGL 761 20th Century Novel (3 credits)",
"ENGL 770 Studies in American Literature (3 credits)",
"ENGL 776 Film Studies (3 credits)",
"ENGL 778 Studies in Visual Culture (3 credits)",
"ENGL 785 Studies in Theory (3 credits)",
"ENGL 786 Research Seminar (3 credits)",
"ENGL 787 Research Seminar 1 (3 credits)",
"ENGL 788 Research Seminar 2 (3 credits)",
"ENGL 794D1 Doctoral Comprehensive Examination Part 4 (3 credits)",
"ENGL 794D2 Doctoral Comprehensive Examination Part 4 (3 credits)",
"ENGL 795D1 Doctoral Comprehensive Examination Part 5 (3 credits)",
"ENGL 795D2 Doctoral Comprehensive Examination Part 5 (3 credits)",
"ENGL 796 Research Project (6 credits)",
"ENGL 797 Compulsory Research Project (6 credits)",
"ENGL 798 Dissertation Proposal (3 credits)",
"ENTO 330 Insect Biology (3 credits)",
"ENTO 340 Field Entomology (3 credits)",
"ENTO 350 Insect Biology and Control (3 credits)",
"ENTO 352 Biocontrol of Pest Insects (3 credits)",
"ENTO 440 Insect Diversity (3 credits)",
"ENTO 515 Parasitoid Behavioural Ecology (3 credits)",
"ENTO 520 Insect Physiology (3 credits)",
"ENTO 535 Aquatic Entomology (3 credits)",
"ENTO 550 Veterinary and Medical Entomology (3 credits)",
"ENTO 610 Insect Phylogeny and Diversity (3 credits)",
"ENTO 615 Forest Entomology (3 credits)",
"ENVB 210 The Biophysical Environment (3 credits)",
"ENVB 222 St. Lawrence Ecosystems (3 credits)",
"ENVB 301 Meteorology (3 credits)",
"ENVB 305 Population & Community Ecology (3 credits)",
"ENVB 313 Phylogeny and Biogeography (3 credits)",
"ENVB 315 Science of Inland Waters (3 credits)",
"ENVB 410 Ecosystem Ecology (3 credits)",
"ENVB 415 Ecosystem Management (3 credits)",
"ENVB 437 Assessing Environmental Impact (3 credits)",
"ENVB 497 Research Project 1 (3 credits)",
"ENVB 498 Research Project 2 (3 credits)",
"ENVB 500 Advanced Topics in Ecotoxicology (3 credits)",
"ENVB 506 Quantitative Methods: Ecology (3 credits)",
"ENVB 529 GIS for Natural Resource Management (3 credits)",
"ENVB 530 Advanced GIS for Natural Resource Management (3 credits)",
"ENVR 200 The Global Environment (3 credits)",
"ENVR 201 Society Environment and Sustainability (3 credits)",
"ENVR 202 The Evolving Earth (3 credits)",
"ENVR 203 Knowledge Ethics and Environment (3 credits)",
"ENVR 301 Environmental Research Design (3 credits)",
"ENVR 380 Topics in Environment 1 (3 credits)",
"ENVR 396 Undergraduate Research Project (3 credits)",
"ENVR 400 Environmental Thought (3 credits)",
"ENVR 401 Environmental Research (3 credits)",
"ENVR 421 Montreal: Environmental History and Sustainability (3 credits)",
"ENVR 422 Montreal Urban Sustainability Analysis (3 credits)",
"ENVR 430 The Economics of Well-Being (3 credits)",
"ENVR 451 Research in Panama (6 credits)",
"ENVR 480 Topics in Environment 2 (3 credits)",
"ENVR 485 Readings in Environment 1 (3 credits)",
"ENVR 490 Independent Study in Environment (3 credits)",
"ENVR 491 Independent Project in Environment (1 credit)",
"ENVR 495D1 Honours Research (3 credits)",
"ENVR 495D2 Honours Research (3 credits)",
"ENVR 495N1 Honours Research (3 credits)",
"ENVR 495N2 Honours Research (3 credits)",
"ENVR 519 Global Environmental Politics (3 credits)",
"ENVR 540 Ecology of Species Invasions (3 credits)",
"ENVR 544 Environmental Measurement and Modelling (3 credits)",
"ENVR 585 Readings in Environment 2 (3 credits)",
"ENVR 610 Foundations of Environmental Policy (3 credits)",
"ENVR 614 Mobilizing Research for Sustainability (3 credits)",
"ENVR 615 Interdisciplinary Approach Environment and Sustainability (3 credits)",
"ENVR 620 Environment and Health of Species (3 credits)",
"ENVR 622 Sustainable Landscapes (3 credits)",
"ENVR 630 Civilization and Environment (3 credits)",
"ENVR 650 Environmental Seminar 1 (1 credit)",
"ENVR 651 Environmental Seminar 2 (1 credit)",
"ENVR 652 Environmental Seminar 3 (1 credit)",
"ENVR 680 Topics in Environment 4 (3 credits)",
"EPIB 507 Biostats for Health Sciences (3 credits)",
"EPIB 521 Regression Analysis for Health Sciences (3 credits)",
"EPIB 526 Society Human Biology and Health (3 credits)",
"EPIB 591 Special Topics in Epidemiology (3 credits)",
"EPIB 600 Clinical Epidemiology (3 credits)",
"EPIB 601 Fundamentals of Epidemiology (4 credits)",
"EPIB 603 Intermediate Epidemiology (4 credits)",
"EPIB 605 Critical Appraisal in Epidemiology (1 credit)",
"EPIB 607 Inferential Statistics (4 credits)",
"EPIB 613 Introduction to Statistical Software (1 credit)",
"EPIB 619 Systematic Reviews and Meta-Analysis (2 credits)",
"EPIB 621 Data Analysis in Health Sciences (4 credits)",
"EPIB 622 Scientific Communication (3 credits)",
"EPIB 625 Ethics of Human Research (3 credits)",
"EPIB 626 Risks and Hazards in Epidemiology (3 credits)",
"EPIB 627 Analysis of Correlated Data (3 credits)",
"EPIB 628 Measurement in Epidemiology (3 credits)",
"EPIB 629 Knowledge Synthesis (3 credits)",
"EPIB 631 Pharmacoepidemiology 2 (2 credits)",
"EPIB 632 Mental Disorders: Population Perspectives and Methods (3 credits)",
"EPIB 633 Pharmacoepidemiology 1 (2 credits)",
"EPIB 634 Fundamentals of Pharmacoepidemiology (3 credits)",
"EPIB 635 Clinical Trials (3 credits)",
"EPIB 636 Reproductive Epidemiology (2 credits)",
"EPIB 637 Advanced Modeling: Survival and Other Multivariable Data (3 credits)",
"EPIB 638 Mathematical Modeling of Infectious Diseases (3 credits)",
"EPIB 639 Pharmacoepidemiologic Methods (4 credits)",
"EPIB 641 Substantive Epidemiology 1 (1 credit)",
"EPIB 642 Substantive Epidemiology 2 (1 credit)",
"EPIB 643 Substantive Epidemiology 3 (1 credit)",
"EPIB 644 Substantive Epidemiology 4 (1 credit)",
"EPIB 645 Substantive Epidemiology 5 (1 credit)",
"EPIB 647 Analysis Temporal & Spatial Data (3 credits)",
"EPIB 648 Methods in Social Epidemiology (3 credits)",
"EPIB 651 Selected Topics in Biostatistics 1 (1 credit)",
"EPIB 654 Pharmacoepidemiology 4 (2 credits)",
"EPIB 660 Practical Aspects: Protocol Development (3 credits)",
"EPIB 661 Pharmacoepidemiology 3 (2 credits)",
"EPIB 662 Pharmacological Basis of Pharmacoepidemiology (1 credit)",
"EPIB 663 Substantive Epidemiology 6 (1 credit)",
"EPIB 664 Substantive Epidemiology 7 (1 credit)",
"EPIB 665 Substantive Epidemiology 8 (1 credit)",
"EPIB 668 Special Topics 1 (2 credits)",
"EPIB 669 Special Topics 2 (2 credits)",
"EPIB 669D1 Special Topics 2 (1 credit)",
"EPIB 669D2 Special Topics 2 (1 credit)",
"EPIB 670 Special Topics 3 (2 credits)",
"EPIB 671 Cancer Epidemiology and Prevention (3 credits)",
"EPIB 672 Special Topics 5 (2 credits)",
"EPIB 675 Special Topics 6 (3 credits)",
"EPIB 676 Special Topics 7 (3 credits)",
"EPIB 677 Special Topics 8 (3 credits)",
"EPIB 678 Special Topics 9 (3 credits)",
"EPIB 679 Special Topics 10 (3 credits)",
"EPIB 681 Global Health: Epidemiological Research (3 credits)",
"EPIB 682 Introduction to Bayesian Analysis in Health Sciences (2 credits)",
"EPIB 683 Intermediate Bayesian Analysis in Health Sciences (2 credits)",
"EPIB 684 Principles of Environmental Health Sciences 1 (3 credits)",
"EPIB 685 Principles of Environmental Health Sciences 2 (3 credits)",
"EPIB 686 Environmental Health Seminar (3 credits)",
"EPIB 690 M.Sc. Thesis (21 credits)",
"EPIB 691 Research Project in Epidemiology (12 credits)",
"EPIB 691D1 Research Project in Epidemiology (6 credits)",
"EPIB 691D2 Research Project in Epidemiology (6 credits)",
"EPIB 701 Ph.D. Comprehensive Examination",
"EPIB 702 Ph.D. Proposal",
"EPIB 702D1 Ph.D. Proposal",
"EPIB 702D2 Ph.D. Proposal",
"EPIB 703 Principles of Study Design (2 credits)",
"EPIB 704 Doctoral Level Epidemiologic Methods 1 (4 credits)",
"EPIB 705 Doctoral Level Epidemiologic Methods 2 (4 credits)",
"EPIB 706 Doctoral Seminar in Epidemiology (3 credits)",
"EPIB 707 Research Design in Health Sciences (3 credits)",
"EPIB 710 Advanced Methods: Causal Inference (3 credits)",
"EPSC 180 The Terrestrial Planets (3 credits)",
"EPSC 181 Environmental Geology (3 credits)",
"EPSC 185 Natural Disasters (3 credits)",
"EPSC 186 Astrobiology (3 credits)",
"EPSC 199 FYS: Earth & Planetary Exploration (3 credits)",
"EPSC 201 Understanding Planet Earth (3 credits)",
"EPSC 210 Introductory Mineralogy (3 credits)",
"EPSC 212 Introductory Petrology (3 credits)",
"EPSC 220 Principles of Geochemistry (3 credits)",
"EPSC 221 General Geology (3 credits)",
"EPSC 225 Properties of Minerals (1 credit)",
"EPSC 231 Field School 1 (3 credits)",
"EPSC 233 Earth and Life History (3 credits)",
"EPSC 240 Geology in the Field (3 credits)",
"EPSC 303 Structural Geology (3 credits)",
"EPSC 320 Elementary Earth Physics (3 credits)",
"EPSC 331 Field School 2 (3 credits)",
"EPSC 334 Invertebrate Paleontology (3 credits)",
"EPSC 340 Earth and Planetary Inference (3 credits)",
"EPSC 341 Field School 3 (3 credits)",
"EPSC 350 Tectonics (3 credits)",
"EPSC 355 Sedimentary Geology (3 credits)",
"EPSC 373 Arctic Geology (3 credits)",
"EPSC 396 Undergraduate Research Project (3 credits)",
"EPSC 423 Igneous Petrology (3 credits)",
"EPSC 425 Sediments to Sequences (3 credits)",
"EPSC 435 Applied Geophysics (3 credits)",
"EPSC 445 Metamorphic Petrology (3 credits)",
"EPSC 452 Mineral Deposits (3 credits)",
"EPSC 460 Independent Reading Project (3 credits)",
"EPSC 460D1 Independent Reading Project (1.5 credits)",
"EPSC 460D2 Independent Reading Project (1.5 credits)",
"EPSC 470D1 Undergraduate Thesis Research  (3 credits)",
"EPSC 470D2 Undergraduate Thesis Research (3 credits)",
"EPSC 470N1 Undergraduate Thesis Research (3 credits)",
"EPSC 470N2 Undergraduate Thesis Research (3 credits)",
"EPSC 473 Arctic Field Research (6 credits)",
"EPSC 478 Short Research Project (1 credit)",
"EPSC 480D1 Honours Research Thesis (3 credits)",
"EPSC 480D2 Honours Research Thesis (3 credits)",
"EPSC 480N1 Honours Research Thesis (3 credits)",
"EPSC 480N2 Honours Research Thesis (3 credits)",
"EPSC 482 Research in Earth and Planetary Sciences (3 credits)",
"EPSC 482D1 Research in Earth and Planetary Sciences (1.5 credits)",
"EPSC 482D2 Research in Earth and Planetary Sciences (1.5 credits)",
"EPSC 501 Crystal Chemistry (3 credits)",
"EPSC 503 Advanced Structural Geology (3 credits)",
"EPSC 510 Geodynamics (3 credits)",
"EPSC 513 Climate and the Carbon Cycle (3 credits)",
"EPSC 519 Isotopes in Earth and Environmental Science (3 credits)",
"EPSC 520 Earthquake Physics and Geology (3 credits)",
"EPSC 530 Volcanology (3 credits)",
"EPSC 542 Chemical Oceanography (3 credits)",
"EPSC 547 Modelling Geochemical Processes (3 credits)",
"EPSC 548 Processes of Igneous Petrology (3 credits)",
"EPSC 549 Hydrogeology (3 credits)",
"EPSC 550 Selected Topics 1 (3 credits)",
"EPSC 551 Selected Topics 2 (3 credits)",
"EPSC 552 Selected Topics 3 (3 credits)",
"EPSC 561 Ore-forming Processes (3 credits)",
"EPSC 567 Advanced Volcanology (3 credits)",
"EPSC 570 Cosmochemistry (3 credits)",
"EPSC 580 Aqueous Geochemistry (3 credits)",
"EPSC 590 Applied Geochemistry Seminar (3 credits)",
"EPSC 644 Topics - Advanced Earth Sciences 1 (3 credits)",
"EPSC 645 Topics - Advanced Earth Sciences 2 (3 credits)",
"EPSC 666 Current Issues in Geosciences (3 credits)",
"EPSC 697 Thesis Preparation 1 (9 credits)",
"EPSC 697D1 Thesis Preparation 1 (4.5 credits)",
"EPSC 697D2 Thesis Preparation 1 (4.5 credits)",
"EPSC 697N1 Thesis Preparation 1 (4.5 credits)",
"EPSC 697N2 Thesis Preparation 1 (4.5 credits)",
"EPSC 698 Thesis Preparation 2 (12 credits)",
"EPSC 698D1 Thesis Preparation 2 (6 credits)",
"EPSC 698D2 Thesis Preparation 2 (6 credits)",
"EPSC 698N1 Thesis Preparation 2 (6 credits)",
"EPSC 698N2 Thesis Preparation 2 (6 credits)",
"EPSC 699 Thesis Preparation 3 (12 credits)",
"EPSC 699D1 Thesis Preparation 3 (6 credits)",
"EPSC 699D2 Thesis Preparation 3 (6 credits)",
"EPSC 699N1 Thesis Preparation 3 (6 credits)",
"EPSC 699N2 Thesis Preparation 3 (6 credits)",
"EPSC 700 Preliminary Doctoral Examination",
"EPSC 700D1 Preliminary Doctoral Examination",
"EPSC 700D2 Preliminary Doctoral Examination",
"EPSC 715 Instrumental Analysis (3 credits)",
"EPSC 725 Independent Studies 1 (3 credits)",
"EPSC 726 Independent Studies 2 (3 credits)",
"ESYS 104 The Earth System (3 credits)",
"ESYS 200 Earth System Processes (3 credits)",
"ESYS 300 Investigating the Earth System (3 credits)",
"ESYS 301 Earth System Modelling (3 credits)",
"ESYS 480D1 Honours Research Project (3 credits)",
"ESYS 480D2 Honours Research Project (3 credits)",
"ESYS 480N1 Honours Research Project (3 credits)",
"ESYS 480N2 Honours Research Project (3 credits)",
"ESYS 500 Earth System Applications (3 credits)",
"EXMD 401 Physiology and Biochemistry Endocrine Systems (3 credits)",
"EXMD 501 Clinical Applications of Regenerative Medicine (3 credits)",
"EXMD 502 Advanced Endocrinology 1 (3 credits)",
"EXMD 503 Advanced Endocrinology 02 (3 credits)",
"EXMD 504 Biology of Cancer (3 credits)",
"EXMD 505 Directed Readings in Regenerative Medicine (3 credits)",
"EXMD 506 Advanced Applied Cardiovascular Physiology (3 credits)",
"EXMD 507 Advanced Applied Respiratory Physiology (3 credits)",
"EXMD 508 Advanced Topics in Respiration (3 credits)",
"EXMD 509 Gastrointestinal Physiology and Pathology (3 credits)",
"EXMD 510 Bioanalytical Separation Methods (3 credits)",
"EXMD 511 Joint Venturing with Industry (3 credits)",
"EXMD 600 Principles of Clinical Research (3 credits)",
"EXMD 601 Real World Applications of Data Science and Informatics (3 credits)",
"EXMD 602 Techniques in Molecular Genetics (3 credits)",
"EXMD 603 Seminars in Endocrinology (3 credits)",
"EXMD 604 Recent Advances in Cellular and Molecular Biology 1 (3 credits)",
"EXMD 605 Recent Advances in Cellular and Molecular Biology 2 (3 credits)",
"EXMD 607 Molecular Control of Cell Growth (3 credits)",
"EXMD 608 Molecular Embryology (3 credits)",
"EXMD 609 Cellular Methods in Medical Research (3 credits)",
"EXMD 610 Molecular Methods in Medical Research (3 credits)",
"EXMD 611D1 Seminars in Oncology (3 credits)",
"EXMD 611D2 Seminars in Oncology (3 credits)",
"EXMD 614 Environmental Carcinogenesis (3 credits)",
"EXMD 615 Essentials of Glycobiology (3 credits)",
"EXMD 616 Molecular and Cell Biology Topics (3 credits)",
"EXMD 617 Workshop in Clinical Trials 1 (1 credit)",
"EXMD 618 Workshop in Clinical Trials 2 (1 credit)",
"EXMD 619 Workshop: Clinical Trials 3 (1 credit)",
"EXMD 620 Clinical Trials and Research 1 (1 credit)",
"EXMD 621 Seminars in Biomedical Research 1 (3 credits)",
"EXMD 622 Seminars in Biomedical Research 2 (3 credits)",
"EXMD 623 Seminars: Biomedical Research 3 (3 credits)",
"EXMD 624 Seminars in Biomedical Research 4 (3 credits)",
"EXMD 625 Clinical Trials and Research 2 (1 credit)",
"EXMD 626 Clinical Trials and Research 3 (1 credit)",
"EXMD 627 Practicum in Clinical Research (18 credits)",
"EXMD 627D1 Practicum in Clinical Research (9 credits)",
"EXMD 627D2 Practicum in Clinical Research (9 credits)",
"EXMD 628 Qualitative Research Methodology (3 credits)",
"EXMD 629 Reproductive Medicine and Assisted Reproductive Technology (3 credits)",
"EXMD 632 Recent Advances in Virology and Antiviral Therapeutics (3 credits)",
"EXMD 633 Clinical Aspects of Research in Respiratory Diseases (3 credits)",
"EXMD 634 Quantitative Research Methods (3 credits)",
"EXMD 635D1 Experimental/Clinical Oncology (3 credits)",
"EXMD 635D2 Experimental/Clinical Oncology (3 credits)",
"EXMD 636 Fundamentals of Research: Shaping and Situating Research (3 credits)",
"EXMD 640 Experimental Medicine Topic 1 (3 credits)",
"EXMD 641 Experimental Medicine Topic 2 (3 credits)",
"EXMD 642 Experimental Medicine Topic 3 (3 credits)",
"EXMD 647 Epigenetics and Cancer (3 credits)",
"EXMD 670 Principles of Environmental Health Sciences (3 credits)",
"EXMD 671 Principles of Environmental Health Sciences 2 (3 credits)",
"EXMD 690 Master's Thesis Research 1 (3 credits)",
"EXMD 691 Master's Thesis Research 2 (6 credits)",
"EXMD 692 Master's Thesis Research 3 (9 credits)",
"EXMD 693 Master's Thesis Research 4 (12 credits)",
"EXMD 694 Master's Thesis Research 5 (12 credits)",
"EXMD 701 Comprehensive Oral Examination",
"EXMD 701D1 Comprehensive Oral Examination",
"EXMD 701D2 Comprehensive Oral Examination",
"EXSU 500 Artificial Intelligence in Medicine (3 credits)",
"EXSU 501 Medical Technology Internship 1 (6 credits)",
"EXSU 502 Medical Technology Internship 2 (6 credits)",
"EXSU 505 Trends in Precision Oncology (3 credits)",
"EXSU 601 Knowledge Management 1 (3 credits)",
"EXSU 602 Knowledge Management 2 (3 credits)",
"EXSU 603 Surgical Education Foundations (3 credits)",
"EXSU 605 Biomedical Research Innovation (3 credits)",
"EXSU 606 Statistics for Surgical Research (3 credits)",
"EXSU 619 The Hospital Environment (3 credits)",
"EXSU 620 Surgical Innovation 1 (3 credits)",
"EXSU 621 Surgical Innovation 2 (3 credits)",
"EXSU 622D1 Surgery Research Project 1 (6 credits)",
"EXSU 622D2 Surgery Research Project 1 (6 credits)",
"EXSU 622N1 Surgery Research Project 1 (6 credits)",
"EXSU 622N2 Surgery Research Project 1 (6 credits)",
"EXSU 623 Surgery Research Project 2 (6 credits)",
"EXSU 630 Medical and Simulation Technologies (3 credits)",
"EXSU 637 Research Project (9 credits)",
"EXSU 637D1 Research Project (4.5 credits)",
"EXSU 637D2 Research Project (4.5 credits)",
"EXSU 684 Signal Transduction (3 credits)",
"EXSU 690 M.Sc. Research 1 (4 credits)",
"EXSU 690D1 M.Sc. Research 1 (2 credits)",
"EXSU 690D2 M.Sc. Research 1 (2 credits)",
"EXSU 690N1 M.Sc. Research 1 (2 credits)",
"EXSU 690N2 M.Sc. Research 1 (2 credits)",
"EXSU 691 M.Sc. Research 2 (4 credits)",
"EXSU 691D1 M.Sc. Research 2 (2 credits)",
"EXSU 691D2 M.Sc. Research 2 (2 credits)",
"EXSU 691N1 M.Sc. Research 2 (2 credits)",
"EXSU 691N2 M.Sc. Research 2 (2 credits)",
"EXSU 692 M.Sc. Research 3 (4 credits)",
"EXSU 692D1 M.Sc. Research 3 (2 credits)",
"EXSU 692D2 M.Sc. Research 3 (2 credits)",
"EXSU 692N1 M.Sc. Research 3 (2 credits)",
"EXSU 692N2 M.Sc. Research 3 (2 credits)",
"EXSU 693 M.Sc. Thesis (18 credits)",
"EXSU 693D1 M.Sc. Thesis (9 credits)",
"EXSU 693D2 M.Sc. Thesis (9 credits)",
"EXSU 693N1 M.Sc. Thesis (9 credits)",
"EXSU 693N2 M.Sc. Thesis (9 credits)",
"EXSU 700 Comprehensive Examination",
"EXSU 700D1 Comprehensive Examination",
"EXSU 700D2 Comprehensive Examination",
"FACC 100 Introduction to the Engineering Profession (1 credit)",
"FACC 200 Industrial Practicum 1",
"FACC 201 Industrial Practicum 2",
"FACC 202 Industrial Practicum 3",
"FACC 203 Industrial Practicum 4",
"FACC 204 Industrial Practicum 5",
"FACC 205 Industrial Practicum 6",
"FACC 210 MIAE Industrial Practicum 1",
"FACC 211 MIAE Industrial Practicum 2",
"FACC 212 MIAE Industrial Practicum 3",
"FACC 213 MIAE Industrial Practicum 4",
"FACC 220 Law for Architects and Engineers (3 credits)",
"FACC 250 Responsibilities of the Professional Engineer",
"FACC 300 Engineering Economy (3 credits)",
"FACC 351 Summer Undergraduate Research Experience 1",
"FACC 352 Summer Undergraduate Research Experience 2",
"FACC 353 Summer Undergraduate Research Experience 3",
"FACC 354 Summer Undergraduate Research Experience 4",
"FACC 400 Engineering Professional Practice (1 credit)",
"FACC 500 Technology Business Plan Design (3 credits)",
"FACC 501 Technology Business Plan Project (3 credits)",
"FACC 510 Selected Topics in the Faculty of Engineering 1 (3 credits)",
"FACC 511 Selected Topics in the Faculty of Engineering 2 (3 credits)",
"FAES 200 Internship 1",
"FAES 300 Internship 2 (3 credits)",
"FAES 310 Agribusiness Entrepreneurship (3 credits)",
"FAES 313 Special Topics 03 (3 credits)",
"FAES 323 Special Topics 04 (3 credits)",
"FAES 371 Special Topics 01 (1 credit)",
"FAES 372 Special Topics 02 (2 credits)",
"FAES 401 Honours Research Project 1 (6 credits)",
"FAES 402 Honours Research Project 2 (6 credits)",
"FAES 405 Honours Project 1 (3 credits)",
"FAES 406 Honours Project 2 (3 credits)",
"FDSC 200 Introduction to Food Science (3 credits)",
"FDSC 213 Analytical Chemistry 1 (3 credits)",
"FDSC 230 Organic Chemistry (4 credits)",
"FDSC 231 Organic Chemistry Lecture (3 credits)",
"FDSC 232 Organic Chemistry Laboratory (1 credit)",
"FDSC 233 Physical Chemistry (3 credits)",
"FDSC 251 Food Chemistry 1 (3 credits)",
"FDSC 300 Principles of Food Analysis 1 (3 credits)",
"FDSC 305 Food Chemistry 2 (3 credits)",
"FDSC 310 Post Harvest Fruit and Vegetable Technology (3 credits)",
"FDSC 315 Separation Techniques in Food Analysis 1 (3 credits)",
"FDSC 319 Food Commodities (3 credits)",
"FDSC 330 Food Processing (3 credits)",
"FDSC 334 Analysis of Food Toxins and Toxicants (3 credits)",
"FDSC 400 Food Packaging (3 credits)",
"FDSC 405 Food Product Development (3 credits)",
"FDSC 442 Food Microbiology (3 credits)",
"FDSC 475 Introduction to Cannabis and Cannabinoids (3 credits)",
"FDSC 476 Contaminants in Cannabis (3 credits)",
"FDSC 477 Introduction to Cannabis Product Design (3 credits)",
"FDSC 480 Food Industry Internship (12 credits)",
"FDSC 490 Research Project 1 (3 credits)",
"FDSC 491 Research Project 2 (3 credits)",
"FDSC 495D1 Food Science Seminar (1.5 credits)",
"FDSC 495D2 Food Science Seminar (1.5 credits)",
"FDSC 495N1 Food Science Seminar (1.5 credits)",
"FDSC 495N2 Food Science Seminar (1.5 credits)",
"FDSC 497 Professional Seminar: Food (1.5 credits)",
"FDSC 515 Enzymology (3 credits)",
"FDSC 516 Flavour Chemistry (3 credits)",
"FDSC 519 Advanced Food Processing (3 credits)",
"FDSC 520 Biophysical Chemistry of Food (3 credits)",
"FDSC 525 Food Quality Assurance (3 credits)",
"FDSC 535 Food Biotechnology (3 credits)",
"FDSC 536 Food Traceability (3 credits)",
"FDSC 537 Nutraceutical Chemistry (3 credits)",
"FDSC 538 Food Science in Perspective (3 credits)",
"FDSC 540 Sensory Evaluation of Foods (3 credits)",
"FDSC 545 Advances in Food Microbiology (3 credits)",
"FDSC 555 Comparative Food Law (3 credits)",
"FDSC 624 Current Food Safety Issues (3 credits)",
"FDSC 626 Food Safety Risk Assessment (3 credits)",
"FDSC 634 Food Toxins & Toxicants (3 credits)",
"FDSC 651 Principles of Food Analysis 2 (3 credits)",
"FDSC 652 Separation Techniques in Food Analysis 2 (3 credits)",
"FDSC 690 M.Sc. Literature Review (8 credits)",
"FDSC 691 M.Sc. Research Protocol (7 credits)",
"FDSC 692 M.Sc. Thesis (15 credits)",
"FDSC 695 M.Sc. Graduate Seminar 1 (3 credits)",
"FDSC 696 M.Sc. Graduate Seminar 2 (3 credits)",
"FDSC 697 M.Sc. Project Part 1 (6 credits)",
"FDSC 698 M.Sc. Project Part 2 (6 credits)",
"FDSC 700 Comprehensive Preliminary Examination",
"FDSC 725 Advanced Topics in Food Science (3 credits)",
"FDSC 797 Ph.D. Graduate Seminar 1 (3 credits)",
"FDSC 798 Ph.D. Graduate Seminar 2 (3 credits)",
"FIGA NU0 Arts U0 Advising",
"FIGE JS01 Novice & Veteran Teachers",
"FIGE JS02 Opportunities for Youth Action",
"FIGE JS03 To Be a Leader",
"FIGE JS04 Community & School Success",
"FIGE JS05 ",
"FIGE JS06 ",
"FIGE JS07 ",
"FIGE JS08 ",
"FIGE KN01 Keynote Presentation",
"FIGF PMCE ",
"FIGF PMCO ",
"FIGG GS1 Diving into the Research Pool: A Professional Development Workshop for Graduate Students",
"FIGG GS2 Going Deeper: A Professional Development Workshop for Graduate Students",
"FIGG MYR1 EndNote Essentials",
"FIGG MYR2 Research Tool Kit",
"FIGG MYR3 Search Strategies & Techniques",
"FIGG MYR4 Getting Your Research Out",
"FIGG TL01 Learning to Teach: A Professional Development Workshop for Graduate Students",
"FIGG TL02 Learning to Teach: A Professional Development Workshop for Graduate Students",
"FIGG TL03 Learning to Teach: A Professional Development Workshop for Graduate Students",
"FIGG TL04 Learning to Teach: A Professional Development Workshop for Graduate Students",
"FIGG WS1 Grantsmanship for Graduate Students",
"FIGI GIG1 Entrepreneurship Science-based",
"FIGI GIG2 Career Seminars for U3 Students",
"FIGI GIG3 ",
"FIGM TRP ",
"FIGN CPRT CPR Training for Nurses",
"FIGN MPST Moving Patients Safely Training",
"FIGN SFTK ",
"FIGS 196 Freshman Interest Groups",
"FILM 499 Internship: World Cinemas (3 credits)",
"FINE 342 Corporate Finance (3 credits)",
"FINE 434 Topics in Finance 1 (3 credits)",
"FINE 435 Advanced Topics in Finance (3 credits)",
"FINE 440 Honours Investment Management Research Project 1 (3 credits)",
"FINE 441 Investment Management (3 credits)",
"FINE 442 Capital Markets and Institutions (3 credits)",
"FINE 443 Applied Corporate Finance (3 credits)",
"FINE 444 Principles and Strategies of Securities Trading (3 credits)",
"FINE 445 Real Estate Finance (3 credits)",
"FINE 446 Behavioural Finance (3 credits)",
"FINE 447 Venture Capital and Entrepreneurial Finance (3 credits)",
"FINE 448 Financial Derivatives (3 credits)",
"FINE 449 Market Risk Models (3 credits)",
"FINE 450 Honours Investment Management Research Project 2 (3 credits)",
"FINE 451 Fixed Income Analysis (3 credits)",
"FINE 452 Applied Quantitative Finance (3 credits)",
"FINE 455 Alternative Investments (3 credits)",
"FINE 456 Trading in Financial Securities (3 credits)",
"FINE 464 Pension Funds and Retirement Systems (3 credits)",
"FINE 480 Global Investments (3 credits)",
"FINE 482 International Finance 1 (3 credits)",
"FINE 490 Mergers and Corporate Reorganizations (3 credits)",
"FINE 492 International Corporate Finance (3 credits)",
"FINE 541 Applied Investments (3 credits)",
"FINE 541D1 Applied Investments (1.5 credits)",
"FINE 541D2 Applied Investments (1.5 credits)",
"FINE 541N1 Applied Investments (1.5 credits)",
"FINE 541N2 Applied Investments (1.5 credits)",
"FINE 547 Advanced Finance Seminar (3 credits)",
"FINE 620 Corporate Mergers (3 credits)",
"FINE 622 Modern Corporate Finance (3 credits)",
"FINE 630 Fixed Income Markets (3 credits)",
"FINE 635 Financial Risk Management (3 credits)",
"FINE 639 Derivatives and Risk Management (3 credits)",
"FINE 645 Money and Capital Markets (3 credits)",
"FINE 646 Investments and Portfolio Management (3 credits)",
"FINE 648 Applied Corporate Finance (3 credits)",
"FINE 660 Global Investment Management (3 credits)",
"FINE 665 Investment Strategies and Behavioural Finance (3 credits)",
"FINE 670 Fundamentals of Financial Research (3 credits)",
"FINE 671 Applied Finance Project (9 credits)",
"FINE 671D1 Applied Finance Project (4.5 credits)",
"FINE 671D2 Applied Finance Project (4.5 credits)",
"FINE 671N1 Applied Finance Project (4.5 credits)",
"FINE 671N2 Applied Finance Project (4.5 credits)",
"FINE 673 Finance Fundamentals (3 credits)",
"FINE 675 Financial Valuation Analytics for Startups (1.5 credits)",
"FINE 678 Financial Economics (3 credits)",
"FINE 679 Corporate Finance Theory (3 credits)",
"FINE 680 Investments (3 credits)",
"FINE 681 International Capital Markets (3 credits)",
"FINE 682 Derivatives (3 credits)",
"FINE 683 Advanced Corporate Finance (3 credits)",
"FINE 684 Fixed Income Analysis (3 credits)",
"FINE 685 Market Risk Management (3 credits)",
"FINE 686 Global Corporate Finance (3 credits)",
"FINE 687 Global Investments (3 credits)",
"FINE 688 Mergers and Acquisitions (3 credits)",
"FINE 689 Integrative Finance Project (12 credits)",
"FINE 689N1 Integrative Finance Project (6 credits)",
"FINE 689N2 Integrative Finance Project (6 credits)",
"FINE 690 Advanced Topics in Finance 1 (3 credits)",
"FINE 690N1 Advanced Topics in Finance 1 (1.5 credits)",
"FINE 690N2 Advanced Topics in Finance 1 (1.5 credits)",
"FINE 691 Advanced Topics in Finance 2 (3 credits)",
"FINE 692 Advanced Topics in Finance 3 (3 credits)",
"FINE 693 Global Capital Markets (3 credits)",
"FINE 694 International Corporate Finance (3 credits)",
"FINE 695 Advanced Topics in Finance Analytics 1 (1.5 credits)",
"FINE 696 Advanced Topics in Finance Analytics 2 (1.5 credits)",
"FINE 702 Continuous-Time Finance (3 credits)",
"FINE 703 Empirical Research in Finance (3 credits)",
"FINE 704 Options and Risk Management (3 credits)",
"FINE 705 Seminar in Finance (3 credits)",
"FINE 706 Introductory Financial Economics (3 credits)",
"FINE 707 Corporate Finance (3 credits)",
"FINE 709 International Finance Seminar (3 credits)",
"FINE 710 Fixed Income Securities Theory (3 credits)",
"FINE 711 Research Topics in Financial Markets Development (3 credits)",
"FMED 301 TCP Family Medicine (3 credits)",
"FMED 402 Family Medicine - Clerkships (4 credits)",
"FMED 402D1 Family Medicine - Clerkships (2 credits)",
"FMED 402D2 Family Medicine - Clerkships (2 credits)",
"FMED 405 Family Medicine Clerkship (8 credits)",
"FMED 500 Introduction to Research and Scholarly Activity (1 credit)",
"FMED 503 Survey Research Methods in Primary Care (1 credit)",
"FMED 504D1 Family Medicine Research Seminars (0.5 credits)",
"FMED 504D2 Family Medicine Research Seminars (0.5 credits)",
"FMED 505 Epidemiology and Data Analysis in Primary Care 1 (3 credits)",
"FMED 506 Indigenous Perspectives: Decolonizing Health Approaches (1 credit)",
"FMED 509 Epidemiology and Data Analysis in Primary Care 2 (3 credits)",
"FMED 511 Introduction to Art in Healthcare: Making Art Accessible (1 credit)",
"FMED 525 Foundations of Translational Science (3 credits)",
"FMED 601 Advanced Topics in Family Medicine (3 credits)",
"FMED 602 Readings in Family Medicine (1 credit)",
"FMED 603 Foundations of Participatory Research (1 credit)",
"FMED 604 Advanced Participatory Research in Health (3 credits)",
"FMED 605 Introduction Analytical Decision-Making in Healthcare (1 credit)",
"FMED 606 Operational Issues in Survey Methods in Primary Care (1 credit)",
"FMED 607 Intro to Discourse Analysis & Interpretive Health Research (1 credit)",
"FMED 608 Advanced Mixed Methods Seminar in Health Research (1 credit)",
"FMED 610 Foundations of Family Medicine (1 credit)",
"FMED 611 Healthcare Systems Policy and Performance (3 credits)",
"FMED 612 Evaluation Research and Implementation Science (1 credit)",
"FMED 613 Communication Education and Complex Collaborations (1 credit)",
"FMED 614 Foundations of Mixed Methods Research (2 credits)",
"FMED 615 Applied Knowledge Translation and Exchange in Health (1 credit)",
"FMED 616 Applied Literature Reviews (1 credit)",
"FMED 618 Topics in Pharmacoeconomics Drug Safety and Policy (1 credit)",
"FMED 619 Program Management in Global Health & Primary Health Care (3 credits)",
"FMED 621 Participatory Health Systems for Safe Birth (1 credit)",
"FMED 625 Qualitative Health Research (3 credits)",
"FMED 672 Applied Mixed Methods in Health Research (1 credit)",
"FMED 679 Epidemiology and Data Analysis in Primary Care 3 (3 credits)",
"FMED 690 Advanced Ethnography: Context Complexity and Coordination (3 credits)",
"FMED 697 Master's Thesis Research 1 (12 credits)",
"FMED 698 Master's Thesis Research 2 (12 credits)",
"FMED 701 PhD Comprehensive Examination",
"FMED 702 Advanced Doctoral Primary Care Research Seminars (1 credit)",
"FMT4 001 Fall Stage (152-VSA-MC) (1.33 credits)",
"FMT4 002 Soil Tillage (152-VSB-MC) (1.67 credits)",
"FMT4 003 Information Management (152-VSC-MC) (1.33 credits)",
"FMT4 004 Animal Physiology and Anatomy (152-VSD-MC) (1.33 credits)",
"FMT4 005 Introduction to Plant Science (152-VSE-MC) (2.33 credits)",
"FMT4 006 Pesticides and the Environment (152-VSF-MC) (1.33 credits)",
"FMT4 007 Health and Safety (152-VSG-MC) (2 credits)",
"FMT4 008 Animal Genetics and Nutrition (152-VSH-MC) (2.33 credits)",
"FMT4 009 Soil Fertility (152-VSJ-MC) (2 credits)",
"FMT4 010 Winter Stage (152-VSK-MC) (1.33 credits)",
"FMT4 011 Farm Accounting (152-VSL-MC) (2 credits)",
"FMT4 012 Machinery Maintenance (152-VSM-MC) (1.67 credits)",
"FMT4 013 Agricultural Internship (152-VSN-MC) (2 credits)",
"FMT4 014 Marketing Strategies (152-VSP-MC) (2 credits)",
"FMT4 015 Forest Management (152-VSQ-MC) (1.33 credits)",
"FMT4 016 Budgeting and Administration (152-VSR-MC) (2 credits)",
"FMT4 017 Agricultural Systems (152-VST-MC) (1.33 credits)",
"FMT4 018 Enterprise Management 1 (152-VSU-MC) (2.33 credits)",
"FMT4 019 Nutrient Management Plan (152-VSV-MC) (2 credits)",
"FMT4 020 Conservation of Soil and Water (152-VSW-MC) (2 credits)",
"FMT4 021 Enterprise Management 2 (152-VSX-MC) (2.67 credits)",
"FMT4 022 Equipment Management (152-VSY-MC) (1.67 credits)",
"FMT4 023 Building Management (152-VSZ-MC) (1.33 credits)",
"FMT4 024 Farm Building Development (152-VTA-MC) (1.67 credits)",
"FMT4 025 Enterprise Management 3 (152-VTB-MC) (2.33 credits)",
"FMT4 026 Human Resources  (152-VTC-MC) (1.67 credits)",
"FMT4 027 Precision Agriculture (152-VTD-MC) (1.33 credits)",
"FMT4 028 Dairy Replacement Management (152-VTE-MC) (2.67 credits)",
"FMT4 029 Dairy Performance Management (152-VTF-MC) (2.67 credits)",
"FMT4 030 Swine and Poultry Management (152-VTG-MC) (2.67 credits)",
"FMT4 031 Beef and Sheep Management (152-VTH-MC) (2.67 credits)",
"FMT4 032 Independent Study in Animal Production(152-VTJ-MC) (2.67 credits)",
"FMT4 033 Vegetable and Fruit Crops (152-VTK-MC) (2.67 credits)",
"FMT4 034 Greenhouse Crop Production (152-VTL-MC) (2.67 credits)",
"FMT4 035 Field Crop Management 1 (152-VTM-MC) (2.67 credits)",
"FMT4 036 Field Crop Management 2 (152-VTN-MC) (2.67 credits)",
"FMT4 037 Independent Study in Crop Production (152-VTP-MC) (2.67 credits)",
"FMTP 001 Farm Practice 1 (152-001-MC) (1.33 credits)",
"FMTP 002 Introduction to Economics (152-002-MC) (1.33 credits)",
"FMTP 003 Soil Preparation (152-003-MC) (2 credits)",
"FMTP 004 Microcomputing (152-004-MC) (1.67 credits)",
"FMTP 005 Animal Anatomy and Physiology (1.33 credits)",
"FMTP 006 Agricultural Botany (2.67 credits)",
"FMTP 007 Health and Farm Safety (152-007-MC) (2 credits)",
"FMTP 008 Introduction to Animal Science (152-008-MC) (2.33 credits)",
"FMTP 009 Soil Fertilization (152-009-MC) (2.67 credits)",
"FMTP 010 Farm Business Management 1 (152-010-MC) (2.33 credits)",
"FMTP 011 Farm Practice 2 (152-011-MC) (1.33 credits)",
"FMTP 012 Farm Practice 3 (152-012-MC) (7 credits)",
"FMTP 013 Farm Business Management 2 (152-013-MC) (2.33 credits)",
"FMTP 014 Machinery Management (152-014-MC) (1.67 credits)",
"FMTP 016 Agro-Environmental Fertilization Plan 1 (152-016-MC) (2 credits)",
"FMTP 017 Pesticide Use (1.33 credits)",
"FMTP 018 Building Maintenance (152-018-MC) (1.33 credits)",
"FMTP 019 Tools & Machinery Maintenance (152-019-MC) (1.67 credits)",
"FMTP 020 Agro-Environmental Fertilization Plan 2 (152-020-MC) (1.33 credits)",
"FMTP 021 Water and Soil Conservation (152-021-MC) (2 credits)",
"FMTP 022 Farm Business Management 3 (152-022-MC) (2.67 credits)",
"FMTP 023 Agricultural Marketing (152-023-MC) (2.33 credits)",
"FMTP 024 Farm Building Planning (152-024-MC) (1.67 credits)",
"FMTP 025 Farm Project (152-025-MC) (2 credits)",
"FMTP 026 Management of Human Resources (152-026-MC) (1.33 credits)",
"FMTP 027 Precision Farming (152-027-MC) (1.33 credits)",
"FMTP 028 Dairy Heifer Management (152-028-MC) (2.67 credits)",
"FMTP 029 Dairy Herd Management (152-029-MC) (2.67 credits)",
"FMTP 030 Swine and Poultry (152-030-MC) (2.67 credits)",
"FMTP 031 Beef and Sheep (152-031-MC) (2.67 credits)",
"FMTP 032 Fruit and Vegetable Crops (152-032-MC) (2.67 credits)",
"FMTP 033 Greenhouse Crops (152-033-MC) (2.67 credits)",
"FMTP 034 Feed Crops (152-034-MC) (2.67 credits)",
"FMTP 035 Industrial Crops (152-035-MC) (2.67 credits)",
"FMTP 036 Enterprise Internship (152-036-MC) (6 credits)",
"FMTP 037 Entrepreneurship 1 (152-037-MC) (2.33 credits)",
"FMTP 038 Financial and Managerial Accounting (152-038-MC) (2 credits)",
"FMTP 039 Agri-Marketing (152-039-MC) (1.67 credits)",
"FMTP 040 Nutrient Management Plan 1 (152-040-MC) (1.67 credits)",
"FMTP 041 Nutrient Management Plan 2 (152-041-MC) (1.33 credits)",
"FMTP 042 Budgeting Finance and Policies (152-042-MC) (2.33 credits)",
"FMTP 043 Entrepreneurship 2 (152-043-MC) (2.67 credits)",
"FMTP 044 Management of Human Resources (152-044-MC) (1.33 credits)",
"FMTP 045 Field Crop Production (152-045-MC) (2.67 credits)",
"FMTP 046 Field Crop Management (152-046-MC) (2.67 credits)",
"FMTP 074 Complementary Course 2 (2 credits)",
"FMTP 075 Langue française et communication (602-101-03) (2 credits)",
"FMTP 076 French 2 (602-VSC-03) (2 credits)",
"FMTP 077 Introduction to College English (2.67 credits)",
"FMTP 078 FMT English (603-VSB-MC) (2 credits)",
"FMTP 080 English Upgrading (2 credits)",
"FMTP 081 Components of Discourse (603-101-04) (2.67 credits)",
"FMTP 082 Literary Genres (603-102-04) (2.33 credits)",
"FMTP 083 Literary Themes (603-103-04) (2.33 credits)",
"FMTP 084 English for FMT (603-VSA-04) (2 credits)",
"FMTP 085 Humanities 1: Knowledge (345-103-04) (2.33 credits)",
"FMTP 086 Humanities 2: World Views (345-102-03) (2 credits)",
"FMTP 087 Humanities 3:Env.& Org. Issues (345-VSH-MC) (2 credits)",
"FMTP 090 Physical Activity and Health (109-101-MQ) (1 credit)",
"FMTP 091 Physical Activity and Effectiveness (109-102-MQ) (1 credit)",
"FMTP 092 Physical Activity and Autonomy (109-103-MQ) (1 credit)",
"FMTP 093 Health and Physical Education (1 credit)",
"FMTP 094 Physical Activity (109-104-02) (1 credit)",
"FMTP 095 Active Living (109-105-02) (1 credit)",
"FMTP 096 Forests Forestry and Society (305-032-MC) (2 credits)",
"FMTP 097 Landscape Design (504-VSG-MC) (2 credits)",
"FMTP 098 Français agricole (602-VSG-MC) (2 credits)",
"FREN 198 FYS: Introduction to French and Québec Literature (3 credits)",
"FREN 199 FYS: Littérature française (3 credits)",
"FREN 201 Le français littéraire (français langue seconde) (3 credits)",
"FREN 203 Analyse de textes (français langue seconde) (3 credits)",
"FREN 222 Introduction aux études littéraires (3 credits)",
"FREN 231 Linguistique française (3 credits)",
"FREN 239 Stylistique comparée (3 credits)",
"FREN 240 Atelier d'écriture poétique (3 credits)",
"FREN 244 Traduction générale (3 credits)",
"FREN 245 Grammaire normative (3 credits)",
"FREN 250 Littérature française avant 1800 (3 credits)",
"FREN 251 Littérature française depuis 1800 (3 credits)",
"FREN 252 Littérature québécoise (3 credits)",
"FREN 310 Cinéma français (3 credits)",
"FREN 311 Cinéma francophone (3 credits)",
"FREN 313 Langage et littérature 1 (3 credits)",
"FREN 315 Cinéma québécois (3 credits)",
"FREN 320 Traduire écrire expérimenter. (3 credits)",
"FREN 324 Traduction littéraire 1 (3 credits)",
"FREN 329 Civilisation québécoise (3 credits)",
"FREN 333 Questions de littérature du Moyen Âge et de l'Ancien Régime (3 credits)",
"FREN 334 L'oeuvre au miroir de la critique (3 credits)",
"FREN 335 Théories littéraires 1 (3 credits)",
"FREN 336 Histoire de la langue française (3 credits)",
"FREN 337 Textes imaginaires sociétés (3 credits)",
"FREN 340 Atelier d'écriture narrative (3 credits)",
"FREN 341 Traduction et recherche 1 (3 credits)",
"FREN 346 Traduction avancée (3 credits)",
"FREN 347 Terminologie générale (3 credits)",
"FREN 349 Traduction et recherche 2 (3 credits)",
"FREN 355 Littérature du 20e siècle 1 (3 credits)",
"FREN 356 Grammaire du texte littéraire. (3 credits)",
"FREN 360 La littérature du 19e siècle 1 (3 credits)",
"FREN 362 La littérature du 17e siècle 1 (3 credits)",
"FREN 364 La littérature du 18e siècle 1 (3 credits)",
"FREN 366 Littérature de la Renaissance 1 (3 credits)",
"FREN 372 Littérature québécoise 1 (3 credits)",
"FREN 375 Théories littéraires 2. (3 credits)",
"FREN 376 Correction et révision (3 credits)",
"FREN 377 Pratiques de l'édition littéraire (3 credits)",
"FREN 380 Littératures francophones 1 (3 credits)",
"FREN 381 Littératures francophones 2 (3 credits)",
"FREN 382 Littérature québécoise 2 (3 credits)",
"FREN 391 Savoirs de la littérature 1 (3 credits)",
"FREN 394 Théories de la traduction (3 credits)",
"FREN 420 Enjeux de l’écriture littéraire. (3 credits)",
"FREN 422 Le métier d'écrivain-e (3 credits)",
"FREN 425 Traduction et culture (3 credits)",
"FREN 431 Traduction et révision (3 credits)",
"FREN 433 Sémantique et lexicologie (3 credits)",
"FREN 434 Sociolinguistique du français (3 credits)",
"FREN 440 Atelier d'écriture dramatique (3 credits)",
"FREN 441 Traduction français-anglais (3 credits)",
"FREN 443 Traduction littéraire 2 (3 credits)",
"FREN 444 Questions de littérature moderne (3 credits)",
"FREN 450 Questions de littérature québécoise (3 credits)",
"FREN 453 Littérature du 20e siècle 2 (3 credits)",
"FREN 455 La littérature médiévale 1 (3 credits)",
"FREN 456 La littérature médiévale 2 (3 credits)",
"FREN 457 La littérature de la Renaissance 2 (3 credits)",
"FREN 458 La littérature du 17e siècle 2 (3 credits)",
"FREN 459 La littérature du 18e siècle 2 (3 credits)",
"FREN 460 Atelier d'écriture. (3 credits)",
"FREN 461 Enjeux littéraires et culturels 1 (3 credits)",
"FREN 464D1 Mémoire de spécialisation (3 credits)",
"FREN 464D2 Mémoire de spécialisation (3 credits)",
"FREN 464N1 Mémoire de spécialisation (3 credits)",
"FREN 464N2 Mémoire de spécialisation (3 credits)",
"FREN 472 Enjeux littéraires et culturels 2 (3 credits)",
"FREN 476 Le livre (3 credits)",
"FREN 480 Littérature québécoise contemporaine (3 credits)",
"FREN 482 La littérature du 19e siècle 2 (3 credits)",
"FREN 485 Littérature française contemporaine (3 credits)",
"FREN 491 Langage et littérature 2 (3 credits)",
"FREN 492 Histoire de la traduction (3 credits)",
"FREN 494 Traduction spécialisée (3 credits)",
"FREN 496 Savoirs de la littérature 2 (3 credits)",
"FREN 498 Questions de littérature 3 (3 credits)",
"FREN 499 Questions de littérature 4 (3 credits)",
"FREN 550 Lectures guidées 1 (3 credits)",
"FREN 551 Lectures guidées 2 (3 credits)",
"FREN 595 Séminaire avancé de recherche (3 credits)",
"FREN 599 Stage en milieu de travail (3 credits)",
"FREN 600 Travaux dirigés 1 (3 credits)",
"FREN 601 Travaux dirigés 2 (3 credits)",
"FREN 609 Atelier de création littéraire (3 credits)",
"FREN 611 L'expérience littéraire (3 credits)",
"FREN 612 Séminaire de recherche 1 (3 credits)",
"FREN 613 Séminaire de recherche 2 (3 credits)",
"FREN 615 Littérature et société 1 (3 credits)",
"FREN 616 Littérature et linguistique (3 credits)",
"FREN 620 Évolution - Langue française au Canada (3 credits)",
"FREN 621 Problèmes d'esthétique 1 (3 credits)",
"FREN 624 Questions de genre 1 (3 credits)",
"FREN 626 Questions de genre 2 (3 credits)",
"FREN 628 Théorie littéraire 1 (3 credits)",
"FREN 629 Histoire des idées (3 credits)",
"FREN 694 Théorie littéraire 2 (3 credits)",
"FREN 696 Élaboration projet de mémoire (3 credits)",
"FREN 697 Méthodologie et théorie littéraires (3 credits)",
"FREN 698 Master's Seminar (18 credits)",
"FREN 698D1 Master's Seminar (9 credits)",
"FREN 698D2 Master's Seminar (9 credits)",
"FREN 698N1 Master's Seminar (9 credits)",
"FREN 698N2 Master's Seminar (9 credits)",
"FREN 699 M.A. Thesis (24 credits)",
"FREN 699D1 M.A. Thesis (12 credits)",
"FREN 699D2 M.A. Thesis (12 credits)",
"FREN 699N1 M.A. Thesis (12 credits)",
"FREN 699N2 M.A. Thesis (12 credits)",
"FREN 706 Élaboration du sujet de thèse",
"FREN 706D1 Élaboration du sujet de thèse",
"FREN 706D2 Élaboration du sujet de thèse",
"FREN 706N1 Élaboration du sujet de thèse",
"FREN 706N2 Élaboration du sujet de thèse",
"FREN 707 Examen préliminaire",
"FREN 707D1 Examen préliminaire",
"FREN 707D2 Examen préliminaire",
"FREN 707N1 Examen préliminaire",
"FREN 707N2 Examen préliminaire",
"FREN 710 Séminaire de doctorat 1 (1.5 credits)",
"FREN 711 Séminaire de doctorat 2 (1.5 credits)",
"FREN 712 Séminaire de recherche 3 (3 credits)",
"FREN 713 Séminaire de recherche 4 (3 credits)",
"FREN 720 Moyen Âge 1 (3 credits)",
"FREN 721 Moyen Âge 2 (3 credits)",
"FREN 723 16e siècle 1 (3 credits)",
"FREN 724 16e siècle 2 (3 credits)",
"FREN 725 Séminaire de recherche 5 (3 credits)",
"FREN 726 17e siècle 1 (3 credits)",
"FREN 727 17e siècle 2 (3 credits)",
"FREN 729 18e siècle 1 (3 credits)",
"FREN 730 18e siècle 2 (3 credits)",
"FREN 731 18e siècle 3 (3 credits)",
"FREN 732 19e siècle 1 (3 credits)",
"FREN 733 19e siècle 2 (3 credits)",
"FREN 734 19e siècle 3 (3 credits)",
"FREN 735 19e siècle 4 (3 credits)",
"FREN 737 20e siècle 1 (3 credits)",
"FREN 738 20e siècle 2 (3 credits)",
"FREN 739 20e siècle 3 (3 credits)",
"FREN 740 20e siècle 4 (3 credits)",
"FREN 741 20e siècle 5 (3 credits)",
"FREN 750 Roman québécois 1 (3 credits)",
"FREN 751 Roman québécois 2 (3 credits)",
"FREN 752 Roman québécois 3 (3 credits)",
"FREN 755 Poésie québécoise 1 (3 credits)",
"FREN 756 Poésie québécoise 2 (3 credits)",
"FREN 759 Séminaire de recherche 6 (3 credits)",
"FREN 760 Littérature et société québécoise (3 credits)",
"FREN 761 Thème de littérature québécoise 1 (3 credits)",
"FREN 762 Thème de littérature québécoise 2 (3 credits)",
"FREN 765 Littératures francophones 1 (3 credits)",
"FREN 790 Language Requirement",
"FREN 790D1 Language Requirement",
"FREN 790D2 Language Requirement",
"FRSL 101 Beginners French 1 (3 credits)",
"FRSL 102 Beginners French 2 (3 credits)",
"FRSL 103 Near Beginners French (3 credits)",
"FRSL 104 Corrective French Pronunciation (3 credits)",
"FRSL 105 Intensive Beginners French (6 credits)",
"FRSL 206 Elementary French (3 credits)",
"FRSL 207 Elementary French 01 (6 credits)",
"FRSL 207D1 Elementary French 01 (3 credits)",
"FRSL 207D2 Elementary French 01 (3 credits)",
"FRSL 208 Intensive Elementary French (6 credits)",
"FRSL 209 Français oral élémentaire : santé et services sociaux (3 credits)",
"FRSL 210 Français oral intermédiaire 1 : santé et services sociaux (3 credits)",
"FRSL 211 Oral and Written French 1 (6 credits)",
"FRSL 211D1 Oral and Written French 1 (3 credits)",
"FRSL 211D2 Oral and Written French 1 (3 credits)",
"FRSL 212 Oral and Written French 1 (3 credits)",
"FRSL 215 Oral and Written French 1 - Intensive (6 credits)",
"FRSL 216 Découvrons Montréal en français (3 credits)",
"FRSL 219 Français intermédiaire 1 : diététique et nutrition (3 credits)",
"FRSL 302 Listening Comprehension and Oral Expression 1 (3 credits)",
"FRSL 303 Listening Comprehension and Oral Expression 2 (3 credits)",
"FRSL 321 Oral and Written French 2 (6 credits)",
"FRSL 321D1 Oral and Written French 2 (3 credits)",
"FRSL 321D2 Oral and Written French 2 (3 credits)",
"FRSL 322 Oral and Written French 2 (3 credits)",
"FRSL 325 Oral and Written French 2 - Intensive (6 credits)",
"FRSL 326 Découvrons le Québec en français (3 credits)",
"FRSL 329 Français écrit en contexte 1 : santé et services sociaux (3 credits)",
"FRSL 330 Français écrit en contexte 2: santé et services sociaux (3 credits)",
"FRSL 332 Intermediate French: Grammar 01 (3 credits)",
"FRSL 333 Intermediate French: Grammar 02 (3 credits)",
"FRSL 407 Compréhension et expression orales (3 credits)",
"FRSL 408 Français oral: Textes et expressions (3 credits)",
"FRSL 431 Français fonctionnel avancé (6 credits)",
"FRSL 431D1 Français fonctionnel avancé (3 credits)",
"FRSL 431D2 Français fonctionnel avancé (3 credits)",
"FRSL 432 Français fonctionnel (3 credits)",
"FRSL 445 Français fonctionnel écrit 1 (3 credits)",
"FRSL 446 Français fonctionnel écrit 2 (3 credits)",
"FRSL 449 Le français des médias (3 credits)",
"FRSL 455 Grammaire et création (3 credits)",
"FSCI 200 Industrial Practicum 1",
"FSCI 300 Industrial Practicum 2",
"FSCI 342 Experiential Learning – Language",
"FSCI 396 Research Project in Science Teaching and Learning 1 (3 credits)",
"FSCI 397 Research Project in Science Teaching and Learning 2 (3 credits)",
"FSCI 398D1 Research Project in Science Teaching and Learning 3 (3 credits)",
"FSCI 398D2 Research Project in Science Teaching and Learning 3 (3 credits)",
"FSCI 400 Field Practicum",
"GDEU 2PGM ",
"GDEU DSRT ",
"GDEU THES ",
"GEOG 199 FYS: Geo-Environments (3 credits)",
"GEOG 200 Geographical Perspectives: World Environmental Problems (3 credits)",
"GEOG 201 Introductory Geo-Information Science (3 credits)",
"GEOG 202 Statistics and Spatial Analysis (3 credits)",
"GEOG 203 Environmental Systems (3 credits)",
"GEOG 205 Global Change: Past Present and Future (3 credits)",
"GEOG 210 Global Places and Peoples (3 credits)",
"GEOG 216 Geography of the World Economy (3 credits)",
"GEOG 217 Cities in the Modern World (3 credits)",
"GEOG 221 Environment and Health (3 credits)",
"GEOG 272 Earth's Changing Surface (3 credits)",
"GEOG 290 Local Geographical Excursion (1 credit)",
"GEOG 291 Independent Short  Project in Geography (1 credit)",
"GEOG 300 Human Ecology in Geography (3 credits)",
"GEOG 301 Geography of Nunavut (3 credits)",
"GEOG 302 Environmental Management 1 (3 credits)",
"GEOG 303 Health Geography (3 credits)",
"GEOG 305 Soils and Environment (3 credits)",
"GEOG 306 Raster Geo-Information Science (3 credits)",
"GEOG 307 Socioeconomic Applications of GIS (3 credits)",
"GEOG 308 Principles of Remote Sensing (3 credits)",
"GEOG 309 Geography of Canada (3 credits)",
"GEOG 310 Development and Livelihoods (3 credits)",
"GEOG 311 Economic Geography (3 credits)",
"GEOG 315 Urban Transportation Geography (3 credits)",
"GEOG 316 Political Geography (3 credits)",
"GEOG 321 Climatic Environments (3 credits)",
"GEOG 322 Environmental Hydrology (3 credits)",
"GEOG 325 New Master-Planned Cities (3 credits)",
"GEOG 331 Urban Social Geography (3 credits)",
"GEOG 333 Introduction to Programming for Spatial Sciences (3 credits)",
"GEOG 350 Ecological Biogeography (3 credits)",
"GEOG 351 Quantitative Methods (3 credits)",
"GEOG 360 Analyzing Sustainability (3 credits)",
"GEOG 370 Protected Areas (3 credits)",
"GEOG 372 Running Water Environments (3 credits)",
"GEOG 373 Arctic Geomorphology (3 credits)",
"GEOG 381 Geographic Thought and Practice (3 credits)",
"GEOG 382 Principles Earth Citizenship (3 credits)",
"GEOG 384 Principles of Geospatial Web (3 credits)",
"GEOG 396 Undergraduate Research Project (3 credits)",
"GEOG 398 Field Studies in Human Geography (3 credits)",
"GEOG 401 Socio-Environmental Systems: Theory and Simulation (3 credits)",
"GEOG 403 Global Health and Environmental Change (3 credits)",
"GEOG 404 Environmental Management 2 (3 credits)",
"GEOG 406 Human Dimensions of Climate Change (3 credits)",
"GEOG 407 Issues in Geography (3 credits)",
"GEOG 408 Geography of Development (3 credits)",
"GEOG 409 Geographies of Developing Asia (3 credits)",
"GEOG 410 Geography of Underdevelopment: Current Problems (3 credits)",
"GEOG 416 Africa South of the Sahara (3 credits)",
"GEOG 417 Urban Geography (3 credits)",
"GEOG 420 Memory Place and Power (3 credits)",
"GEOG 423 Dilemmas of Development (3 credits)",
"GEOG 424 Europe: Places and Peoples (3 credits)",
"GEOG 425 Southeast Asia Urban Field Studies (3 credits)",
"GEOG 451 Research in Society and Development in Africa (3 credits)",
"GEOG 460 Research in Sustainability (3 credits)",
"GEOG 470 Wetlands (3 credits)",
"GEOG 473 Arctic Field Research (6 credits)",
"GEOG 489 Independent Research in Geography (3 credits)",
"GEOG 490 Independent Readings in Geography (3 credits)",
"GEOG 490D1 Independent Readings in Geography (1.5 credits)",
"GEOG 490D2 Independent Readings in Geography (1.5 credits)",
"GEOG 491D1 Honours Research (3 credits)",
"GEOG 491D2 Honours Research (3 credits)",
"GEOG 491N1 Honours Research (3 credits)",
"GEOG 491N2 Honours Research (3 credits)",
"GEOG 492D1 Joint Honours Research (1.5 credits)",
"GEOG 492D2 Joint Honours Research (1.5 credits)",
"GEOG 492N1 Joint Honours Research (1.5 credits)",
"GEOG 492N2 Joint Honours Research (1.5 credits)",
"GEOG 493 Health and Environment in Africa (3 credits)",
"GEOG 494 Urban Field Studies (3 credits)",
"GEOG 495 Field Studies - Physical Geography (3 credits)",
"GEOG 496 Geographical Excursion (3 credits)",
"GEOG 498 Humans in Tropical Environments (3 credits)",
"GEOG 499 Subarctic Field Studies (3 credits)",
"GEOG 502 Geography of Northern Development (3 credits)",
"GEOG 503 Advanced Topics in Health Geography (3 credits)",
"GEOG 504 Advanced Economic Geography (3 credits)",
"GEOG 505 Global Biogeochemistry (3 credits)",
"GEOG 506 Advanced Geographic Information Science (3 credits)",
"GEOG 507 Advanced Social Geography (3 credits)",
"GEOG 509 Qualitative Methods (3 credits)",
"GEOG 510 Humid Tropical Environments (3 credits)",
"GEOG 511 Advanced Political Geography (3 credits)",
"GEOG 512 Advanced Quantitative Methods in Social Field Research (3 credits)",
"GEOG 514 Climate Change Vulnerability and Adaptation (3 credits)",
"GEOG 515 Contemporary Dilemmas of Development (3 credits)",
"GEOG 520  (3 credits)",
"GEOG 523 Global Ecosystems and Climate (3 credits)",
"GEOG 525 Asian Cities in the 21st Century (3 credits)",
"GEOG 530 Global Land and Water Resources (3 credits)",
"GEOG 535 Remote Sensing and Interpretation (3 credits)",
"GEOG 536 Geocryology (3 credits)",
"GEOG 537 Advanced Fluvial Geomorphology (3 credits)",
"GEOG 540 Topics in Geography 1 (3 credits)",
"GEOG 541 Topics in Geography 2 (3 credits)",
"GEOG 542 Advanced Studies in Geography 1 (1 credit)",
"GEOG 543 Advanced Studies in Geography 2 (1 credit)",
"GEOG 550 Historical Ecology Techniques (3 credits)",
"GEOG 551 Environmental Decisions (3 credits)",
"GEOG 555 Ecological Restoration (3 credits)",
"GEOG 601 Advanced Environmental Systems Modelling (3 credits)",
"GEOG 617 Advanced Urban Geography (3 credits)",
"GEOG 625 Special Topics in Human Geography (3 credits)",
"GEOG 626 Special Topics in Physical Geography (3 credits)",
"GEOG 631 Methods of Geographical Research (3 credits)",
"GEOG 631D1 Methods of Geographical Research (1.5 credits)",
"GEOG 631D2 Methods of Geographical Research (1.5 credits)",
"GEOG 631N1 Methods of Geographical Research (1.5 credits)",
"GEOG 631N2 Methods of Geographical Research (1.5 credits)",
"GEOG 634 Quantitative Methods in Geography (3 credits)",
"GEOG 670 Wetlands-Advanced (3 credits)",
"GEOG 696 Thesis Preparation (3 credits)",
"GEOG 697 Thesis Research (Environment Option) (18 credits)",
"GEOG 698 Thesis Proposal (6 credits)",
"GEOG 698D1 Thesis Proposal (3 credits)",
"GEOG 698D2 Thesis Proposal (3 credits)",
"GEOG 698N1 Thesis Proposal (3 credits)",
"GEOG 698N2 Thesis Proposal (3 credits)",
"GEOG 699 Thesis Research (24 credits)",
"GEOG 699D1 Thesis Research (12 credits)",
"GEOG 699D2 Thesis Research (12 credits)",
"GEOG 699N1 Thesis Research (12 credits)",
"GEOG 699N2 Thesis Research (12 credits)",
"GEOG 700 Comprehensive Examination 1",
"GEOG 700D1 Comprehensive Examination 1",
"GEOG 700D2 Comprehensive Examination 1",
"GEOG 701 Comprehensive Examination 2",
"GEOG 701D1 Comprehensive Examination 2",
"GEOG 701D2 Comprehensive Examination 2",
"GEOG 702 Comprehensive Examination 3",
"GEOG 702D1 Comprehensive Examination 3",
"GEOG 702D2 Comprehensive Examination 3",
"GERM 197 FYS: Images of Otherness (3 credits)",
"GERM 200 German Language Intensive Beginners (6 credits)",
"GERM 202 German Language Beginners' (6 credits)",
"GERM 202D1 German Language Beginners' (3 credits)",
"GERM 202D2 German Language Beginners (3 credits)",
"GERM 203D1 German for Reading (3 credits)",
"GERM 203D2 German for Reading (3 credits)",
"GERM 259 Introduction to German Literature 1 (3 credits)",
"GERM 260 Introduction to German Literature 2 (3 credits)",
"GERM 300 German Language Intensive Intermediate (6 credits)",
"GERM 307 German Language - Intermediate (6 credits)",
"GERM 307D1 German Language - Intermediate (3 credits)",
"GERM 307D2 German Language - Intermediate (3 credits)",
"GERM 325 German Language - Intensive Advanced (6 credits)",
"GERM 326 Topics: German Language and Culture (3 credits)",
"GERM 331 Germany after Reunification (3 credits)",
"GERM 332 Topics in Eighteenth-Century German Literature and Culture (3 credits)",
"GERM 333 What is Enlightenment? (3 credits)",
"GERM 335 Science and Literature (3 credits)",
"GERM 336 German Language Media and Culture (3 credits)",
"GERM 337 Literature and Revolution (3 credits)",
"GERM 340 Romanticism (3 credits)",
"GERM 341 Essay Writing (3 credits)",
"GERM 342 Translation (3 credits)",
"GERM 344 Realism (3 credits)",
"GERM 345 Business German 1 (3 credits)",
"GERM 346 Business German 2 (3 credits)",
"GERM 348 Nature and Ecopoetics (3 credits)",
"GERM 350 Modernism and the Avant-Garde (3 credits)",
"GERM 351 Berlin (3 credits)",
"GERM 352 German Literature - 19th Century 3 (3 credits)",
"GERM 353 19th Century Literary Topics (3 credits)",
"GERM 355 Nietzsche and Wagner (3 credits)",
"GERM 357 German Culture in European Context (3 credits)",
"GERM 358 Franz Kafka (3 credits)",
"GERM 359 Bertolt Brecht (3 credits)",
"GERM 360 German Drama (3 credits)",
"GERM 361 Weimar Literature and Culture (3 credits)",
"GERM 362 20th Century Literature Topics (3 credits)",
"GERM 363 German Postwar Literature (3 credits)",
"GERM 364 Gender and Society in German Literature and Culture (3 credits)",
"GERM 365 Modern Short Fiction (3 credits)",
"GERM 366 Lyric Poetry (3 credits)",
"GERM 367 Topics in German Thought (3 credits)",
"GERM 368 Fin-de-Siècle Vienna (3 credits)",
"GERM 369 The German Novel (3 credits)",
"GERM 370 Special Topics in German Film (3 credits)",
"GERM 371 German Cinema (3 credits)",
"GERM 372 Topics in German Cinema (3 credits)",
"GERM 373 Weimar German Cinema (3 credits)",
"GERM 375 German Media Studies (3 credits)",
"GERM 379 German Visual Culture (3 credits)",
"GERM 380 18th Century German Literature (3 credits)",
"GERM 381 Topics in German Thought (3 credits)",
"GERM 382 Faust: Chapbook to Horror Film (3 credits)",
"GERM 385 Critical Theory (3 credits)",
"GERM 388 Post-Wall Culture (3 credits)",
"GERM 390 Topics in 21st Century German Literature and Culture (3 credits)",
"GERM 397 Individual Reading Course 01 (3 credits)",
"GERM 398 Individual Reading Course 02 (3 credits)",
"GERM 400 Interdisciplinary Seminar: Contemporary German Studies (3 credits)",
"GERM 401 Advanced Topics in German Literature and Culture (3 credits)",
"GERM 450 Classical Period in German Literature (3 credits)",
"GERM 451 German Romanticism (3 credits)",
"GERM 455 Women of the Romantic Era (3 credits)",
"GERM 499 Internship: German Studies (3 credits)",
"GERM 570 Joint Honours Thesis (3 credits)",
"GERM 575 Honours Thesis (6 credits)",
"GERM 580 Topics in German Literature and Culture (3 credits)",
"GERM 619 Topics in Literary Theory (3 credits)",
"GERM 620 German Literature: Enlightenment 1 (3 credits)",
"GERM 630 German Classicism 1 (3 credits)",
"GERM 631 German Classicism 2 (3 credits)",
"GERM 635 German Romanticism 1 (3 credits)",
"GERM 636 German Romanticism 2 (3 credits)",
"GERM 638 German Romanticism 4 (3 credits)",
"GERM 640 German Realism and Early Naturalism 1 (3 credits)",
"GERM 645 German Literature - 20th Century 1 (3 credits)",
"GERM 646 German Literature - 20th Century 2 (3 credits)",
"GERM 647 German Literature - 20th Century 3 (3 credits)",
"GERM 655 Literary Theory and Criticism 1 (3 credits)",
"GERM 657 Literary Theory and Criticism 3 (3 credits)",
"GERM 658 Literary Theory and Criticism 4 (3 credits)",
"GERM 660 Comparative Literature Studies 1 (3 credits)",
"GERM 661 Comparative Literature Studies 2 (3 credits)",
"GERM 662 Comparative Literature Studies 3 (3 credits)",
"GERM 663 Comparative Literature Studies 4 (3 credits)",
"GERM 665 Theoretical Approach - Teaching German 1 (3 credits)",
"GERM 670 Staff-Student Seminar: Literature Problems (3 credits)",
"GERM 675 Research Seminar (3 credits)",
"GERM 680 Research Paper 1 (6 credits)",
"GERM 681 Research Paper 2 (6 credits)",
"GERM 682 Research Paper 3 (6 credits)",
"GERM 690 Thesis Research 1 (9 credits)",
"GERM 691 Thesis Research 2 (9 credits)",
"GERM 692 Thesis Research 3 (12 credits)",
"GERM 701 Ph.D. Comprehensive Examination",
"GERM 790 Ph.D. Language Requirement",
"GLIS 601 Foundations of Information Studies (3 credits)",
"GLIS 602 Integrating Research and Practice (3 credits)",
"GLIS 603 Research Project 1 (6 credits)",
"GLIS 604 Research Project 2 (3 credits)",
"GLIS 607 Organization of Information (3 credits)",
"GLIS 608 Classification and Cataloguing (3 credits)",
"GLIS 609 Metadata & Access (3 credits)",
"GLIS 611 Research Principles and Analysis (3 credits)",
"GLIS 612 History of Books and Printing (3 credits)",
"GLIS 613 Library and Archival History (3 credits)",
"GLIS 614 Public Libraries (3 credits)",
"GLIS 615 Reference & Information Services (3 credits)",
"GLIS 616 Information Retrieval (3 credits)",
"GLIS 617 Information System Design (3 credits)",
"GLIS 618 Collection Development (3 credits)",
"GLIS 619 Information Behaviour and Resources (3 credits)",
"GLIS 620 Managing Information Organizations (3 credits)",
"GLIS 624 Marketing Information Services (3 credits)",
"GLIS 625 Information Architecture (3 credits)",
"GLIS 626 Usability Analysis and Assessment (3 credits)",
"GLIS 627 User-Centered Design (3 credits)",
"GLIS 629 Information Security (3 credits)",
"GLIS 630 Data Mining (3 credits)",
"GLIS 631 Systems Thinking (3 credits)",
"GLIS 632 Library Systems (3 credits)",
"GLIS 633 Digital Media (3 credits)",
"GLIS 634 Web System Design and Management (3 credits)",
"GLIS 636 Government Information (3 credits)",
"GLIS 637 Scientific & Technical Information (3 credits)",
"GLIS 638 Business Information (3 credits)",
"GLIS 639 Introduction to Museology (3 credits)",
"GLIS 641 Archival Description and Access (3 credits)",
"GLIS 642 Preservation Management (3 credits)",
"GLIS 644 Descriptive Bibliography (3 credits)",
"GLIS 645 Archival Principles and Practice (3 credits)",
"GLIS 647 Research Project 3 (6 credits)",
"GLIS 647D1 Research Project 3 (3 credits)",
"GLIS 647D2 Research Project 3 (3 credits)",
"GLIS 649 Digital Curation (3 credits)",
"GLIS 650 Digital Libraries (3 credits)",
"GLIS 651 Humanities and Social Science Information (3 credits)",
"GLIS 655 Language and Information (3 credits)",
"GLIS 656 Abstracting and Indexing (3 credits)",
"GLIS 657 Database Design & Development (3 credits)",
"GLIS 660 Enterprise Content Management (3 credits)",
"GLIS 661 Knowledge Management (3 credits)",
"GLIS 662 Intellectual Capital (3 credits)",
"GLIS 663 Knowledge Taxonomies (3 credits)",
"GLIS 664 Knowledge Networks (3 credits)",
"GLIS 665 Competitive Intelligence (3 credits)",
"GLIS 671 Health Sciences Information (3 credits)",
"GLIS 672 Law Information (3 credits)",
"GLIS 673 Bioinformatics Resources (3 credits)",
"GLIS 679 Information Literacy (3 credits)",
"GLIS 689 Selected Topics (3 credits)",
"GLIS 690 Information Policy (3 credits)",
"GLIS 691 Special Topics 1 (3 credits)",
"GLIS 692 Special Topics 2 (3 credits)",
"GLIS 693 Special Topics 3 (3 credits)",
"GLIS 694 Certificate Project (3 credits)",
"GLIS 695 Research Paper 1 (6 credits)",
"GLIS 696D1 Research Paper 2 (6 credits)",
"GLIS 696D2 Research Paper 2 (6 credits)",
"GLIS 696J1 Research Paper 2 (4 credits)",
"GLIS 696J2 Research Paper 2 (4 credits)",
"GLIS 696J3 Research Paper 2 (4 credits)",
"GLIS 696N1 Research Paper 2 (6 credits)",
"GLIS 696N2 Research Paper 2 (6 credits)",
"GLIS 699 Practicum (3 credits)",
"GLIS 701 Comprehensive Examination",
"GLIS 702 Seminar in Information Studies (3 credits)",
"GLIS 703 Research Paradigms in Information Studies (3 credits)",
"GLIS 704 Research Design in Information Studies (3 credits)",
"GLIS 705 Readings in Information Studies (3 credits)",
"GSFS 200 Feminist and Social Justice Studies (3 credits)",
"GSFS 250 Sexual and Gender Diversity Studies (3 credits)",
"GSFS 300 Research Inquiry in GSFS (3 credits)",
"GSFS 301 Current Topics 1 (3 credits)",
"GSFS 302 Current Topics 2 (3 credits)",
"GSFS 303 Gender and Disability (3 credits)",
"GSFS 304 Postcolonial Feminist Theories (3 credits)",
"GSFS 305 Critical Race and Social Justice Theories (3 credits)",
"GSFS 306 Queer Theory (3 credits)",
"GSFS 307 Indigenous Feminisms (3 credits)",
"GSFS 308 Sex & Gender Minority Cultures (3 credits)",
"GSFS 400 Capstone: Engaging Fields of GSFS (3 credits)",
"GSFS 401 Special Topics 1 (3 credits)",
"GSFS 402 Special Topics 2 (3 credits)",
"GSFS 403 Feminisms and the Law (3 credits)",
"GSFS 404 Politics of Identity (3 credits)",
"GSFS 405 Social Justice and Activism (3 credits)",
"GSFS 406 Trans*Feminisms (3 credits)",
"GSFS 407 Sexuality and Gender: New Directions (3 credits)",
"GSFS 450 Independent Reading and Research (3 credits)",
"GSFS 495D1 Honours/Joint Honours Colloquium (1.5 credits)",
"GSFS 495D2 Honours/Joint Honours Colloquium (1.5 credits)",
"GSFS 496D1 Honours Thesis (3 credits)",
"GSFS 496D2 Honours Thesis (3 credits)",
"GSFS 497D1 Joint Honours Thesis (1.5 credits)",
"GSFS 497D2 Joint Honours Thesis (1.5 credits)",
"GSFS 499 GSFS Internship (3 credits)",
"HGEN 396 Human Genetic Research Project (3 credits)",
"HGEN 400 Genetics in Medicine (3 credits)",
"HGEN 600 Genetic Counselling Practicum (6 credits)",
"HGEN 600D1 Genetic Counselling Practicum (3 credits)",
"HGEN 600D2 Genetic Counselling Practicum (3 credits)",
"HGEN 601 Genetic Counselling Principles (3 credits)",
"HGEN 610 Genetic Counselling: Independent Studies (6 credits)",
"HGEN 610D1 Genetic Counselling: Independent Studies (3 credits)",
"HGEN 610D2 Genetic Counselling: Independent Studies (3 credits)",
"HGEN 617 Principles of Medical Genetics (3 credits)",
"HGEN 620 Introductory Field Work Rotations 1 (3 credits)",
"HGEN 621 Intro Field Work Rotations 2 (6 credits)",
"HGEN 630 Advanced Field Work Rotations (12 credits)",
"HGEN 630D1 Advanced Field Work Rotations (6 credits)",
"HGEN 630D2 Advanced Field Work Rotations (6 credits)",
"HGEN 640 Second Year Practicum 1 (3 credits)",
"HGEN 641 Second Year Practicum 2 (3 credits)",
"HGEN 650 Genetic Counselling: Reading Project (3 credits)",
"HGEN 660 Genetics and Bioethics (3 credits)",
"HGEN 661 Population Genetics (3 credits)",
"HGEN 662 Laboratory Research Techniques (3 credits)",
"HGEN 663 Beyond the Human Genome (3 credits)",
"HGEN 670 Advances in Human Genetics 1 (3 credits)",
"HGEN 671 Advances in Human Genetics 2 (3 credits)",
"HGEN 674 Research Internship (3 credits)",
"HGEN 675 Stem Cell Biology (3 credits)",
"HGEN 676 Lab Course in Genomics (3 credits)",
"HGEN 677 Statistical Concepts in Genetic and Genomic Analysis (3 credits)",
"HGEN 678 Neurogenetics (3 credits)",
"HGEN 679 Cancer Genetics: Precision Oncology (3 credits)",
"HGEN 680 M.Sc. Thesis Research 1 (9 credits)",
"HGEN 681 M.Sc. Thesis Research 2 (12 credits)",
"HGEN 682 M.Sc. Thesis Research 3 (12 credits)",
"HGEN 683 M.Sc. Thesis Research 4 (6 credits)",
"HGEN 690 Inherited Cancer Syndromes (3 credits)",
"HGEN 691 Host Responses to Pathogens (3 credits)",
"HGEN 692 Human Genetics (3 credits)",
"HGEN 693 Using Bioinformatics Resources (3 credits)",
"HGEN 695 Psychiatric Genetics (3 credits)",
"HGEN 696 Advanced Readings in Genetics 1 (3 credits)",
"HGEN 697 Advanced Readings in Genetics 2 (3 credits)",
"HGEN 698 Advanced Readings in Genetics 3 (3 credits)",
"HGEN 699 Advanced Readings in Genetics 4 (3 credits)",
"HGEN 701 Ph.D. Comprehensive Examination",
"HGEN 702 Kyoto-McGill Ph.D Seminar (3 credits)",
"HISP 199 FYS: Hispanic Literature and Culture (3 credits)",
"HISP 202 Portuguese Language: Beginners (6 credits)",
"HISP 204 Portuguese Language: Intermed (6 credits)",
"HISP 210 Spanish Language: Beginners (6 credits)",
"HISP 210D1 Spanish Language: Beginners (3 credits)",
"HISP 210D2 Spanish Language: Beginners (3 credits)",
"HISP 218 Spanish Language Intensive - Elementary (6 credits)",
"HISP 219 Spanish Language Intensive - Intermediate (6 credits)",
"HISP 220 Spanish Language: Intermediate (6 credits)",
"HISP 220D1 Spanish Language: Intermediate (3 credits)",
"HISP 220D2 Spanish Language: Intermediate (3 credits)",
"HISP 225 Hispanic Civilization 1 (3 credits)",
"HISP 226 Hispanic Civilization 2 (3 credits)",
"HISP 241 Survey of Spanish Literature and Culture 1 (3 credits)",
"HISP 242 Survey of Spanish Literature and Culture 2 (3 credits)",
"HISP 243 Survey of Latin American Literature and Culture 1 (3 credits)",
"HISP 244 Survey of Latin American Literature and Culture 2 (3 credits)",
"HISP 301 Hispanic Literature and Culture in English 1 (3 credits)",
"HISP 302 Hispanic Literature and Culture in English 2 (3 credits)",
"HISP 303 Hispanic Literature and Culture in English 3 (3 credits)",
"HISP 320 Contemporary Brazilian Literature and Film (3 credits)",
"HISP 321 Hispanic Literature of the 18th Century (3 credits)",
"HISP 324 20th Century Drama (3 credits)",
"HISP 325 Spanish Novel of the 19th Century (3 credits)",
"HISP 326 Spanish Romanticism (3 credits)",
"HISP 327 Literature of Ideas: Spain (3 credits)",
"HISP 328 Literature of Ideas: Latin America (3 credits)",
"HISP 332 Latin American Literature of 19th Century (3 credits)",
"HISP 333 Theatre Performance and Politics in Latin America (3 credits)",
"HISP 340 Latin American Cinema (3 credits)",
"HISP 341 Spanish Cinema (3 credits)",
"HISP 345 Contemporary Hispanic Cultural Studies (3 credits)",
"HISP 347 Queer Iberia (3 credits)",
"HISP 350 Spanish Literature from 1898 to the Civil War (3 credits)",
"HISP 352 Latin American Novel (3 credits)",
"HISP 355 Contemporary Spanish Literature and Culture (3 credits)",
"HISP 356 Latin American Short Story (3 credits)",
"HISP 357 Latin American Digital Literature and Culture (3 credits)",
"HISP 358 Gender and Textualities (3 credits)",
"HISP 425 Topics in Hispanic and Lusophone Visual Cultures (3 credits)",
"HISP 432 Literature - Discovery and Exploration Spain New World (3 credits)",
"HISP 437 Colonial / Postcolonial Latin America (3 credits)",
"HISP 438 Topics: Spanish Literature (3 credits)",
"HISP 439 Topics: Latin American Literature (3 credits)",
"HISP 451 Don Quixote (3 credits)",
"HISP 453 20th Century Latin American Poetry (3 credits)",
"HISP 454 Major Figures: Spanish Literature and Culture (3 credits)",
"HISP 455 Major Figures: Latin American Literature and Culture (3 credits)",
"HISP 457 Medieval Literature (3 credits)",
"HISP 458 Golden Age Literature: Renaissance (3 credits)",
"HISP 460 Golden Age Literature: Baroque (3 credits)",
"HISP 470 Tutorial 01 (3 credits)",
"HISP 471 Tutorial 02 (3 credits)",
"HISP 490 Honours Thesis (6 credits)",
"HISP 490D1 Honours Thesis (3 credits)",
"HISP 490D2 Honours Thesis (3 credits)",
"HISP 499 Internship: Hispanic Studies (3 credits)",
"HISP 505 Seminar in Hispanic Studies 01 (3 credits)",
"HISP 550D1 Comprehensive Examination (3 credits)",
"HISP 550D2 Comprehensive Examination (3 credits)",
"HISP 601D1 M.A. Comprehensive Examination (3 credits)",
"HISP 601D2 M.A. Comprehensive Examination (3 credits)",
"HISP 603 Hispanic Bibliography 1 (3 credits)",
"HISP 604 Hispanic Bibliography 2 (3 credits)",
"HISP 605 Culture and Literature (3 credits)",
"HISP 606 Literature of Ideas (3 credits)",
"HISP 615 Medieval and Golden Age Literature: Grp (9 credits)",
"HISP 616 Modern and Contemporary Spanish Literature: Grp (9 credits)",
"HISP 617 Modern and Contemporary Spanish-American Literature: Grp (9 credits)",
"HISP 620 Spanish Literature of the Middle Ages (3 credits)",
"HISP 625 Spanish Theatre: Golden Age (3 credits)",
"HISP 630 Spanish Poetry: Golden Age (3 credits)",
"HISP 635 Gender and Textualities (3 credits)",
"HISP 640 Cervantes 1 (3 credits)",
"HISP 645 Neoclassicism (3 credits)",
"HISP 650 Realism & Naturalism (3 credits)",
"HISP 651 Fin du Siècle (3 credits)",
"HISP 660 Spanish Literature since Civil War (3 credits)",
"HISP 661 Contemporary Spanish Literature (3 credits)",
"HISP 665 Spanish-American Literature: Colonial Period 1 (3 credits)",
"HISP 666 Spanish-American Literature: Colonial Period 2 (3 credits)",
"HISP 676 Literary Movements (3 credits)",
"HISP 680 Spanish-American Prose (3 credits)",
"HISP 681 Contemporary Spanish-American Literature (3 credits)",
"HISP 690 Special Topics 1 (3 credits)",
"HISP 691 Special Topics 2 (3 credits)",
"HISP 692 Special Topics 3 (3 credits)",
"HISP 693 Special Topics 4 (3 credits)",
"HISP 694 Special Topics 5 (3 credits)",
"HISP 695 Thesis Preparation 1 (3 credits)",
"HISP 695D1 Thesis Preparation 1 (1.5 credits)",
"HISP 695D2 Thesis Preparation 1 (1.5 credits)",
"HISP 695N1 Thesis Preparation 1 (1.5 credits)",
"HISP 695N2 Thesis Preparation 1 (1.5 credits)",
"HISP 696 Thesis Preparation 2 (3 credits)",
"HISP 697 M.A. Thesis (24 credits)",
"HISP 697D1 M.A. Thesis (12 credits)",
"HISP 697D2 M.A. Thesis (12 credits)",
"HISP 698 Reading Course 1 (3 credits)",
"HISP 701 Ph.D. Comprehensive Examination",
"HISP 713 Research Seminar (3 credits)",
"HIST 194 FYS: Jewish Concepts of Others (3 credits)",
"HIST 195 FYS: Sources of World History (3 credits)",
"HIST 197 FYS: Race in Latin America (3 credits)",
"HIST 198 FYS: Nation Building and Nationalism (3 credits)",
"HIST 199 FYS: History (3 credits)",
"HIST 200 Introduction to African History (3 credits)",
"HIST 201 Modern African History (3 credits)",
"HIST 202 Survey: Canada to 1867 (3 credits)",
"HIST 203 Survey: Canada since 1867 (3 credits)",
"HIST 205 Ancient Mediterranean History (3 credits)",
"HIST 206 Indian Ocean World History (3 credits)",
"HIST 207 Jewish History: 400 B.C.E. to 1000 (3 credits)",
"HIST 208 Introduction to East Asian History (3 credits)",
"HIST 209 Introduction to South Asian History (3 credits)",
"HIST 210 Introduction to Latin American History (3 credits)",
"HIST 211 American History to 1865 (3 credits)",
"HIST 212 Medieval Europe (3 credits)",
"HIST 213 World History 600-2000 (3 credits)",
"HIST 214 Early Modern Europe (3 credits)",
"HIST 215 Modern Europe (3 credits)",
"HIST 216 Introduction to Russian History (3 credits)",
"HIST 218 Modern East Asian History (3 credits)",
"HIST 219 Jewish History: 1000 - 2000 (3 credits)",
"HIST 221 United States since 1865 (3 credits)",
"HIST 223 Indigenous Peoples and Empires (3 credits)",
"HIST 226 East Central and Southeastern Europe in 20th Century (3 credits)",
"HIST 238 Histories of Science (3 credits)",
"HIST 240 Modern History of Islamic Movements (3 credits)",
"HIST 249 Health and the Healer in Western History (3 credits)",
"HIST 250 Making Great Britain and Ireland (3 credits)",
"HIST 262 Mediterranean and European Interconnections (3 credits)",
"HIST 275 Ancient Roman History (3 credits)",
"HIST 292 History and the Environment (3 credits)",
"HIST 298 Topics in History (3 credits)",
"HIST 299 The Historian's Craft (3 credits)",
"HIST 301 U.S. Mass Media (3 credits)",
"HIST 302 International Relations History 1: 1750-1950 (3 credits)",
"HIST 303 History of Quebec (3 credits)",
"HIST 304 International Relations History 2: Cold War (3 credits)",
"HIST 306 East Central Europe 1944-2004 (3 credits)",
"HIST 307 Jews in Poland (3 credits)",
"HIST 308 Formation of Chinese Tradition (3 credits)",
"HIST 309 History of Latin America to 1825 (3 credits)",
"HIST 310 Themes in European History (3 credits)",
"HIST 311 The Gilded Age and The Progressive Era (3 credits)",
"HIST 312 History of Consumption in Canada (3 credits)",
"HIST 313 Habsburg Monarchy 1618-1918 (3 credits)",
"HIST 314 Themes: British Isles History (3 credits)",
"HIST 315 Themes in World History (3 credits)",
"HIST 316 History of the Russian Empire (3 credits)",
"HIST 317 Themes in Indian Ocean World History (3 credits)",
"HIST 318 Themes: Modern Japan (3 credits)",
"HIST 319 The Scientific Revolution (3 credits)",
"HIST 320 Themes in Intellectual History (3 credits)",
"HIST 322 History of Forced Migrations (3 credits)",
"HIST 323 History and Sexuality 1 (3 credits)",
"HIST 324 Indigenous Identities and Nationhood (3 credits)",
"HIST 325 Renaissance-Reformation Europe (3 credits)",
"HIST 326 History of the Soviet Union (3 credits)",
"HIST 327 Age of the American Revolution (3 credits)",
"HIST 329 History of Yugoslavia (3 credits)",
"HIST 330 Themes in Canadian History (3 credits)",
"HIST 331 The United States Between the Wars (3 credits)",
"HIST 332 Women in Europe 1350-1700 (3 credits)",
"HIST 333 Indigenous Peoples and French (3 credits)",
"HIST 334 History of New France (3 credits)",
"HIST 335 Science and Medicine in Canada (3 credits)",
"HIST 336 France 1789 to 1914 (3 credits)",
"HIST 338 Twentieth-Century China (3 credits)",
"HIST 339 Arab-Israeli Conflict (3 credits)",
"HIST 340 History of Modern Egypt (3 credits)",
"HIST 341 Themes in South Asian History (3 credits)",
"HIST 342 Canada and the World (3 credits)",
"HIST 343 Women in Post-Confederation Canada (3 credits)",
"HIST 344 The Chinese Family in History (3 credits)",
"HIST 345 History of Italian Renaissance (3 credits)",
"HIST 346 France 1914 to the Present (3 credits)",
"HIST 347 History and Sexuality 2 (3 credits)",
"HIST 349 Greece: From Ottoman to the European Union (3 credits)",
"HIST 350 Science and the Enlightenment (3 credits)",
"HIST 351 Themes in U.S. History since 1865 (3 credits)",
"HIST 353 History of Montreal (3 credits)",
"HIST 354 Women in Europe 1700-2000 (3 credits)",
"HIST 356 Medicine in the Medieval West (3 credits)",
"HIST 357 Cultural Diversity in Canada (3 credits)",
"HIST 358 China's Middle Empires (3 credits)",
"HIST 360 Latin America since 1825 (3 credits)",
"HIST 361 Topics in Canadian Regional History (3 credits)",
"HIST 362 Byzantine History and Historiography (3 credits)",
"HIST 363 Canada 1870-1914 (3 credits)",
"HIST 364 Canada 1914-1945 (3 credits)",
"HIST 365 China's Early Empires (3 credits)",
"HIST 366 Themes in Latin American History (3 credits)",
"HIST 367 Canada since 1945 (3 credits)",
"HIST 368 Greek History: Classical Period (3 credits)",
"HIST 369 Greek History: Early Greece (3 credits)",
"HIST 370 Topics: Canadian Political History (3 credits)",
"HIST 371 American Civil Rights 1877-1940 (3 credits)",
"HIST 372 Themes in Medieval History (3 credits)",
"HIST 373 Canadian Labour History (3 credits)",
"HIST 374 History of Sexuality in Canada (3 credits)",
"HIST 375 Rome: Republic to Empire (3 credits)",
"HIST 376 Fall of the Roman Empire (3 credits)",
"HIST 377 The United States 1940-1965 (3 credits)",
"HIST 378 Early Medieval China (3 credits)",
"HIST 380 The Medieval Mediterranean (3 credits)",
"HIST 381 Colonial Africa (3 credits)",
"HIST 382 History of South Africa (3 credits)",
"HIST 383 Eighteenth-Century Britain (3 credits)",
"HIST 384 Nineteenth-Century Britain (3 credits)",
"HIST 386 Twentieth-Century Britain (3 credits)",
"HIST 387 The First World War (3 credits)",
"HIST 388 The Second World War (3 credits)",
"HIST 389 Topics: African Country Survey (3 credits)",
"HIST 390 Eighteenth-Century France (3 credits)",
"HIST 391 Rise of Rome (3 credits)",
"HIST 392 The United States since 1965 (3 credits)",
"HIST 393 Civil War and Reconstruction (3 credits)",
"HIST 394 British Revolutions 1603-1714 (3 credits)",
"HIST 396 Critical Theory and History (3 credits)",
"HIST 397 Canada: Ethnicity Migration (3 credits)",
"HIST 398 Topics in Italian History (3 credits)",
"HIST 399 History and Historiography (3 credits)",
"HIST 400 Ancient Greece Rome and China (3 credits)",
"HIST 401 Topics: Medieval Culture and Society (3 credits)",
"HIST 403 History of Quebec Institutions (3 credits)",
"HIST 404 The History of Confucius (3 credits)",
"HIST 405 Topics in Intellectual History (3 credits)",
"HIST 406 Topics: Russian History (3 credits)",
"HIST 407 Topics in Ancient History (3 credits)",
"HIST 408 Colonialism and Native Peoples (3 credits)",
"HIST 409 Topics in Latin American History (3 credits)",
"HIST 410 Topics in History of Science (3 credits)",
"HIST 411 African Intellectual History (3 credits)",
"HIST 412 Women and Gender in Modern Britain (3 credits)",
"HIST 414 Canadian Cultural History (3 credits)",
"HIST 417 British & Irish Nationalisms (3 credits)",
"HIST 418 Topics: Atlantic World (3 credits)",
"HIST 419 Central America (3 credits)",
"HIST 420 Gender and Sexuality in Modern China (3 credits)",
"HIST 421 Topics in Early Modern Europe (3 credits)",
"HIST 422 Topics: American Family History (3 credits)",
"HIST 423 Topics: Migration and Ethnicity (3 credits)",
"HIST 424 Gender Sexuality & Medicine (3 credits)",
"HIST 425 European Food History (3 credits)",
"HIST 426 Topics: British Cultural History (3 credits)",
"HIST 427 The Hasidic Movement (3 credits)",
"HIST 428 Topics: History of the Book (3 credits)",
"HIST 429 Topics: Gender/Feminist Histories (3 credits)",
"HIST 430 Topics in Modern Medicine (3 credits)",
"HIST 431 Topics in U.S. History (3 credits)",
"HIST 433 British Queer History (3 credits)",
"HIST 434 British North America 1760-1867 (3 credits)",
"HIST 435 Topics in South Asian History (3 credits)",
"HIST 436 Topics: European History (3 credits)",
"HIST 437 Topics: Issues in Canadian History (3 credits)",
"HIST 438 Topics in Cold War History (3 credits)",
"HIST 439 History of Women in China (3 credits)",
"HIST 440 Fiction and History (3 credits)",
"HIST 441 Topics: Culture and Ritual in China (3 credits)",
"HIST 442 Asian Diaspora: Chinese Overseas (3 credits)",
"HIST 443 Topics: Modern Japan (3 credits)",
"HIST 444 British Colonies: Africa and Asia (3 credits)",
"HIST 445 Late Imperial China (3 credits)",
"HIST 446 Topics in Middle East History (3 credits)",
"HIST 449 Medicine in the Ancient World (3 credits)",
"HIST 450 Ancient History Methods (3 credits)",
"HIST 452 Topics in Pre-Modern Medicine (3 credits)",
"HIST 453 History of Revolution in Europe (3 credits)",
"HIST 454 Marxist Theory (3 credits)",
"HIST 455 Topics: The Global 1960s (3 credits)",
"HIST 457 Topics in Medical History (3 credits)",
"HIST 468 Europe Since 1989 (3 credits)",
"HIST 469 Alexander and Hellenistic World (3 credits)",
"HIST 472 History of European Education (3 credits)",
"HIST 475 Topics: Roman History (3 credits)",
"HIST 478 Pre-modern Chinese Law and Society (3 credits)",
"HIST 480 Democracy and Society in India (3 credits)",
"HIST 481 History of Bangladesh and Pakistan (3 credits)",
"HIST 482 Global History of Coffee (3 credits)",
"HIST 498 Independent Research (3 credits)",
"HIST 499 Internship: History (3 credits)",
"HIST 503 Topics in Modern European History (3 credits)",
"HIST 504 Topics: World History (3 credits)",
"HIST 505 Topics: The British Empire (3 credits)",
"HIST 506 Theory for Historical Studies (3 credits)",
"HIST 507 Topics in Early Modern History (3 credits)",
"HIST 508 The Art of War in China (3 credits)",
"HIST 509 European Intellectual History (3 credits)",
"HIST 510 Environmental History of Latin America (Field) (3 credits)",
"HIST 511 History of Emotions (3 credits)",
"HIST 512 Topics in Chinese History (3 credits)",
"HIST 522 Topics: Canadian International History (3 credits)",
"HIST 525 Women Work and Family in Global History (3 credits)",
"HIST 526 Women and War (3 credits)",
"HIST 527 Topics: Indian Ocean World History (3 credits)",
"HIST 528 Indian Ocean World Slave Trade (3 credits)",
"HIST 530 U.S. Foreign Relations (3 credits)",
"HIST 550D1 Ancient History: Seminar (3 credits)",
"HIST 550D2 Ancient History: Seminar (3 credits)",
"HIST 552 International Relations: Seminar (6 credits)",
"HIST 552D1 International Relations: Seminar (3 credits)",
"HIST 552D2 International Relations Seminar (3 credits)",
"HIST 555D1  (3 credits)",
"HIST 555D2  (3 credits)",
"HIST 556D1 Seminar: Colonial America (3 credits)",
"HIST 556D2 Seminar: Colonial America (3 credits)",
"HIST 558 Modern Medicine: Seminar (3 credits)",
"HIST 559 Modern Medicine: Research (3 credits)",
"HIST 560 World History: Seminar (6 credits)",
"HIST 560D1 World History: Seminar (3 credits)",
"HIST 560D2 World History: Seminar (3 credits)",
"HIST 564D1 Seminar: Latin American History (3 credits)",
"HIST 564D2 Seminar: Latin American History (3 credits)",
"HIST 565 Modern Britain: Seminar (6 credits)",
"HIST 565D1 Modern Britain: Seminar (3 credits)",
"HIST 565D2 Modern Britain: Seminar (3 credits)",
"HIST 567D1 Seminar: Medieval Medicine (3 credits)",
"HIST 567D2 Seminar: Medieval Medicine (3 credits)",
"HIST 568D1 Topics in Chinese History (3 credits)",
"HIST 568D2 Topics in Chinese History (3 credits)",
"HIST 569D1 Topics: Modern French History (3 credits)",
"HIST 569D2 Topics: Modern French History (3 credits)",
"HIST 570D1 Topics: Historical Interpretation (3 credits)",
"HIST 570D2 Topics: Historical Interpretation (3 credits)",
"HIST 571D1 Seminar: Italian Renaissance (3 credits)",
"HIST 571D2 Seminar: Italian Renaissance (3 credits)",
"HIST 572D1 Seminar in Jewish History (3 credits)",
"HIST 572D2 Seminar in Jewish History (3 credits)",
"HIST 573D1 Seminar on Central Europe (3 credits)",
"HIST 573D2 Seminar on Central Europe (3 credits)",
"HIST 574D1 Topics in Comparative History (3 credits)",
"HIST 574D2 Topics in Comparative History (3 credits)",
"HIST 575D1 Topics: Germany (3 credits)",
"HIST 575D2 Topics: Germany (3 credits)",
"HIST 576D1 Seminar: Topics in Russian History (3 credits)",
"HIST 576D2 Seminar: Topics in Russian History (3 credits)",
"HIST 577D1 Seminar: Antiquity to Reformation (3 credits)",
"HIST 577D2 Seminar: Antiquity to Reformation (3 credits)",
"HIST 578D1 Seminar in Japanese History (3 credits)",
"HIST 578D2 Seminar in Japanese History (3 credits)",
"HIST 579D1 Topics: African History (3 credits)",
"HIST 579D2 Topics: African History (3 credits)",
"HIST 580D1 European and Native-American Encounters (3 credits)",
"HIST 580D2 European and Native-American Encounters (3 credits)",
"HIST 586D1 Canada: Diasporas and the State (3 credits)",
"HIST 586D2 Canada: Diasporas and the State (3 credits)",
"HIST 587D1 Topics: Canadian Social History (3 credits)",
"HIST 587D2 Topics: Canadian Social History (3 credits)",
"HIST 588D1 History of Montreal (3 credits)",
"HIST 588D2 History of Montreal (3 credits)",
"HIST 589D1 Topics: History of Women in Canada (3 credits)",
"HIST 589D2 Topics: History of Women in Canada (3 credits)",
"HIST 591D1 Modern Middle East History (3 credits)",
"HIST 591D2 Modern Middle East History (3 credits)",
"HIST 592D1 Topics: Canadian Politics (3 credits)",
"HIST 592D2 Topics: Canadian Politics (3 credits)",
"HIST 593D1 French Atlantic Worlds: Seminar (3 credits)",
"HIST 593D2 French Atlantic Worlds: Seminar (3 credits)",
"HIST 594D1 Seminar in Early Modern Britain (3 credits)",
"HIST 594D2 Seminar in Early Modern Britain (3 credits)",
"HIST 595D1 Seminar: Early Modern Western Europe (3 credits)",
"HIST 595D2 Seminar: Early Modern Western Europe (3 credits)",
"HIST 596D1 Seminar: Canadian Health History (3 credits)",
"HIST 596D2 Seminar: Canadian Health History (3 credits)",
"HIST 597D1 Seminar: Modern Europe (3 credits)",
"HIST 597D2 Seminar: Modern Europe (3 credits)",
"HIST 598D1 Topics in Modern U.S. History (3 credits)",
"HIST 598D2 Topics in Modern U.S. History (3 credits)",
"HIST 599D1 Honours Tutorial (3 credits)",
"HIST 599D2 Honours Tutorial (3 credits)",
"HIST 607 Seminar: Ancient History (3 credits)",
"HIST 611 Subaltern and Decolonial Studies (3 credits)",
"HIST 617 Ancient History Research Methods (3 credits)",
"HIST 618 Readings in East Asian History (3 credits)",
"HIST 621 Bibliography and Research Methods: China (3 credits)",
"HIST 631 Seminar in U.S. History (3 credits)",
"HIST 632 Writing Canadian History (3 credits)",
"HIST 633 New France Research Seminar (3 credits)",
"HIST 634 Topics in Indigenous History (3 credits)",
"HIST 636 Medieval Medicine Seminar 1 (3 credits)",
"HIST 637 Medieval Medicine Seminar 2 (3 credits)",
"HIST 638 Topics in European History (3 credits)",
"HIST 640 Modern Medicine Seminar 1 (3 credits)",
"HIST 641 Modern Medicine Seminar 2 (3 credits)",
"HIST 655 Tutorial (6 credits)",
"HIST 655D1 Tutorial (3 credits)",
"HIST 655D2 Tutorial (3 credits)",
"HIST 656D1 Tutorial (3 credits)",
"HIST 656D2 Tutorial (3 credits)",
"HIST 659 Interdisciplinary Seminar in European Studies (3 credits)",
"HIST 660D1 Topics: African Social History 2 (3 credits)",
"HIST 660D2 Topics: African Social History 2 (3 credits)",
"HIST 678 Historiography (3 credits)",
"HIST 679 Historical Methods (3 credits)",
"HIST 680 Graduate Colloquium 1 (3 credits)",
"HIST 681 Graduate Colloquium 2 (3 credits)",
"HIST 684 Research Proposal (3 credits)",
"HIST 685 Directed Research (3 credits)",
"HIST 686 Bibliography Tutorial (6 credits)",
"HIST 687 M.A. Paper 1 (9 credits)",
"HIST 688 M.A. Paper 2 (6 credits)",
"HIST 693 M.A. Research Paper 3 (9 credits)",
"HIST 694 M.A. Research Paper 4 (9 credits)",
"HIST 696 Thesis Research 1 (9 credits)",
"HIST 696D1 Thesis Research 1 (4.5 credits)",
"HIST 696D2 Thesis Research 1 (4.5 credits)",
"HIST 697 Thesis Research 2 (12 credits)",
"HIST 698 Thesis Research 3 (12 credits)",
"HIST 699 Tutorial (3 credits)",
"HIST 699D1 Tutorial (1.5 credits)",
"HIST 699D2 Tutorial (1.5 credits)",
"HIST 701 Doctoral Seminar (3 credits)",
"HIST 702 Comprehensive Examination - Major Field",
"HIST 702D1 Comprehensive Examination - Major Field",
"HIST 702D2 Comprehensive Examination - Major Field",
"HIST 703 Comprehensive Examination - First Minor Field",
"HIST 703D1 Comprehensive Examination - First Minor Field",
"HIST 703D2 Comprehensive Examination - First Minor Field",
"HIST 704 Comprehensive Examination - Second Minor Field",
"HIST 704D1 Comprehensive Examination - Second Minor Field",
"HIST 704D2 Comprehensive Examination - Second Minor Field",
"HMST 296 Western Humanistic Tradition 1 (3 credits)",
"HMST 297 Western Humanistic Tradition 2 (3 credits)",
"HPSC 300 Independent Studies: History and Philosophy of Science (3 credits)",
"HPSC 500 Interdisciplinary Seminar: History & Philosophy of Science (3 credits)",
"HSED 701 PhD Comprehensive Examination",
"HSED 702D1 Advanced Topics in Health Sciences Education (3 credits)",
"HSED 702D2 Advanced Topics in Health Sciences Education (3 credits)",
"HSED 703 Research Design for Health Sciences Education (3 credits)",
"HSEL 308 Issues in Women's Health (3 credits)",
"HSEL 309 Women's Reproductive Health (3 credits)",
"HSSM 604 History of Medicine (3 credits)",
"HSSM 605 Medical Anthropology (3 credits)",
"HSSM 610 Sociology of Medicine (3 credits)",
"IDFC 500 Indigenous Field Studies (3 credits)",
"IGFS 611 Advanced Issues on Development Food and Agriculture (3 credits)",
"IMED 301 TCP Internal Medicine (7 credits)",
"IMED 401 Internal Medicine Clerkship (8 credits)",
"IMED 401D1 Internal Medicine Clerkship (4 credits)",
"IMED 401D2 Internal Medicine Clerkship (4 credits)",
"IMED 406 Geriatric Medicine - Senior Clerkships (4 credits)",
"IMED 407 Geriatric Medicine Clerkship (4 credits)",
"INDG 200 Introduction to Indigenous Studies (3 credits)",
"INDG 202 Topics in Indigenous Studies 1 (3 credits)",
"INDG 300 Topics in Indigenous Studies 2 (3 credits)",
"INDG 400 Seminar: Indigenous Studies (3 credits)",
"INDG 401 Interdisciplinary Seminar in Indigenous Studies (3 credits)",
"INDG 450 INDG Field Course (3 credits)",
"INDR 294 Introduction to Labour-Management Relations (3 credits)",
"INDR 449 Occupational Health and Safety (3 credits)",
"INDR 459 Comparative Employment Relations (3 credits)",
"INDR 492 Globalization and Labour Policy (3 credits)",
"INDR 494 Labour Law (3 credits)",
"INDR 496 Collective Bargaining (3 credits)",
"INDR 499 Internship in Industrial Relations (3 credits)",
"INDR 603 Industrial Relations (3 credits)",
"INDR 604 Collective Bargaining in Theory and Practice (3 credits)",
"INDR 605 Role of Government: Labour Relations (3 credits)",
"INDR 633 Creating Wealth and Prosperity (3 credits)",
"INDR 690 Advanced Topics in Industrial Relations 1 (3 credits)",
"INDS 101 Molecules Cells and Tissues (6 credits)",
"INDS 102 Musculoskeletal and Blood (6 credits)",
"INDS 103 Gas Fluid and Electrolytes (14 credits)",
"INDS 104 Endocrinology Metabolism and Nutrition (11 credits)",
"INDS 105 Life Cycle (4 credits)",
"INDS 106 Nervous System and Special Senses (12 credits)",
"INDS 111 Molecules to Global Health (6 credits)",
"INDS 112 Respiration (6 credits)",
"INDS 113 Circulation (8 credits)",
"INDS 114 Digestion and Metabolism (8 credits)",
"INDS 115 Renal (6 credits)",
"INDS 116 Defense (6 credits)",
"INDS 117 Infection (6 credits)",
"INDS 118 Movement (6 credits)",
"INDS 119D1 Clinical Method 1 (1.5 credits)",
"INDS 119D2 Clinical Method 1 (1.5 credits)",
"INDS 119J1 Clinical Method 1 (1 credit)",
"INDS 119J2 Clinical Method 1 (1 credit)",
"INDS 119J3 Clinical Method 1 (1 credit)",
"INDS 120 Physicianship 1 (3 credits)",
"INDS 120D1 Physicianship 1 (1.5 credits)",
"INDS 120D2 Physicianship 1 (1.5 credits)",
"INDS 120J1 Physicianship 1 (1 credit)",
"INDS 120J2 Physicianship 1 (1 credit)",
"INDS 120J3 Physicianship 1 (1 credit)",
"INDS 122 Physician Apprenticeship 1 (2 credits)",
"INDS 122D1 Physician Apprenticeship 1 (1 credit)",
"INDS 122D2 Physician Apprenticeship 1 (1 credit)",
"INDS 122J1 Physician Apprenticeship 1 (0.67 credits)",
"INDS 122J2 Physician Apprenticeship 1 (0.67 credits)",
"INDS 122J3 Physician Apprenticeship 1 (0.67 credits)",
"INDS 123D1 Research Fundamentals 1 (1.5 credits)",
"INDS 123D2 Research Fundamentals 1 (1.5 credits)",
"INDS 123J1 Research Fundamentals 1 (1 credit)",
"INDS 123J2 Research Fundamentals 1 (1 credit)",
"INDS 123J3 Research Fundamentals 1 (1 credit)",
"INDS 124D1 Longitudinal Family Medicine Experience (1.5 credits)",
"INDS 124D2 Longitudinal Family Medicine Experience (1.5 credits)",
"INDS 124J1 Longitudinal Family Medicine Experience (1 credit)",
"INDS 124J2 Longitudinal Family Medicine Experience (1 credit)",
"INDS 124J3 Longitudinal Family Medicine Experience (1 credit)",
"INDS 125 Reflection and Evaluation 1",
"INDS 125D1 Reflection and Evaluation 1",
"INDS 125D2 Reflection and Evaluation 1",
"INDS 125J1 Reflection and Evaluation 1",
"INDS 125J2 Reflection and Evaluation 1",
"INDS 125J3 Reflection and Evaluation 1",
"INDS 207 Host Defense and Host/Parasite (12 credits)",
"INDS 208 Pathobiology Treatment & Prevention of Disease (20 credits)",
"INDS 211 Reproduction and Sexuality (6 credits)",
"INDS 212 Human Behaviour (12 credits)",
"INDS 219 Clinical Method 2 (1.5 credits)",
"INDS 220 Physicianship 2 (1 credit)",
"INDS 222 Physician Apprenticeship 2 (1.5 credits)",
"INDS 222D1 Physician Apprenticeship 2 (0.75 credits)",
"INDS 222D2 Physician Apprenticeship 2 (0.75 credits)",
"INDS 222J1 Physician Apprenticeship 2 (0.5 credits)",
"INDS 222J2 Physician Apprenticeship 2 (0.5 credits)",
"INDS 222J3 Physician Apprenticeship 2 (0.5 credits)",
"INDS 223 Research Fundamentals 2 (1.5 credits)",
"INDS 224  Community Health Alliance Project - C.H.A.P (2 credits)",
"INDS 224D1 Community Health Alliance Project - C.H.A.P (1 credit)",
"INDS 224D2 Community Health Alliance Project - C.H.A.P (1 credit)",
"INDS 224J1  Community Health Alliance Project - C.H.A.P (0.67 credits)",
"INDS 224J2 Community Health Alliance Project - C.H.A.P (0.67 credits)",
"INDS 224J3 Community Health Alliance Project - C.H.A.P (0.67 credits)",
"INDS 225 Reflection and Evaluation 2",
"INDS 300 Mindful Medical Practice - Transition to Clinical Practice (1.5 credits)",
"INDS 302 Medical Ethics and Health Law (1.5 credits)",
"INDS 304 Emergency Medicine - Senior Clerkships (4 credits)",
"INDS 305 Transition to Clerkship (1 credit)",
"INDS 320 Formation of the Professional and Healer (1.5 credits)",
"INDS 320D1 Formation of the Professional and Healer (0.75 credits)",
"INDS 320D2 Formation of the Professional and Healer (0.75 credits)",
"INDS 320J1 Formation of the Professional and Healer (0.5 credits)",
"INDS 320J2 Formation of the Professional and Healer (0.5 credits)",
"INDS 320J3 Formation of the Professional and Healer (0.5 credits)",
"INDS 322 Physician Apprenticeship 3 (1.5 credits)",
"INDS 322D1 Physician Apprenticeship 3 (0.75 credits)",
"INDS 322D2 Physician Apprenticeship 3 (0.75 credits)",
"INDS 322J1 Physician Apprenticeship 3 (0.5 credits)",
"INDS 322J2 Physician Apprenticeship 3 (0.5 credits)",
"INDS 322J3 Physician Apprenticeship 3 (0.5 credits)",
"INDS 323 TCP Integrated Assessment ",
"INDS 405 Topics in Medical Science 1 (3 credits)",
"INDS 407 Topics in Medical Science 2 (3 credits)",
"INDS 408 Emergency Medicine Clerkship (4 credits)",
"INDS 420 Physicianship 4 (4 credits)",
"INDS 421 Transition to Residency (8 credits)",
"INDS 422 Physician Apprenticeship 4 (0.5 credits)",
"INDS 422D1 Physician Apprenticeship 4 (0.25 credits)",
"INDS 422D2 Physician Apprenticeship 4 (0.25 credits)",
"INDS 423 Clerkship Integrated Assessment 1",
"INDS 423D1 Clerkship Integrated Assessment 1",
"INDS 423D2 Clerkship Integrated Assessment 1",
"INDS 423J1 Clerkship Integrated Assessment 1",
"INDS 423J2 Clerkship Integrated Assessment 1",
"INDS 423J3 Clerkship Integrated Assessment 1",
"INDS 423N1 Clerkship Integrated Assessment 1",
"INDS 423N2 Clerkship Integrated Assessment 1",
"INDS 424 Clerkship Integrated Assessment 2",
"INDS 424J1 Clerkship Integrated Assessment 2",
"INDS 424J2 Clerkship Integrated Assessment 2",
"INDS 424J3 Clerkship Integrated Assessment 2",
"INDS 424N1 Clerkship Integrated Assessment 2",
"INDS 424N2 Clerkship Integrated Assessment 2",
"INDS 426 Putting It All Together: Basic Science Medicine and Society (6 credits)",
"INDS 427 Public Health and Preventive Medicine Clerkship (1 credit)",
"INSY 331 Managing Information Technology (3 credits)",
"INSY 332 Accounting Information Systems (3 credits)",
"INSY 333 Systems Analysis and Modeling (3 credits)",
"INSY 336 Data Handling and Coding for Analytics (3 credits)",
"INSY 339 IT Consulting (3 credits)",
"INSY 341 Developing Business Applications (3 credits)",
"INSY 430 IT in Financial Markets (3 credits)",
"INSY 431 IT Implementation Management (3 credits)",
"INSY 432 Digital Business Models (3 credits)",
"INSY 434 Topics in Information Systems 1 (3 credits)",
"INSY 437 Managing Data & Databases (3 credits)",
"INSY 440 E-Business (3 credits)",
"INSY 442 Business Intelligence and Data Analytics (3 credits)",
"INSY 444 Online Communities and Open Innovation (3 credits)",
"INSY 446 Data Mining for Business Analytics (3 credits)",
"INSY 448 Text and Social Media Analytics (3 credits)",
"INSY 450 Information Systems Project Management (3 credits)",
"INSY 454 Technological Foundation for E-Commerce (3 credits)",
"INSY 455 Technology and Innovation for Sustainability (3 credits)",
"INSY 605 Systems Analysis and Modelling (3 credits)",
"INSY 606 Technology Management (3 credits)",
"INSY 607 Technology Consulting (3 credits)",
"INSY 608 Winning with IT (3 credits)",
"INSY 609 Technology Project Management (3 credits)",
"INSY 633 Knowledge Management and Technology for Innovation (3 credits)",
"INSY 636 Information Systems Administration (3 credits)",
"INSY 638 Data & Database Management (3 credits)",
"INSY 642 Techniques and Tools for Analytics (3 credits)",
"INSY 645 Managing Electronic Commerce (3 credits)",
"INSY 652 Predictive Analytics (3 credits)",
"INSY 653 Analytics for Digital Business Models (3 credits)",
"INSY 660 Coding Foundations for Analytics (3 credits)",
"INSY 661 Database and Distributed Systems for Analytics (3 credits)",
"INSY 662 Data Mining and Visualization (3 credits)",
"INSY 665 Making Sense of Data (3 credits)",
"INSY 669 Text Analytics (1.5 credits)",
"INSY 670 Social Media Analytics (1.5 credits)",
"INSY 671 Analytics and Open Innovation (1.5 credits)",
"INSY 672 Healthcare Analytics (1.5 credits)",
"INSY 673 Security Analytics (1.5 credits)",
"INSY 690 Advanced Topics in Management Information Systems 1 (3 credits)",
"INSY 691 Adavnced Topics in Management Information Systems 2 (3 credits)",
"INSY 695 Advanced Topics in Information Systems (1.5 credits)",
"INSY 704 Organizational Impacts of Information Technology (3 credits)",
"INSY 705 Seminar in Information Systems (3 credits)",
"INSY 706 Information Technology Acceptance and Usage (3 credits)",
"INSY 707 Strategic Management of IT (3 credits)",
"INSY 708 Technology and Collaboration (3 credits)",
"INSY 709 Information Technology and Digital Economy (3 credits)",
"INTD 200 Introduction to International Development (3 credits)",
"INTD 350 Culture and Development (3 credits)",
"INTD 352 Disasters and Development (3 credits)",
"INTD 354 Civil Society and Development (3 credits)",
"INTD 356 Quantitative Methods for Development (3 credits)",
"INTD 358 Ethnographic Approaches to Development (3 credits)",
"INTD 360 Environmental Challenges in Development (3 credits)",
"INTD 397 Topics in International Development (3 credits)",
"INTD 490 Development Research Project (3 credits)",
"INTD 491 Honours Thesis (3 credits)",
"INTD 491D1 Honours Thesis (1.5 credits)",
"INTD 491D2 Honours Thesis (1.5 credits)",
"INTD 491N1 Honours Thesis (1.5 credits)",
"INTD 491N2 Honours Thesis (1.5 credits)",
"INTD 492 Honours Thesis with Field Research (6 credits)",
"INTD 492D1 Honours Thesis with Field Research (3 credits)",
"INTD 492D2 Honours Thesis with Field Research (3 credits)",
"INTD 492N1 Honours Thesis with Field Research (3 credits)",
"INTD 492N2 Honours Thesis with Field Research (3 credits)",
"INTD 497 Advanced Topics in International Development (3 credits)",
"INTD 498 Honours Seminar in International Development (3 credits)",
"INTD 499 Internship: International Development Studies (3 credits)",
"INTD 597 Seminar in International Development (3 credits)",
"INTD 657 Development Studies Seminar (3 credits)",
"INTG 201 Integrated Management Essentials 1 (3 credits)",
"INTG 202 Integrated Management Essentials 2 (3 credits)",
"IPEA 500 Roles in Interprofessional Teams",
"IPEA 501 Communication in Interprofessional Teams",
"IPEA 502 Patient-Centred Care in Action",
"IPEA 503 Managing Interprofessional Conflict",
"ISLA 199 FYS: Narrations of the Middle East (3 credits)",
"ISLA 200 Islamic Civilization (3 credits)",
"ISLA 210 Muslim Societies (3 credits)",
"ISLA 300 Special Topics 7 (3 credits)",
"ISLA 305 Topics in Islamic History (3 credits)",
"ISLA 310 Women in Islam (3 credits)",
"ISLA 320 Art of Islam (3 credits)",
"ISLA 325 Introduction to Shi'i Islam (3 credits)",
"ISLA 330 Islamic Mysticism:  Sufism (3 credits)",
"ISLA 340 Islamic Law and Human Rights (3 credits)",
"ISLA 345 Science and Civilization in Islam (3 credits)",
"ISLA 350 From Tribe to Dynasty (3 credits)",
"ISLA 355 Modern History of the Middle East (3 credits)",
"ISLA 360 Islam and Politics (3 credits)",
"ISLA 365 Middle East Since the 1970's (3 credits)",
"ISLA 370 The Qur’an: History and Interpretation (3 credits)",
"ISLA 380 Islamic Philosophy and Theology (3 credits)",
"ISLA 383 Central Questions in Islamic Law (3 credits)",
"ISLA 385 Poetics & Politics in Arabic Literature (3 credits)",
"ISLA 388 Persian Literature (3 credits)",
"ISLA 392 Arabic Literature as World Literature (3 credits)",
"ISLA 410 History: Middle-East 1798-1918 (3 credits)",
"ISLA 411 History: Middle-East 1918-1945 (3 credits)",
"ISLA 415 Modern Iran: Anthropological Approach (3 credits)",
"ISLA 420 Indo-Islamic Civilization: Medieval (3 credits)",
"ISLA 421 Islamic Culture - Indian Subcontinent (3 credits)",
"ISLA 430 Islamdom: Baghdad to Cordoba  (3 credits)",
"ISLA 488 Tales of Wonder-Islamic World (3 credits)",
"ISLA 489 Special Topics 6 (3 credits)",
"ISLA 495 World Islamic and Middle East Studies Research Seminar (3 credits)",
"ISLA 496 Independent Reading and Research (3 credits)",
"ISLA 499 World Islamic and Middle East Studies Internship (3 credits)",
"ISLA 501 The Qur'an: Text and History (3 credits)",
"ISLA 502 Art in the Age of Empires (3 credits)",
"ISLA 505 Islam: Origin and Early Development (3 credits)",
"ISLA 506 Islam: Later Developments (3 credits)",
"ISLA 511 Medieval Islam 10th-12th Century (3 credits)",
"ISLA 512 Art of the Ottoman Empire (3 credits)",
"ISLA 515 The Medieval School in Islam (3 credits)",
"ISLA 516 Medieval Islam 13th-15th Century (3 credits)",
"ISLA 521D1 Introductory Arabic (4.5 credits)",
"ISLA 521D2 Introductory Arabic (4.5 credits)",
"ISLA 522 Lower Intermediate Arabic (6 credits)",
"ISLA 522D1 Lower Intermediate Arabic (3 credits)",
"ISLA 522D2 Lower Intermediate Arabic (3 credits)",
"ISLA 523D1 Higher Intermediate Arabic (3 credits)",
"ISLA 523D2 Higher Intermediate Arabic (3 credits)",
"ISLA 524 Advanced Arabic 1 (3 credits)",
"ISLA 525 Advanced Arabic 2 (3 credits)",
"ISLA 526 Colloquial Arabic (3 credits)",
"ISLA 531 Survey Development of Islamic Thought (3 credits)",
"ISLA 532D1 Introductory Turkish (3 credits)",
"ISLA 532D2 Introductory Turkish (3 credits)",
"ISLA 533D1 Lower Intermediate Turkish (3 credits)",
"ISLA 533D2 Lower Intermediate Turkish (3 credits)",
"ISLA 534D1 Higher Intermediate Turkish (3 credits)",
"ISLA 534D2 Higher Intermediate Turkish (3 credits)",
"ISLA 535D1 Advanced Turkish (3 credits)",
"ISLA 535D2 Advanced Turkish (3 credits)",
"ISLA 536 Summer Introductory Arabic 1 (9 credits)",
"ISLA 537 Summer Introductory Arabic 2 (9 credits)",
"ISLA 538 Summer Intermediate Arabic 1 (9 credits)",
"ISLA 539 Summer Intermediate Arabic 2 (9 credits)",
"ISLA 540 Summer Intermediate Arabic 3 (9 credits)",
"ISLA 541D1 Introductory Persian (3 credits)",
"ISLA 541D2 Introductory Persian (3 credits)",
"ISLA 542D1 Lower Intermediate Persian (3 credits)",
"ISLA 542D2 Lower Intermediate Persian (3 credits)",
"ISLA 543 Upper Intermediate Persian 1 (3 credits)",
"ISLA 544 Upper Intermediate Persian 2 (3 credits)",
"ISLA 545 Advanced Persian 1 (3 credits)",
"ISLA 546 Advanced Persian 2 (3 credits)",
"ISLA 551D1 Introductory Urdu-Hindi (3 credits)",
"ISLA 551D2 Introductory Urdu-Hindi (3 credits)",
"ISLA 552D1 Intermediate Urdu-Hindi (3 credits)",
"ISLA 552D2 Intermediate Urdu-Hindi (3 credits)",
"ISLA 553 Advanced Urdu-Hindi 1 (3 credits)",
"ISLA 554 Advanced Urdu-Hindi 2 (3 credits)",
"ISLA 555 Urdu Poetry (3 credits)",
"ISLA 581 Special Topics 1 (3 credits)",
"ISLA 582 Special Topics 2 (3 credits)",
"ISLA 585 Arab Women's Literature (3 credits)",
"ISLA 601 Anthropology and Iranian Studies (3 credits)",
"ISLA 602 Islamic Philosophy & Theology (3 credits)",
"ISLA 603 Introductory: Research Materials - Islamic Studies (3 credits)",
"ISLA 603D1 Introductory: Research Materials - Islamic Studies (1.5 credits)",
"ISLA 603D2 Introductory: Research Materials - Islamic Studies (1.5 credits)",
"ISLA 604 Arabic Manuscript Tradition (3 credits)",
"ISLA 610 Persian Literature (3 credits)",
"ISLA 611 Pre-Modern Islamic History (3 credits)",
"ISLA 612 Autobiography in the Muslim World (3 credits)",
"ISLA 613 Women in Middle Eastern/Islamic Society (3 credits)",
"ISLA 615 Modern Middle Eastern History (3 credits)",
"ISLA 616 Modern Arabic Literature (3 credits)",
"ISLA 670 Islamic Law (3 credits)",
"ISLA 680 Ottoman Institutions (3 credits)",
"ISLA 681 Special Topics 2 (3 credits)",
"ISLA 682 Islamic Politics in Africa (3 credits)",
"ISLA 683 History of Science in Islam (3 credits)",
"ISLA 697 Thesis Research 1 (6 credits)",
"ISLA 698 Thesis Research 2 (6 credits)",
"ISLA 699 Thesis Research 3 (12 credits)",
"ISLA 700D1 Ph.D.Preliminary Examination - Research Seminar",
"ISLA 700D2 Ph.D.Preliminary Examination - Research Seminar",
"ISLA 701 Comprehensive Examination",
"ISLA 706D1 Islamic Law (3 credits)",
"ISLA 706D2 Islamic Law (3 credits)",
"ISLA 707 Qur'an Exegesis (Classical) (3 credits)",
"ISLA 709 Problems in Shi'ah Thought (3 credits)",
"ISLA 716 Islamic Legal Discourse (3 credits)",
"ISLA 723D1 Islamic Developments - Modern India and Pakistan (3 credits)",
"ISLA 723D2 Islamic Developments - Modern India and Pakistan (3 credits)",
"ISLA 735 Special Seminar (3 credits)",
"ISLA 736 Special Topics 3 (3 credits)",
"ISLA 739 Special Seminar (3 credits)",
"ISLA 745 Special Seminar (3 credits)",
"ISLA 749D1 Special Topics 4 (3 credits)",
"ISLA 749D2 Special Topics 4 (3 credits)",
"ISLA 764D1 Ottoman History (3 credits)",
"ISLA 764D2 Ottoman History (3 credits)",
"ISLA 770 Islamic Logic (3 credits)",
"ISLA 777 Islamic Philosophy (3 credits)",
"ISLA 788 Special Topics in Islamic Thought (3 credits)",
"ISLA 789D1 Special Topics 5 (3 credits)",
"ISLA 789D2 Special Topics 5 (3 credits)",
"ITAL 199 FYS: Italy's Literature in Context (3 credits)",
"ITAL 205D1 Italian for Beginners (3 credits)",
"ITAL 205D2 Italian for Beginners (3 credits)",
"ITAL 206 Beginners Italian Intensive (6 credits)",
"ITAL 210D1 Italian for Advanced Beginners (3 credits)",
"ITAL 210D2 Italian for Advanced Beginners (3 credits)",
"ITAL 215D1 Intermediate Italian (3 credits)",
"ITAL 215D2 Intermediate Italian (3 credits)",
"ITAL 216 Intermediate Italian Intensive (6 credits)",
"ITAL 230 Understanding Italy (3 credits)",
"ITAL 250 Italian Literary Composition (3 credits)",
"ITAL 255 Advanced Reading and Composition (6 credits)",
"ITAL 260 Reading Italian Literature (3 credits)",
"ITAL 265 The Italian Short Story (3 credits)",
"ITAL 270 Manzoni: Novel and Nationhood (3 credits)",
"ITAL 281 Masterpieces of Italian Literature 2 (3 credits)",
"ITAL 290 Commedia Dell'Arte (3 credits)",
"ITAL 295 Italian Cultural Studies (3 credits)",
"ITAL 307 Topics in Italian Culture (3 credits)",
"ITAL 309 Perspectives on Italy (3 credits)",
"ITAL 310 The Invention of Italian Literature (3 credits)",
"ITAL 329 Italian Cinematic Tradition (3 credits)",
"ITAL 332 Italian Theatrical Traditions (3 credits)",
"ITAL 341 The Art of Essay Writing (3 credits)",
"ITAL 345 Romanticism in Italy (3 credits)",
"ITAL 355 Dante and the Middle Ages (3 credits)",
"ITAL 356 Medieval Discourses on Love (3 credits)",
"ITAL 360 Contemporary Italian Prose (3 credits)",
"ITAL 361 Modern Italian Literature (3 credits)",
"ITAL 362 Post-World War 2 Literature and Society (3 credits)",
"ITAL 363 Gender Literature and Society (3 credits)",
"ITAL 365 The Italian Renaissance (3 credits)",
"ITAL 368 Literature of the Renaissance (3 credits)",
"ITAL 371 The Italian Baroque (3 credits)",
"ITAL 374 Classics of Italian Cinema (3 credits)",
"ITAL 375 Cinema and Society in Modern Italy (3 credits)",
"ITAL 376 Italian Epic Poetry (3 credits)",
"ITAL 380 Italian Realisms (3 credits)",
"ITAL 383 Women's Writing since 1880 (3 credits)",
"ITAL 385 Italian Futurist Movement (3 credits)",
"ITAL 395 Interdisciplinary Seminar (3 credits)",
"ITAL 400 Italian Regional Identities (3 credits)",
"ITAL 410 Italian Modernism (3 credits)",
"ITAL 411 Pirandello (3 credits)",
"ITAL 416 The Twentieth Century (3 credits)",
"ITAL 420 Leopardi Poet and Philosopher (3 credits)",
"ITAL 435 Petrarch and His Legacy (3 credits)",
"ITAL 436 Tasso's 'Gerusalemme Liberata' (3 credits)",
"ITAL 444 Individual Reading Course (3 credits)",
"ITAL 450 Italy and the Visual Age (3 credits)",
"ITAL 464 Machiavelli (3 credits)",
"ITAL 465 Religious Identities in Italy (3 credits)",
"ITAL 470 Joint Honours Thesis (3 credits)",
"ITAL 471D1 Honours Thesis (3 credits)",
"ITAL 471D2 Honours Thesis (3 credits)",
"ITAL 472 Honours Thesis (Intensive) (6 credits)",
"ITAL 477 Italian Cinema and Video (3 credits)",
"ITAL 499 Internship: Italian Studies (3 credits)",
"ITAL 542 History of Italian Language (3 credits)",
"ITAL 551 Boccaccio and the Italian Novella (3 credits)",
"ITAL 560 Topics in 19th & 20th Century Literature (3 credits)",
"ITAL 563 13th-16th Century Literature (3 credits)",
"ITAL 591 Italian Literary Criticism (3 credits)",
"ITAL 602 The Literary Tradition (3 credits)",
"ITAL 602D1 The Literary Tradition (1.5 credits)",
"ITAL 602D2 The Literary Tradition (1.5 credits)",
"ITAL 602J1 The Literary Tradition (1 credit)",
"ITAL 602J2 The Literary Tradition (1 credit)",
"ITAL 602J3 The Literary Tradition (1 credit)",
"ITAL 602N1 The Literary Tradition (1.5 credits)",
"ITAL 602N2 The Literary Tradition (1.5 credits)",
"ITAL 606 Individual Reading Course 1 (3 credits)",
"ITAL 607 Individual Reading Course 2 (3 credits)",
"ITAL 610 Bibliography of Italian Literature (3 credits)",
"ITAL 610D1 Bibliography of Italian Literature (1.5 credits)",
"ITAL 610D2 Bibliography of Italian Literature (1.5 credits)",
"ITAL 619 Topics in Literary Theory (3 credits)",
"ITAL 631 Italian Humanism (3 credits)",
"ITAL 640 Italian Literature and Western Cultural Tradition (3 credits)",
"ITAL 645 Topics in Italian Cinema (3 credits)",
"ITAL 680 Research Seminar (3 credits)",
"ITAL 680D1 Research Seminar (1.5 credits)",
"ITAL 680D2 Research Seminar (1.5 credits)",
"ITAL 690 Research Paper 1 (9 credits)",
"ITAL 690D1 Research Paper 1 (4.5 credits)",
"ITAL 690D2 Research Paper 1 (4.5 credits)",
"ITAL 690N1 Research Paper 1 (4.5 credits)",
"ITAL 690N2 Research Paper 1 (4.5 credits)",
"ITAL 691 Research Paper 2 (9 credits)",
"ITAL 691D1 Research Paper 2 (4.5 credits)",
"ITAL 691D2 Research Paper 2 (4.5 credits)",
"ITAL 691N1 Research Paper 2 (4.5 credits)",
"ITAL 691N2 Research Paper 2 (4.5 credits)",
"ITAL 698 Thesis Proposal (6 credits)",
"ITAL 698D1 Thesis Proposal (3 credits)",
"ITAL 698D2 Thesis Proposal (3 credits)",
"ITAL 698J1 Thesis Proposal (2 credits)",
"ITAL 698J2 Thesis Proposal (2 credits)",
"ITAL 698J3 Thesis Proposal (2 credits)",
"ITAL 698N1 Thesis Proposal (3 credits)",
"ITAL 698N2 Thesis Proposal (3 credits)",
"ITAL 699 Thesis (18 credits)",
"ITAL 699D1 Thesis (9 credits)",
"ITAL 699D2 Thesis (9 credits)",
"ITAL 699J1 Thesis (6 credits)",
"ITAL 699J2 Thesis (6 credits)",
"ITAL 699J3 Thesis (6 credits)",
"ITAL 699N1 Thesis (9 credits)",
"ITAL 699N2 Thesis (9 credits)",
"ITAL 701 Comprehensive Examination",
"ITAL 710 Topics in Italian Literature 1 (3 credits)",
"ITAL 720 Topics in Italian Literature 2 (3 credits)",
"ITAL 780 Student Staff Seminar (3 credits)",
"ITAL 790 Ph.D. Language Requirement",
"JWST 199 FYS: Images - Jewish Identities (3 credits)",
"JWST 201 Jewish Law (3 credits)",
"JWST 202 Introduction to Jewish Music (3 credits)",
"JWST 205 Introduction to Jewish Literature (3 credits)",
"JWST 206 Introduction to Yiddish Literature (3 credits)",
"JWST 211 Jewish Studies 1: Biblical Period (3 credits)",
"JWST 216 Jewish Studies 2: 400 B.C.E. - 1000 (3 credits)",
"JWST 217 Jewish Studies 3: 1000 - 2000 (3 credits)",
"JWST 220 Introductory Hebrew (6 credits)",
"JWST 220D1 Introductory Hebrew (3 credits)",
"JWST 220D2 Introductory Hebrew (3 credits)",
"JWST 225 Literature and Society (3 credits)",
"JWST 226 Contemporary Israeli Fiction (3 credits)",
"JWST 240 The Holocaust (3 credits)",
"JWST 245 Jewish Life in the Islamic World (3 credits)",
"JWST 252 Interdisciplinary Lectures (3 credits)",
"JWST 254 The Jewish Holy Days (3 credits)",
"JWST 261 History of Jewish Philosophy & Thought (3 credits)",
"JWST 262 Modern Jewish Philosophy (3 credits)",
"JWST 281 Introductory Yiddish 1 (3 credits)",
"JWST 282 Introductory Yiddish 2 (3 credits)",
"JWST 300 Charisma and Social Change (3 credits)",
"JWST 303 The Soviet Jewish Experience (3 credits)",
"JWST 306 The American Jewish Community (3 credits)",
"JWST 309 Jews in Film (3 credits)",
"JWST 310 Believers Heretics and Critics (3 credits)",
"JWST 311 Gender in Jewish History (3 credits)",
"JWST 312 Modern Jewish History (3 credits)",
"JWST 313 Jewish Life in Modern Times (3 credits)",
"JWST 314 Denominations in North American Judaism (3 credits)",
"JWST 315 Modern Liberal Jewish Thought (3 credits)",
"JWST 316 Social and Ethical Issues Jewish Law 1 (3 credits)",
"JWST 318 Judaism and Environment: Moral Dilemmas in Literature (3 credits)",
"JWST 319 Judaism and the Occult (3 credits)",
"JWST 320 Intermediate Hebrew (6 credits)",
"JWST 320D1 Intermediate Hebrew (3 credits)",
"JWST 320D2 Intermediate Hebrew (3 credits)",
"JWST 323 The Israeli Novel (3 credits)",
"JWST 325 Israeli Literature in Translation (3 credits)",
"JWST 327 A Book of the Bible (3 credits)",
"JWST 328 A Book of the Bible (3 credits)",
"JWST 329 A Book of the Bible (3 credits)",
"JWST 330 Topics in the Hebrew Bible (3 credits)",
"JWST 333 The Hebrew Liturgy (3 credits)",
"JWST 334 Jews and Muslims: A Modern History (3 credits)",
"JWST 337 Jewish Philosophy and Thought 1 (3 credits)",
"JWST 338 Jewish Philosophy and Thought 2 (3 credits)",
"JWST 340 Advanced Hebrew (6 credits)",
"JWST 340D1 Advanced Hebrew (3 credits)",
"JWST 340D2 Advanced Hebrew (3 credits)",
"JWST 345 Introduction to Rabbinic Literature (3 credits)",
"JWST 346 Modern Jewish Studies (3 credits)",
"JWST 347 Modern Jewish Studies (3 credits)",
"JWST 348 Modern Jewish Studies (3 credits)",
"JWST 349 Modern Jewish Studies (3 credits)",
"JWST 350 Major Jewish Authors (3 credits)",
"JWST 351 Studies in Modern Jewish Literature (3 credits)",
"JWST 353 Interdisciplinary Approaches to Jewish Studies 1 (3 credits)",
"JWST 354 Interdisciplinary Lectures 2 (3 credits)",
"JWST 355 The Yiddish Canon (3 credits)",
"JWST 358 Topics in Jewish Philosophy 1 (3 credits)",
"JWST 359 Topics in Jewish Philosophy 2 (3 credits)",
"JWST 361 The Shtetl: 1500-1897 (3 credits)",
"JWST 365 Modern Jewish Ideologies (3 credits)",
"JWST 366 History of Zionism (3 credits)",
"JWST 367 Hebrew Language and Israeli Culture 1 (3 credits)",
"JWST 368 Hebrew Language and Israeli Culture 2 (3 credits)",
"JWST 369 Hebrew Language and Israeli Culture 3 (3 credits)",
"JWST 370 Hebrew Language and Israeli Culture 4 (3 credits)",
"JWST 371 Jews and the City (3 credits)",
"JWST 376 Topics in Jewish Music 1 (3 credits)",
"JWST 377 Topics in Jewish Music 2 (3 credits)",
"JWST 381 God and Devil in Modern Yiddish Literature (3 credits)",
"JWST 382 Jews Judaism and Social Justice (3 credits)",
"JWST 383 Holocaust Literature (3 credits)",
"JWST 384 Yiddish: Intermediate 1 (3 credits)",
"JWST 385 Yiddish: Intermediate 2 (3 credits)",
"JWST 386 American Jewish Literature (3 credits)",
"JWST 387 Modern Jewish Authors (3 credits)",
"JWST 403 Contemporary Hebrew Literature (3 credits)",
"JWST 404 Literary Response to Loss/Separation (3 credits)",
"JWST 430 Tutorial in Hebrew Literature (3 credits)",
"JWST 445 The Poetry of Nationalism (3 credits)",
"JWST 474 Maimonides' Mishneh Torah (3 credits)",
"JWST 475 The Responsa Literature (3 credits)",
"JWST 480 Advanced Yiddish 1 (3 credits)",
"JWST 481 Advanced Yiddish 2 (3 credits)",
"JWST 485 Tutorial in Yiddish Literature (3 credits)",
"JWST 486 Tutorial in Yiddish Literature (3 credits)",
"JWST 491 Honours Thesis 1 (3 credits)",
"JWST 492 Honours Thesis 2 (3 credits)",
"JWST 499 Internship: Jewish Studies (3 credits)",
"JWST 500 Directed Readings 1 (3 credits)",
"JWST 501 Directed Readings 2 (3 credits)",
"JWST 502 Directed Readings 3 (3 credits)",
"JWST 503 Directed Readings 4 (3 credits)",
"JWST 504 Seminar in Jewish Thought (3 credits)",
"JWST 510 Jewish Bible Interpretation 1 (3 credits)",
"JWST 511 Jewish Bible Interpretation 2 (3 credits)",
"JWST 520 Bible Interpretation in Antiquity (3 credits)",
"JWST 530 Topics in Yiddish Literature (3 credits)",
"JWST 538 Early Rabbinic Parshanut 1 (3 credits)",
"JWST 541 Medieval Ashkenazi Parshanut (3 credits)",
"JWST 542 Abraham Ibn Ezra as Parshan (3 credits)",
"JWST 543 Maimonides as Parshan (3 credits)",
"JWST 546 Innovative Medieval Parshanut (3 credits)",
"JWST 548 Medieval Parshanut (3 credits)",
"JWST 552 Judaism and Poverty (3 credits)",
"JWST 554 Modern Jewish Biblical Scholarship (3 credits)",
"JWST 558 Topics: Modern Jewish Thought (3 credits)",
"JWST 562 Medieval Islamic and Jewish Philosophy (3 credits)",
"JWST 571 Biblical Literature (3 credits)",
"JWST 573 History of Hebrew Bible Text (3 credits)",
"JWST 575 Topics in Parshanut (3 credits)",
"JWST 576 Jewish Family Law (3 credits)",
"JWST 581 Aramaic Language (3 credits)",
"JWST 585 Tutorial: Eastern European Studies 1 (3 credits)",
"JWST 586 Tutorial: Eastern European Studies 2 (3 credits)",
"JWST 587 Tutorial in Yiddish Literature (3 credits)",
"JWST 588 Tutorial in Yiddish Literature (3 credits)",
"JWST 600 Directed Readings 5 (3 credits)",
"JWST 601 Directed Readings 6 (3 credits)",
"JWST 602 East European Jewish History 1 (3 credits)",
"JWST 604 Topics: In Jewish Thought (3 credits)",
"JWST 615 Literary Analysis of Hebrew Fiction (3 credits)",
"JWST 690 M.A. Thesis 1 (3 credits)",
"JWST 690D1 M.A. Thesis 1 (1.5 credits)",
"JWST 690D2 M.A. Thesis 1 (1.5 credits)",
"JWST 690N1 M.A. Thesis 1 (1.5 credits)",
"JWST 690N2 M.A. Thesis 1 (1.5 credits)",
"JWST 691 M.A. Thesis 2 (6 credits)",
"JWST 692 M.A. Thesis 3 (12 credits)",
"JWST 692D1 M.A. Thesis 3 (6 credits)",
"JWST 692D2 M.A. Thesis 3 (6 credits)",
"JWST 692N1 M.A. Thesis 3 (6 credits)",
"JWST 692N2 M.A. Thesis 3 (6 credits)",
"JWST 694 M.A. Thesis 4 (3 credits)",
"JWST 695 M.A. Thesis 1 (9 credits)",
"JWST 696 M.A. Thesis 2 (9 credits)",
"JWST 697 M.A. Thesis 3 (12 credits)",
"JWST 699 Research in Jewish Studies (3 credits)",
"JWST 791 Comprehensive Examination (3 credits)",
"JWST 791D1 Comprehensive Examination (1.5 credits)",
"JWST 791D2 Comprehensive Examination (1.5 credits)",
"LACS 480 Latin American and Caribbean Studies Reading Course (3 credits)",
"LACS 497 Research Seminar: Latin America and the Caribbean (3 credits)",
"LACS 498 Honours Thesis (3 credits)",
"LACS 499 Internship: Latin America and Caribbean Studies (3 credits)",
"LAWG 100D1 Contractual Obligations (3 credits)",
"LAWG 100D2 Contractual Obligations (3 credits)",
"LAWG 101D1 Extra-Contractual Obligations/Torts (3 credits)",
"LAWG 101D2 Extra-Contractual Obligations/Torts (3 credits)",
"LAWG 102D1 Criminal Justice (3 credits)",
"LAWG 102D2 Criminal Justice (3 credits)",
"LAWG 103 Indigenous Legal Traditions (3 credits)",
"LAWG 110D1 Integration Workshop (1.5 credits)",
"LAWG 110D2 Integration Workshop (1.5 credits)",
"LAWG 200 Commercial Law (3 credits)",
"LAWG 210 Legal Ethics and Professionalism (3 credits)",
"LAWG 220D1 Property (3 credits)",
"LAWG 220D2 Property (3 credits)",
"LAWG 273 Family Law (3 credits)",
"LAWG 300 Family Property Law (3 credits)",
"LAWG 316 Private International Law (3 credits)",
"LAWG 400 Secured Transactions (4 credits)",
"LAWG 400D1 Secured Transactions (2 credits)",
"LAWG 400D2 Secured Transactions (2 credits)",
"LAWG 415 Evidence (Civil Matters) (3 credits)",
"LAWG 426 Evidence (Criminal Matters) (3 credits)",
"LAWG 500 Complex Legal Transactions 1 (3 credits)",
"LAWG 502 Sustainable Development (3 credits)",
"LAWG 503 Inter-American Human Rights (3 credits)",
"LAWG 504 Death and Property (3 credits)",
"LAWG 505 Critical Engagements with Human Rights (3 credits)",
"LAWG 506 Advanced Civil Law Property (3 credits)",
"LAWG 507 Critical Race Theory Advanced Seminar (3 credits)",
"LAWG 508D1 Indigenous Constitutionalism (3 credits)",
"LAWG 508D2 Indigenous Constitutionalism (3 credits)",
"LAWG 511 Specialized Topics in Law 1 (1 credit)",
"LAWG 512 Specialized Topics in Law 2 (1 credit)",
"LAWG 513 Specialized Topics in Law 3 (2 credits)",
"LAWG 514 Specialized Topics in Law 4 (2 credits)",
"LAWG 515 Specialized Topics in Law 5 (3 credits)",
"LAWG 516 Specialized Topics in Law 6 (3 credits)",
"LAWG 516D1 Specialized Topics in Law 6 (1.5 credits)",
"LAWG 516D2 Specialized Topics in Law 6 (1.5 credits)",
"LAWG 517 Specialized Topics in Law 7 (3 credits)",
"LAWG 518 Specialized Topics in Law 8 (3 credits)",
"LAWG 519 Specialized Topics in Law 9 (3 credits)",
"LAWG 519D1 Specialized Topics in Law 9 (1.5 credits)",
"LAWG 519D2 Specialized Topics in Law 9 (1.5 credits)",
"LAWG 520 Specialized Topics in Law 10 (3 credits)",
"LAWG 521 Student-Initiated Seminar 1 (3 credits)",
"LAWG 522 Student-Initiated Seminar 2 (3 credits)",
"LAWG 523 Tax Practice Seminar (3 credits)",
"LAWG 530 Specialized Topics in Law 11 (3 credits)",
"LAWG 531 Specialized Topics in Law 12 (3 credits)",
"LAWG 532 Specialized Topics in Law 13 (3 credits)",
"LAWG 533 Specialized Topics in Law 14 (3 credits)",
"LAWG 534 Specialized Topics in Law 15 (3 credits)",
"LAWG 535 Specialized Topics in Law 16 (3 credits)",
"LAWG 536 Specialized Topics in Law 17 (3 credits)",
"LAWG 537 Specialized Topics in Law 18 (3 credits)",
"LAWG 538 Specialized Topics in Law 19 (3 credits)",
"LAWG 539 Specialized Topics in Law 20 (3 credits)",
"LAWG 550 Law Focus Week Workshop 1 (1 credit)",
"LAWG 551 Law Focus Week Workshop 2 (1 credit)",
"LAWG 552 Law Focus Week Workshop 3 (1 credit)",
"LAWG 553 Law Focus Week Workshop 4 (1 credit)",
"LAWG 554 Law Focus Week Workshop 5 (1 credit)",
"LAWG 555 Law Focus Week Workshop 6 (1 credit)",
"LAWG 560 Law Innovation (3 credits)",
"LAWG 570 Innovation for Non-Law Students (3 credits)",
"LAWG 601 Communication 1 (1.5 credits)",
"LAWG 602 Communication 2 (1.5 credits)",
"LAWG 625 Legal Education Seminar (3 credits)",
"LAWG 659 Interdisciplinary Seminar in European Studies (3 credits)",
"LAWG 701 Comprehensive Exam - Law",
"LAWG 702 Legal Research Methodology for DCL (2 credits)",
"LAWG 703 Literature Review Analysis and Proposal",
"LAWG 704 DCL Research Seminar 1",
"LAWG 705 DCL Research Seminar 2",
"LEEL 369 Labour Law (3 credits)",
"LEEL 570 Employment Law (3 credits)",
"LEEL 582 Law and Poverty (3 credits)",
"LIBA 202 Introduction to Liberal Arts (3 credits)",
"LIBA 395 Individual Reading Course (3 credits)",
"LIBA 402 Seminar in Liberal Arts (3 credits)",
"LIBA 490 Honours Thesis (3 credits)",
"LING 199 First Year Seminar: Language and Mind (3 credits)",
"LING 200 Introduction to the Study of Language (3 credits)",
"LING 201 Introduction to Linguistics (3 credits)",
"LING 210 Introduction to Speech Science (3 credits)",
"LING 211 Introduction to Indigenous Languages (3 credits)",
"LING 215 Languages of the World (3 credits)",
"LING 260 Meaning in Language (3 credits)",
"LING 301 Structure of English (3 credits)",
"LING 320 Sociolinguistics 1 (3 credits)",
"LING 325 Canadian English (3 credits)",
"LING 330 Phonetics (3 credits)",
"LING 331 Phonology 1 (3 credits)",
"LING 350 Linguistic Aspects of Bilingualism (3 credits)",
"LING 355 Language Acquisition 1 (3 credits)",
"LING 360 Introduction to Semantics (3 credits)",
"LING 371 Syntax 1 (3 credits)",
"LING 390 Neuroscience of Language (3 credits)",
"LING 410 Structure of a Specific Language 1 (3 credits)",
"LING 411 Structure of an Indigenous Language (3 credits)",
"LING 415 Field Methods of Linguistics (3 credits)",
"LING 417 Topics at the Interfaces 1 (3 credits)",
"LING 418 Topics at the Interfaces 2 (3 credits)",
"LING 419 Linguistic Theory and  its Foundations (3 credits)",
"LING 425 Historical Linguistics (3 credits)",
"LING 440 Morphology (3 credits)",
"LING 445 Computational Linguistics (3 credits)",
"LING 450 Laboratory Linguistics (3 credits)",
"LING 451 Acquisition of Phonology (3 credits)",
"LING 455 Second Language Syntax (3 credits)",
"LING 460 Semantics 2 (3 credits)",
"LING 461 Formal Methods in Linguistics (3 credits)",
"LING 480 Honours Thesis (6 credits)",
"LING 480D1 Honours Thesis (3 credits)",
"LING 480D2 Honours Thesis (3 credits)",
"LING 480N1 Honours Thesis (3 credits)",
"LING 480N2 Honours Thesis (3 credits)",
"LING 481D1 Joint Honours Thesis (1.5 credits)",
"LING 481D2 Joint Honours Thesis (1.5 credits)",
"LING 483 Special Topics 1 (3 credits)",
"LING 484 Special Topics 2 (3 credits)",
"LING 485 Special Topics 3 (3 credits)",
"LING 488 Independent Study 1 (3 credits)",
"LING 489 Independent Study 2 (3 credits)",
"LING 499 Internship: Linguistics (3 credits)",
"LING 520 Sociolinguistics 2 (3 credits)",
"LING 521 Dialectology (3 credits)",
"LING 530 Acoustic Phonetics (3 credits)",
"LING 531 Phonology 2 (3 credits)",
"LING 555 Language Acquisition 2 (3 credits)",
"LING 565 Pragmatics (3 credits)",
"LING 571 Syntax 2 (3 credits)",
"LING 583 Special Topics 4 (3 credits)",
"LING 590 Language Acquisition and Breakdown (3 credits)",
"LING 601 Graduate Research Seminar 1 (3 credits)",
"LING 602 Graduate Research Seminar 2 (3 credits)",
"LING 605 M.A. Research 1 (3 credits)",
"LING 606 M.A. Research 2 (3 credits)",
"LING 607 M.A. Research Paper (9 credits)",
"LING 610 Linguistic Field Research (3 credits)",
"LING 611 Analysis of an Indigenous Language (3 credits)",
"LING 619 Experimental Linguistics:  Foundations (3 credits)",
"LING 620 Experimental Linguistics: Methods (3 credits)",
"LING 630 Phonetics 3 (3 credits)",
"LING 631 Phonology 3 (3 credits)",
"LING 635 Phonetics and Phonology 4 (3 credits)",
"LING 640 Fundamentals of Morphology (3 credits)",
"LING 645 Computational Research on Language (3 credits)",
"LING 650 Testing Theories in the Laboratory (3 credits)",
"LING 651 Topics in Acquisition of Phonology (3 credits)",
"LING 655 Theory of L2 Acquisition (3 credits)",
"LING 660 Semantics 3 (3 credits)",
"LING 661 Advanced Formal Methods (3 credits)",
"LING 665 Semantics 4 (3 credits)",
"LING 671 Syntax 3 (3 credits)",
"LING 675 Syntax 4 (3 credits)",
"LING 682 Selected Topics 1 (3 credits)",
"LING 683 Selected Topics 2 (3 credits)",
"LING 688 Tutorial 1 (3 credits)",
"LING 706 Ph.D. Evaluation 1",
"LING 707 Ph.D. Evaluation 2",
"LING 710 Language Acquisition Issues 2 (2 credits)",
"LING 721 Advanced Seminar 1 (3 credits)",
"LING 722 Advanced Seminar 2 (3 credits)",
"LING 735 Seminar in Phonology (3 credits)",
"LING 751 Advanced Seminar: Experimental 1 (3 credits)",
"LING 752 Advanced Seminar: Experimental 2 (3 credits)",
"LING 765 Seminar in Semantics (3 credits)",
"LING 775 Seminar in Syntax (3 credits)",
"LING 782 Selected Topics 3 (3 credits)",
"LING 783 Selected Topics 4 (3 credits)",
"LING 788 Tutorial 2 (3 credits)",
"LING 789 Tutorial 3 (3 credits)",
"LLCU 199 FYS: Literary Animals (3 credits)",
"LLCU 200 Topics in Film (3 credits)",
"LLCU 201 Literature and Culture Topics (3 credits)",
"LLCU 210 Introduction to European Literature & Culture (3 credits)",
"LLCU 212 Understanding Digital and Social Media (3 credits)",
"LLCU 220 Introduction to Literary Analysis (3 credits)",
"LLCU 230 Environmental Imaginations (3 credits)",
"LLCU 250 History and Future of the Book (3 credits)",
"LLCU 255 Introduction to Literary Text Mining I (3 credits)",
"LLCU 279 Introduction to Film History (3 credits)",
"LLCU 300 Cinema and the Visual (3 credits)",
"LLCU 301 Topics in Culture and Thought (3 credits)",
"LLCU 311 Digital Studies/Citizenry (3 credits)",
"LLCU 498 Digital Project (3 credits)",
"LLCU 602 The Digital Humanities (3 credits)",
"LLCU 603 Visual Culture (3 credits)",
"LLCU 604 Special Topics in Film (3 credits)",
"LLCU 606 Topics in Literature (3 credits)",
"LLCU 607 Topics in Thought (3 credits)",
"LLCU 609 Literary Theory (3 credits)",
"LLCU 610 Teaching Language (3 credits)",
"LLCU 612 Literary Text Mining (3 credits)",
"LLCU 614 Cultural Analytics (3 credits)",
"LLCU 689 Digital Humanities Project Management (6 credits)",
"LLCU 696 Thesis Research 1 (6 credits)",
"LLCU 697 Thesis Research 2 (6 credits)",
"LLCU 698 Thesis Research 3 (6 credits)",
"LLCU 699 Thesis Research 4 (6 credits)",
"LLCU 701 PhD Comprehensive Examination",
"LSCI 202 Molecular Cell Biology (3 credits)",
"LSCI 204 Genetics (3 credits)",
"LSCI 211 Biochemistry 1 (3 credits)",
"LSCI 230 Introductory Microbiology (3 credits)",
"LSCI 451 Research Project 1 (3 credits)",
"LSCI 452 Research Project 2 (3 credits)",
"MATH 111 Mathematics for Education Students (3 credits)",
"MATH 112 Fundamentals of Mathematics (3 credits)",
"MATH 122 Calculus for Management (3 credits)",
"MATH 123 Linear Algebra and Probability (3 credits)",
"MATH 125 Mathematical Techniques for Economics (3 credits)",
"MATH 133 Linear Algebra and Geometry (3 credits)",
"MATH 134 Enriched Linear Algebra and Geometry (3 credits)",
"MATH 139 Calculus 1 with Precalculus (4 credits)",
"MATH 140 Calculus 1 (3 credits)",
"MATH 141 Calculus 2 (4 credits)",
"MATH 150 Calculus A (4 credits)",
"MATH 151 Calculus B (4 credits)",
"MATH 180 The Art of Mathematics (3 credits)",
"MATH 203 Principles of Statistics 1 (3 credits)",
"MATH 204 Principles of Statistics 2 (3 credits)",
"MATH 208 Introduction to Statistical Computing (3 credits)",
"MATH 222 Calculus 3 (3 credits)",
"MATH 223 Linear Algebra (3 credits)",
"MATH 228 Classical Geometry (3 credits)",
"MATH 235 Algebra 1 (3 credits)",
"MATH 236 Algebra 2 (3 credits)",
"MATH 240 Discrete Structures (3 credits)",
"MATH 242 Analysis 1 (3 credits)",
"MATH 243 Analysis 2 (3 credits)",
"MATH 247 Honours Applied Linear Algebra (3 credits)",
"MATH 248 Honours Vector Calculus (3 credits)",
"MATH 249 Honours Complex Variables (3 credits)",
"MATH 251 Honours Algebra 2 (3 credits)",
"MATH 254 Honours Analysis 1 (3 credits)",
"MATH 255 Honours Analysis 2 (3 credits)",
"MATH 262 Intermediate Calculus (3 credits)",
"MATH 263 Ordinary Differential Equations for Engineers (3 credits)",
"MATH 264 Advanced Calculus for Engineers (3 credits)",
"MATH 270 Applied Linear Algebra (3 credits)",
"MATH 271 Linear Algebra and Partial Differential Equations (3 credits)",
"MATH 308 Fundamentals of Statistical Learning (3 credits)",
"MATH 314 Advanced Calculus (3 credits)",
"MATH 315 Ordinary Differential Equations (3 credits)",
"MATH 316 Complex Variables (3 credits)",
"MATH 317 Numerical Analysis (3 credits)",
"MATH 318 Mathematical Logic (3 credits)",
"MATH 319 Introduction to Partial Differential Equations (3 credits)",
"MATH 320 Differential Geometry (3 credits)",
"MATH 323 Probability (3 credits)",
"MATH 324 Statistics (3 credits)",
"MATH 325 Honours Ordinary Differential Equations (3 credits)",
"MATH 326 Nonlinear Dynamics and Chaos (3 credits)",
"MATH 327 Matrix Numerical Analysis (3 credits)",
"MATH 329 Theory of Interest (3 credits)",
"MATH 335 Computational Algebra (3 credits)",
"MATH 338 History and Philosophy of Mathematics (3 credits)",
"MATH 340 Discrete Mathematics (3 credits)",
"MATH 346 Number Theory (3 credits)",
"MATH 348 Euclidean Geometry (3 credits)",
"MATH 350 Honours Discrete Mathematics (3 credits)",
"MATH 352 Problem Seminar (1 credit)",
"MATH 356 Honours Probability (3 credits)",
"MATH 357 Honours Statistics (3 credits)",
"MATH 358 Honours Advanced Calculus (3 credits)",
"MATH 376 Honours Nonlinear Dynamics (3 credits)",
"MATH 377 Honours Number Theory (3 credits)",
"MATH 381 Complex Variables and Transforms (3 credits)",
"MATH 387 Honours Numerical Analysis (3 credits)",
"MATH 396 Undergraduate Research Project (3 credits)",
"MATH 397 Honours Matrix Numerical Analysis (3 credits)",
"MATH 398 Honours Euclidean Geometry (3 credits)",
"MATH 407 Dynamic Programming (3 credits)",
"MATH 410 Majors Project (3 credits)",
"MATH 417 Linear Optimization (3 credits)",
"MATH 420 Independent Study (3 credits)",
"MATH 423 Applied Regression (3 credits)",
"MATH 427 Statistical Quality Control (3 credits)",
"MATH 430 Mathematical Finance (3 credits)",
"MATH 437 Mathematical Methods in Biology (3 credits)",
"MATH 447 Introduction to Stochastic Processes (3 credits)",
"MATH 454 Honours Analysis 3 (3 credits)",
"MATH 455 Honours Analysis 4 (3 credits)",
"MATH 456 Honours Algebra 3 (3 credits)",
"MATH 457 Honours Algebra 4 (3 credits)",
"MATH 458 Honours Differential Geometry (3 credits)",
"MATH 466 Honours Complex Analysis (3 credits)",
"MATH 470 Honours Research Project (3 credits)",
"MATH 470D1 Honours Research Project (1.5 credits)",
"MATH 470D2 Honours Research Project (1.5 credits)",
"MATH 475 Honours Partial Differential Equations (3 credits)",
"MATH 478 Computational Methods in Applied Mathematics (3 credits)",
"MATH 480 Honours Independent Study (3 credits)",
"MATH 488 Honours Set Theory (3 credits)",
"MATH 517 Honours Linear Optimization (4 credits)",
"MATH 523 Generalized Linear Models (4 credits)",
"MATH 524 Nonparametric Statistics (4 credits)",
"MATH 525 Sampling Theory and Applications (4 credits)",
"MATH 533 Regression and Analysis of Variance (4 credits)",
"MATH 537 Honours Mathematical Models in Biology (4 credits)",
"MATH 540 Life Actuarial Mathematics (4 credits)",
"MATH 541 Nonlife Actuarial Models (4 credits)",
"MATH 545 Introduction to Time Series Analysis (4 credits)",
"MATH 547 Stochastic Processes (4 credits)",
"MATH 550 Combinatorics (4 credits)",
"MATH 552 Combinatorial Optimization (4 credits)",
"MATH 553 Algorithmic Game Theory (4 credits)",
"MATH 555 Fluid Dynamics (4 credits)",
"MATH 556 Mathematical Statistics 1 (4 credits)",
"MATH 557 Mathematical Statistics 2 (4 credits)",
"MATH 560 Optimization (4 credits)",
"MATH 564 Advanced Real Analysis 1 (4 credits)",
"MATH 565 Advanced Real Analysis 2 (4 credits)",
"MATH 566 Advanced Complex Analysis (4 credits)",
"MATH 567 Introduction to Functional Analysis (4 credits)",
"MATH 570 Higher Algebra 1 (4 credits)",
"MATH 571 Higher Algebra 2 (4 credits)",
"MATH 574 Dynamical Systems (4 credits)",
"MATH 576 Geometry and Topology 1 (4 credits)",
"MATH 577 Geometry and Topology 2 (4 credits)",
"MATH 578 Numerical Analysis 1 (4 credits)",
"MATH 579 Numerical Differential Equations (4 credits)",
"MATH 580 Partial Differential Equations 1 (4 credits)",
"MATH 581 Partial Differential Equations 2 (4 credits)",
"MATH 582 Algebraic Topology (4 credits)",
"MATH 583 Geometric Group Theory (4 credits)",
"MATH 587 Advanced Probability Theory 1 (4 credits)",
"MATH 589 Advanced Probability Theory 2 (4 credits)",
"MATH 590 Advanced Set Theory (4 credits)",
"MATH 591 Mathematical Logic 1 (4 credits)",
"MATH 592 Mathematical Logic 2 (4 credits)",
"MATH 594 Topics in Mathematics and Statistics (4 credits)",
"MATH 595 Topics in Analysis (4 credits)",
"MATH 596 Topics in Algebra & Number Theory (4 credits)",
"MATH 597 Topics in Applied Mathematics (4 credits)",
"MATH 598 Topics in Probability and Statistics (4 credits)",
"MATH 599 Topics in Geometry & Topology (4 credits)",
"MATH 600 Master's Thesis Research 1 (6 credits)",
"MATH 601 Master's Thesis Research 2 (6 credits)",
"MATH 602 Master's Research Preparation (6 credits)",
"MATH 604 Master's Thesis Research 3 (6 credits)",
"MATH 605 Master's Thesis Research 4 (6 credits)",
"MATH 635 Functional Analysis 1 (4 credits)",
"MATH 638 Partial Differential Equations 4 (4 credits)",
"MATH 640 Project 1 (8 credits)",
"MATH 641 Project 2 (8 credits)",
"MATH 666 Seminar Mathematics and Statistics 1 (2 credits)",
"MATH 667 Seminar Mathematics and Statistics 2 (2 credits)",
"MATH 669D1 CSE Seminar (0.5 credits)",
"MATH 669D2 CSE Seminar (0.5 credits)",
"MATH 671 Applied Stochastic Processes (4 credits)",
"MATH 680 Computation Intensive Statistics (4 credits)",
"MATH 681 Time Series Analysis (4 credits)",
"MATH 682 Statistical Inference (4 credits)",
"MATH 685D1 Statistical Consulting (2 credits)",
"MATH 685D2 Statistical Consulting (2 credits)",
"MATH 686 Survival Analysis (4 credits)",
"MATH 687 Reading Course in Mathematical Logic (4 credits)",
"MATH 689 Reading Course in Algebra (4 credits)",
"MATH 690 Reading Course in Number Theory (4 credits)",
"MATH 691 Reading Course in Geometry/Topology (4 credits)",
"MATH 693 Reading Course in Analysis (4 credits)",
"MATH 695 Reading Course in Applied Mathematics (4 credits)",
"MATH 697 Reading Course in Statistics (4 credits)",
"MATH 698 Reading Course in Probability (4 credits)",
"MATH 699 Reading Course in Discrete Mathematics (4 credits)",
"MATH 700 Ph.D. Comprehensive Examination Part A",
"MATH 701 Ph.D. Comprehensive Examination Part B",
"MATH 704 Advanced Topics in Mathematical Logic (4 credits)",
"MATH 706 Advanced Topics in Geometry and Topology 1 (4 credits)",
"MATH 707 Advanced Topics in Geometry and Topology 2 (4 credits)",
"MATH 720 Advanced Topics in Algebra 1 (4 credits)",
"MATH 721 Advanced Topics in Algebra 2 (4 credits)",
"MATH 722 Advanced Topics in Algebraic Geometry (4 credits)",
"MATH 723 Advanced Topics in Group Theory (4 credits)",
"MATH 726 Advanced Topics in Number Theory (4 credits)",
"MATH 727 Advanced Topics in Arithmetic Geometry (4 credits)",
"MATH 740 Advanced Topics in Analysis 1 (4 credits)",
"MATH 741 Advanced Topics in Analysis 2 (4 credits)",
"MATH 742 Advanced Topics in Mathematical Physics (4 credits)",
"MATH 743 Advanced Topics in Microlocal Analysis (4 credits)",
"MATH 744 Advanced Topics in Spectral Theory (4 credits)",
"MATH 756 Advanced Topics in Optimization (4 credits)",
"MATH 758 Advanced Topics in Discrete Mathematics (4 credits)",
"MATH 761 Advanced Topics in Applied Mathematics 1 (4 credits)",
"MATH 762 Advanced Topics in Applied Mathematics 2 (4 credits)",
"MATH 763 Advanced Topics in Differential Equations (4 credits)",
"MATH 764 Advanced Topics in Partial Differential Equations (4 credits)",
"MATH 765 Advanced Topics in Numerical Analysis (4 credits)",
"MATH 782 Advanced Topics in Statistics 1 (4 credits)",
"MATH 783 Advanced Topics in Statistics 2 (4 credits)",
"MATH 784 Advanced Topics in Probability (4 credits)",
"MDPH 396 Undergraduate Research Project (3 credits)",
"MDPH 601 Radiation Physics (3 credits)",
"MDPH 602 Radiotherapy Physics (3 credits)",
"MDPH 603 Laboratory Radiotherapy Physics (2 credits)",
"MDPH 607 Medical Imaging (3 credits)",
"MDPH 608 Laboratory - Diagnostic Radiology and Nuclear Medicine (2 credits)",
"MDPH 609 Radiation Biology (2 credits)",
"MDPH 612 Instrumentation and Computation in Medical Physics (3 credits)",
"MDPH 613 Health Physics (2 credits)",
"MDPH 614 Physics of Diagnostic Radiology (3 credits)",
"MDPH 615 Physics of Nuclear Medicine (2 credits)",
"MDPH 617 Advanced MRI Image Acquisition & Analysis (2 credits)",
"MDPH 618 Anatomy and Physiology for Medical Physics (3 credits)",
"MDPH 690 M.Sc. Thesis Research (24 credits)",
"MDPH 690D1 M.Sc. Thesis Research (12 credits)",
"MDPH 690D2 M.Sc. Thesis Research (12 credits)",
"MDPH 690N1 M.Sc. Thesis Research (12 credits)",
"MDPH 690N2 M.Sc. Thesis Research (12 credits)",
"MDPH 702 Advanced Topics in Radiation Oncology Physics Research (3 credits)",
"MDPH 704 Computational Methods in Radiotherapy and Imaging (3 credits)",
"MDST 400 Interdisciplinary Seminar in Medieval Studies (3 credits)",
"MECH 201 Introduction to Mechanical Engineering (2 credits)",
"MECH 210 Mechanics 1 (2 credits)",
"MECH 220 Mechanics 2 (4 credits)",
"MECH 240 Thermodynamics 1 (3 credits)",
"MECH 260 Machine Tool Laboratory (2 credits)",
"MECH 261 Measurement Laboratory (2 credits)",
"MECH 262 Statistics and Measurement Laboratory (3 credits)",
"MECH 289 Design Graphics (3 credits)",
"MECH 290 Design Graphics for Mechanical Engineering (3 credits)",
"MECH 292 Design 1: Conceptual Design (3 credits)",
"MECH 309 Numerical Methods in Mechanical Engineering (3 credits)",
"MECH 314 Dynamics of Mechanisms (3 credits)",
"MECH 315 Mechanics 3 (4 credits)",
"MECH 321 Mechanics of Deformable Solids (3 credits)",
"MECH 331 Fluid Mechanics 1 (3 credits)",
"MECH 341 Thermodynamics 2 (3 credits)",
"MECH 346 Heat Transfer (3 credits)",
"MECH 360 Principles of Manufacturing (3 credits)",
"MECH 362 Mechanical Laboratory 1 (2 credits)",
"MECH 383 Applied Electronics and Instrumentation (3 credits)",
"MECH 393 Design 2: Machine Element Design (3 credits)",
"MECH 403D1 Thesis (Honours) (3 credits)",
"MECH 403D2 Thesis (Honours) (3 credits)",
"MECH 403N1 Thesis (Honours) (3 credits)",
"MECH 403N2 Thesis (Honours) (3 credits)",
"MECH 404 Honours Thesis 2 (3 credits)",
"MECH 412 System Dynamics and Control (3 credits)",
"MECH 419 Advanced Mechanics of Systems (4 credits)",
"MECH 430 Fluid Mechanics 2 (3 credits)",
"MECH 447 Combustion (3 credits)",
"MECH 463D1 Design 3: Mechanical Engineering Project (3 credits)",
"MECH 463D2 Design 3: Mechanical Engineering Project (3 credits)",
"MECH 494 Honours Design Project (3 credits)",
"MECH 497 Value Engineering (3 credits)",
"MECH 498 Interdisciplinary Design Project 1 (3 credits)",
"MECH 499 Interdisciplinary Design Project 2 (3 credits)",
"MECH 500 Selected Topics in Mechanical Engineering (3 credits)",
"MECH 501 Special Topics: Mechanical Engineering (3 credits)",
"MECH 502 Topics in Mechanical Engineering (3 credits)",
"MECH 510 Engineering Acoustics (3 credits)",
"MECH 513 Control Systems (3 credits)",
"MECH 515 Unsteady Gasdynamics (3 credits)",
"MECH 516 Computational Gasdynamics (3 credits)",
"MECH 524 Computer Integrated Manufacturing (3 credits)",
"MECH 526 Manufacturing and the Environment (3 credits)",
"MECH 528 Product Design (3 credits)",
"MECH 529 Discrete Manufacturing Systems (3 credits)",
"MECH 530 Mechanics of Composite Materials (3 credits)",
"MECH 532 Aircraft Performance Stability and Control (3 credits)",
"MECH 533 Subsonic Aerodynamics (3 credits)",
"MECH 534 Air Pollution Engineering (3 credits)",
"MECH 535 Turbomachinery and Propulsion (3 credits)",
"MECH 536 Aerospace Structures (3 credits)",
"MECH 537 High-Speed Aerodynamics (3 credits)",
"MECH 538 Unsteady Aerodynamics (3 credits)",
"MECH 539 Computational Aerodynamics (3 credits)",
"MECH 541 Kinematic Synthesis (3 credits)",
"MECH 542 Spacecraft Dynamics (3 credits)",
"MECH 543 Design with Composite Materials (3 credits)",
"MECH 544 Processing of Composite Materials (3 credits)",
"MECH 546 Finite Element Methods in Solid Mechanics (3 credits)",
"MECH 547 Mechanics of Biological Materials (3 credits)",
"MECH 548 Cellular Materials in Natural and Engineering Structures (3 credits)",
"MECH 550 Vibrations of Continuous Systems (3 credits)",
"MECH 551 Nonlinear Dynamics of Shell Structures (3 credits)",
"MECH 553 Design and Manufacture of Microdevices (3 credits)",
"MECH 554 Microprocessors for Mechanical Systems (3 credits)",
"MECH 556 Microfluidics and BioMEMS (3 credits)",
"MECH 557 Mechatronic Design (3 credits)",
"MECH 559 Engineering Systems Optimization (3 credits)",
"MECH 560 Eco-design and Product Life Cycle Assessment (3 credits)",
"MECH 561 Biomechanics of Musculoskeletal Systems (3 credits)",
"MECH 562 Advanced Fluid Mechanics (3 credits)",
"MECH 563 Biofluids and Cardiovascular Mechanics (3 credits)",
"MECH 565 Fluid Flow and Heat Transfer Equipment (3 credits)",
"MECH 566 Fluid-Structure Interactions (3 credits)",
"MECH 567 Structural Dynamics of Turbomachines (3 credits)",
"MECH 572 Mechanics and Control of Robotic Manipulators (3 credits)",
"MECH 573 Mechanics of Robotic Systems (3 credits)",
"MECH 577 Optimum Design (3 credits)",
"MECH 578 Advanced Thermodynamics (3 credits)",
"MECH 579 Multidisciplinary Design Optimization (3 credits)",
"MECH 600 Advanced Topics in Mechanical Engineering 1 (4 credits)",
"MECH 602 Advanced Topics in Mechanical Engineering 2 (3 credits)",
"MECH 603 M. Eng. Project 1 (9 credits)",
"MECH 604 M. Eng. Project 2 (3 credits)",
"MECH 605 Applied Mathematics 1 (4 credits)",
"MECH 609 Seminar (1 credit)",
"MECH 610 Fundamentals of Fluid Dynamics (4 credits)",
"MECH 616 Viscous Flow and Boundary Layer Theory (4 credits)",
"MECH 620 Advanced Computational Aerodynamics (4 credits)",
"MECH 627 Manufacturing Industrial Stage (9 credits)",
"MECH 628 Manufacturing Case Studies (2 credits)",
"MECH 628D1 Manufacturing Case Studies (1 credit)",
"MECH 628D2 Manufacturing Case Studies (1 credit)",
"MECH 629 Manufacturing Industrial Seminar (1 credit)",
"MECH 629D1 Manufacturing Industrial Seminar (0.5 credits)",
"MECH 629D2 Manufacturing Industrial Seminar (0.5 credits)",
"MECH 632 Advanced Mechanics of Materials (4 credits)",
"MECH 642 Advanced Dynamics (4 credits)",
"MECH 650 Fundamentals of Heat Transfer (4 credits)",
"MECH 652 Dynamics of Combustion (4 credits)",
"MECH 654 Compt. Fluid Flow and Heat Transfer (4 credits)",
"MECH 656 Fundamentals of Turbulent Flow (4 credits)",
"MECH 661 Finite Element Methods in Computational Fluid Dynamics (4 credits)",
"MECH 669 Computational Science Engineering Seminar (1 credit)",
"MECH 681 Aeronautics Project (6 credits)",
"MECH 687 Aerospace Case Studies (3 credits)",
"MECH 688 Industrial Stage (6 credits)",
"MECH 691 M.Eng. Thesis Literature Review (3 credits)",
"MECH 692 M.Eng. Thesis Research Proposal (4 credits)",
"MECH 693 M.Eng. Thesis Progress Report 1 (3 credits)",
"MECH 694 M.Eng. Thesis Progress Report 2 (6 credits)",
"MECH 695 M.Eng. Thesis (12 credits)",
"MECH 700 Ph.D. Literature Review",
"MECH 701 Ph.D. Thesis Proposal",
"MECH 702 Ph.D. Comprehensive Preliminary Oral Examination",
"MGCR 211 Introduction to Financial Accounting (3 credits)",
"MGCR 222 Introduction to Organizational Behaviour (3 credits)",
"MGCR 271 Business Statistics (3 credits)",
"MGCR 273 Introductory Management Statistics (3 credits)",
"MGCR 293 Managerial Economics (3 credits)",
"MGCR 331 Information Systems (3 credits)",
"MGCR 341 Introduction to Finance (3 credits)",
"MGCR 352 Principles of Marketing (3 credits)",
"MGCR 360 Social Context of Business (3 credits)",
"MGCR 382 International Business (3 credits)",
"MGCR 423 Strategic Management (3 credits)",
"MGCR 472 Operations Management (3 credits)",
"MGCR 610 Research Paper (6 credits)",
"MGCR 610D1 Research Paper (3 credits)",
"MGCR 610D2 Research Paper (3 credits)",
"MGCR 610J1 Research Paper (2 credits)",
"MGCR 610J2 Research Paper (2 credits)",
"MGCR 610J3 Research Paper (2 credits)",
"MGCR 611 Financial Accounting (2 credits)",
"MGCR 612 Organizational Behaviour (2 credits)",
"MGCR 613 Managerial Economics (1.5 credits)",
"MGCR 614 Management Statistics (1.5 credits)",
"MGCR 616 Marketing (2 credits)",
"MGCR 617 Operations Management (1.5 credits)",
"MGCR 618 Leadership and Professional Skills (1.5 credits)",
"MGCR 618D1 Leadership and Professional Skills (0.75 credits)",
"MGCR 618D2 Leadership and Professional Skills (0.75 credits)",
"MGCR 618J1 Leadership and Professional Skills (0.5 credits)",
"MGCR 618J2 Leadership and Professional Skills (0.5 credits)",
"MGCR 618J3 Leadership and Professional Skills (0.5 credits)",
"MGCR 619 Research Development and Engineering (1 credit)",
"MGCR 620 Information Systems (1.5 credits)",
"MGCR 621 International Environment (1.5 credits)",
"MGCR 622 Organizational Strategy (1.5 credits)",
"MGCR 628 Integrative Course (1.5 credits)",
"MGCR 628D1 Integrative Course (0.75 credits)",
"MGCR 628D2 Integrative Course (0.75 credits)",
"MGCR 628J1 Integrative Course (0.5 credits)",
"MGCR 628J2 Integrative Course (0.5 credits)",
"MGCR 628J3 Integrative Course (0.5 credits)",
"MGCR 629 Global Leadership (1 credit)",
"MGCR 638 Marketing Management (1.5 credits)",
"MGCR 639 Managing Organizational Behaviour (1.5 credits)",
"MGCR 640 Accounting and Financial Reporting (1.5 credits)",
"MGCR 641 Elements of Modern Finance 1 (2 credits)",
"MGCR 642 Financial Reporting (1.5 credits)",
"MGCR 650 Business Tools (2 credits)",
"MGCR 651 Managing Resources (4 credits)",
"MGCR 651D1 Managing Resources (2 credits)",
"MGCR 651D2 Managing Resources (2 credits)",
"MGCR 652 Value Creation (4 credits)",
"MGCR 652D1 Value Creation (2 credits)",
"MGCR 652D2 Value Creation (2 credits)",
"MGCR 653 Markets and Globalization (4 credits)",
"MGCR 660 International Study Trip (4.5 credits)",
"MGCR 660D1 International Study Trip (2.25 credits)",
"MGCR 660D2 International Study Trip (2.25 credits)",
"MGCR 661 International Study Experience (6 credits)",
"MGMT 690 Advanced Topics in International Business 1 (3 credits)",
"MGMT 701 Comprehensive Examination",
"MGMT 706 Seminar in Pedagogy (3 credits)",
"MGMT 707 Research Methodology (3 credits)",
"MGMT 708 General Research Methods (3 credits)",
"MGMT 710 Seminars in Management (3 credits)",
"MGMT 711 Seminars in Management (3 credits)",
"MGMT 712 Seminars in Management (3 credits)",
"MGMT 713 Seminars in Management (3 credits)",
"MGMT 720 Research Paper (3 credits)",
"MGMT 721 Special Topics in Management (3 credits)",
"MGPO 362 Fundamentals of Entrepreneurship (3 credits)",
"MGPO 364 Entrepreneurship in Practice (3 credits)",
"MGPO 365 Business-Government Relations (3 credits)",
"MGPO 383 International Business Policy (3 credits)",
"MGPO 402 Dynamic Cities (3 credits)",
"MGPO 430 Practicum in Not for Profit Consulting (3 credits)",
"MGPO 432 Topics in Entrepreneurship (3 credits)",
"MGPO 433 Topics in Social Business and Enterprise (3 credits)",
"MGPO 434 Topics in Policy 1 (3 credits)",
"MGPO 435 The Origins of Capitalism (3 credits)",
"MGPO 438 Social Entrepreneurship and Innovation (3 credits)",
"MGPO 440 Strategies for Sustainability (3 credits)",
"MGPO 445 Industry Analysis & Competitive Strategy (3 credits)",
"MGPO 450 Ethics in Management (3 credits)",
"MGPO 460 Managing Innovation (3 credits)",
"MGPO 468 Managing Organizational Politics (3 credits)",
"MGPO 469 Managing Globalization (3 credits)",
"MGPO 470 Strategy and Organization (3 credits)",
"MGPO 475 Strategies for Developing Countries (3 credits)",
"MGPO 567 Business in Society (3 credits)",
"MGPO 615 Consulting for Change (3 credits)",
"MGPO 630 Managing Strategy and Innovation (3 credits)",
"MGPO 637 Cases in Competitive Strategy (3 credits)",
"MGPO 638 Managing Organizational Politics (3 credits)",
"MGPO 640 Strategies for Sustainable Development (3 credits)",
"MGPO 645 Strategy in Context (3 credits)",
"MGPO 650 Managing Innovation (3 credits)",
"MGPO 651 Strategic Management: Developing Countries (3 credits)",
"MGPO 669 Managing Globalization (3 credits)",
"MGPO 683 International Business Policy (3 credits)",
"MGPO 690 Advanced Topics in Strategic Management 1 (3 credits)",
"MGPO 691 Advanced Topics in Strategic Management 2 (3 credits)",
"MGPO 692 Advanced Topics in Strategic Management 3 (3 credits)",
"MGPO 695 Advanced Topics in Strategy Analytics (1.5 credits)",
"MGPO 701 Seminar in Qualitative Methods (3 credits)",
"MGPO 702 New Paradigms: Strategic Management (3 credits)",
"MGPO 704 Organizational Theory Seminar (3 credits)",
"MGPO 705 Seminar in Policy (3 credits)",
"MGPO 706 Perspectives on Innovation (3 credits)",
"MGPO 707 International Business and Government (3 credits)",
"MGPO 708 Seminar in Strategic Management (3 credits)",
"MGPO 709 Social Networks: Concepts Theory and Applications (3 credits)",
"MGSC 372 Advanced Business Statistics (3 credits)",
"MGSC 373 Operations Research 1 (3 credits)",
"MGSC 401 Statistical Foundations of Data Analytics (3 credits)",
"MGSC 402 Operations Strategy (3 credits)",
"MGSC 403 Introduction to Logistics Management (3 credits)",
"MGSC 404 Foundations of Decision Analytics (3 credits)",
"MGSC 405 Quality Management (3 credits)",
"MGSC 415 Supplier Management (3 credits)",
"MGSC 431 Operations and Supply Chain Analysis (3 credits)",
"MGSC 434 Topics in Operations Management (3 credits)",
"MGSC 479 Applied Optimization (3 credits)",
"MGSC 488 Sustainability and Operations (3 credits)",
"MGSC 575 Applied Time Series Analysis Managerial Forecasting (3 credits)",
"MGSC 578 Simulation of Management Systems (3 credits)",
"MGSC 602 Strategic Management of Operations (3 credits)",
"MGSC 603 Logistics Management (3 credits)",
"MGSC 605 Total Quality Management (3 credits)",
"MGSC 608 Data Decisions and Models (3 credits)",
"MGSC 615 Procurement and Distribution (3 credits)",
"MGSC 616 Technology in Action (3 credits)",
"MGSC 631 Analysis: Production Operations (3 credits)",
"MGSC 640 Fundamentals of Decision Analytics (3 credits)",
"MGSC 641D1 Operations Management in Health Services (1 credit)",
"MGSC 641D2 Operations Management in Health Services (1 credit)",
"MGSC 642D1 Quality Management in Healthcare (1 credit)",
"MGSC 642D2 Quality Management in Healthcare (1 credit)",
"MGSC 650 Operations and Risk Analytics (3 credits)",
"MGSC 656 Analytics Consulting (3 credits)",
"MGSC 660 Mathematical and Statistical Foundations for Analytics (3 credits)",
"MGSC 661 Multivariate Statistical Analysis (3 credits)",
"MGSC 662 Decision Analytics (3 credits)",
"MGSC 670 Revenue Management (1.5 credits)",
"MGSC 672 Operations and Supply Chain Analytics (1.5 credits)",
"MGSC 673 Introduction to Artificial Intelligence and Deep Learning (1.5 credits)",
"MGSC 679 Applied Deterministic Optimization (3 credits)",
"MGSC 690 Advanced Topics in Management Science 1 (3 credits)",
"MGSC 695 Advanced Topics in Management Science (1.5 credits)",
"MGSC 702 Operations Management Seminar (3 credits)",
"MGSC 706 Management Research Statistics (3 credits)",
"MGSC 708 Healthcare Operations Management (3 credits)",
"MGSC 709 Manufacturing Systems (3 credits)",
"MGSC 710 Applied Optimization (3 credits)",
"MGSC 711 Public Sector Operations Management (3 credits)",
"MHEC 600 Création de valeur (4 credits)",
"MHEC 601 Excellence opérationnelle (4 credits)",
"MHEC 602 Outils et pratiques de gestion (4 credits)",
"MICR 300 Microbial Physiology Laboratory (3 credits)",
"MICR 331 Microbial Ecology (3 credits)",
"MICR 338 Bacterial Molecular Genetics (3 credits)",
"MICR 341 Mechanisms of Pathogenicity (3 credits)",
"MICR 450 Environmental Microbiology (3 credits)",
"MICR 772 Molecular Microbiology (3 credits)",
"MICR 773 Advanced Environmental Microbiology (3 credits)",
"MIME 200 Introduction to the Minerals Industry (3 credits)",
"MIME 202 Engineering Communication Skills (2 credits)",
"MIME 203 Mine Surveying (2 credits)",
"MIME 209 Mathematical Applications (3 credits)",
"MIME 212 Engineering Thermodynamics (3 credits)",
"MIME 250 Introduction to Extractive Metallurgy (3 credits)",
"MIME 260 Materials Science and Engineering (3 credits)",
"MIME 261 Structure of Materials (3 credits)",
"MIME 262 Properties of Materials in Electrical Engineering (3 credits)",
"MIME 280 Industrial Training 1 (2 credits)",
"MIME 290 Industrial Work Period 1 (2 credits)",
"MIME 291 Industrial Work Period 2 (2 credits)",
"MIME 308 Social Impact of Technology (3 credits)",
"MIME 311 Modelling and Automatic Control (3 credits)",
"MIME 317 Analytical and Characterization Techniques (3 credits)",
"MIME 320 Extraction of Energy Resources (3 credits)",
"MIME 322 Rock Fragmentation (3 credits)",
"MIME 323 Rock and Soil Mass Characterization (3 credits)",
"MIME 325 Mineral Industry Economics (3 credits)",
"MIME 329 Mining Geology (2 credits)",
"MIME 330 Mining Geotechnics (3 credits)",
"MIME 333 Materials Handling (3 credits)",
"MIME 340 Applied Fluid Dynamics (3 credits)",
"MIME 341 Introduction to Mineral Processing (3 credits)",
"MIME 345 Applications of Polymers (3 credits)",
"MIME 350 Extractive Metallurgical Engineering (3 credits)",
"MIME 352 Hydrochemical Processing (3 credits)",
"MIME 356 Heat Mass and Fluid Flow (4 credits)",
"MIME 360 Phase Transformations: Solids (3 credits)",
"MIME 362 Mechanical Properties (3 credits)",
"MIME 380 Industrial Training 2 (2 credits)",
"MIME 392 Industrial Work Period 3 (2 credits)",
"MIME 410 Materials Research Project (3 credits)",
"MIME 413 Strategic Mine Planning With Uncertainty (3 credits)",
"MIME 419 Surface Mining (3 credits)",
"MIME 421 Rock Mechanics (3 credits)",
"MIME 422 Mine Ventilation (3 credits)",
"MIME 424 Underground Mining Methods (3 credits)",
"MIME 425 Applied Stochastic Orebody Modelling (3 credits)",
"MIME 426 Mine Design and Prefeasibility Study (6 credits)",
"MIME 428 Environmental Mining Engineering (3 credits)",
"MIME 442 Analysis Modelling and Optimization in Mineral Processing (3 credits)",
"MIME 452 Process and Materials Design (4 credits)",
"MIME 455 Advanced Process Engineering (3 credits)",
"MIME 456 Steelmaking and Steel Processing (3 credits)",
"MIME 465 Metallic and Ceramic Powders Processing (3 credits)",
"MIME 467 Electronic Properties of Materials (3 credits)",
"MIME 470 Engineering Biomaterials (3 credits)",
"MIME 473 Introduction to Computational Materials Design (3 credits)",
"MIME 480 Industrial Training 3 (2 credits)",
"MIME 481 Industrial Training 4 (2 credits)",
"MIME 484 Mining Project (3 credits)",
"MIME 494 Industrial Work Period 4 (2 credits)",
"MIME 495 Industrial Work Period 5 (2 credits)",
"MIME 511 Advanced Subsurface Ventilation and Air Conditioning (3 credits)",
"MIME 512 Corrosion and Degradation of Materials (3 credits)",
"MIME 513 Mine Planning Optimization Under Uncertainty (3 credits)",
"MIME 514 Sustainability Analysis of Mining Systems (3 credits)",
"MIME 515 Material Surfaces: A Biomimetic Approach (3 credits)",
"MIME 520 Stability of Rock Slopes (3 credits)",
"MIME 521 Stability of Underground Openings (3 credits)",
"MIME 522 Mineral Reserve Assessment Techniques (3 credits)",
"MIME 524 Mineral Resources Economics (3 credits)",
"MIME 525 Stochastic Orebody Modelling (3 credits)",
"MIME 526 Mineral Economics (3 credits)",
"MIME 527 Selected Topics in Mineral Resource Engineering (3 credits)",
"MIME 542 Transmission Electron Microscopy (3 credits)",
"MIME 544 Analysis: Mineral Processing Systems 1 (3 credits)",
"MIME 545 Analysis: Mineral Processing Systems 2 (3 credits)",
"MIME 551 Electrochemical Processing (3 credits)",
"MIME 553 Impact of Materials Production (3 credits)",
"MIME 556 Sustainable Materials Processing (3 credits)",
"MIME 558 Engineering Nanomaterials (3 credits)",
"MIME 559 Aluminum Physical Metallurgy (3 credits)",
"MIME 560 Joining Processes (3 credits)",
"MIME 561 Advanced Materials Design (3 credits)",
"MIME 563 Hot Deformation of Metals (3 credits)",
"MIME 565 Aerospace Metallic-Materials and Manufacturing Processes (3 credits)",
"MIME 567 Advanced Electronic Properties of Materials (3 credits)",
"MIME 568 Topics in Advanced Materials (3 credits)",
"MIME 569 Electron Beam Analysis of Materials (3 credits)",
"MIME 570 Micro- and Nano-Fabrication Fundamentals (3 credits)",
"MIME 571 Surface Engineering (3 credits)",
"MIME 572 Computational Thermodynamics (3 credits)",
"MIME 576 Advanced Steelmaking and Processing (4 credits)",
"MIME 580 Additive Manufacturing Using Metallic and Ceramic Materials (3 credits)",
"MIME 588 Reliability Analysis of Mining Systems (3 credits)",
"MIME 601 Engineering Laboratory Practice",
"MIME 606 Mineral/Metal Production and Marketing 1 (3 credits)",
"MIME 608 Mineral/Metal Production and Marketing 2 (3 credits)",
"MIME 610D1 Master's Foundation Course (1.5 credits)",
"MIME 610D2 Master's Foundation Course (1.5 credits)",
"MIME 620 Rock Mechanics 1 (4 credits)",
"MIME 621 Rock Mechanics 2 (4 credits)",
"MIME 623 Ground Fragmentation (4 credits)",
"MIME 624D1 Materials Handling in Mines (3 credits)",
"MIME 624D2 Materials Handling in Mines (3 credits)",
"MIME 624N1 Materials Handling in Mines (3 credits)",
"MIME 624N2 Materials Handling in Mines (3 credits)",
"MIME 625 Applied Mineral Economics 1 (4 credits)",
"MIME 626 Applied Geostatistics (3 credits)",
"MIME 627 Applied Mineral Economics 2 (4 credits)",
"MIME 628 Mineral Engineering Project 1 (6 credits)",
"MIME 628D1 Mineral Engineering Project 1 (3 credits)",
"MIME 628D2 Mineral Engineering Project 1 (3 credits)",
"MIME 628N1 Mineral Engineering Project 1 (3 credits)",
"MIME 628N2 Mineral Engineering Project 1 (3 credits)",
"MIME 629 Mineral Engineering Project 2 (6 credits)",
"MIME 629D1 Mineral Engineering Project 2 (3 credits)",
"MIME 629D2 Mineral Engineering Project 2 (3 credits)",
"MIME 629N1 Mineral Engineering Project 2 (3 credits)",
"MIME 629N2 Mineral Engineering Project 2 (3 credits)",
"MIME 631 Advanced Stochastic Optimization in Mine Planning (4 credits)",
"MIME 634 Mineral Engineering Project 3 (3 credits)",
"MIME 634D1 Mineral Engineering Project 3 (1.5 credits)",
"MIME 634D2 Mineral Engineering Project 3 (1.5 credits)",
"MIME 634N1 Mineral Engineering Project 3 (1.5 credits)",
"MIME 634N2 Mineral Engineering Project 3 (1.5 credits)",
"MIME 635 Finite Element Method - Rock Mechanics (4 credits)",
"MIME 636 Boundary Elements: Geomechanics (4 credits)",
"MIME 638 Mine Waste Management (4 credits)",
"MIME 640 Advanced Mineral Processing (6 credits)",
"MIME 640D1 Advanced Mineral Processing (3 credits)",
"MIME 640D2 Advanced Mineral Processing (3 credits)",
"MIME 641D1 Mineral Dressing and Mill Design (3 credits)",
"MIME 641D2 Mineral Dressing and Mill Design (3 credits)",
"MIME 650N1 Advanced Extractive Metallurgy 1 (3 credits)",
"MIME 650N2 Advanced Extractive Metallurgy 1 (3 credits)",
"MIME 652 Aqueous Processing (3 credits)",
"MIME 653 Transport Phenomena - Process Metallurgy (3 credits)",
"MIME 656 Deformation Mechanisms in Crystalline Solids (3 credits)",
"MIME 658 Quantum Materials (3 credits)",
"MIME 661 Literature Review on Selected Research Topics (3 credits)",
"MIME 665 Advanced Processing of Powder Materials (3 credits)",
"MIME 670 Research Seminar 1 (6 credits)",
"MIME 670D1 Research Seminar 1 (3 credits)",
"MIME 670D2 Research Seminar 1 (3 credits)",
"MIME 670N1 Research Seminar 1 (3 credits)",
"MIME 670N2 Research Seminar 1 (3 credits)",
"MIME 672D1 Rock Mechanics Seminar (3 credits)",
"MIME 672D2 Rock Mechanics Seminar (3 credits)",
"MIME 673 Mining Engineering Seminar (6 credits)",
"MIME 673D1 Mining Engineering Seminar (3 credits)",
"MIME 673D2 Mining Engineering Seminar (3 credits)",
"MIME 673N1 Mining Engineering Seminar (3 credits)",
"MIME 673N2 Mining Engineering Seminar (3 credits)",
"MIME 680 Materials Engineering Project 1 (6 credits)",
"MIME 681 Materials Engineering Project 2 (6 credits)",
"MIME 682 Materials Engineering Project 3 (3 credits)",
"MIME 690 Thesis Research 1 (6 credits)",
"MIME 690D1 Thesis Research 1 (3 credits)",
"MIME 690D2 Thesis Research 1 (3 credits)",
"MIME 690N1 Thesis Research 1 (3 credits)",
"MIME 690N2 Thesis Research 1 (3 credits)",
"MIME 691 Thesis Research 2 (3 credits)",
"MIME 692 Thesis Research 3 (6 credits)",
"MIME 692D1 Thesis Research 3 (3 credits)",
"MIME 692D2 Thesis Research 3 (3 credits)",
"MIME 692N1 Thesis Research 3 (3 credits)",
"MIME 692N2 Thesis Research 3 (3 credits)",
"MIME 693 Thesis Research 4 (3 credits)",
"MIME 693D1 Thesis Research 4 (1.5 credits)",
"MIME 693D2 Thesis Research 4 (1.5 credits)",
"MIME 694 Thesis Research 5 (6 credits)",
"MIME 694D1 Thesis Research 5 (3 credits)",
"MIME 694D2 Thesis Research 5 (3 credits)",
"MIME 694N1 Thesis Research 5 (3 credits)",
"MIME 694N2 Thesis Research 5 (3 credits)",
"MIME 695 Thesis Research 6 (3 credits)",
"MIME 695D1 Thesis Research 6 (1.5 credits)",
"MIME 695D2 Thesis Research 6 (1.5 credits)",
"MIME 701 Ph.D. Thesis Research Proposal",
"MIME 702 Ph.D. Preliminary Examination",
"MIME 703 Ph.D. Comprehensive Exam",
"MIME 704 Ph.D. Comprehensive Examination in Mining Engineering",
"MIME 710D1 Ph.D. Foundation Course (1.5 credits)",
"MIME 710D2 Ph.D. Foundation Course (1.5 credits)",
"MIME 771 Research Seminar 2 (6 credits)",
"MIME 771D1 Research Seminar 2 (3 credits)",
"MIME 771D2 Research Seminar 2 (3 credits)",
"MIME 771N1 Research Seminar 2 (3 credits)",
"MIME 771N2 Research Seminar 2 (3 credits)",
"MIME 776 Ph.D. Research Seminar (6 credits)",
"MIME 776D1 Ph.D. Research Seminar (3 credits)",
"MIME 776D2 Ph.D. Research Seminar (3 credits)",
"MIME 776N1 Ph.D. Research Seminar (3 credits)",
"MIME 776N2 Ph.D. Research Seminar (3 credits)",
"MIMM 211 Introductory Microbiology (3 credits)",
"MIMM 212 Laboratory in Microbiology (3 credits)",
"MIMM 214 Introductory Immunology: Elements of Immunity (3 credits)",
"MIMM 301 Scientific Writing Skills in MIMM (1 credit)",
"MIMM 314 Intermediate Immunology (3 credits)",
"MIMM 323 Microbial Physiology (3 credits)",
"MIMM 324 Fundamental Virology (3 credits)",
"MIMM 384 Molecular Microbiology Laboratory (3 credits)",
"MIMM 385 Laboratory in Immunology (3 credits)",
"MIMM 387 The Business of Science (3 credits)",
"MIMM 396 Undergraduate Research Project in Microbiology (3 credits)",
"MIMM 397 Undergraduate Research Project in Immunology (3 credits)",
"MIMM 413 Parasitology (3 credits)",
"MIMM 414 Advanced Immunology (3 credits)",
"MIMM 465 Bacterial Pathogenesis (3 credits)",
"MIMM 466 Viral Pathogenesis (3 credits)",
"MIMM 496D1 Microbiology Advanced Research Project (3 credits)",
"MIMM 496D2 Microbiology Advanced Research Project (3 credits)",
"MIMM 497D1 Immunology Advanced Research Project (3 credits)",
"MIMM 497D2 Immunology Advanced Research Project (3 credits)",
"MIMM 498 Library Research Project in Immunology (1 credit)",
"MIMM 499 Library Research Project in Microbiology (1 credit)",
"MIMM 501D1 Honours Research Project in Immunology (6 credits)",
"MIMM 501D2 Honours Research Project in Immunology (6 credits)",
"MIMM 502D1 Honours Research Project in Microbiology (6 credits)",
"MIMM 502D2 Honours Research Project in Microbiology (6 credits)",
"MIMM 503 Honours Research Project in Immunology 1 (3 credits)",
"MIMM 504 Honours Research Project in Immunology 2 (6 credits)",
"MIMM 505 Honours Research Project in Molecular Microbiology 1 (3 credits)",
"MIMM 506 Honours Research Project in Molecular Microbiology 2 (6 credits)",
"MIMM 509 Inflammatory Processes (3 credits)",
"MIMM 607 Biochemical Pathology (3 credits)",
"MIMM 611 Graduate Seminars 1 (3 credits)",
"MIMM 612 Graduate Seminars 2 (3 credits)",
"MIMM 613 Current Topics 1 (3 credits)",
"MIMM 614 Current Topics 2 (3 credits)",
"MIMM 615 Current Topics 3 (3 credits)",
"MIMM 616 Reading and Conference 1 (3 credits)",
"MIMM 617 Reading and Conference 2 (3 credits)",
"MIMM 618 Reading and Conference 3 (3 credits)",
"MIMM 619 Reading and Conference 4 (3 credits)",
"MIMM 697 Master's Research 1 (11 credits)",
"MIMM 698 Master's Research 2 (11 credits)",
"MIMM 699 Master's Research 3 (11 credits)",
"MIMM 701 Comprehensive Examination-Ph.D. Candidate",
"MIMM 701D1 Comprehensive Examination-Ph.D. Candidate",
"MIMM 701D2 Comprehensive Examination-Ph.D. Candidate",
"MIMM 713 Graduate Seminars 3 (3 credits)",
"MIMM 721 Ph.D. Research Progress Report 1 (1 credit)",
"MIMM 722 Ph.D. Research Progress Report 2 (1 credit)",
"MIMM 723 Ph.D. Research Progress Report 3 (1 credit)",
"MIMM 724 Ph.D. Research Progress Report 4 (1 credit)",
"MPCO 720  (3 credits)",
"MPCO 721  (3 credits)",
"MPCO 722  (3 credits)",
"MPCO 723  (3 credits)",
"MPCO 724  (3 credits)",
"MPCO 725  (3 credits)",
"MPHE 740  (3 credits)",
"MPHE 741  (3 credits)",
"MPHE 742  (3 credits)",
"MPHE 743  (3 credits)",
"MPHE 744  (3 credits)",
"MPHE 745  (3 credits)",
"MPHE 746  (3 credits)",
"MPMC 320 CAO et informatique pour les mines (3 credits)",
"MPMC 321 Mécanique des roches et contrôle des terrains (3 credits)",
"MPMC 326 Recherche opérationnelle I (3 credits)",
"MPMC 328 Environnement et gestion des rejets miniers (3 credits)",
"MPMC 329 Géologie minière (2 credits)",
"MPMC 330 Géotechnique minière (3 credits)",
"MPMC 421 Exploitation en souterrain (3 credits)",
"MPQM 760  (3 credits)",
"MPQM 761  (3 credits)",
"MPQM 762  (3 credits)",
"MRKT 351 Marketing and Society (3 credits)",
"MRKT 354 Marketing Strategy (3 credits)",
"MRKT 355 Services Marketing (3 credits)",
"MRKT 357 Marketing Planning 1 (3 credits)",
"MRKT 365 New Products (3 credits)",
"MRKT 434 Topics in Marketing 1 (3 credits)",
"MRKT 438 Brand Management (3 credits)",
"MRKT 440 Marketing Analytics (3 credits)",
"MRKT 451 Marketing Research (3 credits)",
"MRKT 452 Consumer Behaviour (3 credits)",
"MRKT 453 Advertising and Media (3 credits)",
"MRKT 455 Sales Management (3 credits)",
"MRKT 456 Business to Business Marketing (3 credits)",
"MRKT 459 Retail Management (3 credits)",
"MRKT 483 International Marketing Management (3 credits)",
"MRKT 645 Winning at Brands (3 credits)",
"MRKT 652 Competitive Marketing Strategy (3 credits)",
"MRKT 654 Marketing Communications (3 credits)",
"MRKT 655 Marketing Planning (3 credits)",
"MRKT 657 Customer Insights (3 credits)",
"MRKT 657D1 Customer Insights (1.5 credits)",
"MRKT 657D2 Customer Insights (1.5 credits)",
"MRKT 658 Marketing Intelligence (3 credits)",
"MRKT 659 Advanced Business Marketing (3 credits)",
"MRKT 671 Advanced Marketing Analytics (1.5 credits)",
"MRKT 672 Internet Marketing Analytics (1.5 credits)",
"MRKT 673 Pricing Analytics (1.5 credits)",
"MRKT 674 Retail Analytics (1.5 credits)",
"MRKT 690 Advanced Topics in Marketing 1 (3 credits)",
"MRKT 691 Advanced Topics in Marketing 2 (3 credits)",
"MRKT 696 Advanced Topics in Marketing Analytics (1.5 credits)",
"MRKT 698 International Marketing Management (3 credits)",
"MRKT 701 Models in Consumer Research (3 credits)",
"MRKT 702 Advances in Consumer Behaviour (3 credits)",
"MRKT 705 Seminar in Marketing (3 credits)",
"MRKT 706 Automatic Consumer Behaviour (3 credits)",
"MRKT 707 Multilevel Modelling (3 credits)",
"MRKT 708 Judgement and Decision Making (3 credits)",
"MRKT 709 Decision-Neuroscience (3 credits)",
"MRKT 710 Topics in Marketing Strategy (3 credits)",
"MRKT 711 Topics in Service Science (3 credits)",
"MSUS 400 Independent Studies in Sustainability (3 credits)",
"MSUS 401 Sustainability Consulting (3 credits)",
"MSUS 402 Systems Thinking and Sustainability (3 credits)",
"MSUS 434 Topics in Sustainability (3 credits)",
"MSUS 488 Sustainability and Operations (3 credits)",
"MSUS 497 Internship in Sustainability (3 credits)",
"MUAR 201 Basic Materials: Western Music (3 credits)",
"MUAR 202 Basic Materials: Western Music 2 (3 credits)",
"MUAR 211 The Art of Listening (3 credits)",
"MUAR 250 Women Making Music (3 credits)",
"MUAR 374 Special Topics in Music (3 credits)",
"MUAR 382 Introduction to World Music (3 credits)",
"MUAR 384 Romanticism and the Piano (3 credits)",
"MUAR 385 Music of the Avant-Garde (3 credits)",
"MUAR 387 The Opera (3 credits)",
"MUAR 389 The Symphony and Concerto (3 credits)",
"MUAR 392 Popular Music after 1945 (3 credits)",
"MUAR 393 Introduction to Jazz (3 credits)",
"MUAR 399 Music and Queer Identity (3 credits)",
"MUCO 230 The Art of Composition (3 credits)",
"MUCO 241 Tonal Composition 1A (3 credits)",
"MUCO 242 Tonal Composition 1B (3 credits)",
"MUCO 245 Composition 1A (2 credits)",
"MUCO 246 Composition 1B (3 credits)",
"MUCO 260 Instruments of the Orchestra (3 credits)",
"MUCO 261 Orchestration 1 (3 credits)",
"MUCO 340D1 Composition 2 (2 credits)",
"MUCO 340D2 Composition 2 (2 credits)",
"MUCO 341 Digital Studio Composition 1 (3 credits)",
"MUCO 342 Digital Studio Composition 2 (3 credits)",
"MUCO 360 Orchestration 2 (3 credits)",
"MUCO 373 Special Topic in Composition 1 (3 credits)",
"MUCO 374 Special Topic in Composition 2 (3 credits)",
"MUCO 440D1 Composition 3 (2 credits)",
"MUCO 440D2 Composition 3 (2 credits)",
"MUCO 460 Orchestration 3 (2 credits)",
"MUCO 462 Advanced Tonal Writing (3 credits)",
"MUCO 475 Special Project: Composition (3 credits)",
"MUCO 541 Advanced Digital Studio Composition 1 (3 credits)",
"MUCO 542 Advanced Digital Studio Composition 2 (3 credits)",
"MUCO 575 Topics in Composition (3 credits)",
"MUCO 622D1 Composition Tutorial (3 credits)",
"MUCO 622D2 Composition Tutorial (3 credits)",
"MUCO 631 Seminar in Composition 1 (3 credits)",
"MUCO 632 Seminar in Composition 2 (3 credits)",
"MUCO 633 Seminar in Composition 3 (3 credits)",
"MUCO 634 Seminar in Composition 4 (3 credits)",
"MUCO 635 Seminar in Composition 5 (3 credits)",
"MUCO 636 Seminar in Composition 6 (3 credits)",
"MUCO 710 General Examinations",
"MUCO 722D1 Doctoral Composition Tutorial (3 credits)",
"MUCO 722D2 Doctoral Composition Tutorial (3 credits)",
"MUCT 235 Vocal Techniques (3 credits)",
"MUCT 315 Choral Conducting 1 (3 credits)",
"MUEN 454 Introductory Opera Repertoire Experience (2 credits)",
"MUEN 496 Opera Studio (2 credits)",
"MUEN 540 Chamber Music Project 1 (0.5 credits)",
"MUEN 541 Chamber Music Project 2 (0.5 credits)",
"MUEN 553 Vocal Chamber Ensemble (1 credit)",
"MUEN 556 Introduction to Collaborative Piano 1 (1 credit)",
"MUEN 557 Introduction to Collaborative Piano 2 (1 credit)",
"MUEN 560 Chamber Music Ensemble (1 credit)",
"MUEN 561 2nd Chamber Music Ensemble (1 credit)",
"MUEN 562 Guitar Ensemble (1 credit)",
"MUEN 563 Jazz Vocal Workshop (2 credits)",
"MUEN 564 Conducting Workshop (1 credit)",
"MUEN 565 String Quartet Seminar (2 credits)",
"MUEN 567 Beethoven Orchestra (1 credit)",
"MUEN 568 Multiple Ensemble 1 (1 credit)",
"MUEN 569 Tabla Ensemble (1 credit)",
"MUEN 570 Jazz Combo (1 credit)",
"MUEN 571 Jazz Combo Project (0.5 credits)",
"MUEN 572 Cappella Antica (2 credits)",
"MUEN 573 Baroque Orchestra (2 credits)",
"MUEN 574 Afro-Cuban/Brazilian Jazz Combo (1 credit)",
"MUEN 578 Song Interpretation 1 (1 credit)",
"MUEN 579 Song Interpretation 2 (1 credit)",
"MUEN 580 Early Music Ensemble (1 credit)",
"MUEN 581 Introduction to Ensemble Playing for Pianists (1 credit)",
"MUEN 582 Piano Ensembles (1 credit)",
"MUEN 584 Studio Accompanying (1 credit)",
"MUEN 585 Sonata Masterclass (1 credit)",
"MUEN 586 Opera Coaching (1 credit)",
"MUEN 587 Cappella McGill (2 credits)",
"MUEN 588 Multiple Ensemble 2 (1 credit)",
"MUEN 589 Woodwind Ensembles (1 credit)",
"MUEN 590 McGill Wind Orchestra (2 credits)",
"MUEN 591 Brass Consort (1 credit)",
"MUEN 592 Chamber Jazz Ensemble (2 credits)",
"MUEN 593 Choral Ensembles (2 credits)",
"MUEN 594 Contemporary Music Ensemble (2 credits)",
"MUEN 595 Jazz Ensembles (2 credits)",
"MUEN 596 Opera Repetiteur (2 credits)",
"MUEN 597 McGill Symphony Orchestra (2 credits)",
"MUEN 598 Percussion Ensembles (1 credit)",
"MUEN 599 Jazz Studio Orchestra (1 credit)",
"MUEN 654 Opera Repertoire Experience (1 credit)",
"MUEN 684 Studio Accompanying (2 credits)",
"MUEN 688 Multiple Ensembles (2 credits)",
"MUEN 690 McGill Winds (2 credits)",
"MUEN 696 Opera Theatre (1 credit)",
"MUGS 605 Graduate Performance Colloquium",
"MUGS 614 Reading Course 1 (3 credits)",
"MUGS 615 Reading Course 2 (3 credits)",
"MUGS 635 Research Paper 1 (9 credits)",
"MUGS 635D1 Research Paper 1 (4.5 credits)",
"MUGS 635D2 Research Paper 1 (4.5 credits)",
"MUGS 636 Research Paper 2 (9 credits)",
"MUGS 636D1 Research Paper 2 (4.5 credits)",
"MUGS 636D2 Research Paper 2 (4.5 credits)",
"MUGS 675 Special Project (3 credits)",
"MUGS 675D1 Special Project (1.5 credits)",
"MUGS 675D2 Special Project (1.5 credits)",
"MUGS 683 Master's Thesis Research 1 (3 credits)",
"MUGS 684 Master's Thesis Research 2 (6 credits)",
"MUGS 685 Master's Thesis Research 3 (9 credits)",
"MUGS 686 Master's Thesis Research 4 (12 credits)",
"MUGS 687 Master's Thesis (12 credits)",
"MUGS 694 Special Topic Seminar (3 credits)",
"MUGS 695 Special Topic Seminar (3 credits)",
"MUGS 701 Comprehensive Examinations",
"MUGS 701D1 Comprehensive Examinations",
"MUGS 701D2 Comprehensive Examinations",
"MUGS 702 Comprehensive Examination Part 2",
"MUGS 702D1 Comprehensive Examination Part 2",
"MUGS 702D2 Comprehensive Examination Part 2",
"MUGS 705 Colloquium",
"MUGS 705D1 Colloquium",
"MUGS 705D2 Colloquium",
"MUGS 711 Performance Doctoral Colloquium 1",
"MUGS 712 Performance Doctoral Colloquium 2",
"MUGT 205 Psychology of Music (3 credits)",
"MUGT 215 Basic Conducting Techniques (1 credit)",
"MUGT 301 Technology and Media for Music Education (3 credits)",
"MUGT 305 Introduction to Music Therapy (3 credits)",
"MUGT 354 Music for Children (3 credits)",
"MUGT 355 Music in Early Childhood (3 credits)",
"MUGT 358 General Music for Adults and Teenagers (3 credits)",
"MUGT 401 Issues in Music Education (3 credits)",
"MUGT 475 Special Project (3 credits)",
"MUGT 610 Seminar - Music Education 1 (3 credits)",
"MUGT 611 Seminar - Music Education 2 (3 credits)",
"MUGT 612 Seminar - Music Education 3 (3 credits)",
"MUGT 613 Seminar - Music Education 4 (3 credits)",
"MUHL 186 Western Musical Traditions (3 credits)",
"MUHL 286 Critical Thinking About Music (3 credits)",
"MUHL 314 Women in Music: A Cross-Cultural Perspective (3 credits)",
"MUHL 330 Music and Film (3 credits)",
"MUHL 342 History of Electroacoustic Music (3 credits)",
"MUHL 362 Popular Music (3 credits)",
"MUHL 366 The Era of the Fortepiano (3 credits)",
"MUHL 372 Solo Song Outside Germany and Austria (3 credits)",
"MUHL 374 Special Topic (3 credits)",
"MUHL 375 Introduction to Ethnomusicology (3 credits)",
"MUHL 377 Baroque Opera (3 credits)",
"MUHL 380 Medieval Music (3 credits)",
"MUHL 381 Renaissance Music (3 credits)",
"MUHL 382 Baroque Music (3 credits)",
"MUHL 383 Classical Music (3 credits)",
"MUHL 384 Romantic Music (3 credits)",
"MUHL 385 Early Twentieth-Century Music (3 credits)",
"MUHL 386 Chamber Music Literature (3 credits)",
"MUHL 387 Opera from Mozart to Puccini (3 credits)",
"MUHL 388 Opera After 1900 (3 credits)",
"MUHL 389 Orchestral Literature (3 credits)",
"MUHL 390 The German Lied (3 credits)",
"MUHL 391 Canadian Music (3 credits)",
"MUHL 392 Music since 1945 (3 credits)",
"MUHL 393 History of Jazz (3 credits)",
"MUHL 395 Keyboard Literature before 1750 (3 credits)",
"MUHL 396 Era of the Modern Piano (3 credits)",
"MUHL 397 Choral Literature after 1750 (3 credits)",
"MUHL 398 Wind Ensemble Literature after 1750 (3 credits)",
"MUHL 475 Special Project (3 credits)",
"MUHL 529 Proseminar in Musicology (3 credits)",
"MUHL 590 Topics in Christian Liturgy and Music (3 credits)",
"MUHL 591D1 Paleography (1.5 credits)",
"MUHL 591D2 Paleography (1.5 credits)",
"MUHL 592 Popular Music Studies (3 credits)",
"MUHL 680 Seminar in Musicology 1 (3 credits)",
"MUHL 681 Seminar in Musicology 2 (3 credits)",
"MUHL 682 Seminar in Musicology 3 (3 credits)",
"MUHL 683 Seminar in Musicology 4 (3 credits)",
"MUHL 684 Seminar in Musicology 5 (3 credits)",
"MUHL 685 Seminar in Musicology 6 (3 credits)",
"MUHL 692 Seminar in Music Literature 1 (3 credits)",
"MUIN 110 Elective Practical Instruction 1 (2 credits)",
"MUIN 111 Elective Practical Instruction 2 (2 credits)",
"MUIN 120 Practical Instruction 1 (2 credits)",
"MUIN 121 Practical Instruction 2 (2 credits)",
"MUIN 130 Performance Practical Instruction 1 (4 credits)",
"MUIN 131 Performance Practical Instruction 2 (4 credits)",
"MUIN 180 BMus Practical Lessons 1 (3 credits)",
"MUIN 181 BMus Practical Lessons 2 (3 credits)",
"MUIN 210 Elective Practical Instruction 3 (2 credits)",
"MUIN 211 Elective Practical Instruction 4 (2 credits)",
"MUIN 220 Practical Instruction 3 (2 credits)",
"MUIN 221 Practical Instruction 4 (2 credits)",
"MUIN 222 Concentration 1 Examination",
"MUIN 230 Performance Practical Instruction 3 (4 credits)",
"MUIN 231 Performance Practical Instruction 4 (4 credits)",
"MUIN 232 Performance 1 Examination",
"MUIN 250 L.Mus. Practical Instruction 1 (6 credits)",
"MUIN 251 L.Mus. Practical Instruction 2 (6 credits)",
"MUIN 252 L.Mus. Performance 1 Examination (4 credits)",
"MUIN 269 Classical Concerto Exam (1 credit)",
"MUIN 270 Practical Lessons Performance Minor 1 (3 credits)",
"MUIN 271 Practical Lessons Performance Minor 2 (3 credits)",
"MUIN 272 Performance Minor Examination 1",
"MUIN 273 Practical Lessons Performance Minor 3 (1.5 credits)",
"MUIN 274 Practical Lessons Performance Minor 4 (1.5 credits)",
"MUIN 275 Practical Lessons Performance Minor 5 (1.5 credits)",
"MUIN 276 Practical Lessons Performance Minor 6 (1.5 credits)",
"MUIN 280 BMus Practical Lessons 3 (2.5 credits)",
"MUIN 281 BMus Practical Lessons 4 (2.5 credits)",
"MUIN 282 BMus Performance Examination 1 (1 credit)",
"MUIN 283 BMus Concentration Final Examination (1 credit)",
"MUIN 300 Voice Coaching 1 (2 credits)",
"MUIN 301 Voice Coaching 2 (2 credits)",
"MUIN 302 Early Music Minor Repertoire Coaching 1 (1.5 credits)",
"MUIN 303 Early Music Minor Repertoire Coaching 2 (1.5 credits)",
"MUIN 304 Early Music Minor Repertoire Coaching 3 (1.5 credits)",
"MUIN 305 Early Music Minor Repertoire Coaching 4 (1.5 credits)",
"MUIN 320 Practical Instruction 5 (2 credits)",
"MUIN 321 Practical Instruction 6 (2 credits)",
"MUIN 322 Concentration 2 Examination",
"MUIN 330 Performance Practical Instruction 5 (4 credits)",
"MUIN 331 Performance Practical Instruction 6 (4 credits)",
"MUIN 332 Performance 2 Examination",
"MUIN 333 Piano Techniques 2",
"MUIN 340 Honours Practical Instruction 5 (4 credits)",
"MUIN 341 Honours Practical Instruction 6 (4 credits)",
"MUIN 342 Honours Performance 2 Examination",
"MUIN 350 L.Mus. Practical Instruction 3 (6 credits)",
"MUIN 351 L.Mus. Practical Instruction 4 (6 credits)",
"MUIN 352 L.Mus. Performance 2 Examination (4 credits)",
"MUIN 369 Concerto",
"MUIN 380 BMus Practical Lessons 5 (2.5 credits)",
"MUIN 381 BMus Practical Lessons 6 (2.5 credits)",
"MUIN 382 BMus Performance Examination 2 (1 credit)",
"MUIN 384 Conducting Minor Project (1 credit)",
"MUIN 400 Voice Coaching 3 (2 credits)",
"MUIN 401 Voice Coaching 4 (2 credits)",
"MUIN 430 Performance Practical Instruction 7 (4 credits)",
"MUIN 431 Performance Practical Instruction 8 (4 credits)",
"MUIN 432 Performance 3 Examination",
"MUIN 433 Piano Techniques 3",
"MUIN 440 Honours Practical Instruction 7 (4 credits)",
"MUIN 441 Honours Practical Instruction 8 (4 credits)",
"MUIN 442 Honours Performance 3 Examination",
"MUIN 450 L.Mus. Practical Instruction 5 (4 credits)",
"MUIN 451 L.Mus. Practical Instruction 6 (4 credits)",
"MUIN 452 L.Mus. Performance 3 Examination (8 credits)",
"MUIN 452D1 L.Mus. Performance 3 Examination (4 credits)",
"MUIN 452D2 L.Mus. Performance 3 Examination (4 credits)",
"MUIN 460 Artist Diploma Practical Instruction 1 (8 credits)",
"MUIN 461 Artist Diploma Practical Instruction 2 (8 credits)",
"MUIN 462 Artist Diploma Recital 1",
"MUIN 469 Artist Diploma Concerto 1 (1 credit)",
"MUIN 480 BMus Practical Lessons 7 (2 credits)",
"MUIN 481 BMus Practical Lessons 8 (2 credits)",
"MUIN 482 BMus Performance Examination 3 (2 credits)",
"MUIN 500 Practical Instruction 1 (1 credit)",
"MUIN 560 Artist Diploma Practical Instruction 3 (8 credits)",
"MUIN 561 Artist Diploma Practical Instruction 4 (8 credits)",
"MUIN 562 Artist Diploma Recital 2",
"MUIN 563 Artist Diploma Recital 3",
"MUIN 569 Artist Diploma Concerto 2 (1 credit)",
"MUIN 600 Graduate Diploma Vocal Coaching 1 (2 credits)",
"MUIN 601 Graduate Diploma Vocal Coaching 2 (2 credits)",
"MUIN 602 Vocal Repertoire Coaching 3 (2 credits)",
"MUIN 610 Vocal Coaching 1 (1 credit)",
"MUIN 611 Vocal Coaching 2 (1 credit)",
"MUIN 612 Vocal Coaching 3 (1 credit)",
"MUIN 620 Performance Tutorial 1 (3 credits)",
"MUIN 621 Performance Tutorial 2 (3 credits)",
"MUIN 622 Performance Tutorial 3 (3 credits)",
"MUIN 622D1 Performance Tutorial 3 (1.5 credits)",
"MUIN 622D2 Performance Tutorial 3 (1.5 credits)",
"MUIN 623 Performance Tutorial 4 (3 credits)",
"MUIN 624 Performance Tutorial 5 (3 credits)",
"MUIN 626 Jazz Performance/Composition Tutorial 1 (3 credits)",
"MUIN 627 Jazz Performance/Composition Tutorial 2 (3 credits)",
"MUIN 628 Jazz Performance/Composition Tutorial 3 (3 credits)",
"MUIN 628D1 Jazz Performance/Composition Tutorial 3 (1.5 credits)",
"MUIN 628D2 Jazz Performance/Composition Tutorial 3 (1.5 credits)",
"MUIN 630 Conducting Tutorial 1 (3 credits)",
"MUIN 631 Conducting Tutorial 2 (3 credits)",
"MUIN 632 Conducting Tutorial 3 (3 credits)",
"MUIN 633 Conducting Tutorial 4 (3 credits)",
"MUIN 634 Graduate Diploma Tutorial 1 (8 credits)",
"MUIN 635 Graduate Diploma Tutorial 2 (8 credits)",
"MUIN 637 Graduate Certificate Conducting Tutorial 1 (3 credits)",
"MUIN 638 Graduate Certificate Conducting Tutorial 2 (3 credits)",
"MUIN 700 Doctoral Repertoire Coaching 1 (2 credits)",
"MUIN 701 Doctoral Repertoire Coaching 2 (2 credits)",
"MUIN 702 Doctoral Repertoire Coaching 3 (2 credits)",
"MUIN 703 Doctoral Repertoire Coaching 4 (2 credits)",
"MUIN 710 Graduate Artist Diploma Tutorial 1 (8 credits)",
"MUIN 711 Graduate Artist Diploma Tutorial 2 (8 credits)",
"MUIN 720 D.Mus. Performance Tutorial 1 (4 credits)",
"MUIN 721 D.Mus. Performance Tutorial 2 (4 credits)",
"MUIN 722 D.Mus. Performance Tutorial 3 (4 credits)",
"MUIN 723 D.Mus. Performance Tutorial 4 (4 credits)",
"MUIN 724 D.Mus. Performance Tutorial 5 (4 credits)",
"MUIN 725 D.Mus. Performance Tutorial 6 (4 credits)",
"MUIN 726 D.Mus. Performance Tutorial 7 (4 credits)",
"MUIN 730 D.Mus. Performance Tutorial 8 (6 credits)",
"MUIN 731 D.Mus. Performance Tutorial 9 (6 credits)",
"MUIN 732 D.Mus. Performance Tutorial 10 (6 credits)",
"MUIN 733 D.Mus. Performance Tutorial 11 (6 credits)",
"MUIN 734 D.Mus. Performance Tutorial 12 (6 credits)",
"MUIT 201 String Techniques (3 credits)",
"MUIT 202 Woodwind Techniques (3 credits)",
"MUIT 203 Brass Techniques (3 credits)",
"MUIT 204 Percussion Techniques (3 credits)",
"MUIT 250 Guitar Techniques (3 credits)",
"MUIT 302 Advanced Wind Techniques (3 credits)",
"MUIT 315 Instrumental Conducting (3 credits)",
"MUIT 356 Jazz Instruction: Philosophy and Techniques (3 credits)",
"MUJZ 160 Jazz Materials 1 (3 credits)",
"MUJZ 161 Jazz Materials 2 (3 credits)",
"MUJZ 170 Jazz Keyboard Proficiency 1 (1 credit)",
"MUJZ 171 Jazz Keyboard Proficiency 2 (1 credit)",
"MUJZ 172 Drum Set Proficiency (1 credit)",
"MUJZ 187 Jazz History Survey (3 credits)",
"MUJZ 213 Fundamentals of Jazz Improvisation 1 (2 credits)",
"MUJZ 214 Fundamentals of Jazz Improvisation 2 (2 credits)",
"MUJZ 223 Jazz Improvisation/Musicianship 1 (3 credits)",
"MUJZ 224 Jazz Improvisation/Musicianship 2 (3 credits)",
"MUJZ 260 Jazz Arranging 1 (3 credits)",
"MUJZ 261 Jazz Arranging 2 (3 credits)",
"MUJZ 262 Applied Jazz Theory (3 credits)",
"MUJZ 323 Advanced Jazz Ear Training (2 credits)",
"MUJZ 340 Jazz Composition 1 (3 credits)",
"MUJZ 341 Jazz Composition 2 (3 credits)",
"MUJZ 423 Jazz Improvisation/Musicianship 3 (3 credits)",
"MUJZ 424 Jazz Improvisation/Musicianship 4 (3 credits)",
"MUJZ 440 Advanced Jazz Composition 1 (2 credits)",
"MUJZ 441 Advanced Jazz Composition 2 (2 credits)",
"MUJZ 461D1 Advanced Jazz Arranging (2 credits)",
"MUJZ 461D2 Advanced Jazz Arranging (2 credits)",
"MUJZ 493 Jazz Performance Practice (3 credits)",
"MUJZ 601 Jazz Pedagogy (3 credits)",
"MUJZ 640 Jazz Composition & Arranging 1 (2 credits)",
"MUJZ 641 Jazz Composition & Arranging 2 (2 credits)",
"MUJZ 644 Jazz Repertoire Project 1 (2 credits)",
"MUJZ 645 Jazz Repertoire Project 2 (2 credits)",
"MUMT 201 Introduction to Music Technologies (3 credits)",
"MUMT 202 Fundamentals of New Media (3 credits)",
"MUMT 203 Introduction to Digital Audio (3 credits)",
"MUMT 250 Music Perception and Cognition (3 credits)",
"MUMT 301 Music and the Internet (3 credits)",
"MUMT 302 New Media Production 1 (3 credits)",
"MUMT 303 New Media Production 2 (3 credits)",
"MUMT 306 Music and Audio Computing 1 (3 credits)",
"MUMT 307 Music and Audio Computing 2 (3 credits)",
"MUMT 402 Advanced Multimedia Development (3 credits)",
"MUMT 475 Special Project (3 credits)",
"MUMT 501 Digital Audio Signal Processing (3 credits)",
"MUMT 502 Senior Project: Music Technology (3 credits)",
"MUMT 605 Digital Sound Synthesis and Audio Process (3 credits)",
"MUMT 609 Music Media and Technology Project (3 credits)",
"MUMT 610 Music Technology Seminar 1 (3 credits)",
"MUMT 611 Music Technology Seminar 2 (3 credits)",
"MUMT 612 Music Technology Seminar 3 (3 credits)",
"MUMT 613 Music Technology Seminar 4 (3 credits)",
"MUMT 614 Music Technology Seminar 5 (3 credits)",
"MUMT 615 Music Technology Seminar 6 (3 credits)",
"MUMT 616 Timbre Form-Bearing Dimension in Music (3 credits)",
"MUMT 617 Cognitive Dynamics of Music Listening (3 credits)",
"MUMT 618 Computational Modeling of Musical Acoustics (3 credits)",
"MUMT 619 Input Devices for Musical Expression (3 credits)",
"MUMT 620 Gestural Control of Sound Synthesis (3 credits)",
"MUMT 621 Music Information Retrieval Acquisition Preservation (3 credits)",
"MUMT 622 Time-Frequency and Parametric Representations of Sounds (3 credits)",
"MUPD 135 Music as a Profession 1 (1 credit)",
"MUPD 200 Introduction to Music Marketing (3 credits)",
"MUPD 201 Business Fundamentals for Musicians (3 credits)",
"MUPD 204 Production for Digital Media 1 (3 credits)",
"MUPD 205 Production for Digital Media 2 (3 credits)",
"MUPD 235 Music as a Profession 2 (1 credit)",
"MUPD 350 Applied Projects for Musicians (3 credits)",
"MUPD 473 Special Project: Professional Development 1 (1 credit)",
"MUPD 474 Special Project: Professional Development 2 (2 credits)",
"MUPD 475 Special Project: Professional Development 3 (3 credits)",
"MUPD 499 Internship: Music Professional Development (3 credits)",
"MUPD 560 Introduction to Research Methods in Music (1 credit)",
"MUPD 580 Piano Pedagogy Practicum (2 credits)",
"MUPD 650 Research Methods in Music (3 credits)",
"MUPG 209 Introduction to Lyric Diction (1 credit)",
"MUPG 210 Italian Diction (2 credits)",
"MUPG 211 French Diction (2 credits)",
"MUPG 212 English Diction (2 credits)",
"MUPG 213 German Diction (2 credits)",
"MUPG 229 Traditional Drumming 1: Rudiments (1 credit)",
"MUPG 272D1 Continuo (2 credits)",
"MUPG 272D2 Continuo (2 credits)",
"MUPG 296 Acting for Voice (1 credit)",
"MUPG 297 Movement for Voice (1 credit)",
"MUPG 300 Music Performance Strategies (2 credits)",
"MUPG 309 Advanced Diction (1 credit)",
"MUPG 315D1 Introduction to Orchestral Conducting (2 credits)",
"MUPG 315D2 Introduction to Orchestral Conducting (2 credits)",
"MUPG 316D1 Introduction to Choral Conducting (2 credits)",
"MUPG 316D2 Introduction to Choral Conducting (2 credits)",
"MUPG 325 Improvisation for String Players (2 credits)",
"MUPG 326 Introduction to String Pedagogy (2 credits)",
"MUPG 328 Introduction to Percussion Pedagogy (1 credit)",
"MUPG 329 Traditional Drumming 2: Hand Drumming (1 credit)",
"MUPG 331 Introduction to Woodwind Pedagogy (2 credits)",
"MUPG 336 Introduction to Brass Pedagogy (2 credits)",
"MUPG 350 Introduction to Piano Pedagogy (2 credits)",
"MUPG 353 Song Repertoire Class (2 credits)",
"MUPG 356 Piano Repertoire Studies 1 (2 credits)",
"MUPG 357 Piano Repertoire Studies 2 (2 credits)",
"MUPG 372D1 Continuo (1 credit)",
"MUPG 372D2 Continuo (1 credit)",
"MUPG 380 Oratorio Class (2 credits)",
"MUPG 410 Violin Orchestral Excerpts (1 credit)",
"MUPG 411 Viola Orchestral Excerpts (1 credit)",
"MUPG 412 Cello Orchestral Excerpts (1 credit)",
"MUPG 413 Double Bass Orchestral Excerpts (1 credit)",
"MUPG 414 Woodwinds Orchestral Excerpts (1 credit)",
"MUPG 415 Brass Orchestral Excerpts (1 credit)",
"MUPG 416 Percussion Orchestral Excerpts (1 credit)",
"MUPG 425 Extended Techniques - Strings (2 credits)",
"MUPG 429 Percussion Seminar (2 credits)",
"MUPG 431 Extended Techniques - Woodwinds (2 credits)",
"MUPG 435 Extended Techniques - Brass (2 credits)",
"MUPG 453 Contemporary Repertoire for Voice (2 credits)",
"MUPG 473 Special Project in Performance (1 credit)",
"MUPG 474 Special Project in Performance (2 credits)",
"MUPG 475 Special Project in Performance (3 credits)",
"MUPG 541 Senior Piano Seminar 1 (2 credits)",
"MUPG 542 Senior Piano Seminar 2 (2 credits)",
"MUPG 571 Free Improvisation 1 (1 credit)",
"MUPG 572D1 Free Improvisation 2 (0.5 credits)",
"MUPG 572D2 Free Improvisation 2 (0.5 credits)",
"MUPG 575D1 Organ Repertoire and Performance Practice (1.5 credits)",
"MUPG 575D2 Organ Repertoire and Performance Practice (1.5 credits)",
"MUPG 580 Rehearsal Techniques for Conductors (1.5 credits)",
"MUPG 590 Vocal Styles and Conventions (3 credits)",
"MUPG 600 Recital Project 1 (9 credits)",
"MUPG 600D1 Recital Project 1 (4.5 credits)",
"MUPG 600D2 Recital Project 1 (4.5 credits)",
"MUPG 601 Recital Project 2 (9 credits)",
"MUPG 601D1 Recital Project 2 (4.5 credits)",
"MUPG 601D2 Recital Project 2 (4.5 credits)",
"MUPG 602 Recital Project 3 (6 credits)",
"MUPG 603 Recital Project 4 (3 credits)",
"MUPG 604 Chamber Music Recital (6 credits)",
"MUPG 605 Recording Project (3 credits)",
"MUPG 606 Interdisciplinary Project 1 (3 credits)",
"MUPG 607 Interdisciplinary Project 2 (6 credits)",
"MUPG 607D1 Interdisciplinary Project 2 (3 credits)",
"MUPG 607D2 Interdisciplinary Project 2 (3 credits)",
"MUPG 608 Orchestral Repertoire Examination 1 (3 credits)",
"MUPG 609 Orchestral Repertoire Examination 2 (6 credits)",
"MUPG 609D1 Orchestral Repertoire Examination 2 (3 credits)",
"MUPG 609D2 Orchestral Repertoire Examination 2 (3 credits)",
"MUPG 610 Orchestral Repertoire Examination 3 (9 credits)",
"MUPG 610D1 Orchestral Repertoire Examination 3 (4.5 credits)",
"MUPG 610D2 Orchestral Repertoire Examination 3 (4.5 credits)",
"MUPG 614 Quick Study (3 credits)",
"MUPG 634 Performance Tutorial 6 (6 credits)",
"MUPG 635 Performance Tutorial 7 (6 credits)",
"MUPG 640 Graduate Diploma Performance Project 1 (4 credits)",
"MUPG 641 Graduate Diploma Performance Project 2 (4 credits)",
"MUPG 642 Graduate Diploma Performance Project 3 (8 credits)",
"MUPG 642D1 Graduate Diploma Performance Project 3 (4 credits)",
"MUPG 642D2 Graduate Diploma Performance Project 3 (4 credits)",
"MUPG 643 Graduate Diploma Interdisciplinary Project (4 credits)",
"MUPG 644 Graduate Diploma Concerto Performance (4 credits)",
"MUPG 645 Graduate Diploma Recording Project (4 credits)",
"MUPG 646 Score- and Sight-Reading 1 (1 credit)",
"MUPG 647 Score- and Sight-Reading 2 (1 credit)",
"MUPG 648 Graduate Certificate Conducting Project (4 credits)",
"MUPG 651 Performance/Composition Recital Project (9 credits)",
"MUPG 651D1 Performance/Composition Recital Project (4.5 credits)",
"MUPG 651D2 Performance/Composition Recital Project (4.5 credits)",
"MUPG 652 Jazz Ensemble Recital Project (9 credits)",
"MUPG 653 Opera Coach Project (9 credits)",
"MUPG 653D1 Opera Coach Project (4.5 credits)",
"MUPG 653D2 Opera Coach Project (4.5 credits)",
"MUPG 654 Opera Coach Performance (6 credits)",
"MUPG 659 Performance in Recording Media (9 credits)",
"MUPG 659D1 Performance in Recording Media (4.5 credits)",
"MUPG 659D2 Performance in Recording Media (4.5 credits)",
"MUPG 666 Fretboard Guitar Project (3 credits)",
"MUPG 669 Guitar Pedagogy Project (3 credits)",
"MUPG 670 Advanced Continuo 1 (2 credits)",
"MUPG 670D1 Advanced Continuo 1 (1 credit)",
"MUPG 670D2 Advanced Continuo 1 (1 credit)",
"MUPG 671 Advanced Continuo 2 (2 credits)",
"MUPG 671D1 Advanced Continuo 2 (1 credit)",
"MUPG 671D2 Advanced Continuo 2 (1 credit)",
"MUPG 673 Special Project: Performance 2 (1 credit)",
"MUPG 674 Special Project: Performance 3 (2 credits)",
"MUPG 675 Special Project in Performance 1 (3 credits)",
"MUPG 675D1 Special Project in Performance 1 (1.5 credits)",
"MUPG 675D2 Special Project in Performance 1 (1.5 credits)",
"MUPG 676 Special Project in Church Music (9 credits)",
"MUPG 676D1 Special Project in Church Music (4.5 credits)",
"MUPG 676D2 Special Project in Church Music (4.5 credits)",
"MUPG 677 Seminar in Performance Topics 1 (3 credits)",
"MUPG 678 Seminar in Performance Topics 2 (3 credits)",
"MUPG 680 Rehearsal Techniques for Conductors 2 (2 credits)",
"MUPG 681 Piano Seminar 1 (2 credits)",
"MUPG 682 Piano Seminar 2 (2 credits)",
"MUPG 683 Piano Seminar 1 (1.5 credits)",
"MUPG 684 Piano Seminar 2 (1.5 credits)",
"MUPG 687 Collaborative Piano Repertoire 1: Song (1 credit)",
"MUPG 688 Collaborative Piano Repertoire 2: Instrumental (1 credit)",
"MUPG 689 Collaborative Piano Rep.3: Orch. Reduction Opera Oratorio (1 credit)",
"MUPG 691 Vocal Ornamentation (3 credits)",
"MUPG 693 Vocal Treatises and Methods (3 credits)",
"MUPG 694 Vocal Physiology for Singers (3 credits)",
"MUPG 695 Graduate Jazz Improvisation Seminar (3 credits)",
"MUPG 740 Graduate Artist Diploma Performance Project 1 (4 credits)",
"MUPG 741 Graduate Artist Diploma Performance Project 2 (4 credits)",
"MUPG 742 Graduate Artist Diploma Performance Project 3 (8 credits)",
"MUPG 742D1 Graduate Artist Diploma Performance Project 3 (4 credits)",
"MUPG 742D2 Graduate Artist Diploma Performance Project 3 (4 credits)",
"MUPG 743 Graduate Artist Diploma Interdisciplinary Project (4 credits)",
"MUPG 744 Graduate Artist Diploma Concerto Performance (4 credits)",
"MUPG 745 Graduate Artist Diploma Recording Project (4 credits)",
"MUPG 760 Doctoral Recital 1 (12 credits)",
"MUPG 767 Doctoral Recital 2 (12 credits)",
"MUPG 770 Doctoral Lecture - Recital Project (9 credits)",
"MUPG 771 Doctoral Final Project (12 credits)",
"MUPP 381 Topics in Performance Practice (3 credits)",
"MUPP 690 Performance Practice Seminar 1 (3 credits)",
"MUPP 691 Performance Practice Seminar 2 (3 credits)",
"MUPP 692 Performance Practice Seminar 3 (3 credits)",
"MUPP 693 Performance Practice Seminar 4 (3 credits)",
"MUPP 694 Performance Practice Seminar 5 (3 credits)",
"MUPP 695 Performance Practice Seminar 6 (3 credits)",
"MURG 473 Special Project: Music Research 1 (1 credit)",
"MURG 474 Special Project: Music Research 2 (2 credits)",
"MUSP 123 Jazz Ear Training 1 (2 credits)",
"MUSP 124 Jazz Ear Training 2 (2 credits)",
"MUSP 129D1 Musicianship 1 (1 credit)",
"MUSP 129D2 Musicianship 1 (1 credit)",
"MUSP 140 Musicianship Training 1 (2 credits)",
"MUSP 141 Musicianship Training 2 (2 credits)",
"MUSP 170 Musicianship (Keyboard) 1 (1 credit)",
"MUSP 171 Musicianship (Keyboard) 2 (1 credit)",
"MUSP 240 Musicianship Training 3 (2 credits)",
"MUSP 241 Musicianship Training 4 (2 credits)",
"MUSP 324 Musicianship for Strings (2 credits)",
"MUSP 330 Musicianship for Woodwinds (2 credits)",
"MUSP 335 Musicianship for Brass (2 credits)",
"MUSP 346 Post-Tonal Musicianship (2 credits)",
"MUSP 350 Musicianship for Pianists (2 credits)",
"MUSP 353 Musicianship for Voice (2 credits)",
"MUSP 354 Introduction to Improvisation and Ornamentation (2 credits)",
"MUSP 355 Musicianship for Percussion (2 credits)",
"MUSP 381 Singing Renaissance Notation (2 credits)",
"MUSP 446 Advanced Musicianship 1 (2 credits)",
"MUSP 447 Advanced Musicianship 2 (2 credits)",
"MUSP 500D1 Keyboard for Professional Practice (1 credit)",
"MUSP 500D2 Keyboard for Professional Practice (1 credit)",
"MUSR 200 Audio Recording Essentials (3 credits)",
"MUSR 201 Audio Production Essentials (3 credits)",
"MUSR 232 Introduction to Electronics (3 credits)",
"MUSR 300D1 Introduction to Music Recording (3 credits)",
"MUSR 300D2 Introduction to Music Recording (3 credits)",
"MUSR 339 Introduction to Electroacoustics (3 credits)",
"MUSR 629D1 Technical Ear Training (2 credits)",
"MUSR 629D2 Technical Ear Training (2 credits)",
"MUSR 631D1 Advanced Technical Ear Training (2 credits)",
"MUSR 631D2 Advanced Technical Ear Training (2 credits)",
"MUSR 667 Digital Studio Technology (3 credits)",
"MUSR 668 Digital/Analog Audio Editing (3 credits)",
"MUSR 669 Topics: Classical Music Recording (3 credits)",
"MUSR 669D1 Topics: Classical Music Recording (1.5 credits)",
"MUSR 669D2 Topics: Classical Music Recording (1.5 credits)",
"MUSR 670D1 Recording Theory and Practice 1 (5 credits)",
"MUSR 670D2 Recording Theory and Practice 1 (5 credits)",
"MUSR 671D1 Recording Theory and Practice 2 (5 credits)",
"MUSR 671D2 Recording Theory and Practice 2 (5 credits)",
"MUSR 672D1 Analysis of Recordings (3 credits)",
"MUSR 672D2 Analysis of Recordings (3 credits)",
"MUSR 676 Audio Industry Experience (3 credits)",
"MUSR 676D1 Audio Industry Experience (1.5 credits)",
"MUSR 676D2 Audio Industry Experience (1.5 credits)",
"MUSR 677D1 Audio for Video Post-Production (3 credits)",
"MUSR 677D2 Audio for Video Post-Production (3 credits)",
"MUSR 678 Advanced Digital Editing and Post-Production (2 credits)",
"MUSR 690 Special Field Research (3 credits)",
"MUSR 691 Mastering and Restoration (3 credits)",
"MUSR 692 Music Production Workshop (3 credits)",
"MUSR 693 Media Theory and Practice Seminar 4 (3 credits)",
"MUSR 694 Media Theory and Practice Seminar 5 (3 credits)",
"MUSR 695 Techniques of Immersive Sound (3 credits)",
"MUTH 100 Music Theory Fundamentals (3 credits)",
"MUTH 150 Theory and Analysis 1 (3 credits)",
"MUTH 151 Theory and Analysis 2 (3 credits)",
"MUTH 202 Modal Counterpoint 1 (3 credits)",
"MUTH 204 Tonal Counterpoint 1 (3 credits)",
"MUTH 250 Theory and Analysis 3 (3 credits)",
"MUTH 251 Theory and Analysis 4 (3 credits)",
"MUTH 302 Modal Counterpoint 2 (3 credits)",
"MUTH 304 Tonal Counterpoint 2 (3 credits)",
"MUTH 321 Topics in Tonal Analysis (3 credits)",
"MUTH 322 Topics in Post-Tonal Analysis (3 credits)",
"MUTH 327 19th-Century Analysis (4 credits)",
"MUTH 350 Theory and Analysis 5 (3 credits)",
"MUTH 426 Topics in Early Music Analysis (3 credits)",
"MUTH 461 Choral and Keyboard Arranging (2 credits)",
"MUTH 462 Instrumental Arranging (3 credits)",
"MUTH 473 Special Studies: 20th-Century Theory and Composition (3 credits)",
"MUTH 474 Special Studies: 20th-Century Theory and Composition (3 credits)",
"MUTH 475 Special Project (3 credits)",
"MUTH 528 Schenkerian Theory and Analysis (3 credits)",
"MUTH 529 Proseminar in Music Theory (3 credits)",
"MUTH 538 Mathematical Models for Musical Analysis (3 credits)",
"MUTH 539 Topics in Advanced Writing Techniques (3 credits)",
"MUTH 541 Topics in Popular Music Analysis (3 credits)",
"MUTH 602 Keyboard Modal Counterpoint (3 credits)",
"MUTH 604 Keyboard Tonal Counterpoint (3 credits)",
"MUTH 652 Seminar in Music Theory 1 (3 credits)",
"MUTH 653 Seminar in Music Theory 2 (3 credits)",
"MUTH 654 Seminar in Music Theory 3 (3 credits)",
"MUTH 655 Seminar in Music Theory 4 (3 credits)",
"MUTH 656 Seminar in Music Theory 5 (3 credits)",
"MUTH 657 Seminar in Music Theory 6 (3 credits)",
"MUTH 658 History of Music Theory 1 (3 credits)",
"MUTH 659 History of Music Theory 2 (3 credits)",
"MUTH 710 Teaching Practicum",
"MUTH 711 General Examinations",
"NEUR 301 TCP Neurology (2 credits)",
"NEUR 310 Cellular Neurobiology (3 credits)",
"NEUR 502 Basic and Clinical Aspects of Neuroimmunology (3 credits)",
"NEUR 503 Computational Neuroscience (3 credits)",
"NEUR 507 Topics in Radionuclide Imaging (3 credits)",
"NEUR 550 Free Radical Biomedicine (3 credits)",
"NEUR 560 History of Neuroscience (3 credits)",
"NEUR 570 Human Brain Imaging (3 credits)",
"NEUR 602 Current Topics in Neuroscience (3 credits)",
"NEUR 604 Neuroscience Seminar 3 (3 credits)",
"NEUR 605 Neuroscience Seminar 4 (3 credits)",
"NEUR 606 Methods in Neuroimaging (3 credits)",
"NEUR 608 Neuroimaging Data Science (3 credits)",
"NEUR 610 Functional Neuroanatomy (3 credits)",
"NEUR 630 Principles of Neuroscience 1 (3 credits)",
"NEUR 631 Principles of Neuroscience 2 (3 credits)",
"NEUR 696 Master's Thesis Research (6 credits)",
"NEUR 696D1 Master's Thesis Research (3 credits)",
"NEUR 696D2 Master's Thesis Research (3 credits)",
"NEUR 696N1 Master's Thesis Research (3 credits)",
"NEUR 696N2 Master's Thesis Research (3 credits)",
"NEUR 697 Master's Thesis Proposal (9 credits)",
"NEUR 697D1 Master's Thesis Proposal (4.5 credits)",
"NEUR 697D2 Master's Thesis Proposal (4.5 credits)",
"NEUR 697N1 Master's Thesis Proposal (4.5 credits)",
"NEUR 697N2 Master's Thesis Proposal (4.5 credits)",
"NEUR 698 Master's Seminar Presentation (9 credits)",
"NEUR 698D1 Master's Seminar Presentation (4.5 credits)",
"NEUR 698D2 Master's Seminar Presentation (4.5 credits)",
"NEUR 698N1 Master's Seminar Presentation (4.5 credits)",
"NEUR 698N2 Master's Seminar Presentation (4.5 credits)",
"NEUR 699 Master's Thesis Submission (12 credits)",
"NEUR 699D1 Master's Thesis Submission (6 credits)",
"NEUR 699D2 Master's Thesis Submission (6 credits)",
"NEUR 699N1 Master's Thesis Submission (6 credits)",
"NEUR 699N2 Master's Thesis Submission (6 credits)",
"NEUR 700 Doctoral Candidacy Examination",
"NEUR 700D1 Doctoral Candidacy Examination",
"NEUR 700D2 Doctoral Candidacy Examination",
"NEUR 705 Responsible Research Conduct",
"NEUR 710 Connectional Research: Lab-to-World Impact (3 credits)",
"NRSC 221 Environment and Health (3 credits)",
"NRSC 333 Pollution and Bioremediation (3 credits)",
"NRSC 340 Global Perspectives on Food (3 credits)",
"NRSC 405 Natural History of East Africa (3 credits)",
"NRSC 451 Research in Ecology and Development in Africa (3 credits)",
"NRSC 510 Agricultural Micrometeorology (3 credits)",
"NRSC 514 Freshwater Ecosystems (3 credits)",
"NRSC 540 Socio-Cultural Issues in Water (3 credits)",
"NRSC 610 Advanced Environmental Assessment (3 credits)",
"NRSC 611 Environmental Assessment Knowledge Base (3 credits)",
"NRSC 612 Environmental Assessment and Sustainable Development (3 credits)",
"NRSC 613 Strategic and Sectoral Environmental Assessment (3 credits)",
"NRSC 614 Special Topics 7 (3 credits)",
"NRSC 615 Environmental Assessment Internship (15 credits)",
"NRSC 616 Environmental Assessment Project Paper (9 credits)",
"NRSC 617 Environmental Assessment: Institutional Approaches (6 credits)",
"NRSC 620 Into the Ecozoic (3 credits)",
"NRSC 621 Restoring a Flourishing Earth (3 credits)",
"NRSC 622D1 Seminar for the Ecozoic (1.5 credits)",
"NRSC 622D2 Seminar for the Ecozoic (1.5 credits)",
"NRSC 643 Graduate Seminar 1 (1 credit)",
"NRSC 644 Graduate Seminar 2 (1 credit)",
"NRSC 651 Graduate Seminar 3 (1 credit)",
"NRSC 670 Principles of Environmental Health Sciences 1 (3 credits)",
"NRSC 671 Principles of Environmental Health Sciences 2 (3 credits)",
"NRSC 680 Special Topics 1 (1 credit)",
"NRSC 684 Special Topics 5 (3 credits)",
"NRSC 685 Special Topics 6 (3 credits)",
"NRSC 691 M.Sc. Thesis Research 1 (12 credits)",
"NRSC 692 M.Sc. Thesis Research 2 (12 credits)",
"NRSC 693 M.Sc. Thesis Research 3 (12 credits)",
"NRSC 694 M.Sc. Thesis Research 4 (9 credits)",
"NRSC 701 Ph.D. Comprehensive Examination",
"NRSC 701D1 Ph.D. Comprehensive Examination",
"NRSC 701D2 Ph.D. Comprehensive Examination",
"NRSC 701N1 Ph.D. Comprehensive Examination",
"NRSC 701N2 Ph.D. Comprehensive Examination",
"NRSC 751 Graduate Seminar 4",
"NRSC 752 Graduate Seminar 5",
"NRSC 753 Graduate Seminar 6",
"NRSC 754 Graduate Seminar 7",
"NSCI 200 Introduction to Neuroscience 1 (3 credits)",
"NSCI 201 Introduction to Neuroscience 2 (3 credits)",
"NSCI 300 Neuroethics (3 credits)",
"NSCI 396 Undergraduate Research Project (3 credits)",
"NSCI 400D1 Neuroscience Seminar (0.5 credits)",
"NSCI 400D2 Neuroscience Seminar (0.5 credits)",
"NSCI 400N1 Neuroscience Seminar (0.5 credits)",
"NSCI 400N2 Neuroscience Seminar (0.5 credits)",
"NSCI 410 Independent Research 1 (6 credits)",
"NSCI 410D1 Independent Research 1 (3 credits)",
"NSCI 410D2 Independent Research 1 (3 credits)",
"NSCI 420 Independent Research 2 (9 credits)",
"NSCI 420D1 Independent Research 2 (4.5 credits)",
"NSCI 420D2 Independent Research 2 (4.5 credits)",
"NSCI 420N1 Independent Research 2 (4.5 credits)",
"NSCI 420N2 Independent Research 2 (4.5 credits)",
"NSCI 430D1 Honours Research Project (4.5 credits)",
"NSCI 430D2 Honours Research Project (4.5 credits)",
"NUR1 200 Biology for Illness & Therapy (4 credits)",
"NUR1 209 Pathophysiology for Nursing 1 (3 credits)",
"NUR1 210 Pathophysiology for Nursing 2 (3 credits)",
"NUR1 219 Transition to the McGill Model (1 credit)",
"NUR1 222 Strengths-Based Nursing and Professional Practice (3 credits)",
"NUR1 224 Individual and Family Development Across Lifespans 1 (4 credits)",
"NUR1 225 Individual and Family Development Across Lifespans 2 (4 credits)",
"NUR1 230 Supporting Health and Healing Capacities 1 (1 credit)",
"NUR1 231 Supporting Health and Healing Capacities 2 (1 credit)",
"NUR1 233 Promoting Young Family Development (2 credits)",
"NUR1 234 Nursing Older Adults (2 credits)",
"NUR1 235 Health & Physical Assessment/Anatomy 1 (3 credits)",
"NUR1 236 Health & Physical Assessment/Anatomy 2 (3 credits)",
"NUR1 300 Pharmacology for Nursing 1 (3 credits)",
"NUR1 301 Pharmacology for Nursing 2 (3 credits)",
"NUR1 311 Infection Prevention and Control (3 credits)",
"NUR1 312 Research in Nursing (3 credits)",
"NUR1 318 Chronic Illness and Palliative Health Challenges (4 credits)",
"NUR1 320 Critical Care Nursing Theory (3 credits)",
"NUR1 322 Chronic Illness and Palliative Care (3 credits)",
"NUR1 323 Illness Management 1 (3 credits)",
"NUR1 324 Illness Management 2 (3 credits)",
"NUR1 325 Acute Chronic & Palliative Health Challenges 1 (4 credits)",
"NUR1 326 Acute Chronic and Palliative Health Challenges 2 (4 credits)",
"NUR1 327 Critical Health Challenges (4 credits)",
"NUR1 329 Skin Integrity and Wound Care (3 credits)",
"NUR1 331 Nursing in Illness 1 (4 credits)",
"NUR1 332 Nursing in Illness 2 (4 credits)",
"NUR1 333 Nursing in Illness 3 (3 credits)",
"NUR1 335 Illness Management Clinical Skills Laboratory 1 (1 credit)",
"NUR1 336 Illness Management Clinical Skills Laboratory 2 (1 credit)",
"NUR1 338 Applied Health and Physical Assessment/Anatomy 1 (3 credits)",
"NUR1 339 Applied Health and Physical Assessment/Anatomy 2 (3 credits)",
"NUR1 420 Primary Health Care (3 credits)",
"NUR1 421 Resources: Special Populations (3 credits)",
"NUR1 423 Leading Change: Policy and Practice (4 credits)",
"NUR1 424 Legal Ethical and Professional Practice Issues (4 credits)",
"NUR1 428 Learning and Health Education (3 credits)",
"NUR1 431 Community Health Nursing Practicum (3 credits)",
"NUR1 432 Community Health Nursing Project (3 credits)",
"NUR1 434 Critical Care Nursing Practicum (4 credits)",
"NUR1 435 Ambassador Critical Care Practicum (4 credits)",
"NUR1 529 Critical Care Nursing (4 credits)",
"NUR1 530 Nursing Practice Consolidation (5 credits)",
"NUR1 531 Ambassador Nursing Practice Consolidation (5 credits)",
"NUR1 548 Introduction to Telehealth Nursing (3 credits)",
"NUR2 500 Integrated Health Sciences 1 (4 credits)",
"NUR2 501 Integrated Health Sciences 2 (4 credits)",
"NUR2 510 Practice of Nursing 1 (3 credits)",
"NUR2 511 Practice of Nursing 2 (3 credits)",
"NUR2 512 Practice and Theory in Nursing (4 credits)",
"NUR2 513 Introduction to Nursing Care (4 credits)",
"NUR2 514 Introduction to Nursing 2 (4 credits)",
"NUR2 514D1 Introduction to Nursing 2 (2 credits)",
"NUR2 514D2 Introduction to Nursing 2 (2 credits)",
"NUR2 515 Applied Statistics for Nursing (3 credits)",
"NUR2 516 Perspectives on Global Health (3 credits)",
"NUR2 517 Nursing Clinical Skills Laboratory 1 (1 credit)",
"NUR2 518 Nursing Clinical Skills Lab 2 (1 credit)",
"NUR2 519 Nursing Clinical Skills Laboratory 3 (1 credit)",
"NUR2 521 Wound Care 1 (1.5 credits)",
"NUR2 534 Health Assessment/Anatomy 1 (3 credits)",
"NUR2 535 Health Assessment/Anatomy 2 (3 credits)",
"NUR2 590 Introduction to Nursing Theories and Models (2 credits)",
"NUR2 591 Introduction to Graduate Practice (4 credits)",
"NUR2 607 Children's Nursing (3 credits)",
"NUR2 608 Seminar in Nursing (3 credits)",
"NUR2 609 Nursing Care of Children and their Families (3 credits)",
"NUR2 610 Ambulatory/Community Care (3 credits)",
"NUR2 611 Policy Leadership in Nursing (3 credits)",
"NUR2 612 Research Methods in Nursing 1 (3 credits)",
"NUR2 615 Health Care Evaluation (3 credits)",
"NUR2 616 Advanced Clinical Skills (4 credits)",
"NUR2 617 Clinical in Family Systems Nursing 1 (3 credits)",
"NUR2 618 Clinical in Family Systems Nursing 2 (3 credits)",
"NUR2 619 Nursing Clinical Skills Lab 4 (1 credit)",
"NUR2 620 Current Theories of Nursing (2 credits)",
"NUR2 621 Wound Care 2 (2 credits)",
"NUR2 622 Nursing Education Internship (4 credits)",
"NUR2 623 Clinical Assessment and Therapeutics 1 (3 credits)",
"NUR2 624 Clinical Laboratory in Nursing 2 (4 credits)",
"NUR2 625 Clinical Laboratory in Nursing 3 (6 credits)",
"NUR2 626 Professional Issues in Nursing (3 credits)",
"NUR2 627 Nursing Practicum (3 credits)",
"NUR2 628 Advanced Assessment (4 credits)",
"NUR2 629 Nursing Administration Stage (4 credits)",
"NUR2 630 Clinical Project 1 (3 credits)",
"NUR2 631 Clinical Project 2 (6 credits)",
"NUR2 632 Clinical Project 3 (3 credits)",
"NUR2 634 Clinical Assessment and Therapeutics 2 (3 credits)",
"NUR2 635 Pain Measurement in Children (3 credits)",
"NUR2 636 Global Health Nursing Clinical (3 credits)",
"NUR2 637 Clinical Nursing Specialization (3 credits)",
"NUR2 638 Nursing in Critical Care (3 credits)",
"NUR2 640 Clinical Reasoning (3 credits)",
"NUR2 642 Ethics in Advanced Practice (3 credits)",
"NUR2 643 Role Development (3 credits)",
"NUR2 644 Pharmacology for Neonatal Nurse Practitioners (3 credits)",
"NUR2 645 Pharmacology for Pediatric Nurse Practitioners (3 credits)",
"NUR2 646 Pharmacology for Primary Care Nurse Practitioners (3 credits)",
"NUR2 647 Pharmacology for Mental Health Nurse Practitioners (3 credits)",
"NUR2 649 Neonatology Internship 1 (12 credits)",
"NUR2 650 Neonatology Internship 2 (12 credits)",
"NUR2 651 Primary Care Internship 1 (8 credits)",
"NUR2 652 Primary Care Internship 2 (14 credits)",
"NUR2 653 Pediatric Internship 1 (8 credits)",
"NUR2 654 Pediatric Internship 2 (14 credits)",
"NUR2 655 Mental Health Internship 1 (8 credits)",
"NUR2 656 Mental Health Internship 2 (14 credits)",
"NUR2 660 Reasoning in Neonatology 1 (6 credits)",
"NUR2 661 Reasoning in Neonatology 2 (6 credits)",
"NUR2 662 Reasoning in Neonatology 3 (3 credits)",
"NUR2 663 Neonatology Clinical Project (3 credits)",
"NUR2 664 Neonatal Health Assessment (3 credits)",
"NUR2 665 Newborn Internship (4 credits)",
"NUR2 666 Neonatal Follow-Up Internship (6 credits)",
"NUR2 670 Reasoning in Primary Care 1 (3 credits)",
"NUR2 671 Reasoning in Primary Care 2 (3 credits)",
"NUR2 672 Reasoning in Primary Care 3 (4 credits)",
"NUR2 673 Reasoning in Primary Care 4 (4 credits)",
"NUR2 674 Reasoning in Primary Care 5 (4 credits)",
"NUR2 675 Reasoning in Primary Care 6 (4 credits)",
"NUR2 676 Primary Care Assessment (4 credits)",
"NUR2 680 Reasoning in Pediatrics 1 (3 credits)",
"NUR2 681 Reasoning in Pediatrics 2 (3 credits)",
"NUR2 682 Reasoning in Pediatrics 3 (4 credits)",
"NUR2 683 Reasoning in Pediatrics 4 (4 credits)",
"NUR2 684 Reasoning in Pediatrics 5 (4 credits)",
"NUR2 685 Reasoning in Pediatrics 6 (4 credits)",
"NUR2 686 Pediatric Assessment (4 credits)",
"NUR2 690 Reasoning in Mental Health 1 (3 credits)",
"NUR2 691 Reasoning in Mental Health 2 (3 credits)",
"NUR2 692 Reasoning in Mental Health 3 (4 credits)",
"NUR2 693 Reasoning in Mental Health 4 (4 credits)",
"NUR2 694 Reasoning in Mental Health 5 (4 credits)",
"NUR2 695 Reasoning in Mental Health 6 (4 credits)",
"NUR2 696 Reasoning in Mental Health 7 (4 credits)",
"NUR2 699 Reasoning in Mental Health 8 (5 credits)",
"NUR2 701 Comprehensive Examination (1 credit)",
"NUR2 702 Quantitative Research (3 credits)",
"NUR2 703 Issues of Measurement (3 credits)",
"NUR2 705 Palliative Care (3 credits)",
"NUR2 706 Qualitative Nursing Research (3 credits)",
"NUR2 720 Nursing Workforce Determinants (3 credits)",
"NUR2 730 Theory Development in Nursing (3 credits)",
"NUR2 780 Advanced Nursing (3 credits)",
"NUR2 783 Psychosocial Oncology Research (3 credits)",
"NUTR 200 Contemporary Nutrition (3 credits)",
"NUTR 207 Nutrition and Health (3 credits)",
"NUTR 208 Professional Practice Stage 1A (2 credits)",
"NUTR 209 Professional Practice Stage 1B (2 credits)",
"NUTR 214 Food Fundamentals (4 credits)",
"NUTR 217 Application: Food Fundamentals (4 credits)",
"NUTR 301 Psychology (3 credits)",
"NUTR 307 Metabolism and Human Nutrition (3 credits)",
"NUTR 310 Professional Practice Stage 2A (2 credits)",
"NUTR 311 Professional Practice Stage 2B (5 credits)",
"NUTR 322 Applied Sciences Communication (3 credits)",
"NUTR 337 Nutrition Through Life (3 credits)",
"NUTR 341 Global Food Security (3 credits)",
"NUTR 342 Applied Human Resources (3 credits)",
"NUTR 343 Financial Management and Accounting (3 credits)",
"NUTR 344 Clinical Nutrition 1 (4 credits)",
"NUTR 345 Food Service Systems Management (3 credits)",
"NUTR 346 Applied Food Service Management (3 credits)",
"NUTR 401 Emerging Issues in Nutrition (1 credit)",
"NUTR 404 Nutrition Field Studies in East Africa (3 credits)",
"NUTR 408 Professional Practice Stage 3A (1 credit)",
"NUTR 409 Professional Practice Stage 3B (9 credits)",
"NUTR 430 Directed Studies: Dietetics and Nutrition 1 (3 credits)",
"NUTR 431 Directed Studies: Dietetics and Nutrition 2 (3 credits)",
"NUTR 431D1 Directed Studies: Dietetics and Nutrition 2 (1.5 credits)",
"NUTR 431D2 Directed Studies: Dietetics and Nutrition 2 (1.5 credits)",
"NUTR 431N1 Directed Studies: Dietetics and Nutrition 2 (1.5 credits)",
"NUTR 431N2 Directed Studies: Dietetics and Nutrition 2 (1.5 credits)",
"NUTR 432 Directed Studies: Dietetics and Nutrition 3 (3 credits)",
"NUTR 433 Directed Studies: Dietetics and Nutrition 4 (5 credits)",
"NUTR 438 Interviewing and Counselling (3 credits)",
"NUTR 450 Research Methods: Human Nutrition (3 credits)",
"NUTR 480 Nutrition Industry Internship (12 credits)",
"NUTR 497 Professional Seminar: Nutrition (1.5 credits)",
"NUTR 500 Independent Study 1 (3 credits)",
"NUTR 501 Nutrition in Developing Countries (3 credits)",
"NUTR 502 Independent Study 2 (3 credits)",
"NUTR 503 Nutrition and Exercise (3 credits)",
"NUTR 505 Public Health Nutrition (3 credits)",
"NUTR 508 Professional Practice Stage 4A (7 credits)",
"NUTR 509 Professional Practice Stage 4B (7 credits)",
"NUTR 510 Professional Practice - Stage 4 (14 credits)",
"NUTR 511 Nutrition and Behaviour (3 credits)",
"NUTR 512 Herbs Foods and Phytochemicals (3 credits)",
"NUTR 513 Credentialing in Dietetics (3 credits)",
"NUTR 515 Dietetics French Examination (1 credit)",
"NUTR 545 Clinical Nutrition 2 (4 credits)",
"NUTR 546 Clinical Nutrition 3 (4 credits)",
"NUTR 551 Analysis of Nutrition Data (3 credits)",
"NUTR 600 Advanced Clinical Nutrition 1 (3 credits)",
"NUTR 601 Advanced Clinical Nutrition 2 (3 credits)",
"NUTR 602 Nutritional - Status Assessment (3 credits)",
"NUTR 603 Credentialing in Dietetics (3 credits)",
"NUTR 604 Integrated Metabolic Research (3 credits)",
"NUTR 606 Human Nutrition Research Methods (3 credits)",
"NUTR 607 Counselling in Professional Practice (3 credits)",
"NUTR 608 Special Topics 1 (3 credits)",
"NUTR 609 Special Topics 2 (3 credits)",
"NUTR 610 Maternal and Child Nutrition (3 credits)",
"NUTR 611 Graduate Professional Practice 1 (2 credits)",
"NUTR 612 Graduate Professional Practice 2 Management (8 credits)",
"NUTR 613 Graduate Professional Practice 3 Clinical Nutrition (7 credits)",
"NUTR 614 Graduate Professional Practice 4 Community Nutrition (8 credits)",
"NUTR 615 Graduate Prof Practice 5 Clinical Nutrition (7 credits)",
"NUTR 620 Nutrition of Indigenous Peoples (3 credits)",
"NUTR 625 Emerging Issues for Nutritionists (1 credit)",
"NUTR 626 Writing for Dietetics Practice (2 credits)",
"NUTR 627 Professional Dietetics Presentation (1 credit)",
"NUTR 628 Dietetics Comprehensive Examination (1 credit)",
"NUTR 629 Professional Dietetics Project (6 credits)",
"NUTR 629D1 Professional Dietetics Project (3 credits)",
"NUTR 629D2 Professional Dietetics Project (3 credits)",
"NUTR 641 Advanced Global Food Security (3 credits)",
"NUTR 651 M.Sc. (Applied) Literature Review (3 credits)",
"NUTR 652 M.Sc. (Applied) Project 1 (3 credits)",
"NUTR 653 M.Sc. (Applied) Project 2 (3 credits)",
"NUTR 654 M.Sc. (Applied) Project 3 (3 credits)",
"NUTR 655 M.Sc. (Applied) Project 4 (3 credits)",
"NUTR 656 M.Sc. (Applied) Practicum 1 (3 credits)",
"NUTR 657 M.Sc. (Applied) Practicum 2 (3 credits)",
"NUTR 658 M.Sc. (Applied) Practicum 3 (3 credits)",
"NUTR 659 M.Sc. (Applied) Practicum 4 (3 credits)",
"NUTR 660 M.Sc.(Applied) Final Presentation (1 credit)",
"NUTR 680 Human Nutrition M.Sc. Thesis 1 (7 credits)",
"NUTR 680D1 Human Nutrition M.Sc. Thesis 1 (3.5 credits)",
"NUTR 680D2 Human Nutrition M.Sc. Thesis 1 (3.5 credits)",
"NUTR 680N1 Human Nutrition M.Sc. Thesis 1 (3.5 credits)",
"NUTR 680N2 Human Nutrition M.Sc. Thesis 1 (3.5 credits)",
"NUTR 681 Human Nutrition M.Sc. Thesis 2 (8 credits)",
"NUTR 681D1 Human Nutrition M.Sc. Thesis 2 (4 credits)",
"NUTR 681D2 Human Nutrition M.Sc. Thesis 2 (4 credits)",
"NUTR 681N1 Human Nutrition M.Sc. Thesis 2 (4 credits)",
"NUTR 681N2 Human Nutrition M.Sc. Thesis 2 (4 credits)",
"NUTR 682 Human Nutrition M.Sc. Thesis 3 (9 credits)",
"NUTR 682D1 Human Nutrition M.Sc. Thesis 3 (4.5 credits)",
"NUTR 682D2 Human Nutrition M.Sc. Thesis 3 (4.5 credits)",
"NUTR 682N1 Human Nutrition M.Sc. Thesis 3 (4.5 credits)",
"NUTR 682N2 Human Nutrition M.Sc. Thesis 3 (4.5 credits)",
"NUTR 683 Human Nutrition M.Sc. Thesis 4 (9 credits)",
"NUTR 683D1 Human Nutrition M.Sc. Thesis 4 (4.5 credits)",
"NUTR 683D2 Human Nutrition M.Sc. Thesis 4 (4.5 credits)",
"NUTR 683N1 Human Nutrition M.Sc. Thesis 4 (4.5 credits)",
"NUTR 683N2 Human Nutrition M.Sc. Thesis 4 (4.5 credits)",
"NUTR 695 Human Nutrition Research Orientation (1 credit)",
"NUTR 696 Human Nutrition Seminar (1 credit)",
"NUTR 697 MSc Final Presentation (1 credit)",
"NUTR 701 Doctoral Comprehensive Examination",
"NUTR 701D1 Doctoral Comprehensive Examination",
"NUTR 701D2 Doctoral Comprehensive Examination",
"NUTR 796 PhD Research Presentation (1 credit)",
"OBGY 401 Obstetrics and Gynecology Clerkship (6 credits)",
"OCC1 245 Introduction to Professional Practice 1 (3 credits)",
"OCC1 320 Clinical Affiliation 2 (6 credits)",
"OCC1 321 Clinical Affiliation 3 (6 credits)",
"OCC1 335 OT Practice 2 (Part 1) (2 credits)",
"OCC1 336 OT Practice 2: Neurological Conditions (4 credits)",
"OCC1 337 OT Practice 3 (3 credits)",
"OCC1 338 OT Practice 4: Mental Health (3 credits)",
"OCC1 339 Strategies for Independent Living (2 credits)",
"OCC1 340 Assessment of Performance 2 (2 credits)",
"OCC1 341 Assessment of Performance 3 (3 credits)",
"OCC1 420 Clinical Affiliation 4 (3 credits)",
"OCC1 422 Clinical Affiliation 5 (3 credits)",
"OCC1 424 Splinting and Orthotics (2 credits)",
"OCC1 436 OT Practice 5: Medical and Surgical (3 credits)",
"OCC1 437D1 OT and Community Mental Health (1.5 credits)",
"OCC1 437D2 OT and Community Mental Health (1.5 credits)",
"OCC1 438 Psychosocial Theories in OT (3 credits)",
"OCC1 440 Pre and Vocational Rehabilitation (2 credits)",
"OCC1 441 Advanced Technology/Ergonomics (2 credits)",
"OCC1 442 Environments for the Disabled (2 credits)",
"OCC1 443 Constructing Mental Health (3 credits)",
"OCC1 450 Enabling Leisure Occupations (3 credits)",
"OCC1 500D1 Pre-Clinical Practicum Seminar",
"OCC1 500D2 Pre-Clinical Practicum Seminar",
"OCC1 501 Clinical Practicum 1 (7 credits)",
"OCC1 502 Clinical Practicum 2 (7 credits)",
"OCC1 503 Clinical Practicum 3 (8 credits)",
"OCC1 545 Therapeutic Strategies in OT 1 (8 credits)",
"OCC1 546 Strategies in OT Professional Practice (3 credits)",
"OCC1 547 Occupational Solutions 1 (6 credits)",
"OCC1 548 Holistic Approaches in OT (3 credits)",
"OCC1 549 Therapeutic Strategies in OT 2 (4 credits)",
"OCC1 550 Enabling Human Occupation (3 credits)",
"OCC1 551 Psychosocial Practice in OT (3 credits)",
"OCC1 600J1 Clinical Practicum Seminars",
"OCC1 600J2 Clinical Practicum Seminars",
"OCC1 600J3 Clinical Practicum Seminars",
"OCC1 602 Clinical Practicum 4 (7 credits)",
"OCC1 617 Occupational Solutions 2 (6 credits)",
"OCC1 618 Applied OT: Psychosocial Theory (5 credits)",
"OCC1 620 Work/Ergonomics (3 credits)",
"OCC1 622 Community-Based OT (3 credits)",
"OCC1 623 Assistive Technology (3 credits)",
"OCC1 625 Functional Environments (3 credits)",
"OCC1 626 Mental Health: Child and Youth (3 credits)",
"OCCH 600 Master's Integrative Exam",
"OCCH 602 Occupational Health Practice (3 credits)",
"OCCH 603 Work and Environment Epidemiology 1 (3 credits)",
"OCCH 604 Monitoring Occupational Environment (3 credits)",
"OCCH 605 Physical Health Hazards (6 credits)",
"OCCH 605D1 Physical Health Hazards (3 credits)",
"OCCH 605D2 Physical Health Hazards (3 credits)",
"OCCH 608 Biological Hazards (3 credits)",
"OCCH 612 Principles of Toxicology (3 credits)",
"OCCH 614 Topics in Occupational Health (3 credits)",
"OCCH 615 Occupational Safety Practice (3 credits)",
"OCCH 616 Occupational Hygiene (3 credits)",
"OCCH 617 Occupational Diseases (3 credits)",
"OCCH 624 Social and Behavioural Aspects - Occupational Health (3 credits)",
"OCCH 625 Work and Environment Epidemiology 2 (3 credits)",
"OCCH 626 Basics: Physical Health Hazards (3 credits)",
"OCCH 627 Work Physiology and Ergonomics (3 credits)",
"OCCH 630 Occupational Diseases for OHNS (3 credits)",
"OCCH 635 Environmental Risks to Health (3 credits)",
"OCCH 699 Project Occupational Health and Safety (15 credits)",
"OCCH 699D1 Project Occupational Health and Safety (7.5 credits)",
"OCCH 699D2 Project Occupational Health and Safety (7.5 credits)",
"OCCH 699N1 Project Occupational Health and Safety (7.5 credits)",
"OCCH 699N2 Project Occupational Health and Safety (7.5 credits)",
"OCCH 700 Ph.D. Comprehensive Examination",
"OCCH 706 Ph.D. Seminar on Occupational Health and Hygiene (2 credits)",
"OCCH 706D1 Ph.D. Seminar on Occupational Health and Hygiene (1 credit)",
"OCCH 706D2 Ph.D. Seminar on Occupational Health and Hygiene (1 credit)",
"ONCO 610D1 Fundamentals of Oncology and Cancer Research (3 credits)",
"ONCO 610D2 Fundamentals of Oncology and Cancer Research (3 credits)",
"ONCO 615 Principles and Practice of Clinical Trials (3 credits)",
"ONCO 620 Best Practices in Biomedical Research (3 credits)",
"ONCO 625 Quality Improvement Principles and Methods (3 credits)",
"ONCO 630 Oncology Practicum (3 credits)",
"ONCO 635 Qualitative and Psychosocial Health Research (3 credits)",
"OPTH 300 TCP Ophthalmology (1 credit)",
"ORGB 321 Leadership (3 credits)",
"ORGB 325 Negotiations and Conflict Resolution (3 credits)",
"ORGB 330 People Analytics (3 credits)",
"ORGB 380 Cross Cultural Management (3 credits)",
"ORGB 401 Leadership Practicum in Social Sector (3 credits)",
"ORGB 409 Organizational Research Methods (3 credits)",
"ORGB 420 Managing Organizational Teams (3 credits)",
"ORGB 421 Managing Organizational Change (3 credits)",
"ORGB 423 Human Resources Management (3 credits)",
"ORGB 434 Topics in Organizational Behaviour 1 (3 credits)",
"ORGB 440 Career Theory and Development (3 credits)",
"ORGB 525 Compensation Management (3 credits)",
"ORGB 625 Managing Organizational Change (3 credits)",
"ORGB 632 Managing Teams in Organizations (3 credits)",
"ORGB 633 Managerial Negotiations (3 credits)",
"ORGB 634 Career Development (3 credits)",
"ORGB 635 Advanced Managerial Negotiations (3 credits)",
"ORGB 640 The Art of Leadership (3 credits)",
"ORGB 643D1 Leading and Managing People in Healthcare (1 credit)",
"ORGB 643D2 Leading and Managing People in Healthcare (1 credit)",
"ORGB 644D1 Managerial Negotiations in Healthcare (1 credit)",
"ORGB 644D2 Managerial Negotiations in Healthcare (1 credit)",
"ORGB 660 Managing Data Analytics Teams (1.5 credits)",
"ORGB 661 Ethical Leadership and Leading Change (1.5 credits)",
"ORGB 671 Talent Analytics (1.5 credits)",
"ORGB 672 Organizational Network Analysis (1.5 credits)",
"ORGB 680 Talent Management in a Global World (3 credits)",
"ORGB 685 Cross Cultural Management (3 credits)",
"ORGB 685D1 Cross Cultural Management (1.5 credits)",
"ORGB 685D2 Cross Cultural Management (1.5 credits)",
"ORGB 690 Advanced Topics in Organizational Behaviour 1 (3 credits)",
"ORGB 695 Advanced Topics in Organizational Behaviour (1.5 credits)",
"ORGB 705 Seminar in Behavioural Science (3 credits)",
"ORGB 706 Meso Organizational Behaviour (3 credits)",
"ORGB 707 The Use and Abuse of Power (3 credits)",
"ORGB 708 Social Network Analysis for Social Science Research (3 credits)",
"OTOL 602 Physiology Histopathology and Clinical Otolaryngology 1 (3 credits)",
"OTOL 603 Advanced Scientific Principles - Otolaryngology 1 (3 credits)",
"OTOL 612 Physiology Histopathology and Clinical Otolaryngology 2 (3 credits)",
"OTOL 613 Advanced Scientific Principles - Otolaryngology 2 (3 credits)",
"OTOL 690 M.Sc. Thesis 1 (3 credits)",
"OTOL 691 M.Sc. Thesis 2 (3 credits)",
"OTOL 692 M.Sc. Thesis 3 (6 credits)",
"OTOL 693 M.Sc. Thesis 4 (6 credits)",
"OTOL 694 M.Sc. Thesis 5 (12 credits)",
"PAED 301 TCP Pediatrics (2 credits)",
"PAED 401 Pediatrics Clerkship (6 credits)",
"PAED 401D1 Pediatrics Clerkship (3 credits)",
"PAED 401D2 Pediatrics Clerkship (3 credits)",
"PARA 410 Environment and Infection (3 credits)",
"PARA 424 Fundamental Parasitology (3 credits)",
"PARA 438 Immunology (3 credits)",
"PARA 515 Water Health and Sanitation (3 credits)",
"PARA 606 Parasitology Seminar (2 credits)",
"PARA 607 Parasitology Research Seminar (2 credits)",
"PARA 635 Cell Biology and Infection (3 credits)",
"PARA 645 Applied Parasitology (3 credits)",
"PARA 655 Host-Parasite Interactions (3 credits)",
"PARA 665 Special Topics in Parasitology (3 credits)",
"PARA 678 Microcirculation and Inflammation (3 credits)",
"PARA 687 Thesis Research 1 (11 credits)",
"PARA 688 Thesis Research 2 (11 credits)",
"PARA 689 Thesis Research 3 (13 credits)",
"PARA 690 Thesis Research 4 (2 credits)",
"PARA 691 Thesis Research 5 (6 credits)",
"PARA 701 PhD Comprehensive Exam",
"PARA 710 Parasitology Ph.D. Seminar 1 (2 credits)",
"PARA 711 Parasitology Ph.D. Seminar 2 (2 credits)",
"PATH 300 Human Disease (3 credits)",
"PATH 504 Disease in Depth (3 credits)",
"PATH 607 Biochemical Pathology (3 credits)",
"PATH 613 Research Topics in Pathology 1 (3 credits)",
"PATH 614 Research Topics in Pathology 2 (3 credits)",
"PATH 620 Research Seminar 1 (3 credits)",
"PATH 622 Research Seminar 2 (3 credits)",
"PATH 652 Molecular Biology of Disease (3 credits)",
"PATH 653 Reading and Conference (3 credits)",
"PATH 690 M.Sc. Thesis Research Project 1 (9 credits)",
"PATH 691 M.Sc. Thesis Research Project 2 (9 credits)",
"PATH 692 M.Sc. Thesis Research Project 3 (12 credits)",
"PATH 701 Comprehensive Examination - Ph.D. Candidates",
"PHAR 200 Introduction to Pharmacology 1 (1 credit)",
"PHAR 201 Introduction to Pharmacology 2 (1 credit)",
"PHAR 300 Drug Action (3 credits)",
"PHAR 301 Drugs and Disease (3 credits)",
"PHAR 303 Principles of Toxicology (3 credits)",
"PHAR 390 Laboratory in Pharmacology (3 credits)",
"PHAR 396 Undergraduate Research Project (3 credits)",
"PHAR 397 Pharmacology Research Project 2 (3 credits)",
"PHAR 503 Drug Discovery and Development 1 (3 credits)",
"PHAR 504 Drug Discovery and Development 2 (3 credits)",
"PHAR 505 Structural Pharmacology (3 credits)",
"PHAR 508 Drug Discovery and Development 3 (3 credits)",
"PHAR 540 Advances in Industrial Biotechnology (3 credits)",
"PHAR 562 Neuropharmacology (3 credits)",
"PHAR 563 Endocrine Pharmacology (3 credits)",
"PHAR 565 Epigenetic Drugs and Targets (3 credits)",
"PHAR 598 Honours Pharmacology Research Project (6 credits)",
"PHAR 598D1 Honours Pharmacology Research Project (3 credits)",
"PHAR 598D2 Honours Pharmacology Research Project (3 credits)",
"PHAR 599 Pharmacology Research Project (6 credits)",
"PHAR 599D1 Pharmacology Research Project (3 credits)",
"PHAR 599D2 Pharmacology Research Project (3 credits)",
"PHAR 601 Research Seminar (6 credits)",
"PHAR 601D1 Research Seminar (3 credits)",
"PHAR 601D2 Research Seminar (3 credits)",
"PHAR 601N1 Research Seminar (3 credits)",
"PHAR 601N2 Research Seminar (3 credits)",
"PHAR 602 Principles of Pharmacology (3 credits)",
"PHAR 609 Research Professionalism for Pharmacologists (1 credit)",
"PHAR 610 Scientific Communication for Pharmacologists (2 credits)",
"PHAR 670 Principles of Environmental Health Sciences 1 (3 credits)",
"PHAR 671 Principles of Environmental Health Sciences 2 (3 credits)",
"PHAR 696 Thesis Preparation (3 credits)",
"PHAR 697 Thesis Preparation 1 (6 credits)",
"PHAR 698 Thesis Preparation 2 (9 credits)",
"PHAR 699 Thesis Preparation 3 (12 credits)",
"PHAR 700 Seminars in Pharmacology (3 credits)",
"PHAR 701 Ph.D. Comprehensive Exam",
"PHAR 702 Topics in Pharmacology 1 (3 credits)",
"PHAR 703 Topics in Pharmacology 2 (3 credits)",
"PHAR 704 Topics in Pharmacology 3 (3 credits)",
"PHAR 705 Topics in Pharmacology 4 (3 credits)",
"PHAR 706 Topics in Pharmacology 5 (3 credits)",
"PHAR 707 Topics in Pharmacology 6 (3 credits)",
"PHAR 712 Statistics for Pharmacologists (3 credits)",
"PHGY 209 Mammalian Physiology 1 (3 credits)",
"PHGY 210 Mammalian Physiology 2 (3 credits)",
"PHGY 212 Introductory Physiology Laboratory 1 (1 credit)",
"PHGY 213 Introductory Physiology Laboratory 2 (1 credit)",
"PHGY 311 Channels Synapses and Hormones (3 credits)",
"PHGY 312 Respiratory Renal & Cardiovascular Physiology (3 credits)",
"PHGY 313 Blood Gastrointestinal & Immune Systems Physiology (3 credits)",
"PHGY 314 Integrative Neuroscience (3 credits)",
"PHGY 351 Research Techniques: Physiology (3 credits)",
"PHGY 359D1 Tutorial in Physiology (0.5 credits)",
"PHGY 359D2 Tutorial in Physiology (0.5 credits)",
"PHGY 396 Undergraduate Research Project (3 credits)",
"PHGY 419D1 Immunology Research Project (4.5 credits)",
"PHGY 419D2 Immunology Research Project (4.5 credits)",
"PHGY 425 Analyzing Physiological Systems (3 credits)",
"PHGY 451 Advanced Neurophysiology (3 credits)",
"PHGY 459D1 Physiology Seminar (3 credits)",
"PHGY 459D2 Physiology Seminar (3 credits)",
"PHGY 461D1 Experimental Physiology (4.5 credits)",
"PHGY 461D2 Experimental Physiology (4.5 credits)",
"PHGY 488 Stem Cell Biology (3 credits)",
"PHGY 499 Independent Study in Physiology (1 credit)",
"PHGY 502 Exercise Physiology (3 credits)",
"PHGY 508 Advanced Renal Physiology (3 credits)",
"PHGY 513 Translational Immunology (3 credits)",
"PHGY 515 Blood-Brain Barrier in Health and Disease (3 credits)",
"PHGY 516 Physiology of Blood (3 credits)",
"PHGY 517 Artificial Internal Organs (3 credits)",
"PHGY 518 Artificial Cells (3 credits)",
"PHGY 520 Ion Channels (3 credits)",
"PHGY 524 Chronobiology (3 credits)",
"PHGY 531 Topics in Applied Immunology (3 credits)",
"PHGY 550 Molecular Physiology of Bone (3 credits)",
"PHGY 552 Cellular and Molecular Physiology (3 credits)",
"PHGY 556 Topics in Systems Neuroscience (3 credits)",
"PHGY 560 Light Microscopy-Life Science (3 credits)",
"PHGY 601 M.Sc. Proposal Seminar (1 credit)",
"PHGY 602 Literature Search and Research Proposal (2 credits)",
"PHGY 603 Systems Biology and Biophysics (3 credits)",
"PHGY 604 Responsible Conduct in Research",
"PHGY 607 Laboratory Research 1 (3 credits)",
"PHGY 608 Laboratory Research 2 (3 credits)",
"PHGY 610 Biophysics (3 credits)",
"PHGY 620 Progress in Research (3 credits)",
"PHGY 621 Thesis 1 (12 credits)",
"PHGY 622 Thesis 2 (12 credits)",
"PHGY 623 M.Sc. Final Seminar (3 credits)",
"PHGY 701 Ph.D. Comprehensive Examination",
"PHGY 703 Ph.D. Progress Seminar 1 (1 credit)",
"PHGY 704 Ph.D. Progress Seminar 2 (1 credit)",
"PHGY 720 Ph.D. Seminar Course 1 (1 credit)",
"PHGY 721 Ph.D. Seminar Course 2 (1 credit)",
"PHGY 722 Ph.D. Seminar Course 3 (1 credit)",
"PHGY 723 Ph.D. Seminar Course 4 (1 credit)",
"PHGY 724 Ph.D. Seminar Course 5 (1 credit)",
"PHGY 725 Ph.D. Seminar Course 6 (1 credit)",
"PHIL 197 FYS: Right and Wrong (3 credits)",
"PHIL 198 FYS: Knowledge and Ideas in Early Modern Philosophy (3 credits)",
"PHIL 199 FYS: Minds Brain and Machines (3 credits)",
"PHIL 200 Introduction to Philosophy 1 (3 credits)",
"PHIL 201 Introduction to Philosophy 2 (3 credits)",
"PHIL 210 Introduction to Deductive Logic 1 (3 credits)",
"PHIL 221 Introduction to History and Philosophy of Science 2 (3 credits)",
"PHIL 230 Introduction to Moral Philosophy 1 (3 credits)",
"PHIL 237 Contemporary Moral Issues (3 credits)",
"PHIL 240 Political Philosophy 1 (3 credits)",
"PHIL 242 Introduction to Feminist Theory (3 credits)",
"PHIL 301 Philosophical Fundamentals (3 credits)",
"PHIL 304 Chomsky (3 credits)",
"PHIL 306 Philosophy of Mind (3 credits)",
"PHIL 310 Intermediate Logic (3 credits)",
"PHIL 311 Philosophy of Mathematics (3 credits)",
"PHIL 327 Philosophy of Race (3 credits)",
"PHIL 332 Philosophy of Religion 1 (3 credits)",
"PHIL 334 Ethical Theory (3 credits)",
"PHIL 336 Aesthetics (3 credits)",
"PHIL 340 Philosophy of the Social Sciences 1 (3 credits)",
"PHIL 341 Philosophy of Science 1 (3 credits)",
"PHIL 343 Biomedical Ethics (3 credits)",
"PHIL 344 Medieval and Renaissance Political Theory (3 credits)",
"PHIL 345 Greek Political Theory (3 credits)",
"PHIL 348 Philosophy of Law 1 (3 credits)",
"PHIL 349 Environmental Philosophy (3 credits)",
"PHIL 350 History and Philosophy of Ancient Science (3 credits)",
"PHIL 353 The Presocratic Philosophers (3 credits)",
"PHIL 354 Plato (3 credits)",
"PHIL 355 Aristotle (3 credits)",
"PHIL 356 Early Medieval Philosophy (3 credits)",
"PHIL 357 Late Medieval and Renaissance Philosophy (3 credits)",
"PHIL 360 17th Century Philosophy (3 credits)",
"PHIL 361 18th Century Philosophy (3 credits)",
"PHIL 366 18th and Early 19th Century German Philosophy (3 credits)",
"PHIL 367 19th Century Philosophy (3 credits)",
"PHIL 370 Problems in Analytic Philosophy (3 credits)",
"PHIL 375 Existentialism (3 credits)",
"PHIL 397 Tutorial 01 (3 credits)",
"PHIL 398 Tutorial 02 (3 credits)",
"PHIL 410 Advanced Topics in Logic 1 (3 credits)",
"PHIL 411 Topics in Philosophy of Logic and Mathematics (3 credits)",
"PHIL 415 Philosophy of Language (3 credits)",
"PHIL 419 Epistemology (3 credits)",
"PHIL 421 Metaphysics (3 credits)",
"PHIL 434 Metaethics (3 credits)",
"PHIL 436 Aesthetics 2 (3 credits)",
"PHIL 440 Philosophy of Social Sciences 2 (3 credits)",
"PHIL 441 Philosophy of Science 2 (3 credits)",
"PHIL 442 Topics in Feminist Theory (3 credits)",
"PHIL 444 Early Modern Political Theory (3 credits)",
"PHIL 445 19th Century Political Theory (3 credits)",
"PHIL 446 Current Issues in Political Philosophy (3 credits)",
"PHIL 450 Major Philosophers 1 (3 credits)",
"PHIL 452 Later Greek Philosophy (3 credits)",
"PHIL 453 Ancient Metaphysics and Natural Philosophy (3 credits)",
"PHIL 454 Ancient Moral Theory (3 credits)",
"PHIL 460 Major Philosophers 2 (3 credits)",
"PHIL 470 Topics in Contemporary Analytic Philosophy (3 credits)",
"PHIL 474 Phenomenology (3 credits)",
"PHIL 475 Topics in Contemporary European Philosophy (3 credits)",
"PHIL 480 Topics in the History of Philosophy (3 credits)",
"PHIL 481 Topics in Philosophy (3 credits)",
"PHIL 497 Tutorial 04 (3 credits)",
"PHIL 497N1 Tutorial 04 (1.5 credits)",
"PHIL 497N2 Tutorial 04 (1.5 credits)",
"PHIL 498 Tutorial 05 (3 credits)",
"PHIL 498N1 Tutorial 05 (1.5 credits)",
"PHIL 498N2 Tutorial 05 (1.5 credits)",
"PHIL 499 Tutorial 06 (6 credits)",
"PHIL 499D1 Tutorial 06 (3 credits)",
"PHIL 499D2 Tutorial 06 (3 credits)",
"PHIL 499N1 Tutorial 06 (3 credits)",
"PHIL 499N2 Tutorial 06 (3 credits)",
"PHIL 551 Seminar: Ancient Philosophy 2 (3 credits)",
"PHIL 598 Tutorial 07 (3 credits)",
"PHIL 606 Seminar: Philosophy of Mind (3 credits)",
"PHIL 607 Pro-Seminar 1 (6 credits)",
"PHIL 609 Seminar: Cognitive Science (3 credits)",
"PHIL 610 Seminar on Advanced Logic 2 (3 credits)",
"PHIL 611 Seminar: Philosophy of Logic and Mathematics (3 credits)",
"PHIL 615 Seminar: Philosophy of Language (3 credits)",
"PHIL 619 Seminar: Epistemology (3 credits)",
"PHIL 621 Seminar: Metaphysics (3 credits)",
"PHIL 624 Seminar: History & Philosophy of Science (3 credits)",
"PHIL 634 Seminar: Ethics (3 credits)",
"PHIL 635 Seminar: History of Ethics (3 credits)",
"PHIL 636 Seminar: Aesthetics (3 credits)",
"PHIL 640 Seminar: Foundations of Science 1 (3 credits)",
"PHIL 641 Seminar: Philosophy of Science (3 credits)",
"PHIL 642 Seminar: Feminist Theory (3 credits)",
"PHIL 643 Seminar: Medical Ethics (3 credits)",
"PHIL 644 Political Theory (3 credits)",
"PHIL 648 Seminar: Philosophy of Law (3 credits)",
"PHIL 650 Seminar: Ancient Philosophy 1 (3 credits)",
"PHIL 651 Seminar: Ancient Philosophy 2 (3 credits)",
"PHIL 656 Medieval Philosophy (3 credits)",
"PHIL 660 Seminar: 17th Century Philosophy (3 credits)",
"PHIL 661 Seminar: 18th Century Philosophy (3 credits)",
"PHIL 667 Seminar: 19th Century Philosophy (3 credits)",
"PHIL 670 Seminar: Contemporary Analytic Philosophy (3 credits)",
"PHIL 675 Seminar: Contemporary European Philosophy (3 credits)",
"PHIL 680 Seminar: Problems of Philosophy 1 (3 credits)",
"PHIL 682 Pro-Seminar 3 (6 credits)",
"PHIL 685 Fundamentals of Logic (3 credits)",
"PHIL 689 Seminar: Special Topics in Philosophy (3 credits)",
"PHIL 690 Candidacy Paper (3 credits)",
"PHIL 701D1 Ph.D. Comprehensive Examination",
"PHIL 701D2 Ph.D. Comprehensive Examination",
"PHIL 701N1 Ph.D. Comprehensive Examination",
"PHIL 701N2 Ph.D. Comprehensive Examination",
"PHIL 702 Seminar: Teaching Philosophy (3 credits)",
"PHIL 703 Teaching Reflection and Practice (1 credit)",
"PHIL 705 Guided Research in Ethics 1 (3 credits)",
"PHIL 706 Guided Research in Ethics 2 (3 credits)",
"PHIL 710 Guided Research in Logic 1 (3 credits)",
"PHIL 711 Guided Research in Logic 2 (3 credits)",
"PHIL 720 Guided Research: Philosophy of Science 1 (3 credits)",
"PHIL 721 Guided Research: Philosophy of Science 2 (3 credits)",
"PHIL 731 Guided Research: Philosophy of Religion 2 (3 credits)",
"PHIL 740 Guided Research: Ancient Philosophy 1 (3 credits)",
"PHIL 741 Guided Research: Ancient Philosophy 2 (3 credits)",
"PHIL 750 Guided Research: Medieval Philosophy 1 (3 credits)",
"PHIL 751 Guided Research: Medieval Philosophy 2 (3 credits)",
"PHIL 760 Guided Research: History of Philosophy 1 (3 credits)",
"PHIL 761 Guided Research: History of Philosophy 2 (3 credits)",
"PHIL 770 Guided Research: Philosophy of Politics 1 (3 credits)",
"PHIL 771 Guided Research: Philosophy of Politics 2 (3 credits)",
"PHIL 780 Guided Research: Epistemology/Metaphysics 1 (3 credits)",
"PHIL 781 Guided Research: Epistemology/Metaphysics 2 (3 credits)",
"PHTH 201 Sports Medicine Practicum 1 (1 credit)",
"PHTH 202 Sports Medicine Practicum 2 (1 credit)",
"PHTH 245 Introduction to Professional Practice 1 (3 credits)",
"PHTH 301 Sports Medicine Practicum (3 credits)",
"PHTH 301D1 Sports Medicine Practicum (1.5 credits)",
"PHTH 301D2 Sports Medicine Practicum (1.5 credits)",
"PHTH 303 Sports Medicine Practicum 3 (1 credit)",
"PHTH 320 Clinical Affiliation 2 (6 credits)",
"PHTH 321 Clinical Affiliation 3 (6 credits)",
"PHTH 328 Biophysical Agents (2 credits)",
"PHTH 336 Movement 2: Cardiorespiratory (3 credits)",
"PHTH 337 Movement 3: Neuromuscular (3 credits)",
"PHTH 338 Movement 4: Neurological (4 credits)",
"PHTH 340 Exercise Physiology (3 credits)",
"PHTH 420 Clinical Affiliation 4 (3 credits)",
"PHTH 421 Clinical Affiliation 5 (3 credits)",
"PHTH 432 Pain Management (3 credits)",
"PHTH 433 Coordinated Rehabilitation 1 (3 credits)",
"PHTH 434 Biomechanics (3 credits)",
"PHTH 435 Coordinated Rehabilitation (3 credits)",
"PHTH 438 Fitness/Injury Management (2 credits)",
"PHTH 440 Clinical Exercise Physiology (3 credits)",
"PHTH 450 Introduction to PT Clinical Practice (3 credits)",
"PHTH 550 Physical Therapy Orthopedic Management (7 credits)",
"PHTH 551 Physical Therapy Neurological Rehabilitation (4 credits)",
"PHTH 554 PT Cardiorespiratory Rehabilitation (2 credits)",
"PHTH 560 Integrated Orthopedic Management (6 credits)",
"PHTH 561 Integrated Neurological Rehabilitation (5 credits)",
"PHTH 564 Integrated Cardiorespiratory Rehabilitation (3 credits)",
"PHTH 570 Strategies in Physical Therapy Professional Practice (3 credits)",
"PHTH 571 PT Clinical Practicum 1 (7 credits)",
"PHTH 572 PT Clinical Practicum 2 (7 credits)",
"PHTH 573 PT Clinical Practicum 3 (8 credits)",
"PHTH 606 Introduction to Pediatric Physical Therapy (2 credits)",
"PHTH 620 PT Clinical Practicum 4 (7 credits)",
"PHTH 622 Integrated Pain Management (3 credits)",
"PHTH 623 Differential Diagnosis and Management (4 credits)",
"PHTH 641 Topics in Cardiorespiratory Rehabilitation (3 credits)",
"PHTH 645 Pelvic Floor Rehabilitation (3 credits)",
"PHTH 652 Integrated Clinical Exercise Rehabilitation (3 credits)",
"PHTH 661 Sport Physiotherapy (3 credits)",
"PHTH 662 Advanced Manual Therapy (3 credits)",
"PHWR 300 Philosophy & Western Religions 1 (3 credits)",
"PHWR 301 Philosophy & Western Religions 2 (3 credits)",
"PHWR 400 Joint Honours/Honours Tutorial (3 credits)",
"PHWR 401 Honours Thesis Tutorial 1 (3 credits)",
"PHWR 402 Honours Thesis Tutorial 2 (3 credits)",
"PHWR 500D1 Interdisciplinary Seminar (1.5 credits)",
"PHWR 500D2 Interdisciplinary Seminar (1.5 credits)",
"PHYS 101 Introductory Physics - Mechanics (4 credits)",
"PHYS 102 Introductory Physics - Electromagnetism (4 credits)",
"PHYS 107 Mechanics Laboratory (Life Sciences) (1 credit)",
"PHYS 108 E&M Laboratory (Life Sciences) (1 credit)",
"PHYS 117 Mechanics Laboratory (1 credit)",
"PHYS 118 E & M Laboratory (1 credit)",
"PHYS 131 Mechanics and Waves (4 credits)",
"PHYS 142 Electromagnetism and Optics (4 credits)",
"PHYS 180 Space Time and Matter (3 credits)",
"PHYS 181 Everyday Physics (3 credits)",
"PHYS 182 Our Evolving Universe (3 credits)",
"PHYS 183 The Milky Way Inside and Out (3 credits)",
"PHYS 184 Energy and the Environment (3 credits)",
"PHYS 186 Astrobiology (3 credits)",
"PHYS 224 Physics of Music (3 credits)",
"PHYS 228 Energy and the Environment (3 credits)",
"PHYS 230 Dynamics of Simple Systems (3 credits)",
"PHYS 232 Heat and Waves (3 credits)",
"PHYS 241 Signal Processing (3 credits)",
"PHYS 242 Electricity and Magnetism (2 credits)",
"PHYS 251 Honours Classical Mechanics 1 (3 credits)",
"PHYS 253 Thermal Physics (3 credits)",
"PHYS 257 Experimental Methods 1 (3 credits)",
"PHYS 258 Experimental Methods 2 (3 credits)",
"PHYS 260 Modern Physics and Relativity (3 credits)",
"PHYS 271 Introduction to Quantum Physics (3 credits)",
"PHYS 319 Introduction to Biophysics (3 credits)",
"PHYS 320 Introductory Astrophysics (3 credits)",
"PHYS 321 Data Science and Observational Astrophysics (3 credits)",
"PHYS 328 Electronics (3 credits)",
"PHYS 329 Statistical Physics with Biophysical Applications (3 credits)",
"PHYS 331 Topics in Classical Mechanics (3 credits)",
"PHYS 333 Thermal and Statistical Physics (3 credits)",
"PHYS 339 Measurements Laboratory in General Physics (3 credits)",
"PHYS 340 Majors Electricity and Magnetism (3 credits)",
"PHYS 342 Majors Electromagnetic Waves (3 credits)",
"PHYS 346 Majors Quantum Physics (3 credits)",
"PHYS 350 Honours Electricity and Magnetism (3 credits)",
"PHYS 351 Honours Classical Mechanics 2 (3 credits)",
"PHYS 352 Honours Electromagnetic Waves (3 credits)",
"PHYS 357 Honours Quantum Physics 1 (3 credits)",
"PHYS 359 Honours Laboratory in Modern Physics 1 (3 credits)",
"PHYS 362 Statistical Mechanics (3 credits)",
"PHYS 396 Undergraduate Research Project (3 credits)",
"PHYS 404 Climate Physics (3 credits)",
"PHYS 413 Physical Basis of Physiology (3 credits)",
"PHYS 432 Physics of Fluids (3 credits)",
"PHYS 434 Optics (3 credits)",
"PHYS 439 Majors Laboratory in Modern Physics (3 credits)",
"PHYS 447 Applications of Quantum Mechanics (3 credits)",
"PHYS 449 Majors Research Project (3 credits)",
"PHYS 457 Honours Quantum Physics 2 (3 credits)",
"PHYS 459D1 Honours Research Thesis (3 credits)",
"PHYS 459D2 Honours Research Thesis (3 credits)",
"PHYS 469 Honours Laboratory in Modern Physics 2 (3 credits)",
"PHYS 478 Short Research Project (1 credit)",
"PHYS 479 Physics Research Project (3 credits)",
"PHYS 489 Special Project (3 credits)",
"PHYS 512 Computational Physics with Applications (3 credits)",
"PHYS 514 General Relativity (3 credits)",
"PHYS 519 Advanced Biophysics (3 credits)",
"PHYS 521 Astrophysics (3 credits)",
"PHYS 534 Nanoscience and Nanotechnology (3 credits)",
"PHYS 551 Quantum Theory (3 credits)",
"PHYS 557 Nuclear Physics (3 credits)",
"PHYS 558 Solid State Physics (3 credits)",
"PHYS 559 Advanced Statistical Mechanics (3 credits)",
"PHYS 562 Electromagnetic Theory (3 credits)",
"PHYS 567 Particle Physics (3 credits)",
"PHYS 606 Selected Topics: Contemporary Physics 1 (3 credits)",
"PHYS 607 Selected Topics: Contemporary Physics 2 (3 credits)",
"PHYS 610 Quantum Field Theory 1 (3 credits)",
"PHYS 616 Multifractals and Turbulence (3 credits)",
"PHYS 620 Experimental Methods of Subatomic Physics (3 credits)",
"PHYS 632 Seminar in  Astrophysics 1 (3 credits)",
"PHYS 633 Seminar in Astrophysics 2 (3 credits)",
"PHYS 634 Seminar in Advanced Materials (3 credits)",
"PHYS 641 Observational Techniques of Modern Astrophysics (3 credits)",
"PHYS 642 Radiative Processes in Astrophysics (3 credits)",
"PHYS 643 Astrophysical Fluids (3 credits)",
"PHYS 644 Galaxies and Cosmology (3 credits)",
"PHYS 645 High Energy Astrophysics (3 credits)",
"PHYS 657 Classical Condensed Matter (3 credits)",
"PHYS 658 Advanced Condensed Matter (3 credits)",
"PHYS 659 Experimental Condensed Matter (3 credits)",
"PHYS 660 Quantum Condensed Matter (3 credits)",
"PHYS 673 Quantum Field Theory 2 (3 credits)",
"PHYS 690 M.Sc. Thesis (24 credits)",
"PHYS 690D1 M.Sc. Thesis (12 credits)",
"PHYS 690D2 M.Sc. Thesis (12 credits)",
"PHYS 690N1 M.Sc. Thesis (12 credits)",
"PHYS 690N2 M.Sc. Thesis (12 credits)",
"PHYS 691 Thesis Preparation (3 credits)",
"PHYS 692 Thesis Project (6 credits)",
"PHYS 692D1 Thesis Project (3 credits)",
"PHYS 692D2 Thesis Project (3 credits)",
"PHYS 693 M.Sc. Research (3 credits)",
"PHYS 700 Preliminary Ph.D. Examination",
"PHYS 717 Many-body Physics (3 credits)",
"PHYS 718 Special Topics: Solid State Physics 1 (3 credits)",
"PHYS 719 Special Topics: Solid State Physics 2 (3 credits)",
"PHYS 729 Special Topics in Nuclear Physics (3 credits)",
"PHYS 730 Special Topics: High Energy Physics 1 (3 credits)",
"PHYS 731 Special Topics: High Energy Physics 2 (3 credits)",
"PHYS 741 Superstring Theory (3 credits)",
"PHYS 742 Introduction to the Standard Model (3 credits)",
"PHYS 743 Very Early Universe (3 credits)",
"PHYS 744 Finite Temperature Field Theory (3 credits)",
"PHYS 745 Supersymmetry and Supergravity (3 credits)",
"PLAI 300 Interdisciplinary Humanities Topics (3 credits)",
"PLAI 400 Interdisciplinary Seminar in the Humanities (3 credits)",
"PLAI 500 Advanced Interdisciplinary Humanities Seminar (3 credits)",
"PLAI 600 Interdisciplinary Theories and Methods (3 credits)",
"PLNT 203 Economic Botany (3 credits)",
"PLNT 221 Introduction to Fungi (1 credit)",
"PLNT 300 Cropping Systems (3 credits)",
"PLNT 302 Forage Crops and Pastures (3 credits)",
"PLNT 304 Biology of Fungi (3 credits)",
"PLNT 305 Plant Pathology (3 credits)",
"PLNT 307 Agroecology of Vegetables and Fruits (3 credits)",
"PLNT 310 Plant Propagation (3 credits)",
"PLNT 312 Urban Horticulture (3 credits)",
"PLNT 322 Greenhouse Management (3 credits)",
"PLNT 350 Special Topics: Plant Science 1 (2 credits)",
"PLNT 353 Plant Structure and Function (3 credits)",
"PLNT 358 Flowering Plant Diversity (3 credits)",
"PLNT 426 Plant Ecophysiology (3 credits)",
"PLNT 430 Pesticides in Agriculture (3 credits)",
"PLNT 434 Weed Biology and Control (3 credits)",
"PLNT 435 Plant Breeding (3 credits)",
"PLNT 460 Plant Ecology (3 credits)",
"PLNT 470 Cannabis Issues and Concerns (3 credits)",
"PLNT 471 Commercial Cannabis Production (4 credits)",
"PLNT 472 Cannabis Genetics and Breeding (4 credits)",
"PLNT 473 Control of Cannabis Diseases (4 credits)",
"PLNT 474 Commercial Cannabis Internship (6 credits)",
"PLNT 602 Advances in Agronomy (3 credits)",
"PLNT 619 Advances in Plant Biology & Physiology (3 credits)",
"PLNT 622 Advances in Plant Protection (3 credits)",
"PLNT 646 Advances in Plant-Biotic & -Abiotic Interactions (3 credits)",
"PLNT 650 Advances in Plant Biodiversity & Ecology (3 credits)",
"PLNT 662 Advances in Plant Biotechnology (3 credits)",
"PLNT 664 M.Sc. Thesis 1 (12 credits)",
"PLNT 665 M.Sc. Thesis 2 (12 credits)",
"PLNT 666 M.Sc. Thesis 3 (15 credits)",
"PLNT 667 MSc Thesis 3A (12 credits)",
"PLNT 670 Special Topics (3 credits)",
"PLNT 690 Research Horizons in Plant Science 1",
"PLNT 691 Research Horizons in Plant Science 2",
"PLNT 701 Doctoral Comprehensive Examination",
"POLI 099 Teaching Methods (3 credits)",
"POLI 099D1 Teaching Methods (1.5 credits)",
"POLI 099D2 Teaching Methods (1.5 credits)",
"POLI 200 Introduction to Political Science (3 credits)",
"POLI 210 Political Science Research Methods (3 credits)",
"POLI 212 Government and Politics - Developed World (3 credits)",
"POLI 221 Government of Canada (3 credits)",
"POLI 222 Political Process and Behaviour in Canada (3 credits)",
"POLI 226 La vie politique québécoise (3 credits)",
"POLI 227 Developing Areas/Introduction (3 credits)",
"POLI 231 Introduction to Political Theory (3 credits)",
"POLI 232 Modern Political Thought (3 credits)",
"POLI 243 International Politics of Economic Relations (3 credits)",
"POLI 244 International Politics: State Behaviour (3 credits)",
"POLI 311 Introduction to Quantitative Political Science (3 credits)",
"POLI 312 Intermediate Quantitative Political Science (3 credits)",
"POLI 313 Introduction to Qualitative Methods in Political Science (3 credits)",
"POLI 315 Approaches to Political Economy (3 credits)",
"POLI 318 Comparative Local Government (3 credits)",
"POLI 319 Politics of Latin America (3 credits)",
"POLI 320 Issues in Canadian Democracy (3 credits)",
"POLI 321 Issues: Canadian Public Policy (3 credits)",
"POLI 322 Political Change in South Asia (3 credits)",
"POLI 324 Developing Areas/Africa (3 credits)",
"POLI 325 U.S. Politics (3 credits)",
"POLI 326 Provincial Politics (3 credits)",
"POLI 328 Comparing European Democracies (3 credits)",
"POLI 329 Russian and Soviet Politics (3 credits)",
"POLI 330 Law and Courts in Europe (3 credits)",
"POLI 331 Politics in East Central Europe (3 credits)",
"POLI 333 Western Political Theory 1 (3 credits)",
"POLI 334 Western Political Theory 2 (3 credits)",
"POLI 336 Le Québec et le Canada (3 credits)",
"POLI 337 Canadian Public Administration (3 credits)",
"POLI 338 Developing Areas/Topics 1 (3 credits)",
"POLI 339 Comparative Developed: Topics 1 (3 credits)",
"POLI 340 Developing Areas/Middle East (3 credits)",
"POLI 341 Foreign Policy: The Middle East (3 credits)",
"POLI 342 Canadian Foreign Policy (3 credits)",
"POLI 344 Foreign Policy: Europe (3 credits)",
"POLI 345 International Organizations (3 credits)",
"POLI 346 American Foreign Policy (3 credits)",
"POLI 347 Arab-Israel Conflict Crisis Peace (3 credits)",
"POLI 348 Gender and Canadian Politics (3 credits)",
"POLI 349 Foreign Policy: Asia (3 credits)",
"POLI 350 Global Environmental Politics (3 credits)",
"POLI 351 The Causes of Major Wars (3 credits)",
"POLI 352 International Policy/Foreign Policy: Africa (3 credits)",
"POLI 353 Politics of the International Refugee Regime (3 credits)",
"POLI 354 Approaches to International Political Economy (3 credits)",
"POLI 355 The Politics of International Law (3 credits)",
"POLI 357 Politics: Contemporary Europe (3 credits)",
"POLI 358 Political Economy of International Organizations (3 credits)",
"POLI 359 Topics in International Politics 1 (3 credits)",
"POLI 360 Security: War and Peace (3 credits)",
"POLI 361 Political Participation in Comparative Perspective (3 credits)",
"POLI 362 Political Theory and International Relations (3 credits)",
"POLI 363 Contemporary Political Theory (3 credits)",
"POLI 364 Radical Political Thought (3 credits)",
"POLI 365 Democratic Theory (3 credits)",
"POLI 366 Topics in Political Theory 1 (3 credits)",
"POLI 367 Liberal Political Theory (3 credits)",
"POLI 369 Politics of Southeast Asia (3 credits)",
"POLI 371 Challenge of Canadian Federalism (3 credits)",
"POLI 372 Indigenous Peoples and the Canadian State (3 credits)",
"POLI 378 The Canadian Judicial Process (3 credits)",
"POLI 379 Topics in Canadian Politics (3 credits)",
"POLI 380 Contemporary Chinese Politics (3 credits)",
"POLI 381 Politics in Japan and South Korea (3 credits)",
"POLI 410 Canadian Political Parties (3 credits)",
"POLI 412 Canadian Voting/Public Opinion (3 credits)",
"POLI 417 Health Care in Canada (3 credits)",
"POLI 419 Transitions from Communism (3 credits)",
"POLI 420 Memory Place and Power (3 credits)",
"POLI 422 Developing Areas/Topics 2 (3 credits)",
"POLI 423 Politics of Ethno-Nationalism (3 credits)",
"POLI 424 Media and Politics (3 credits)",
"POLI 425 Topics in American Politics (3 credits)",
"POLI 426 Partis politiques et comportements électoraux au Québec (3 credits)",
"POLI 427 Selected Topics: Canadian Politics (3 credits)",
"POLI 431 Nations and States/Developed World (3 credits)",
"POLI 432 Selected Topics: Comparative Politics (3 credits)",
"POLI 433 History of Political/Social Theory 3 (3 credits)",
"POLI 434 History of Political/Social Theory 4 (3 credits)",
"POLI 435 Identity and Inequality (3 credits)",
"POLI 436 Aboriginal Rights in the Canadian Constitution (3 credits)",
"POLI 441 IPE: Trade (3 credits)",
"POLI 442 International Relations of Ethnic Conflict (3 credits)",
"POLI 444 Topics in International Politics 2 (3 credits)",
"POLI 445 International Political Economy: Monetary Relations (3 credits)",
"POLI 448 Gender and International Relations (3 credits)",
"POLI 449 Diplomacy in Practice (3 credits)",
"POLI 450 Peacebuilding (3 credits)",
"POLI 451 The European Union (3 credits)",
"POLI 452 Conflict Simulation (3 credits)",
"POLI 459 Topics in Political Theory 2 (3 credits)",
"POLI 461 Advanced Quantitative Political Science (3 credits)",
"POLI 470 Philosophy Economy and Society (3 credits)",
"POLI 473 Democracy and the Market (3 credits)",
"POLI 474 Inequality and Development (3 credits)",
"POLI 475 Social Capital in Comparative Perspective (3 credits)",
"POLI 476 Religion and Politics (3 credits)",
"POLI 478 The Canadian Constitution (3 credits)",
"POLI 480 Contentious Politics (3 credits)",
"POLI 490 Independent Reading and Research 1 (3 credits)",
"POLI 499 Honours Essay (3 credits)",
"POLI 521 Seminar: Canadian Politics and Government (3 credits)",
"POLI 522 Seminar: Developing Areas (3 credits)",
"POLI 524 Seminar: Developed Areas (3 credits)",
"POLI 561 Seminar: Political Theory (3 credits)",
"POLI 575 Seminar: International Politics (3 credits)",
"POLI 599 Internship: Political Science (3 credits)",
"POLI 610 Public Policy: Canadian and Comparative Perspectives (3 credits)",
"POLI 611 Qualitative Analysis (3 credits)",
"POLI 612 Research Methods in Political Science (3 credits)",
"POLI 613 Selected Themes: Political Theory (3 credits)",
"POLI 614 Proseminar in Political Theory (3 credits)",
"POLI 615 Gender and Politics (3 credits)",
"POLI 616 Modern Political Analysis (3 credits)",
"POLI 617 Problems in Political Theory (3 credits)",
"POLI 618 Quantitative Analysis (3 credits)",
"POLI 619 Immigrants / Refugees / Minorities (3 credits)",
"POLI 621 Interpreting Canadian Political Process (3 credits)",
"POLI 622 Advanced Topics in Canadian Politics (3 credits)",
"POLI 623 Judicial Politics and the Constitution (3 credits)",
"POLI 626 Historical Analysis in Political Science (3 credits)",
"POLI 628 Comparative Politics (3 credits)",
"POLI 629 Post-Communist Transformations (3 credits)",
"POLI 630 Topics in European Politics (3 credits)",
"POLI 631 Comparative Federalism (3 credits)",
"POLI 632 Voting Behaviour/Public Opinion (3 credits)",
"POLI 633 Southeast Asian Politics (3 credits)",
"POLI 635 Theories of U.S. Politics (3 credits)",
"POLI 636 Approches Theor:Politique Que (3 credits)",
"POLI 639 Politics of Developed Areas (3 credits)",
"POLI 640 Middle East Politics (3 credits)",
"POLI 641 Seminar: Political Change in South Asia (3 credits)",
"POLI 642 African Politics (3 credits)",
"POLI 643 Politics of Identity (3 credits)",
"POLI 645 Advanced Contemporary Chinese Politics (3 credits)",
"POLI 646 Politics of Developing Areas 1 (3 credits)",
"POLI 647 Development Political Economy (3 credits)",
"POLI 648 Latin American Politics (3 credits)",
"POLI 650 Seminar in Peacebuilding (3 credits)",
"POLI 651 The EU and Political Integration (3 credits)",
"POLI 659 Interdisciplinary Seminar in European Studies (3 credits)",
"POLI 666 Causal Inference for Political Science (3 credits)",
"POLI 670 Advanced Topics: International Relations (3 credits)",
"POLI 671 International Relations Theory (3 credits)",
"POLI 672 International Political Economy (3 credits)",
"POLI 676 Sociological Issues in International Relations (3 credits)",
"POLI 677 International Crisis Conflict War (3 credits)",
"POLI 678 Research Seminar - International Politics (3 credits)",
"POLI 679 International Security: Conflict and Co-operation (3 credits)",
"POLI 680 Social Change/Advanced Industrialized Democracies (3 credits)",
"POLI 688 Seminar on Social Statistics (3 credits)",
"POLI 690 Reading in Political Science (3 credits)",
"POLI 690D1 Reading in Political Science (1.5 credits)",
"POLI 690D2 Reading in Political Science (1.5 credits)",
"POLI 691 Bibliographic Methods 1 (6 credits)",
"POLI 693 M.A. Research Proposal (3 credits)",
"POLI 694 Research Preparation 1 (3 credits)",
"POLI 695 Research Preparation 2 (3 credits)",
"POLI 696 Research Preparation 3 (3 credits)",
"POLI 697 M.A. Thesis Proposal (12 credits)",
"POLI 698 Master's Thesis Submission (12 credits)",
"POLI 698D1 Master's Thesis Submission (6 credits)",
"POLI 698D2 Master's Thesis Submission (6 credits)",
"POLI 699 Master's Research Essay (6 credits)",
"POLI 699D1 Master's Research Essay (3 credits)",
"POLI 699D2 Master's Research Essay (3 credits)",
"POLI 700 PhD Research Seminar",
"POLI 701 Ph.D. General Written Examination First Field",
"POLI 702 Ph.D. General Written Examination Second Field",
"POLI 799 Ph.D. Oral Comprehensive Examination",
"POTH 204 Introduction to Statistics for OT/PT (3 credits)",
"POTH 225 Introduction to Biomechanics in Rehabilitation Sciences (3 credits)",
"POTH 250 Introduction to Professional Practice 2 (3 credits)",
"POTH 401 Research Methods (3 credits)",
"POTH 402 Advanced Rheumatology (2 credits)",
"POTH 403 Paediatrics (2 credits)",
"POTH 410 Child and Adolescent Psychiatry (2 credits)",
"POTH 434 Musculoskeletal Biomechanics (3 credits)",
"POTH 441 Research Elective (2 credits)",
"POTH 445 Administration/Management (4 credits)",
"POTH 446 Current Topics: Rehabilitation (2 credits)",
"POTH 447 Specialized Area of Practice (2 credits)",
"POTH 455 Neurophysiology (3 credits)",
"POTH 508 Plasticity in Rehabilitation (3 credits)",
"POTH 563 Foundations of Professional Practice (3 credits)",
"POTH 602 Advanced Educational and Management Strategies (3 credits)",
"POTH 603 Directed Practicum (3 credits)",
"POTH 604 Current Topics in Pediatrics (3 credits)",
"POTH 610 Research Methodology (4 credits)",
"POTH 611 Health Research Methods (3 credits)",
"POTH 612 Applied Clinical Research Methods (4 credits)",
"POTH 614 Selected Topics in Rehabilitation Science (2 credits)",
"POTH 616 Seminars in Rehabilitation Science (1 credit)",
"POTH 617 Rehabilitation Seminars 1",
"POTH 618 Topics in Rehabilitation (3 credits)",
"POTH 619 Rehabilitation Seminars 2",
"POTH 620 Measurement: Rehabilitation 1 (3 credits)",
"POTH 624 Master's Project (7 credits)",
"POTH 625D1 Design of Assistive Technologies: Principles (1.5 credits)",
"POTH 625D2 Design of Assistive Technologies: Principles (1.5 credits)",
"POTH 627 Enabling Eating Drinking and Swallowing (3 credits)",
"POTH 628 Introduction to Regression Analysis (3 credits)",
"POTH 630 Measurement: Rehabilitation 2 (3 credits)",
"POTH 631 Research Proposal (3 credits)",
"POTH 632 Research Elective (3 credits)",
"POTH 633 Function/Activity in Arthritis (3 credits)",
"POTH 634 Childhood Performance Issues (3 credits)",
"POTH 635 Enabling Upper Extremity Function (3 credits)",
"POTH 636 Physical Therapy in Pediatrics (3 credits)",
"POTH 637 Cancer Rehabilitation (3 credits)",
"POTH 638 Promoting Wellness of Seniors (3 credits)",
"POTH 639 Motor Control (3 credits)",
"POTH 640 Role-Emerging Management (3 credits)",
"POTH 661 Research Project 1 (7 credits)",
"POTH 662 Research Project 2 (8 credits)",
"POTH 663 Pain Assessment in Clinical Practice (3 credits)",
"POTH 664 Neuroscience and Behavioural Perspectives of Pain (3 credits)",
"POTH 665 Interdisciplinary Management of Chronic Pain (3 credits)",
"POTH 666 Common Clinical Pain Syndromes (3 credits)",
"POTH 673 Screening for at Risk Drivers (3 credits)",
"POTH 674 Assessing Driving Ability 1 (3 credits)",
"POTH 675 Driving Assessment Practicum (3 credits)",
"POTH 676 Adaptive Equipment and Driving (3 credits)",
"POTH 677 Retraining Driving Skills (3 credits)",
"POTH 680 Knowledge Translation in Rehabilitation (3 credits)",
"POTH 682 Promoting Healthy Activity (2 credits)",
"POTH 684 Advanced Practice in Stroke Rehabilitation (3 credits)",
"POTH 685 Perception and Action (3 credits)",
"POTH 696 Thesis Research (2 credits)",
"POTH 697 Thesis Research 1 (6 credits)",
"POTH 697D1 Thesis Research 1 (3 credits)",
"POTH 697D2 Thesis Research 1 (3 credits)",
"POTH 698 Thesis Research 2 (9 credits)",
"POTH 698D1 Thesis Research 2 (4.5 credits)",
"POTH 698D2 Thesis Research 2 (4.5 credits)",
"POTH 699 Thesis Research 3 (12 credits)",
"POTH 699D1 Thesis Research 3 (6 credits)",
"POTH 699D2 Thesis Research 3 (6 credits)",
"POTH 701 Ph.D. Comprehensive",
"PPHS 501 Population Health and Epidemiology (3 credits)",
"PPHS 511 Fundamentals of Global Health (3 credits)",
"PPHS 525 Health Care Systems in Comparative Perspective (3 credits)",
"PPHS 527 Economics for Health Services Research and Policy (3 credits)",
"PPHS 528 Economic Evaluation of Health Programs (3 credits)",
"PPHS 529 Global Environmental Health and Burden of Disease (3 credits)",
"PPHS 593 Special Topics in Population and Public Health 1 (3 credits)",
"PPHS 602 Foundations of Population Health (3 credits)",
"PPHS 612 Principles of Public Health Practice (3 credits)",
"PPHS 612D1 Principles of Public Health Practice (1.5 credits)",
"PPHS 612D2 Principles of Public Health Practice (1.5 credits)",
"PPHS 613 The Practice of Global Health (3 credits)",
"PPHS 614 Knowledge Translation and Public Health Leadership (3 credits)",
"PPHS 615 Introduction to Infectious Disease Epidemiology (3 credits)",
"PPHS 616 Principles and Practice of Public Health Surveillance (3 credits)",
"PPHS 617 Impact Evaluation (3 credits)",
"PPHS 618 Program Planning and Evaluation in Public Health (3 credits)",
"PPHS 624 Public Health Ethics and Policy (3 credits)",
"PPHS 630 MScPH Practicum/Project (12 credits)",
"PPHS 631 MScPH Forum 2 (4 credits)",
"PPHS 631D1 MScPH Forum 2 (2 credits)",
"PPHS 631D2 MScPH Forum 2 (2 credits)",
"PPHS 681 Special Topics in Population and Public Health 2 (1 credit)",
"PPHS 682 Special Topics in Population and Public Health 3 (2 credits)",
"PPHS 683 Special Topics in Population and Public Health 4 (3 credits)",
"PPHS 684 Special Topics in Population and Public Health 5 (3 credits)",
"PPHS 699 MScPH Practicum Requirement (9 credits)",
"PPOL 601 Global Macroeconomic Policy (3 credits)",
"PPOL 602 Microeconomics for Public Policy (3 credits)",
"PPOL 603 Comparative Government Structures (3 credits)",
"PPOL 604 Ethics Rights and Law (3 credits)",
"PPOL 605 Analytical Methods for Policy Evaluation (3 credits)",
"PPOL 606 Experts Science and Evidence (3 credits)",
"PPOL 607 Information and Media Literacy (3 credits)",
"PPOL 611 Canadian Political and Policy Landscape (3 credits)",
"PPOL 612 U.S. Political and Policy Landscape (3 credits)",
"PPOL 613 Global Political and Policy Landscape (3 credits)",
"PPOL 620D1 Client-Focused Policy Laboratory (4.5 credits)",
"PPOL 620D2 Client-Focused Policy Laboratory (4.5 credits)",
"PPOL 631 Policy Case Study 1 (1 credit)",
"PPOL 632 Policy Case Study 2 (1 credit)",
"PPOL 633 Policy Case Study 3 (1 credit)",
"PPOL 634 Policy Case Study 4 (1 credit)",
"PPOL 635 Policy Case Study 5 (1 credit)",
"PPOL 636 Policy Case Study 6 (1 credit)",
"PPOL 637 Policy Case Study 7 (1 credit)",
"PPOL 638 Policy Case Study 8 (1 credit)",
"PPOL 640 Policymaking in a World of Business (2 credits)",
"PPOL 641 Rhetoric and Communication of Public Policy (2 credits)",
"PPOL 642 Policy and Globalization (2 credits)",
"PPOL 643 Ethical Dimensions of Policymaking (2 credits)",
"PPOL 644 Stakeholder Management (2 credits)",
"PPOL 645 Partisan Politics and Policy Process (2 credits)",
"PPOL 646 Budgeting and Fiscal Policy (2 credits)",
"PPOL 647 Achieving Policy Transparency (2 credits)",
"PPOL 648 Race Inequality and Public Policy (2 credits)",
"PPOL 650 Special Topics in Policy Complexity (2 credits)",
"PPOL 651 Special Topics in Policy Complexity 2 (2 credits)",
"PRAC 147D1 Introductory Legal Research (1.5 credits)",
"PRAC 147D2 Introductory Legal Research (1.5 credits)",
"PRAC 155D1 Legal Ethics and Advocacy (1.5 credits)",
"PRAC 155D2 Legal Ethics and Advocacy (1.5 credits)",
"PRAC 200 Advocacy (1 credit)",
"PRAC 510 Advanced Mooting 1 (3 credits)",
"PRAC 510D1 Advanced Mooting 1 (1.5 credits)",
"PRAC 510D2 Advanced Mooting 1 (1.5 credits)",
"PRAC 511 Advanced Mooting 2 (3 credits)",
"PROC 124 Judicial Institutions and Civil Procedure (4 credits)",
"PROC 124D1 Judicial Institutions and Civil Procedure (2 credits)",
"PROC 124D2 Judicial Institutions and Civil Procedure (2 credits)",
"PROC 200 Advanced Civil Law Obligations (3 credits)",
"PROC 459 Civil Litigation Workshop (3 credits)",
"PROC 549 Lease Enterprise Suretyship (3 credits)",
"PRV1 144 Civil Law Property (5 credits)",
"PRV1 144D1 Civil Law Property (2.5 credits)",
"PRV1 144D2 Civil Law Property (2.5 credits)",
"PRV2 270 Law of Persons (3 credits)",
"PRV2 500 Children and the Law (3 credits)",
"PRV3 200 Advanced Common Law Obligations (3 credits)",
"PRV3 534 Remedies (3 credits)",
"PRV4 144 Common Law Property (4 credits)",
"PRV4 144D1 Common Law Property (2 credits)",
"PRV4 144D2 Common Law Property (2 credits)",
"PRV4 451 Real Estate Transactions (3 credits)",
"PRV4 500 Restitution (3 credits)",
"PRV4 545 Land Use Planning (3 credits)",
"PRV4 548 Administration Property of Another and Trusts (3 credits)",
"PRV4 549 Equity and Trusts (3 credits)",
"PRV4 549D1 Equity and Trusts (1.5 credits)",
"PRV4 549D2 Equity and Trusts (1.5 credits)",
"PRV5 483 Consumer Law (3 credits)",
"PRV5 582 Advanced Torts (2 credits)",
"PSYC 100 Introduction to Psychology (3 credits)",
"PSYC 180 Critical Thinking: Biases and Illusions (3 credits)",
"PSYC 199 FYS: Mind-Body Medicine (3 credits)",
"PSYC 204 Introduction to Psychological Statistics (3 credits)",
"PSYC 211 Introductory Behavioural Neuroscience (3 credits)",
"PSYC 212 Perception (3 credits)",
"PSYC 213 Cognition (3 credits)",
"PSYC 215 Social Psychology (3 credits)",
"PSYC 301 Animal Learning and Theory (3 credits)",
"PSYC 302 The Psychology of Pain (3 credits)",
"PSYC 304 Child Development (3 credits)",
"PSYC 305 Statistics for Experimental Design (3 credits)",
"PSYC 310 Intelligence (3 credits)",
"PSYC 311 Human Cognition and the Brain (3 credits)",
"PSYC 315 Computational Psychology (3 credits)",
"PSYC 316 Psychology of Deafness (3 credits)",
"PSYC 317 Genes and Behaviour (3 credits)",
"PSYC 318 Behavioural Neuroscience 2 (3 credits)",
"PSYC 319 Computational Models -  Cognition (3 credits)",
"PSYC 328 Health Psychology (3 credits)",
"PSYC 329 Introduction to Auditory Cognition (3 credits)",
"PSYC 331 Inter-Group Relations (3 credits)",
"PSYC 332 Introduction to Personality (3 credits)",
"PSYC 333 Personality and Social Psychology (3 credits)",
"PSYC 337 Introduction to Psychopathology (3 credits)",
"PSYC 340 Psychology of Language (3 credits)",
"PSYC 341 The Psychology of Bilingualism (3 credits)",
"PSYC 342 Hormones and Behaviour (3 credits)",
"PSYC 351 Research Methods in Social Psychology (3 credits)",
"PSYC 352 Cognitive Psychology Laboratory (3 credits)",
"PSYC 353 Laboratory in Human Perception (3 credits)",
"PSYC 380D1 Honours Research Project Seminar (4.5 credits)",
"PSYC 380D2 Honours Research Project Seminar (4.5 credits)",
"PSYC 395 Psychology Research Project 1 (6 credits)",
"PSYC 396 Undergraduate Research Project (3 credits)",
"PSYC 403 Modern Psychology in Historical Perspective (3 credits)",
"PSYC 406 Psychological Tests (3 credits)",
"PSYC 408 Principles and Applications of Psychotherapy (3 credits)",
"PSYC 409 Positive Psychology (3 credits)",
"PSYC 410 Special Topics in Neuropsychology (3 credits)",
"PSYC 412 Developmental Psychopathology (3 credits)",
"PSYC 413 Cognitive Development (3 credits)",
"PSYC 414 Social Development (3 credits)",
"PSYC 427 Sensorimotor Neuroscience (3 credits)",
"PSYC 433 Cognitive Science (3 credits)",
"PSYC 436 Human Sexuality and Its Problems (3 credits)",
"PSYC 443 Affective Neuroscience (3 credits)",
"PSYC 444 Sleep Mechanisms and Behaviour (3 credits)",
"PSYC 450D1 Research Project and Seminar (4.5 credits)",
"PSYC 450D2 Research Project and Seminar (4.5 credits)",
"PSYC 451 Human Factors Research and Techniques (3 credits)",
"PSYC 470 Memory and Brain (3 credits)",
"PSYC 471 Human Motivation (3 credits)",
"PSYC 473 Social Cognition and the Self (3 credits)",
"PSYC 474 Interpersonal Relationships (3 credits)",
"PSYC 475 Neuroscience of Social Psychology (3 credits)",
"PSYC 482 Advanced Honours Seminar (3 credits)",
"PSYC 483 Seminar in Experimental Psychopathology (3 credits)",
"PSYC 488D1 Special Topics Seminar (1.5 credits)",
"PSYC 488D2 Special Topics Seminar (1.5 credits)",
"PSYC 491D1 Advanced Study: Behavioural Disorders (3 credits)",
"PSYC 491D2 Advanced Study: Behavioural Disorders (3 credits)",
"PSYC 492 Special Topics Seminar 1 (3 credits)",
"PSYC 493 Special Topics Seminar 2 (3 credits)",
"PSYC 494D1 Psychology Research Project (4.5 credits)",
"PSYC 494D2 Psychology Research Project (4.5 credits)",
"PSYC 494N1 Psychology Research Project (4.5 credits)",
"PSYC 494N2 Psychology Research Project (4.5 credits)",
"PSYC 495 Psychology Research Project 2 (6 credits)",
"PSYC 496 Senior Honours Research 1 (6 credits)",
"PSYC 497 Senior Honours Research 2 (6 credits)",
"PSYC 498D1 Senior Honours Research (4.5 credits)",
"PSYC 498D2 Senior Honours Research (4.5 credits)",
"PSYC 499 Reading Project (1 credit)",
"PSYC 501 Auditory Perception (3 credits)",
"PSYC 502 Psychoneuroendocrinology (3 credits)",
"PSYC 506 Cognitive Neuroscience of Attention (3 credits)",
"PSYC 507 Emotions Stress and Illness (3 credits)",
"PSYC 509 Diverse Clinical Populations (3 credits)",
"PSYC 512 Advanced Personality Seminar (3 credits)",
"PSYC 513 Human Decision-Making (3 credits)",
"PSYC 514 Neurobiology of Memory (3 credits)",
"PSYC 522 Neurochemistry and Behaviour (3 credits)",
"PSYC 526 Advances in Visual Perception (3 credits)",
"PSYC 528 Vulnerability to Depression and Anxiety (3 credits)",
"PSYC 529 Music Cognition (3 credits)",
"PSYC 530 Applied Topics in Deafness (3 credits)",
"PSYC 531 Structural Equation Models (3 credits)",
"PSYC 533 International Health Psychology (3 credits)",
"PSYC 535 Advanced Topics in Social Psychology (3 credits)",
"PSYC 536 Correlational Techniques (3 credits)",
"PSYC 537 Advanced Seminar in Psychology of Language (3 credits)",
"PSYC 538 Categorization Communication and Consciousness (3 credits)",
"PSYC 539 Advanced Topics in Social Psychology 2 (3 credits)",
"PSYC 541 Multilevel Modelling (3 credits)",
"PSYC 545 Topics in Language Acquisition (3 credits)",
"PSYC 561 Methods: Developmental Psycholinguistics (3 credits)",
"PSYC 562 Measurement of Psychological Processes (3 credits)",
"PSYC 601 Master's Comprehensive (6 credits)",
"PSYC 601D1 Master's Comprehensive (3 credits)",
"PSYC 601D2 Master's Comprehensive (3 credits)",
"PSYC 615D1 Diagnostic Methods (Children) (1.5 credits)",
"PSYC 615D2 Diagnostic Methods (Children) (1.5 credits)",
"PSYC 616D1 Practicum - Child Diagnostics (1.5 credits)",
"PSYC 616D2 Practicum - Child Diagnostics (1.5 credits)",
"PSYC 617D1 Diagnostic Methods (Adults) (1.5 credits)",
"PSYC 617D2 Diagnostic Methods (Adults) (1.5 credits)",
"PSYC 618D1 Practicum - Adult Diagnostics (1.5 credits)",
"PSYC 618D2 Practicum - Adult Diagnostics (1.5 credits)",
"PSYC 620 Practicum in Psychotherapy (6 credits)",
"PSYC 620D1 Practicum in Psychotherapy (3 credits)",
"PSYC 620D2 Practicum in Psychotherapy (3 credits)",
"PSYC 625 Research: Clinical Psychology (3 credits)",
"PSYC 625D1 Research: Clinical Psychology (1.5 credits)",
"PSYC 625D2 Research: Clinical Psychology (1.5 credits)",
"PSYC 630 Psychopathology (3 credits)",
"PSYC 641 Behaviour Deviations 1 (3 credits)",
"PSYC 642 Behaviour Deviations 2 (3 credits)",
"PSYC 650 Advanced Statistics 1 (3 credits)",
"PSYC 651 Advanced Statistics 2 (3 credits)",
"PSYC 660 Psychology Theory (6 credits)",
"PSYC 660D1 Psychology Theory (3 credits)",
"PSYC 660D2 Psychology Theory (3 credits)",
"PSYC 661 Psychology Theory (Integrative Program in Neuroscience) (3 credits)",
"PSYC 690 Masters Research 1 (15 credits)",
"PSYC 690D1 Masters Research 1 (7.5 credits)",
"PSYC 690D2 Masters Research 1 (7.5 credits)",
"PSYC 690J1 Masters Research 1 (5 credits)",
"PSYC 690J2 Masters Research 1 (5 credits)",
"PSYC 690J3 Masters Research 1 (5 credits)",
"PSYC 690N1 Masters Research 1 (7.5 credits)",
"PSYC 690N2 Masters Research 1 (7.5 credits)",
"PSYC 699 Masters Research 2 (12 credits)",
"PSYC 699D1 Masters Research 2 (6 credits)",
"PSYC 699D2 Masters Research 2 (6 credits)",
"PSYC 699N1 Masters Research 2 (6 credits)",
"PSYC 699N2 Masters Research 2 (6 credits)",
"PSYC 701 Doctoral Comprehensive Examination",
"PSYC 701D1 Doctoral Comprehensive Examination",
"PSYC 701D2 Doctoral Comprehensive Examination",
"PSYC 706 Clinical Practicum (15 credits)",
"PSYC 706D1 Clinical Practicum (7.5 credits)",
"PSYC 706D2 Clinical Practicum (7.5 credits)",
"PSYC 706J1 Clinical Practicum (5 credits)",
"PSYC 706J2 Clinical Practicum (5 credits)",
"PSYC 706J3 Clinical Practicum (5 credits)",
"PSYC 707 Clinical Internship 1 (15 credits)",
"PSYC 707D1 Clinical Internship 1 (7.5 credits)",
"PSYC 707D2 Clinical Internship 1 (7.5 credits)",
"PSYC 707J1 Clinical Internship 1 (5 credits)",
"PSYC 707J2 Clinical Internship 1 (5 credits)",
"PSYC 707J3 Clinical Internship 1 (5 credits)",
"PSYC 708 Clinical Internship 2 (15 credits)",
"PSYC 708D1 Clinical Internship 2 (7.5 credits)",
"PSYC 708D2 Clinical Internship 2 (7.5 credits)",
"PSYC 708J1 Clinical Internship 2 (5 credits)",
"PSYC 708J2 Clinical Internship 2 (5 credits)",
"PSYC 708J3 Clinical Internship 2 (5 credits)",
"PSYC 709 Language Acquisition Issues 1 (2 credits)",
"PSYC 710 Comparative and Physiological Psychology 1 (3 credits)",
"PSYC 711 Comparative and Physiological Psychology 2 (3 credits)",
"PSYC 712 Comparative and Physiological Psychology 3 (3 credits)",
"PSYC 713 Comparative and Physiological Psychology 4 (3 credits)",
"PSYC 714 Comparative and Physiological Psychology 5 (3 credits)",
"PSYC 715 Comparative and Physiological Psychology 6 (3 credits)",
"PSYC 718 Learning and Motivation (3 credits)",
"PSYC 722 Personality and Social Psychology (3 credits)",
"PSYC 723 Personality and Social Psychology (3 credits)",
"PSYC 724 Personality and Social Psychology (3 credits)",
"PSYC 725 Personality and Social Psychology (3 credits)",
"PSYC 727 Personality and Social Psychology (3 credits)",
"PSYC 728 Ethics and Professional Issues (3 credits)",
"PSYC 729 Theory of Assessment (3 credits)",
"PSYC 730 Clinical Neuroscience Methods (3 credits)",
"PSYC 732 Clinical Psychology 1 (3 credits)",
"PSYC 732D1 Clinical Psychology 1 (1.5 credits)",
"PSYC 732D2 Clinical Psychology 1 (1.5 credits)",
"PSYC 733 Clinical Psychology 2 (3 credits)",
"PSYC 733D1 Clinical Psychology 2 (1.5 credits)",
"PSYC 733D2 Clinical Psychology 2 (1.5 credits)",
"PSYC 734 Developmental Psychology and Language (3 credits)",
"PSYC 735 Developmental Psychology and Language (3 credits)",
"PSYC 736 Developmental Psychology and Language (3 credits)",
"PSYC 740 Perception and Cognition (3 credits)",
"PSYC 741 Perception and Cognition (3 credits)",
"PSYC 742 Perception and Cognition (3 credits)",
"PSYC 743 Perception and Cognition (3 credits)",
"PSYC 744 Perception and Cognition (3 credits)",
"PSYC 746 Quantitative and Individual Differences (3 credits)",
"PSYC 747 Quantitative and Individual Differences (3 credits)",
"PSYC 748 Quantitative and Individual Differences (3 credits)",
"PSYC 749 Quantitative and Individual Differences (3 credits)",
"PSYC 752D1 Psychotherapy and Behaviour Change (3 credits)",
"PSYC 752D2 Psychotherapy and Behaviour Change (3 credits)",
"PSYC 753 Health Psychology Seminar 1 (3 credits)",
"PSYC 754 Health Psychology Seminar 2 (3 credits)",
"PSYC 755 Health Psychology Seminar 3 (3 credits)",
"PSYC 756 Health Psychology Seminar 4 (3 credits)",
"PSYC 780 Special Topics in Clinical Psychology (6 credits)",
"PSYC 781 Behavioural Neuroscience Special Topics (3 credits)",
"PSYC 782 Behavioural Neuroscience Advanced Seminar (3 credits)",
"PSYC 797 Teaching Methods: Psychology 1 (3 credits)",
"PSYC 798 Teaching Methods: Psychology 2 (3 credits)",
"PSYT 199 FYS: Mental Illness and the Brain (3 credits)",
"PSYT 301 Issues in Drug Dependence (3 credits)",
"PSYT 400D1 Research Project in Psychiatry (3 credits)",
"PSYT 400D2 Research Project in Psychiatry (3 credits)",
"PSYT 401 Psychiatry Clerkship (8 credits)",
"PSYT 401D1 Psychiatry Clerkship (4 credits)",
"PSYT 401D2 Psychiatry Clerkship (4 credits)",
"PSYT 455 Neurochemistry (3 credits)",
"PSYT 500 Advances: Neurobiology of Mental Disorders (3 credits)",
"PSYT 502 Brain Evolution and Psychiatry (3 credits)",
"PSYT 503 Mental Health Services and Policy (3 credits)",
"PSYT 504 Issues In Forensic Mental Health (3 credits)",
"PSYT 505 Neurobiology of Schizophrenia (3 credits)",
"PSYT 515 Advanced Studies in Addiction (3 credits)",
"PSYT 605 History and Philosophy of Psychiatry (3 credits)",
"PSYT 606 Mental Illness: Symptoms Diagnostics and Determinants (3 credits)",
"PSYT 610 Diploma Evaluation: Written",
"PSYT 611 Diploma Evaluation: Oral",
"PSYT 620 Trends in Clinical Psychiatry (3 credits)",
"PSYT 625 Qualitative Research in Health Care (3 credits)",
"PSYT 630 Statistics for Neurosciences (3 credits)",
"PSYT 633 Social and Cultural Research Methods (3 credits)",
"PSYT 640 Non-Pharmacological Clinical Trials (3 credits)",
"PSYT 682 Psychosocial Issues of Disease (3 credits)",
"PSYT 691 Thesis Research 1 (12 credits)",
"PSYT 691N1 Thesis Research 1 (6 credits)",
"PSYT 691N2 Thesis Research 1 (6 credits)",
"PSYT 692 Thesis Research 2 (12 credits)",
"PSYT 692N1 Thesis Research 2 (6 credits)",
"PSYT 692N2 Thesis Research 2 (6 credits)",
"PSYT 693 Thesis Research 3 (12 credits)",
"PSYT 693N1 Thesis Research 3 (6 credits)",
"PSYT 693N2 Thesis Research 3 (6 credits)",
"PSYT 696 Special Topics in Psychiatry (3 credits)",
"PSYT 701 Comprehensive Exam Mental Health",
"PSYT 711 Cultural Psychiatry (3 credits)",
"PSYT 711D1 Cultural Psychiatry (1.5 credits)",
"PSYT 711D2 Cultural Psychiatry (1.5 credits)",
"PSYT 713 Psychiatric Epidemiology (3 credits)",
"PUB1 004 Land Use Planning (3 credits)",
"PUB2 101D1 Constitutional Law (3 credits)",
"PUB2 101D2 Constitutional Law (3 credits)",
"PUB2 102 Constitutional Law of the United States (3 credits)",
"PUB2 105 Public International Law (3 credits)",
"PUB2 111 Criminal Law (3 credits)",
"PUB2 313 Taxation (4 credits)",
"PUB2 313D1 Taxation (2 credits)",
"PUB2 313D2 Taxation (2 credits)",
"PUB2 400 The Administrative Process (3 credits)",
"PUB2 401 Judicial Review of Administrative Action (3 credits)",
"PUB2 401D1 Judicial Review of Administrative Action (1.5 credits)",
"PUB2 401D2 Judicial Review of Administrative Action (1.5 credits)",
"PUB2 403 Municipal Law (2 credits)",
"PUB2 420 Trial Advocacy (3 credits)",
"PUB2 422 Criminal Procedure (3 credits)",
"PUB2 500 Law and Psychiatry (3 credits)",
"PUB2 501 Advanced Criminal Law (3 credits)",
"PUB2 502 International Criminal Law (3 credits)",
"PUB2 503 Comparative Federalism (3 credits)",
"PUB2 504 Sentencing in Canadian Law (3 credits)",
"PUB2 505 Statutory Interpretation (3 credits)",
"PUB2 506 The Law of International Organization (2 credits)",
"PUB2 515 Tax Policy (3 credits)",
"PUB2 517 Corporate Taxation (3 credits)",
"PUB2 551 Immigration and Refugee Law (3 credits)",
"PUB3 116 Foundations (3 credits)",
"PUB3 515 Canadian Charter of Rights and Freedoms (3 credits)",
"QCST 200 Introduction to the Study of Quebec (3 credits)",
"QCST 300 Quebec Culture and Society (3 credits)",
"QCST 336 Quebec Studies Summer Seminar (6 credits)",
"QCST 440 Contemporary Issues in Quebec (3 credits)",
"QLSC 600D1 Foundations of Quantitative Life Sciences (3 credits)",
"QLSC 600D2 Foundations of Quantitative Life Sciences (3 credits)",
"QLSC 601D1 Quantitative Life Sciences Seminars 1",
"QLSC 601D2 Quantitative Life Sciences Seminars 1",
"QLSC 601N1 Quantitative Life Sciences Seminars 1",
"QLSC 601N2 Quantitative Life Sciences Seminars 1",
"QLSC 602D1 Quantitative Life Sciences Seminars 2",
"QLSC 602D2 Quantitative Life Sciences Seminars 2",
"QLSC 602N1 Quantitative Life Sciences Seminars 2",
"QLSC 602N2 Quantitative Life Sciences Seminars 2",
"QLSC 603D1 Quantitative Life Sciences Seminars 3",
"QLSC 603D2 Quantitative Life Sciences Seminars 3",
"QLSC 603N1 Quantitative Life Sciences Seminars 3",
"QLSC 603N2 Quantitative Life Sciences Seminars 3",
"QLSC 611 Directed Readings (3 credits)",
"QLSC 612 Fundamentals for Neuro Data Science (3 credits)",
"QLSC 701 Ph.D. Comprehensive Exam",
"RADD 301 TCP Radiology (1 credit)",
"REDM 396 Undergraduate Research Project (3 credits)",
"REDM 399 Science Writing (1 credit)",
"REDM 400 Science and Museums (3 credits)",
"REDM 405 Natural History of East Africa (3 credits)",
"REDM 410 Writing Research Articles (3 credits)",
"REDM 511 Advanced Museum-Based Science (3 credits)",
"REDM 610 Writing Science Articles 1 (3 credits)",
"REDM 710 Writing Science Articles 2 (3 credits)",
"RELG 201 Religions of the Ancient Near East (3 credits)",
"RELG 202 Religion of Ancient Israel (3 credits)",
"RELG 203 Bible and Western Culture (3 credits)",
"RELG 204 Judaism Christianity and Islam (3 credits)",
"RELG 207 Introduction to the Study of Religions (3 credits)",
"RELG 210 Jesus of Nazareth (3 credits)",
"RELG 222 World Christianity (3 credits)",
"RELG 252 Hinduism and Buddhism (3 credits)",
"RELG 253 Religions of East Asia (3 credits)",
"RELG 254 Introduction to Yoga Traditions (3 credits)",
"RELG 256 Women in Judaism and Islam (3 credits)",
"RELG 257 Introductory Sanskrit (6 credits)",
"RELG 257D1 Introductory Sanskrit (3 credits)",
"RELG 257D2 Introductory Sanskrit (3 credits)",
"RELG 264 Introductory Tibetan 1 (3 credits)",
"RELG 265 Introductory Tibetan 2 (3 credits)",
"RELG 266 Introductory Tamil 1 (3 credits)",
"RELG 267 Introductory Tamil 2 (3 credits)",
"RELG 269 Colloquial Tibetan (6 credits)",
"RELG 270 Religious Ethics and the Environment (3 credits)",
"RELG 271 Religion and Sexuality (3 credits)",
"RELG 279 New Testament Greek 1 (3 credits)",
"RELG 280 New Testament Greek 2 (3 credits)",
"RELG 285 The Gnostic Worldview (3 credits)",
"RELG 288 Introduction to Sikhism (3 credits)",
"RELG 300 Second Temple Judaism (3 credits)",
"RELG 302 Literature of Ancient Israel 1 (3 credits)",
"RELG 303 Literature of Ancient Israel 2 (3 credits)",
"RELG 307 Bible Quran & Interpretations (3 credits)",
"RELG 308 Ancient Bible Translations (3 credits)",
"RELG 309 World Religions and Cultures They Create (3 credits)",
"RELG 311 Formation of the New Testament (3 credits)",
"RELG 312 The Gospels (3 credits)",
"RELG 313 Topics in Biblical Studies 1 (3 credits)",
"RELG 314 Topics in Biblical Studies 2 (3 credits)",
"RELG 315 Special Topics in Religion 1 (3 credits)",
"RELG 316 New Religious Movements (3 credits)",
"RELG 317 Special Topics in Religion 2 (3 credits)",
"RELG 318 Special Topics in Religion 3 (3 credits)",
"RELG 319 Special Topics in Religion 4 (3 credits)",
"RELG 321 Western Intellectual Tradition (3 credits)",
"RELG 322 Church and Empire to 1300 (3 credits)",
"RELG 323 Church and State since 1300 (3 credits)",
"RELG 324 Armenian Apostolic Tradition (3 credits)",
"RELG 325 Varieties Religious Experience in Christianity (3 credits)",
"RELG 326 Christians in the Roman World (3 credits)",
"RELG 330 Reformed Theology (3 credits)",
"RELG 331 Religion and Globalization (3 credits)",
"RELG 332 Conversations Across World Religions (3 credits)",
"RELG 333 Principles of Christian Theology 1 (3 credits)",
"RELG 334 Christian Thought and Culture (3 credits)",
"RELG 336 Contemporary Theological Issues (3 credits)",
"RELG 337 Themes in Buddhist Studies (3 credits)",
"RELG 338 Women and the Christian Tradition (3 credits)",
"RELG 339 Gender & Sexuality in Buddhism (3 credits)",
"RELG 340 Religion and the Sciences (3 credits)",
"RELG 341 Introduction: Philosophy of Religion (3 credits)",
"RELG 342 Theravada Buddhist Literature (3 credits)",
"RELG 343 Topics: Philosophy of Religion (3 credits)",
"RELG 344 Mahayana Buddhism (3 credits)",
"RELG 345 Religion and the Arts 1 (3 credits)",
"RELG 347 Topics in Religion and the Arts (3 credits)",
"RELG 348 Classical Hinduism (3 credits)",
"RELG 350 Bhakti Hinduism (3 credits)",
"RELG 352 Japanese Religions: History and Thought (3 credits)",
"RELG 353 Gandhi: His Life and Thought (3 credits)",
"RELG 354 Chinese Religions (3 credits)",
"RELG 355 Religion and the Arts 2 (3 credits)",
"RELG 356 Gender & Sexuality in Hinduism (3 credits)",
"RELG 357D1 Sanskrit 2 (3 credits)",
"RELG 357D2 Sanskrit 2 (3 credits)",
"RELG 358 Religion and Cinema in India (3 credits)",
"RELG 361 Religious Behaviour (3 credits)",
"RELG 364 Intermediate Tibetan 1 (3 credits)",
"RELG 365 Intermediate Tibetan 2 (3 credits)",
"RELG 366 Rivers Religion and Environment in South Asia (3 credits)",
"RELG 368 Japanese Religions in Pop Culture (3 credits)",
"RELG 369 Tibetan Buddhism (3 credits)",
"RELG 370 Religion and Human Rights (3 credits)",
"RELG 371 Ethics of Violence/Non-Violence (3 credits)",
"RELG 372 Hindu Goddesses (3 credits)",
"RELG 373 Christian Ethics of Love (3 credits)",
"RELG 374 Topics: Philosophy of Religion (3 credits)",
"RELG 375 Religion Politics and Society (3 credits)",
"RELG 376 Religious Ethics (3 credits)",
"RELG 377 Religious Controversies (3 credits)",
"RELG 378 Pilgrimage Heritage and Tourism (3 credits)",
"RELG 379 Eastern Orthodox Christianity (3 credits)",
"RELG 380 Religion Philosophy Modernity (3 credits)",
"RELG 381 Advanced New Testament Greek (3 credits)",
"RELG 387 Introduction to Jainism (3 credits)",
"RELG 388 Introduction to Sikhism (3 credits)",
"RELG 390 Elementary Biblical Hebrew (6 credits)",
"RELG 390D1 Elementary Biblical Hebrew (3 credits)",
"RELG 390D2 Elementary Biblical Hebrew (3 credits)",
"RELG 399 Christian Spirituality (3 credits)",
"RELG 407 The Writings (3 credits)",
"RELG 408 The Prophets (3 credits)",
"RELG 411 New Testament Exegesis (3 credits)",
"RELG 420 Canadian Church History (3 credits)",
"RELG 423 Reformation Thought (3 credits)",
"RELG 434 Principles of Christian Theology 2 (3 credits)",
"RELG 439 Religious Dialogues (3 credits)",
"RELG 440 Global Islam (3 credits)",
"RELG 441 Phenomenology of Religion (3 credits)",
"RELG 442 Pure Land Buddhism (3 credits)",
"RELG 443 Japanese Esoteric Buddhism (3 credits)",
"RELG 444 Indian Ocean Religious Networks (3 credits)",
"RELG 451 Zen Buddhism: Poetry and Art (3 credits)",
"RELG 452 East Asian Buddhism (3 credits)",
"RELG 453 Vajrayana Buddhism (3 credits)",
"RELG 454 Modern Hindu Thought (3 credits)",
"RELG 455 Religion and the Performing Arts in South India (3 credits)",
"RELG 456 Theories of Religion (3 credits)",
"RELG 457D1 Advanced Sanskrit (3 credits)",
"RELG 457D2 Advanced Sanskrit (3 credits)",
"RELG 464 Advanced Tibetan 1 (3 credits)",
"RELG 465 Advanced Tibetan 2 (3 credits)",
"RELG 470 Theological Ethics (3 credits)",
"RELG 471 Christian Social Ethics (3 credits)",
"RELG 479 Christianity in Global Perspective (3 credits)",
"RELG 482 Exegesis of Greek New Testament (3 credits)",
"RELG 490 Honours Thesis (6 credits)",
"RELG 491 Hebrew Texts (3 credits)",
"RELG 492 Hebrew Texts (3 credits)",
"RELG 494 B.Th. Honours Seminar 1 (3 credits)",
"RELG 495 B.Th. Honours Seminar 2 (3 credits)",
"RELG 496 Special Studies (3 credits)",
"RELG 497 Research Seminar (3 credits)",
"RELG 498 Special Studies (3 credits)",
"RELG 499 Internship: Religious Studies (3 credits)",
"RELG 502 Greco-Roman Judaism (3 credits)",
"RELG 532 History of Christian Thought 1 (3 credits)",
"RELG 533 History of Christian Thought 2 (3 credits)",
"RELG 535 Currents in Philosophy of Religion (3 credits)",
"RELG 544 Ethnography as Method in Religious Studies (3 credits)",
"RELG 545 Ramayana: Multiple Lives (3 credits)",
"RELG 546 Indian Philosophy (3 credits)",
"RELG 547 Special Topics in Hinduism (3 credits)",
"RELG 548 Indian Buddhist Philosophy (3 credits)",
"RELG 549 Japanese Buddhism in Historical Context (3 credits)",
"RELG 551 Special Topics in Buddhism (3 credits)",
"RELG 552 Advaita Vedanta (3 credits)",
"RELG 553 Religions of South India 1 (3 credits)",
"RELG 554 Religions of South Asia (3 credits)",
"RELG 555 Honours Seminar (3 credits)",
"RELG 556 Issues in Buddhist Studies (3 credits)",
"RELG 558 Indian Tantric Traditions (3 credits)",
"RELG 559 Caste and Dalits: Historical and Political Perspectives (3 credits)",
"RELG 560 Buddhist Poetry (3 credits)",
"RELG 571 Ethics Medicine and Religion (3 credits)",
"RELG 572 Religion and Global Politics (3 credits)",
"RELG 573 Religions in Global Society (3 credits)",
"RELG 582 Topics in Christian Liturgy and Music (3 credits)",
"RELG 583 Hellenistic Religious Texts (3 credits)",
"RELG 601 Ancient Jewish Literature (3 credits)",
"RELG 602 Theory in Religious Ethics (3 credits)",
"RELG 605 Interpreters of Religion and Faith of Ancient Israel (3 credits)",
"RELG 611 Pauline Theology (3 credits)",
"RELG 613 The Ministry of Jesus (3 credits)",
"RELG 618 The Church in the New Testament (3 credits)",
"RELG 621 Patristic Studies (3 credits)",
"RELG 622 Medieval Studies (3 credits)",
"RELG 624 Reformation Studies (3 credits)",
"RELG 625 Creeds and Confessions (3 credits)",
"RELG 626 Reformation: Secular Dimensions (3 credits)",
"RELG 629 Primary Text: Aramaic (3 credits)",
"RELG 630 Theological Foundations (3 credits)",
"RELG 633 The Theology of Karl Barth (3 credits)",
"RELG 635 Christology and Ecclesiology (3 credits)",
"RELG 640 Primary Text: Biblical Hebrew (3 credits)",
"RELG 641 Modern Philosophy of Religion (3 credits)",
"RELG 642 Philosophy of Religion in the 21st Century (3 credits)",
"RELG 643 Problems: Philosophy of Religion (3 credits)",
"RELG 644 Biblical Theology (3 credits)",
"RELG 645 Methods in Religious Studies (3 credits)",
"RELG 646 Research Project 1 (6 credits)",
"RELG 647 Research Project 2 (6 credits)",
"RELG 648 Church History (3 credits)",
"RELG 649 Primary Text: Coptic (3 credits)",
"RELG 652 Christian Theology (3 credits)",
"RELG 653 Philosophy of Religion (3 credits)",
"RELG 656 Theological Ethics (3 credits)",
"RELG 657D1 Introductory Sanskrit (3 credits)",
"RELG 657D2 Introductory Sanskrit (3 credits)",
"RELG 658 Dogen: Philosophy and Practice (3 credits)",
"RELG 660 M.A. Research Paper 1 (3 credits)",
"RELG 661 M.A. Research Paper 2 (3 credits)",
"RELG 662 M.A. Research Paper 3 (3 credits)",
"RELG 663 Comparative Religion (3 credits)",
"RELG 665 Primary Text: Sanskrit 1 (3 credits)",
"RELG 666 Primary Text: Sanskrit 2 (3 credits)",
"RELG 667 Readings in Indic Texts 1 (3 credits)",
"RELG 668 Readings in Indic Texts 2 (3 credits)",
"RELG 669 Primary Text: Tibetan (3 credits)",
"RELG 679 Research in Interfaith Studies (3 credits)",
"RELG 680 Old Testament Research (3 credits)",
"RELG 681 Research in New Testament (3 credits)",
"RELG 682 Research: History of Christianity (3 credits)",
"RELG 683 Research in Christian Theology (3 credits)",
"RELG 684 Research in Philosophy of Religion 1 (3 credits)",
"RELG 685 Research in Ethical Problems (3 credits)",
"RELG 687 Research in Comparative Religion 1 (3 credits)",
"RELG 688 Thesis Research 1 (3 credits)",
"RELG 689 Thesis Research 2 (3 credits)",
"RELG 690 Old Testament Research (3 credits)",
"RELG 692 Research: History of Christianity (3 credits)",
"RELG 693 Research in Christian Theology (3 credits)",
"RELG 694 Research in Philosophy of Religion 2 (3 credits)",
"RELG 695 Research in Ethical Problems (3 credits)",
"RELG 698 Thesis Research 3 (9 credits)",
"RELG 699 Thesis Research 4 (12 credits)",
"RELG 701 Major Comprehensive Examination",
"RELG 702 Minor Comprehensive Examination",
"RELG 703 Oral Comprehensive Examination",
"RELG 745 Understanding Religious Studies (3 credits)",
"RELG 751 Tutorial on a Selected Topic (3 credits)",
"RETL 402 Innovations in Retailing (3 credits)",
"RETL 407 Retail Management Project (3 credits)",
"RETL 434 Topics in Retail Management (3 credits)",
"RETL 601 Foundations of Retailing (3 credits)",
"RETL 603 Retail Science and Data Analytics (3 credits)",
"RETL 611 360-Degree Customer Insight (3 credits)",
"RETL 613 Digital Retailing Models (3 credits)",
"RETL 615 Managing Retail Operations (3 credits)",
"RETL 617 Managing for Sustainability (3 credits)",
"RETL 621 Retail Internship (6 credits)",
"RETL 625 Experiential Retail (3 credits)",
"RETL 631 Digital Media Marketing (3 credits)",
"RETL 633 Data-Driven Retail Decisions (3 credits)",
"RETL 635 Creativity and Experiential Economy (3 credits)",
"RETL 637 Innovative Retail Technology (3 credits)",
"RETL 641 Fashion Retail Management (3 credits)",
"RETL 643 Fintech and Financial Services (3 credits)",
"RETL 645 Food Retail (3 credits)",
"RETL 661 Advanced Topics in Retail Management 1 (3 credits)",
"RETL 662 Advanced Topics in Retail Management 2 (3 credits)",
"RETL 663 Advanced Topics in Retail Management 3 (3 credits)",
"RUSS 210 Elementary Russian Language 1 (3 credits)",
"RUSS 211 Elementary Russian Language 2 (3 credits)",
"RUSS 213 Introduction to Soviet Film (3 credits)",
"RUSS 215 Elementary Russian Language Intensive 1 (6 credits)",
"RUSS 217 Russia's Eternal Questions (3 credits)",
"RUSS 218 Russian Literature and Revolution (3 credits)",
"RUSS 223 Russian 19th Century: Literary Giants 1 (3 credits)",
"RUSS 224 Russian 19th Century: Literary Giants 2 (3 credits)",
"RUSS 229 Introduction to Russian Folklore (3 credits)",
"RUSS 300 Russian for Heritage Speakers 1 (3 credits)",
"RUSS 301 Russian for Heritage Speakers 2 (3 credits)",
"RUSS 310 Intermediate Russian Language 1 (3 credits)",
"RUSS 311 Intermediate Russian Language 2 (3 credits)",
"RUSS 316 Intermediate Russian Language Intensive 2 (6 credits)",
"RUSS 327 Reading Russian Poetry (3 credits)",
"RUSS 328 Readings in Russian (3 credits)",
"RUSS 330 Chekhov without Borders (3 credits)",
"RUSS 333 Petersburg: City of Myth (3 credits)",
"RUSS 337 Vladimir Nabokov (3 credits)",
"RUSS 340 Russian Short Story (3 credits)",
"RUSS 347 Late and Post-Soviet Culture (3 credits)",
"RUSS 357 Leo Tolstoy (3 credits)",
"RUSS 358 Fyodor Dostoevsky (3 credits)",
"RUSS 365 Supernatural and Absurd in Russian Literature (3 credits)",
"RUSS 369 Narrative and Memory in Russian Culture (3 credits)",
"RUSS 381 Russia's Utopia Complex (3 credits)",
"RUSS 382 Russian Opera (3 credits)",
"RUSS 385 Russian Drama: from Pushkin to Chekhov (3 credits)",
"RUSS 390 Special Topics in Russian (3 credits)",
"RUSS 395 Soviet Cinema: Art and Politics (3 credits)",
"RUSS 397 Tarkovsky: Cinema and Philosophy (3 credits)",
"RUSS 398 Soviet Women Filmmakers (3 credits)",
"RUSS 400 Advanced Russian Language 1 (3 credits)",
"RUSS 401 Advanced Russian Language 2 (3 credits)",
"RUSS 415 Advanced Russian Language Intensive 1 (6 credits)",
"RUSS 416 Advanced Russian Language Intensive 2 (6 credits)",
"RUSS 427 Russian Fin de Siècle (3 credits)",
"RUSS 428 Russian Avantgarde (3 credits)",
"RUSS 430 High Stalinist Culture 1 (3 credits)",
"RUSS 440 Russia and Its Others (3 credits)",
"RUSS 452 Advanced Russian Language and Syntax 1 (3 credits)",
"RUSS 453 Advanced Russian Language and Syntax 2 (3 credits)",
"RUSS 454 Narratives of Desire (3 credits)",
"RUSS 458 Development Russian Novel before Turgenev (3 credits)",
"RUSS 470 Individual Reading Course (3 credits)",
"RUSS 475 Special Topics in Russ Culture (3 credits)",
"RUSS 490 Honours Seminar 01 (3 credits)",
"RUSS 491 Honours Seminar 02 (3 credits)",
"RUSS 499 Internship: Russian and Slavic Studies (3 credits)",
"RUSS 500 Special Topics (3 credits)",
"RUSS 600 Tutorial in Russian 1",
"RUSS 601 Tutorial in Russian 2",
"RUSS 620 High Stalinist Culture 2 (3 credits)",
"RUSS 622 Special Topics Seminar 3 (3 credits)",
"RUSS 644 Major Russian Writers (3 credits)",
"RUSS 675 Russian Realism 1 (3 credits)",
"RUSS 676 Russian Realism 2 (3 credits)",
"RUSS 679 Russian Romanticism 1 (3 credits)",
"RUSS 682 Russian Twentieth Century 1 (3 credits)",
"RUSS 683 Russian Twentieth Century 2 (3 credits)",
"RUSS 689 19th Century Russian Literature in Theory (3 credits)",
"RUSS 690 20th Century Russian Literature in Theory (3 credits)",
"RUSS 691 M.A. Thesis Proposal (3 credits)",
"RUSS 691D1 M.A. Thesis Proposal (1.5 credits)",
"RUSS 691D2 M.A. Thesis Proposal (1.5 credits)",
"RUSS 691N1 M.A. Thesis Proposal (1.5 credits)",
"RUSS 691N2 M.A. Thesis Proposal (1.5 credits)",
"RUSS 692 M.A. Thesis (24 credits)",
"RUSS 692D1 M.A. Thesis (12 credits)",
"RUSS 692D2 M.A. Thesis (12 credits)",
"RUSS 692N1 M.A. Thesis (12 credits)",
"RUSS 692N2 M.A. Thesis (12 credits)",
"RUSS 700 Ph.D. Tutorial",
"RUSS 701 Ph.D. Comprehensive Examination",
"RUSS 702 Ph.D. Thesis Proposal",
"RUSS 720 Special Topics Seminar 1 (3 credits)",
"RUSS 721 Special Topics Seminar 2 (3 credits)",
"RUSS 750 History of Russian Language",
"RUSS 760 Pre-Petrine Foundation",
"RUSS 770 18th Century Foundation",
"SCSD 609 Neuromotor Disorders (3 credits)",
"SCSD 616 Audiology (3 credits)",
"SCSD 617 Anatomy and Physiology: Speech and Hearing (3 credits)",
"SCSD 618 Research and Measurement Methodologies 1 (3 credits)",
"SCSD 619 Phonological Development (3 credits)",
"SCSD 624 Language Processes (3 credits)",
"SCSD 631 Speech Science (3 credits)",
"SCSD 632 Phonological Disorders: Children (3 credits)",
"SCSD 633 Language Development (3 credits)",
"SCSD 636 Fluency Disorders (3 credits)",
"SCSD 637 Developmental Language Disorders 1 (3 credits)",
"SCSD 638 Neurolinguistics (3 credits)",
"SCSD 639 Voice Disorders (3 credits)",
"SCSD 642 Aural Rehabilitation (3 credits)",
"SCSD 643 Developmental Language Disorders 2 (3 credits)",
"SCSD 644 Applied Neurolinguistics (3 credits)",
"SCSD 646 Introductory Clinical Practicum (4 credits)",
"SCSD 652 Advanced Research Seminar 1 (3 credits)",
"SCSD 653 Advanced Research Seminar 2 (3 credits)",
"SCSD 654 Advanced Research Seminar 3 (3 credits)",
"SCSD 655 Advanced Research Seminar 4 (3 credits)",
"SCSD 664 Augmentative and Alternative Communication (3 credits)",
"SCSD 666 Communication Sciences and Disorders 3 (3 credits)",
"SCSD 667 Communication Sciences and Disorders 4 (3 credits)",
"SCSD 669 ASD and Neurodevelopmental Disorders (3 credits)",
"SCSD 670 Communication Sciences and Disorders 2 (3 credits)",
"SCSD 671 M.Sc. Thesis 1 (12 credits)",
"SCSD 671D1 M.Sc. Thesis 1 (6 credits)",
"SCSD 671D2 M.Sc. Thesis 1 (6 credits)",
"SCSD 671N1 M.Sc. Thesis 1 (6 credits)",
"SCSD 671N2 M.Sc. Thesis 1 (6 credits)",
"SCSD 672 M.Sc. Thesis 2 (12 credits)",
"SCSD 672D1 M.Sc. Thesis 2 (6 credits)",
"SCSD 672D2 M.Sc. Thesis 2 (6 credits)",
"SCSD 672N1 M.Sc. Thesis 2 (6 credits)",
"SCSD 672N2 M.Sc. Thesis 2 (6 credits)",
"SCSD 673 M.Sc. Thesis 3 (12 credits)",
"SCSD 673D1 M.Sc. Thesis 3 (6 credits)",
"SCSD 673D2 M.Sc. Thesis 3 (6 credits)",
"SCSD 673N1 M.Sc. Thesis 3 (6 credits)",
"SCSD 673N2 M.Sc. Thesis 3 (6 credits)",
"SCSD 674 M.Sc. Thesis 4 (3 credits)",
"SCSD 675 Special Topics 1 (12 credits)",
"SCSD 676 Special Topics 2 (9 credits)",
"SCSD 677 Special Topics 3 (6 credits)",
"SCSD 678 Special Topics 4 (3 credits)",
"SCSD 679 Advanced Clinical Practicum (12 credits)",
"SCSD 680 Deglutition and Dysphagia (3 credits)",
"SCSD 681 Practicum and Seminar 1 (1 credit)",
"SCSD 682 Practicum and Seminar 2 (1 credit)",
"SCSD 683 Practicum and Seminar 3 (1 credit)",
"SCSD 684 Practicum and Seminar 4 (1 credit)",
"SCSD 685 Research Project 1 (3 credits)",
"SCSD 686 Research Project 2 (3 credits)",
"SCSD 687 Special Topics 5 (3 credits)",
"SCSD 688 Genetics in Speech-Language Pathology Practice (1 credit)",
"SCSD 689 Management Cranio-Facial Disorders (1 credit)",
"SCSD 701 Doctoral Comprehensive",
"SCSD 701D1 Doctoral Comprehensive",
"SCSD 701D2 Doctoral Comprehensive",
"SCSD 712 Language Acquisition Issues 4 (2 credits)",
"SEAD 500 Foundations of Sustainability for Engineering and Design (3 credits)",
"SEAD 510 Energy Analysis (4 credits)",
"SEAD 515 Climate Change Adaptation and Engineering Infrastructure (3 credits)",
"SEAD 520 Life Cycle-Based Environmental Footprinting (3 credits)",
"SEAD 530 Economics for Sustainability in Engineering and Design (3 credits)",
"SEAD 540 Industrial Ecology and Systems (3 credits)",
"SEAD 550 Decision-Making for Sustainability in Engineering and Design (3 credits)",
"SENT 499 Internship: Social Entrepreneurship (3 credits)",
"SOCI 210 Sociological Perspectives (3 credits)",
"SOCI 211 Sociological Inquiry (3 credits)",
"SOCI 212 International Migration (3 credits)",
"SOCI 213 Deviance (3 credits)",
"SOCI 219 Sociology of Culture (3 credits)",
"SOCI 222 Urban Sociology (3 credits)",
"SOCI 225 Medicine and Health in Modern Society (3 credits)",
"SOCI 227 Jews in North America (3 credits)",
"SOCI 230 Sociology of Ethnic Relations (3 credits)",
"SOCI 234 Population and Society (3 credits)",
"SOCI 235 Technology and Society (3 credits)",
"SOCI 245 The Sociology of Emotions (3 credits)",
"SOCI 247 Family and Modern Society (3 credits)",
"SOCI 250 Social Problems (3 credits)",
"SOCI 254 Development and Underdevelopment (3 credits)",
"SOCI 255 Gender and the State (3 credits)",
"SOCI 265 War States and Social Change (3 credits)",
"SOCI 270 Sociology of Gender (3 credits)",
"SOCI 304 Sociology of the Welfare State (3 credits)",
"SOCI 305 Socialization (3 credits)",
"SOCI 307 Globalization (3 credits)",
"SOCI 309 Health and Illness (3 credits)",
"SOCI 310 Sociology of Mental Disorder (3 credits)",
"SOCI 312 Sociology of Work and Industry (3 credits)",
"SOCI 318 Sociology of the Media (3 credits)",
"SOCI 320 Topics in Sociology 2 (3 credits)",
"SOCI 321 Gender and Work (3 credits)",
"SOCI 322 Sociology of Literature (3 credits)",
"SOCI 325 Sociology of Science (3 credits)",
"SOCI 326 Political Sociology 01 (3 credits)",
"SOCI 330 Sociological Theory (3 credits)",
"SOCI 331 Population and Environment (3 credits)",
"SOCI 333 Social Stratification (3 credits)",
"SOCI 335 Sociology of Aging and the Life Course (3 credits)",
"SOCI 338 Introduction to Biomedical Knowledge (3 credits)",
"SOCI 341 Current Problems in Sociology 02 (3 credits)",
"SOCI 342 Independent Study 1 (3 credits)",
"SOCI 343 Independent Study 2 (3 credits)",
"SOCI 345 Topics in Sociology (3 credits)",
"SOCI 350 Statistics in Social Research (3 credits)",
"SOCI 354 Dynamics of Industrial Societies (3 credits)",
"SOCI 355 Rural Life in a Global Society (3 credits)",
"SOCI 365 Health and Development (3 credits)",
"SOCI 366 Neighborhoods and Inequality   (3 credits)",
"SOCI 370 Sociology: Gender and Development (3 credits)",
"SOCI 375 Suspect Minorities in Canada (3 credits)",
"SOCI 385 Sociology of Human Sexuality (3 credits)",
"SOCI 386 Contemporary Social Movements (3 credits)",
"SOCI 388 Crime (3 credits)",
"SOCI 390 Gender and Health (3 credits)",
"SOCI 395 Sociology of Law (3 credits)",
"SOCI 400 Comparative Migration & Citizenship (3 credits)",
"SOCI 405 Families over the Life Course (3 credits)",
"SOCI 410 Urban Ethnography (3 credits)",
"SOCI 415 Education and Inequality (3 credits)",
"SOCI 420 Organizations (3 credits)",
"SOCI 424 Networks and Social Structures (3 credits)",
"SOCI 430 Sociology of Citizenship (3 credits)",
"SOCI 441 Current Problems in Sociology 03 (3 credits)",
"SOCI 442 Independent Reading and Research 01 (3 credits)",
"SOCI 443 Independent Reading and Research 02 (3 credits)",
"SOCI 445 Readings: Sociological Theory (3 credits)",
"SOCI 446 Colonialism and Society (3 credits)",
"SOCI 455 Post-Socialist Societies (3 credits)",
"SOCI 460 Responses to Social Problems (3 credits)",
"SOCI 461 Quantitative Data Analysis (3 credits)",
"SOCI 470 Topics in Economic Sociology (3 credits)",
"SOCI 475 Canadian Ethnic Studies Seminar (3 credits)",
"SOCI 477 Qualitative Methods in Sociology (3 credits)",
"SOCI 480 Honours Project (3 credits)",
"SOCI 484 Emerging Democratic States (3 credits)",
"SOCI 488 Punishment and Prisons (3 credits)",
"SOCI 489 Gender Deviance and Social Control (3 credits)",
"SOCI 495 Social Problems and Conflicts (3 credits)",
"SOCI 499 Internship: Sociology (3 credits)",
"SOCI 501 Capitalism Socialism and Democracy (3 credits)",
"SOCI 502 Sociology of Fertility (3 credits)",
"SOCI 503 Surveillance in Modern Society (3 credits)",
"SOCI 504 Quantitative Methods 1 (3 credits)",
"SOCI 506 Quantitative Methods 3 (3 credits)",
"SOCI 507 Social Change (3 credits)",
"SOCI 508 Medical Sociology and Social Psychiatry (3 credits)",
"SOCI 510 Seminar in Social Stratification (3 credits)",
"SOCI 511 Movements/Collective Action (3 credits)",
"SOCI 512 Ethnicity & Public Policy (3 credits)",
"SOCI 513 Social Aspects HIV/AIDS in Africa (3 credits)",
"SOCI 514 Criminology (3 credits)",
"SOCI 515 Medicine and Society (3 credits)",
"SOCI 516 Sociological Theory & Research (3 credits)",
"SOCI 519 Gender and Globalization (3 credits)",
"SOCI 520 Migration and Immigrant Groups (3 credits)",
"SOCI 525 Health Care Systems in Comparative Perspective (3 credits)",
"SOCI 526 Indigenous Women's Health and Healthcare (3 credits)",
"SOCI 529 Political Sociology 1 (3 credits)",
"SOCI 530 Sex and Gender (3 credits)",
"SOCI 535 Sociology of the Family (3 credits)",
"SOCI 538 Selected Topics in Sociology of Biomedical Knowledge (3 credits)",
"SOCI 545 Sociology of Population (3 credits)",
"SOCI 550 Developing Societies (3 credits)",
"SOCI 555 Comparative Historical Sociology (3 credits)",
"SOCI 560 Labour and Globalization (3 credits)",
"SOCI 571 Deviance and Social Control (3 credits)",
"SOCI 580 Social Research Design and Practice (3 credits)",
"SOCI 588 Biosociology/Biodemography (3 credits)",
"SOCI 590 Social Conflict and Violence (3 credits)",
"SOCI 595 Immigration Control and The State (3 credits)",
"SOCI 600 Qualitative Research Methods 1 (3 credits)",
"SOCI 601 Qualitative Research Methods 2 (3 credits)",
"SOCI 602 Comparative-Historical Methods (3 credits)",
"SOCI 603 Bibliographic Methods 1 (3 credits)",
"SOCI 604 Bibliographic Methods 2 (3 credits)",
"SOCI 620 Quantitative Methods 2 (3 credits)",
"SOCI 621 Fixed and Random Effects (3 credits)",
"SOCI 622 Event History Analysis (3 credits)",
"SOCI 623 Latent Variable Models (3 credits)",
"SOCI 624 Social Networks (3 credits)",
"SOCI 625D1 Professional Development Seminar in Sociology",
"SOCI 625D2 Professional Development Seminar in Sociology",
"SOCI 626 Demographic Methods (3 credits)",
"SOCI 631D1 Informing Social Policy with Canadian Data (3 credits)",
"SOCI 631D2 Informing Social Policy with Canadian Data (3 credits)",
"SOCI 652 Current Sociological Theory (3 credits)",
"SOCI 690 M.A. Thesis 1 (3 credits)",
"SOCI 691 M.A. Thesis 2 (6 credits)",
"SOCI 692 M.A. Thesis 3 (3 credits)",
"SOCI 693 M.A. Thesis 4 (3 credits)",
"SOCI 694 M.A. Thesis 5 (18 credits)",
"SOCI 695 M.A. Thesis 6 (15 credits)",
"SOCI 696 Research Paper 1 (3 credits)",
"SOCI 697 Research Paper 2 (3 credits)",
"SOCI 698 Research Paper 3 (6 credits)",
"SOCI 699 Research Paper 4 (12 credits)",
"SOCI 700 Ph.D. Area Examination 1",
"SOCI 701 Ph.D. Area Examination 2",
"SOCI 702 Ph.D. Proposal Approval",
"SOCI 703 Bibliographic Methods 3",
"SOCI 704 Bibliographic Methods 4",
"SOCI 705 PhD Comprehensive Examination",
"SOCI 720 Reading in Social Theory (3 credits)",
"SOCI 730 Reading and Research (3 credits)",
"SOIL 210 Principles of Soil Science (3 credits)",
"SOIL 300 Geosystems (3 credits)",
"SOIL 315 Soil Nutrient Management (3 credits)",
"SOIL 326 Soils in a Changing Environment (3 credits)",
"SOIL 331 Environmental Soil Physics (3 credits)",
"SOIL 510 Environmental Soil Chemistry (3 credits)",
"SOIL 535 Ecological Soil Management (3 credits)",
"SOIL 602 Advanced Soil Ecology 1 (3 credits)",
"SOIL 610 Pedology (3 credits)",
"SOIL 631 Advanced Soil Physics (3 credits)",
"SURG 301 TCP Surgery (4 credits)",
"SURG 402 Surgery Clerkship (8 credits)",
"SURG 403 Surgery Sub-Specialty - Senior Clerkships (4 credits)",
"SWRK 220 History and Philosophy of Social Work (3 credits)",
"SWRK 221 Public Social Services in Canada (3 credits)",
"SWRK 222 Introduction to Practicum (3 credits)",
"SWRK 223 Poverty and Inequality (3 credits)",
"SWRK 224 Human Development Across the Lifespan (3 credits)",
"SWRK 320 Practice with Individuals and Families 1 (3 credits)",
"SWRK 321 Introduction to Practice with Groups (3 credits)",
"SWRK 322 Field Practice 1 (3 credits)",
"SWRK 322D1 Field Practice 1 (1.5 credits)",
"SWRK 322D2 Field Practice 1 (1.5 credits)",
"SWRK 323 Field Practice 2 (3 credits)",
"SWRK 323D1 Field Practice 2 (1.5 credits)",
"SWRK 323D2 Field Practice 2 (1.5 credits)",
"SWRK 325 Anti-Oppression Social Work Practice (3 credits)",
"SWRK 326 Practice with Individuals and Families 2 (3 credits)",
"SWRK 327 Approaches to Community Practice (3 credits)",
"SWRK 342 Practice with Gay Lesbian Bisexual & Two-Spirit People (3 credits)",
"SWRK 344 Integrative Seminar 1 (3 credits)",
"SWRK 350 Social Work Skills Laboratory (3 credits)",
"SWRK 350D1 Social Work Skills Laboratory (1.5 credits)",
"SWRK 350D2 Social Work Skills Laboratory (1.5 credits)",
"SWRK 353 Introduction to Practice (3 credits)",
"SWRK 354 Social Work in the Health Field (3 credits)",
"SWRK 400 Policy and Practice for Refugees (3 credits)",
"SWRK 404 Foundations of Social Policy in Canada (3 credits)",
"SWRK 405 Approaches to Community and Group Practice (3 credits)",
"SWRK 420 Advanced Field Practice 1 (3 credits)",
"SWRK 421 Advanced Field Practice 2 (3 credits)",
"SWRK 422 Integrative Seminar 2 (3 credits)",
"SWRK 423 Social Work Research (3 credits)",
"SWRK 424 Mental Health and Illness (3 credits)",
"SWRK 428 Social Policy and Administration (3 credits)",
"SWRK 434 Practice with Involuntary Clients (3 credits)",
"SWRK 445 First Peoples and Social Work (3 credits)",
"SWRK 463 Social Work Practice with Older Adults (3 credits)",
"SWRK 471 Tutorial in Social Work Research (3 credits)",
"SWRK 485 Tutorial: Social Work Practice (3 credits)",
"SWRK 486 Tutorial in Social Policy (3 credits)",
"SWRK 492 Violence against Women and Children (3 credits)",
"SWRK 493 Seminar on Child Protection (3 credits)",
"SWRK 498 Clinical Practice Seminar 2 (3 credits)",
"SWRK 510 Disability and Rehabilitation (3 credits)",
"SWRK 525 Critical Thought and Ethics in Social Work (3 credits)",
"SWRK 532 International Social Work (3 credits)",
"SWRK 535 Addictions (3 credits)",
"SWRK 600 Mothering Fathering and Social Work Practice (3 credits)",
"SWRK 602 Youth Justice in Canada (3 credits)",
"SWRK 603 Evidence Informed Advocacy (3 credits)",
"SWRK 606 Reclaiming Child Welfare (3 credits)",
"SWRK 609 Understanding Social Care (3 credits)",
"SWRK 610 Family Treatment (3 credits)",
"SWRK 612 Knowledge Values and Practice (3 credits)",
"SWRK 620 Migration and Social Work (3 credits)",
"SWRK 621 Seminar on Trauma and Resilience (3 credits)",
"SWRK 622 Understanding and Assessing Families (3 credits)",
"SWRK 623 Couple Therapy (3 credits)",
"SWRK 624 Community Organization: Advocacy (3 credits)",
"SWRK 626 International and Community Development (3 credits)",
"SWRK 628 Violence against Women (3 credits)",
"SWRK 630 Adult Mental Health (3 credits)",
"SWRK 631 Leadership and Organization (3 credits)",
"SWRK 633 Program Evaluation (3 credits)",
"SWRK 635 Advanced Clinical Seminar: Use of Self (3 credits)",
"SWRK 636 Tutorial in Social Work (3 credits)",
"SWRK 641 Social Policy Analysis (3 credits)",
"SWRK 642 Tutorial Social Welfare (3 credits)",
"SWRK 643 Research Methods 2 (3 credits)",
"SWRK 649 Special Topics in Social Welfare (3 credits)",
"SWRK 650 Field Work Practicum 1 (3 credits)",
"SWRK 651 Field Work Practicum 2 (3 credits)",
"SWRK 653 Research Methods 1 (3 credits)",
"SWRK 655 Seminar on Aging (3 credits)",
"SWRK 657 Child and Adolescent Mental Health(3 credits)",
"SWRK 660 Field Work Practicum 3 (6 credits)",
"SWRK 668 Living with Illness Loss and Bereavement (3 credits)",
"SWRK 670 Seminar on Caregiving (3 credits)",
"SWRK 690 Independent Study Project (9 credits)",
"SWRK 690D1 Independent Study Project (4.5 credits)",
"SWRK 690D2 Independent Study Project (4.5 credits)",
"SWRK 691 Social Work / Law Independent Study Project (12 credits)",
"SWRK 691D1 Social Work / Law Independent Study Project (6 credits)",
"SWRK 691D2 Social Work / Law Independent Study Project (6 credits)",
"SWRK 698 Thesis Research 1 (12 credits)",
"SWRK 698D1 Thesis Research 1 (6 credits)",
"SWRK 698D2 Thesis Research 1 (6 credits)",
"SWRK 699 Thesis Research 2 (15 credits)",
"SWRK 699D1 Thesis Research 2 (7.5 credits)",
"SWRK 699D2 Thesis Research 2 (7.5 credits)",
"SWRK 701 Comprehensive Examination",
"SWRK 720 Thought and Theory Development in Social Work (3 credits)",
"SWRK 721 Advanced Integrative Seminar (3 credits)",
"SWRK 721D1 Advanced Integrative Seminar (1.5 credits)",
"SWRK 721D2 Advanced Integrative Seminar (1.5 credits)",
"SWRK 722 Advanced Seminar: Social Work Intervention (3 credits)",
"SWRK 723 Advanced Seminar on Social Policy (3 credits)",
"SWRK 724 Advanced Research Methods and Analysis: Quantitative Data (3 credits)",
"SWRK 725 Advanced Qualitative Research Methods and Data Analysis (3 credits)",
"SWRK 726 Independent Study (3 credits)",
"TRNS COMS Communications Transfer Course (15 credits)",
"TRNS ENGR Engineering General Transfer Course (15 credits)",
"TRNS GNST General Studies Transfer Course (15 credits)",
"TRNS HUMN  (15 credits)",
"TRNS LANG Foreign Language Transfer Course (15 credits)",
"TRNS MASC  (15 credits)",
"TRNS SOSC  (15 credits)",
"UQAC 024  (3 credits)",
"UQAC 100 Alimentation et activité physique (3 credits)",
"UQAC 101  (3 credits)",
"UQAC 102  (3 credits)",
"UQAC 103  (3 credits)",
"UQAC 104  (3 credits)",
"UQAC 105 Principes de Management (3 credits)",
"UQAC 106  (3 credits)",
"UQAC 1060  (3 credits)",
"UQAC 110  (3 credits)",
"UQAC 111  (3 credits)",
"UQAC 112  (3 credits)",
"UQAC 113  (3 credits)",
"UQAC 114  (3 credits)",
"UQAC 116 Théories de la Personalité (3 credits)",
"UQAC 119  (3 credits)",
"UQAC 120  (3 credits)",
"UQAC 1200  (3 credits)",
"UQAC 127  (3 credits)",
"UQAC 130 Psychologie sociale (3 credits)",
"UQAC 135 Psychologie du développement de l'adolescent (3 credits)",
"UQAC 144  (3 credits)",
"UQAC 145  (3 credits)",
"UQAC 147  (3 credits)",
"UQAC 148  (3 credits)",
"UQAC 155 Anal&Int-données quant psych I (3 credits)",
"UQAC 156  (3 credits)",
"UQAC 186  (3 credits)",
"UQAC 202 Natation et securite (3 credits)",
"UQAC 206  (3 credits)",
"UQAC 210  (3 credits)",
"UQAC 216  (3 credits)",
"UQAC 243  (3 credits)",
"UQAC 244  (3 credits)",
"UQAC 245  (3 credits)",
"UQAC 246 Psychologie gérontologique (3 credits)",
"UQAC 248  (3 credits)",
"UQAC 255 Analyse et interprétation de données quantitatives en psychologie II (3 credits)",
"UQAC 305  (3 credits)",
"UQAC 317 Fondements de la dynamique familiale (3 credits)",
"UQAC 319 Physiologie de l’homme en movement (3 credits)",
"UQAC 320  (3 credits)",
"UQAC 324 Introduction à la psychologie sportive (3 credits)",
"UQAC 328  (3 credits)",
"UQAC 329 Psychologie de la sexualité (3 credits)",
"UQAC 333  (3 credits)",
"UQAC 429  (3 credits)",
"UQAC 583 Stage clinique en physiothérapie (7 credits)",
"UQAC 611 Méthodologie avancée de la recherche (4 credits)",
"UQAC 612 Méthodologie avancée de la recherche (3 credits)",
"UQAC 660 Réadaptation Cardiorespiratoire (5 credits)",
"UQAC 671  (7 credits)",
"UQAC 672 Stage spécialisé en physiothérapie II (7 credits)",
"UQAC 673 Stage spécialisé en physiothérapie III (7 credits)",
"UQAC 674  (7 credits)",
"UQAC 812  (3 credits)",
"UQSP 116  (3 credits)",
"URBP 201 Planning the 21st Century City (3 credits)",
"URBP 501 Principles and Practice 1 (2 credits)",
"URBP 503 Public Transport: Planning and Operations (3 credits)",
"URBP 504 Planning for Active Transportation (3 credits)",
"URBP 505 Geographic Information Systems (3 credits)",
"URBP 506 Environmental Policy and Planning (3 credits)",
"URBP 507 Planning and Infrastructure (3 credits)",
"URBP 514 Community Design Workshop (4 credits)",
"URBP 519 Sustainable Development Plans (6 credits)",
"URBP 520 Globalization: Planning and Change (3 credits)",
"URBP 530 Urban Infrastructure and Services in International Context (3 credits)",
"URBP 536 Current Issues in Transportation 1 (2 credits)",
"URBP 537 Current Issues in Transportation 2 (2 credits)",
"URBP 541 Selected Topics in Planning (1 credit)",
"URBP 542 Selected Topics in Visual Analysis (1 credit)",
"URBP 543 Special Topics (3 credits)",
"URBP 551 Urban Design and Planning (3 credits)",
"URBP 553 Urban Governance (3 credits)",
"URBP 555 Real Estate and Planning (3 credits)",
"URBP 556 Urban Economy: A Spatial Perspective (3 credits)",
"URBP 557 Rethinking Zoning (3 credits)",
"URBP 604 Urban Design Seminar (3 credits)",
"URBP 606 Supervised Research Seminar (3 credits)",
"URBP 607 Reading Course: Urban Planning (3 credits)",
"URBP 607D1 Reading Course: Urban Planning (1.5 credits)",
"URBP 607D2 Reading Course: Urban Planning (1.5 credits)",
"URBP 608 Advanced GIS Applications (3 credits)",
"URBP 609 Planning Graphics 1 (1 credit)",
"URBP 610 Planning Graphics 2 (1 credit)",
"URBP 611 Planning Graphics 3 (1 credit)",
"URBP 612 History and Theory of Planning (3 credits)",
"URBP 616 Selected Topics 1 (3 credits)",
"URBP 617 Selected Topics 2 (3 credits)",
"URBP 618 Selected Topics 3 (3 credits)",
"URBP 619 Land Use and Transport Planning (4 credits)",
"URBP 619D1 Land Use and Transport Planning (2 credits)",
"URBP 619D2 Land Use and Transport Planning (2 credits)",
"URBP 620 Transport Economics (4 credits)",
"URBP 622 Planning Studio 1 (6 credits)",
"URBP 622D1 Planning Studio 1 (3 credits)",
"URBP 622D2 Planning Studio 1 (3 credits)",
"URBP 623 Planning Studio 2 (6 credits)",
"URBP 624 Planning Studio 3 (6 credits)",
"URBP 625 Principles and Practice 2 (2 credits)",
"URBP 626 Principles and Practice 3 (2 credits)",
"URBP 628 Practical Experience",
"URBP 629 Planning Theory and Practice in a Globalizing World (3 credits)",
"URBP 630 Supervised Research Project 1 (3 credits)",
"URBP 631 Supervised Research Project 2 (3 credits)",
"URBP 632 Supervised Research Project 3 (6 credits)",
"URBP 633 Research Methods for Planners (3 credits)",
"URBP 634 Planning Water Resources in Barbados (3 credits)",
"URBP 635 Planning Law (3 credits)",
"URBP 640 Introduction to Planning Statistics (1 credit)",
"URBP 641 Reading the Urban Landscape (1 credit)",
"URBP 642 Introduction to Planning Data (1 credit)",
"URBP 643 Introduction to Geographic Information Systems (1 credit)",
"URBP 644 Multivariate Statistics (1 credit)",
"URBP 645 Social Research Methods 1 (1 credit)",
"URBP 646 Social Research Methods 2 (1 credit)",
"URBP 647 Selected Methods in Planning 1 (1 credit)",
"URBP 648 Selected Methods in Planning 2 (1 credit)",
"URBP 649 Visual and Spatial Methods (1 credit)",
"URBP 651 Redesigning Suburban Space (3 credits)",
"URBP 656 Urban Innovation and Creativity (3 credits)",
"URBP 701 Doctoral Comprehensive Examination",
"URBP 703 Doctoral Research Seminar 1 (3 credits)",
"URBP 704 Doctoral Research Seminar 2 (3 credits)",
"URBP 707 Doctoral Reading Course (3 credits)",
"URBP 708D1 Doctoral Research Forum",
"URBP 708D2 Doctoral Research Forum",
"URBP 709 Doctoral Research Proposal",
"WILD 302 Fish Ecology (3 credits)",
"WILD 307 Natural History of Vertebrates (3 credits)",
"WILD 350 Mammalogy (3 credits)",
"WILD 375 Issues: Environmental Sciences (3 credits)",
"WILD 382 Fish and Wildlife Propagation (3 credits)",
"WILD 401 Fisheries and Wildlife Management (4 credits)",
"WILD 420 Ornithology (3 credits)",
"WILD 421 Wildlife Conservation (3 credits)",
"WILD 475 Desert Ecology (3 credits)",
"WILD 605 Advanced Wildlife Ecology (3 credits)",
"WMST 501 Advanced Topics 1 (3 credits)",
"WMST 513 Gender Race and Science (3 credits)",
"WMST 601 Feminist Theories and Methods (3 credits)",
"WMST 602 Feminist Research Symposium (3 credits)",
"WMST 610 Current Topics 1 (3 credits)",
"WMST 620 Current Topics 2 (3 credits)",
"WOOD 420 Environmental Issues: Forestry (3 credits)",
"WOOD 441 Integrated Forest Management (3 credits)",
"WOOD 640 Recent Advances: Tree Ecophysiology (3 credits)",
"WRIT 001D1 Editor-in-Chief 2 (3 credits)",
"WRIT 001D2 Editor-in-Chief 2 (3 credits)",
"WRIT 002D1 Executive Editor 2 (2.5 credits)",
"WRIT 002D2 Executive Editor 2 (2.5 credits)",
"WRIT 003D1 Managing Editor 2 (3 credits)",
"WRIT 003D2 Managing Editor 2 (3 credits)",
"WRIT 004 Senior Editor 2 (3 credits)",
"WRIT 004D1 Senior Editor 2 (1.5 credits)",
"WRIT 004D2 Senior Editor 2 (1.5 credits)",
"WRIT 005 Senior Manager (2 credits)",
"WRIT 005D1 Senior Manager (1 credit)",
"WRIT 005D2 Senior Manager (1 credit)",
"WRIT 009D1 Specialized Editor 2 (2 credits)",
"WRIT 009D2 Specialized Editor 2 (2 credits)",
"WRIT 010D1 Junior Manager (1 credit)",
"WRIT 010D2 Junior Manager (1 credit)",
"WRIT 011D1 Junior Editor (1.5 credits)",
"WRIT 011D2 Junior Editor (1.5 credits)",
"WRIT 016D1 Legal Methodology Teaching 1 (2 credits)",
"WRIT 016D2 Legal Methodology Teaching 1 (2 credits)",
"WRIT 017D1 Legal Methodology Teaching 2 (2 credits)",
"WRIT 017D2 Legal Methodology Teaching 2 (2 credits)",
"WRIT 020 The McGill International Human Rights Internship (3 credits)",
"WRIT 021 Independent Human Rights Internship (3 credits)",
"WRIT 048 Group Assistants (2 credits)",
"WRIT 048D1 Group Assistants (1 credit)",
"WRIT 048D2 Group Assistants (1 credit)",
"WRIT 300 Major Internship (6 credits)",
"WRIT 300D1 Major Internship (3 credits)",
"WRIT 300D2 Major Internship (3 credits)",
"WRIT 330D1 Editor-in-Chief 1 (2 credits)",
"WRIT 330D2 Editor-in-Chief 1 (2 credits)",
"WRIT 331D1 Executive Editor 1 (2 credits)",
"WRIT 331D2 Executive Editor 1 (2 credits)",
"WRIT 332D1 Managing Editor 1 (2 credits)",
"WRIT 332D2 Managing Editor 1 (2 credits)",
"WRIT 333 Senior Editor 1 (2 credits)",
"WRIT 333D1 Senior Editor 1 (1 credit)",
"WRIT 333D2 Senior Editor 1 (1 credit)",
"WRIT 334 Specialized Editor 1 (2 credits)",
"WRIT 334D1 Specialized Editor 1 (1 credit)",
"WRIT 334D2 Specialized Editor 1 (1 credit)",
"WRIT 400 Senior Essay (6 credits)",
"WRIT 400D1 Senior Essay (3 credits)",
"WRIT 400D2 Senior Essay (3 credits)",
"WRIT 433 Legal Clinic 1 (6 credits)",
"WRIT 433D1 Legal Clinic 1 (3 credits)",
"WRIT 433D2 Legal Clinic 1 (3 credits)",
"WRIT 434 Legal Clinic 2 (3 credits)",
"WRIT 435 Legal Clinic 3 (3 credits)",
"WRIT 440 Student Clerkship A (6 credits)",
"WRIT 440D1 Student Clerkship A (3 credits)",
"WRIT 440D2 Student Clerkship A (3 credits)",
"WRIT 441 Student Clerkship B (3 credits)",
"WRIT 449D1 The Capstone Project (3 credits)",
"WRIT 449D2 The Capstone Project (3 credits)",
"WRIT 450 Honours Thesis 1 (3 credits)",
"WRIT 451 Honours Thesis 2 (6 credits)",
"WRIT 452 Honours Thesis 3 (6 credits)",
"WRIT 452D1 Honours Thesis 3 (3 credits)",
"WRIT 452D2 Honours Thesis 3 (3 credits)",
"WRIT 491 Term Essay 1A (3 credits)",
"WRIT 492 Term Essay 2 (3 credits)",
"WRIT 493 Term Essay 3 (3 credits)",
"WRIT 494 Term Essay 1B (3 credits)",
"WRIT 495 Term Essay 1C (3 credits)",
"WRIT 500D1 Editorial Assistant 1 (1.5 credits)",
"WRIT 500D2 Editorial Assistant 1 (1.5 credits)",
"WRIT 501D1 Editorial Assistant 2 (1 credit)",
"WRIT 501D2 Editorial Assistant 2 (1 credit)",
"WRIT 520 Writing & Drafting Project (1 credit)",
"YCFN N03",
"YRFA 300"]

export default courses;
